'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var chatSdkJavascript = require('@cometchat/chat-sdk-javascript');
var rxjs = require('rxjs');

class CometChatUIKitConstants {
}
CometChatUIKitConstants.MessageCategory = Object.freeze({
    message: chatSdkJavascript.CometChat.CATEGORY_MESSAGE,
    custom: chatSdkJavascript.CometChat.CATEGORY_CUSTOM,
    action: chatSdkJavascript.CometChat.CATEGORY_ACTION,
    call: chatSdkJavascript.CometChat.CATEGORY_CALL,
    interactive: chatSdkJavascript.CometChat.CATEGORY_INTERACTIVE
});
CometChatUIKitConstants.MessageTypes = Object.freeze({
    text: chatSdkJavascript.CometChat.MESSAGE_TYPE.TEXT,
    file: chatSdkJavascript.CometChat.MESSAGE_TYPE.FILE,
    image: chatSdkJavascript.CometChat.MESSAGE_TYPE.IMAGE,
    audio: chatSdkJavascript.CometChat.MESSAGE_TYPE.AUDIO,
    video: chatSdkJavascript.CometChat.MESSAGE_TYPE.VIDEO,
    delete: "delete",
    edited: "edited",
    groupMember: "groupMember",
    form: "form",
    card: "card",
    customInteractive: "customInteractive",
    scheduler: "scheduler"
});
CometChatUIKitConstants.groupMemberAction = Object.freeze({
    ROLE: "role",
    BLOCK: "block",
    REMOVE: "remove",
    JOINED: chatSdkJavascript.CometChat.ACTION_TYPE.MEMBER_JOINED,
    LEFT: chatSdkJavascript.CometChat.ACTION_TYPE.MEMBER_LEFT,
    ADDED: chatSdkJavascript.CometChat.ACTION_TYPE.MEMBER_ADDED,
    BANNED: chatSdkJavascript.CometChat.ACTION_TYPE.MEMBER_BANNED,
    UNBANNED: chatSdkJavascript.CometChat.ACTION_TYPE.MEMBER_UNBANNED,
    KICKED: chatSdkJavascript.CometChat.ACTION_TYPE.MEMBER_KICKED,
    INVITED: chatSdkJavascript.CometChat.ACTION_TYPE.MEMBER_INVITED,
    SCOPE_CHANGE: chatSdkJavascript.CometChat.ACTION_TYPE.MEMBER_SCOPE_CHANGED,
});
CometChatUIKitConstants.MessageReceiverType = Object.freeze({
    user: chatSdkJavascript.CometChat.RECEIVER_TYPE.USER,
    group: chatSdkJavascript.CometChat.RECEIVER_TYPE.GROUP,
});
CometChatUIKitConstants.userStatusType = Object.freeze({
    online: chatSdkJavascript.CometChat.USER_STATUS.ONLINE,
    offline: chatSdkJavascript.CometChat.USER_STATUS.OFFLINE,
});
CometChatUIKitConstants.MessageOption = Object.freeze({
    editMessage: "edit",
    deleteMessage: "delete",
    replyMessage: "reply",
    replyInThread: "replyInThread",
    translateMessage: "translate",
    reactToMessage: "react",
    messageInformation: "messageInformation",
    copyMessage: "copy",
    shareMessage: "share",
    forwardMessage: "forward",
    sendMessagePrivately: "sendMessagePrivately",
    replyMessagePrivately: "replyMessagePrivately",
});
CometChatUIKitConstants.GroupOptions = Object.freeze({
    leave: "leave",
    delete: "delete",
    viewMembers: "viewMembers",
    addMembers: "addMembers",
    bannedMembers: "bannedMembers",
});
CometChatUIKitConstants.GroupMemberOptions = Object.freeze({
    kick: "kick",
    ban: "ban",
    unban: "unban",
    changeScope: "changeScope",
});
CometChatUIKitConstants.groupMemberScope = Object.freeze({
    owner: "owner",
    admin: chatSdkJavascript.CometChat.GROUP_MEMBER_SCOPE.ADMIN,
    participant: chatSdkJavascript.CometChat.GROUP_MEMBER_SCOPE.PARTICIPANT,
    moderator: chatSdkJavascript.CometChat.GROUP_MEMBER_SCOPE.MODERATOR
});
CometChatUIKitConstants.UserOptions = Object.freeze({
    block: "block",
    unblock: "unblock",
    viewProfile: "viewProfile",
});
CometChatUIKitConstants.ConversationOptions = Object.freeze({
    delete: "delete"
});
CometChatUIKitConstants.GroupTypes = Object.freeze({
    private: chatSdkJavascript.CometChat.GROUP_TYPE.PRIVATE,
    password: chatSdkJavascript.CometChat.GROUP_TYPE.PASSWORD,
    public: chatSdkJavascript.CometChat.GROUP_TYPE.PUBLIC
});
CometChatUIKitConstants.liveReaction = Object.freeze({
    timeout: 1500
});
CometChatUIKitConstants.messages = Object.freeze({
    MESSAGE_DELIVERED: "onMessagesDelivered",
    MESSAGE_READ: "onMessagesRead",
    MESSAGE_DELETED: "onMessageDeleted",
    MESSAGE_EDITED: "onMessageEdited",
    MESSAGE_SENT: "messageSent",
    TEXT_MESSAGE_RECEIVED: "onTextMessageReceived",
    MEDIA_MESSAGE_RECEIVED: "onMediaMessageReceived",
    CUSTOM_MESSAGE_RECEIVED: "onCustomMessageReceived",
    TRANSIENT_MESSAGE_RECEIVED: "onTransientMessageReceived",
    INTERACTIVE_MESSAGE_RECEIVED: "onInteractiveMessageReceived",
    INTERACTION_GOAL_COMPLETED: "onInteractionGoalCompleted",
    DELIVERY: "delivery",
    READ: "read",
    APP_SYSTEM: "app_system",
    MESSAGE_REACTION_ADDED: "onMessageReactionAdded",
    MESSAGE_REACTION_REMOVED: "onMessageReactionRemoved",
});
CometChatUIKitConstants.details = Object.freeze({
    primary: "primary",
    secondary: "secondary"
});
CometChatUIKitConstants.calls = Object.freeze({
    meeting: "meeting",
    ongoing: chatSdkJavascript.CometChat.CALL_STATUS.ONGOING,
    ended: chatSdkJavascript.CometChat.CALL_STATUS.ENDED,
    initiated: chatSdkJavascript.CometChat.CALL_STATUS.INITIATED,
    cancelled: chatSdkJavascript.CometChat.CALL_STATUS.CANCELLED,
    rejected: chatSdkJavascript.CometChat.CALL_STATUS.REJECTED,
    unanswered: chatSdkJavascript.CometChat.CALL_STATUS.UNANSWERED,
    busy: chatSdkJavascript.CometChat.CALL_STATUS.BUSY,
    activecall: "cometchat:activecall",
    default: chatSdkJavascript.CometChat.CALL_MODE.DEFAULT,
    grid: chatSdkJavascript.CometChat.CALL_MODE.GRID,
    single: chatSdkJavascript.CometChat.CALL_MODE.SINGLE,
    spotlight: chatSdkJavascript.CometChat.CALL_MODE.SPOTLIGHT,
    tile: chatSdkJavascript.CometChat.CALL_MODE.TILE,
});
CometChatUIKitConstants.goalType = Object.freeze({
    allOf: chatSdkJavascript.CometChat.GoalType.ALL_OF,
    anyOf: chatSdkJavascript.CometChat.GoalType.ANY_OF,
    anyAction: chatSdkJavascript.CometChat.GoalType.ANY_ACTION,
    none: chatSdkJavascript.CometChat.GoalType.NONE
});
CometChatUIKitConstants.requestBuilderLimits = Object.freeze({
    reactionListLimit: 10,
    reactionInfoLimit: 10,
    messageListLimit: 30,
    usersLimit: 30,
    groupsLimit: 30,
});

class CometChatUtilityConstants {
}
CometChatUtilityConstants.TextFormatter = Object.freeze({
    KEY_UP_DEBOUNCE_TIME: 300,
});
CometChatUtilityConstants.MentionsTextFormatter = Object.freeze({
    MENTIONS_LIMIT: 10,
    MENTIONS_HOVER_TIMEOUT: 500
});

var INFO$d = "معلومات";
var REACT$d = "تتفاعل";
var EDIT$d = "تحرير";
var MESSAGE_PRIVATELY$d = "أرسل رسالة بشكل خاص";
var TRANSLATE$d = "ترجم";
var USERS$d = "مستخدمون";
var CHATS$d = "الدردشات";
var WOULD__YOU_LIKE_TO_DELETE_THIS_CONVERSATION$d = "هل ترغب في حذف هذه المحادثة؟ سيتم حذف هذه المحادثة من جميع أجهزتك.";
var GROUPS$d = "المجموعات";
var SHARED$d = "مشترك";
var SOUND_MANAGER$d = "إدارة الصوت";
var THEME$d = "موضوع";
var LOCALIZE$d = "حدد الموقع";
var CONVERSATION_LIST_ITEM$d = "عنصر قائمة المحادثة";
var DATA_ITEM$d = "عنصر البيانات";
var STATUS_INDICATOR$d = "مؤشر الحالة";
var BADGE_COUNT$d = "عدد الشارات";
var MESSAGE_RECEIPT$d = "استلام الرسائل";
var MESSAGE$d = "رسالة";
var RECEIPT_INFORMATION$d = "معلومات الاستلام";
var NO_RECIPIENT$d = "لا يوجد مستلم";
var NO_RECIPIENTS$d = "لا يوجد مستلمون";
var CONVERSATIONS_WITH_MESSAGES$d = "محادثات مع رسائل";
var CONVERSATIONS$d = "محادثات";
var CONVERSATION_LIST$d = "قائمة المحادثة";
var MESSAGES$d = "الرسائل";
var MESSAGE_HEADER$d = "رأس الرسالة";
var MESSAGE_LIST$d = "قائمة الرسائل";
var MESSAGE_COMPOSER$d = "ملحن الرسائل";
var USERS_WITH_MESSAGES$d = "المستخدمون الذين لديهم رسائل";
var USER_LIST$d = "قائمة المستخدمين";
var GROUP_LIST$d = "قائمة المجموعات";
var GROUPS_WITH_MESSAGES$d = "مجموعات تحتوي على رسائل";
var NEW__GROUP$d = "مجموعة جديدة";
var PASSWORD$d = "كلمة المرور";
var CONTINUE$d = "استمر";
var NO_CHATS_SELECTED$d = "لم يتم تحديد أي محادثات";
var NO_USERS_SELECTED$d = "لم يتم تحديد أي مستخدم";
var NO_GROUPS_SELECTED$d = "لم يتم تحديد أي مجموعات";
var SELECT_DAY$d = "حدد اليوم";
var SELECT_TIME$d = "حدد الوقت";
var NO_CALLS_SELECTED$d = "لم يتم تحديد أي مكالمات";
var SELECT__GROUP$d = "حدد مجموعة لبدء المراسلة";
var SELECT__USER$d = "حدد مستخدمًا لبدء المراسلة";
var GROUP_PASSWORD_BLANK$d = "لا يمكن أن تكون كلمة مرور المجموعة فارغة";
var GROUP_NAME_BLANK$d = "لا يمكن ترك اسم المجموعة فارغاً";
var GROUP_TYPE_BLANK$d = "لا يمكن أن يكون نوع المجموعة فارغًا";
var DELETE_CONVERSATION$d = "حذف المحادثة؟";
var ADD_TO_CHAT$d = "إضافة إلى الدردشة";
var MORE$d = "المزيد";
var COPY$d = "نسخة";
var VOICE_RECORDING$d = "التسجيل الصوتي";
var MESSAGE_IMAGE$d = "📷 صورة";
var MESSAGE_FILE$d = "📁 ملف";
var MESSAGE_VIDEO$d = "📹 فيديو";
var MESSAGE_AUDIO$d = "🎵 الصوت";
var CUSTOM_MESSAGE$d = "لديك رسالة";
var SELECT_A_DATE$d = "حدد التاريخ";
var TIME_ZONE$d = "منطقة زمنية";
var MEETING_SCHEDULED$d = "تمت جدولة اجتماعك.";
var SOMETHING_WRONG$d = "حدث خطأ ما. يرجى المحاولة مرة أخرى.";
var MEETING_SLOT_BOOK$d = "لم تعد الفترة الزمنية متاحة. يرجى اختيار آخر.";
var MEETING_BOOK_NEW_SLOT$d = "احجز فتحة جديدة";
var MEETING_NO_SLOTS_AVAILABLE$d = "لا توجد فترة زمنية متاحة لهذا التاريخ. يرجى تجربة تاريخ آخر.";
var MEETING_TRY_DIFFERENT_DATE$d = "يرجى تجربة تاريخ مختلف.";
var NO_TIME_SLOTS_AVAILABLE$d = "لا توجد فترات زمنية متاحة";
var SCHEDULE$d = "جدول";
var MORE_TIMES$d = "المزيد من المرات";
var MISSED_VOICE_CALL$d = "مكالمة صوتية فائتة";
var MEET_WITH$d = "اجتمع مع";
var MEETING_SCHEDULER$d = "جدولة الاجتماعات";
var MISSED_VIDEO_CALL$d = "مكالمة فيديو فائتة";
var CUSTOM_MESSAGE_POLL$d = "📊 استطلاع";
var CUSTOM_MESSAGE_STICKER$d = "💟 ملصق";
var CUSTOM_MESSAGE_DOCUMENT$d = "📃 مستند";
var CUSTOM_MESSAGE_WHITEBOARD$d = "📝 سبورة بيضاء";
var ONLINE$d = "عبر الإنترنت";
var ADMINISTRATOR$d = "المسؤول";
var ADMIN$d = "مشرف";
var MODERATOR$d = "مقدم";
var PARTICIPANT$d = "مشارك";
var PUBLIC$d = "الجمهور";
var PRIVATE$d = "خاص";
var PASSWORD_PROTECTED$d = "محمي بكلمة مرور";
var PRIVACY_AND_SECURITY$d = "الخصوصية والأمان";
var PREFERENCES$d = "التفضيلات";
var MEMBERS$d = "الأعضاء";
var MEMBER$d = "عضو";
var TODAY$d = "اليوم";
var YESTERDAY$d = "يوم أمس";
var SUNDAY$d = "الأحد";
var MONDAY$d = "الإثنين";
var TUESDAY$d = "الثلاثاء";
var WEDNESDAY$d = "الأربعاء";
var THURSDAY$d = "الخميس";
var FRIDAY$d = "الجمعة";
var SATURDAY$d = "يوم السبت";
var TYPING$d = "الكتابة...";
var IS_TYPING$d = "يقوم بالكتابة...";
var CLOSE$d = "أغلق";
var ENTER_GROUP_NAME$d = "أدخل اسم المجموعة";
var ADD_MEMBERS$d = "إضافة أعضاء";
var SEND_MESSAGE$d = "أرسل رسالة";
var UNBLOCK_USER$d = "إلغاء حظر المستخدم";
var BLOCK_USER$d = "حظر المستخدم";
var DELETE_AND_EXIT$d = "الحذف والخروج";
var LEAVE_GROUP$d = "اترك المجموعة";
var CREATE_GROUP$d = "إنشاء مجموعة";
var SHARED_MEDIA$d = "وسائل الإعلام المشتركة";
var SHARED_FILE$d = "ملف مشترك";
var VIDEO_CALL$d = "مكالمة فيديو";
var AUDIO_CALL$d = "مكالمة صوتية";
var LOADING$d = "جاري التحميل...";
var REPLY$d = "الرد";
var REPLIES$d = "الردود";
var AI$d = "منظمة العفو الدولية";
var SMART_REPLIES$d = "الردود الذكية";
var CONVERSATION_STARTER$d = "بداية المحادثة";
var LAUNCH$d = "إطلاق";
var SHARED_COLLABORATIVE_DOCUMENT$d = "شارك مستندًا تعاونيًا";
var SHARED_COLLABORATIVE_WHITEBOARD$d = "قام بمشاركة لوحة بيضاء تعاونية";
var CREATED_WHITEBOARD$d = "لقد قمت بإنشاء لوحة بيضاء تعاونية جديدة";
var CREATED_DOCUMENT$d = "لقد أنشأت مستندًا تعاونيًا جديدًا";
var PHOTOS$d = "صور";
var VIDEOS$d = "مقاطع فيديو";
var DOCUMENT$d = "مستند";
var YOU_DELETED_THIS_MESSAGE$d = "⚠️ لقد حذفت هذه الرسالة";
var THIS_MESSAGE_DELETED$d = "⚠️ تم حذف هذه الرسالة";
var MESSAGE_IS_DELETED$d = "تم حذف الرسالة";
var VIEW_ON_YOUTUBE$d = "شاهد على يوتيوب";
var SEARCH$d = "ابحث";
var NO_USERS_FOUND$d = "لم يتم العثور على أي مستخدم";
var ERROR$d = "خطأ";
var NO_GROUPS_FOUND$d = "لم يتم العثور على أي مجموعات";
var NO_CHATS_FOUND$d = "لم يتم العثور على محادثات";
var CANT__LOAD__CHATS$d = "لا يمكن تحميل الدردشات";
var MEDIA_MESSAGE$d = "رسالة وسائل الإعلام";
var INCOMING_AUDIO_CALL$d = "مكالمة صوتية واردة";
var INCOMING_VIDEO_CALL$d = "مكالمة فيديو واردة";
var DECLINE$d = "تراجع";
var ACCEPT$d = "اقبل";
var CALL_INITIATED$d = "تم بدء المكالمة";
var OUTGOING_AUDIO_CALL$d = "مكالمة صوتية صادرة";
var OUTGOING_VIDEO_CALL$d = "مكالمة فيديو صادرة";
var CALL_REJECTED$d = "تم رفض المكالمة";
var REJECTED_CALL$d = "مكالمة مرفوضة";
var CALL_ACCEPTED$d = "تم قبول المكالمة";
var OUTGOING_CALL$d = "مكالمة صادرة";
var INCOMING_CALL$d = "مكالمة واردة";
var MISSED_CALL$d = "مكالمة فائتة";
var JOINED$d = "انضم";
var LEFT_THE_CALL$d = "تركت المكالمة";
var UNANSWERED_AUDIO_CALL$d = "مكالمة صوتية لم يتم الرد عليها";
var UNANSWERED_VIDEO_CALL$d = "مكالمة فيديو لم يتم الرد عليها";
var CALL_ENDED$d = "تم إنهاء المكالمة";
var CALL_CANCELLED$d = "تم إلغاء المكالمة";
var CALL_BUSY$d = "اتصل مشغول";
var CALLING$d = "جاري الاتصال...";
var ADD$d = "أضِف";
var NO_BANNED_MEMBERS_FOUND$d = "لم يتم العثور على أعضاء محظورين";
var BANNED_MEMBERS$d = "الأعضاء المحظورون";
var NAME$d = "الاسم";
var SCOPE$d = "النطاق";
var UNBAN$d = "إلغاء الحظر";
var SELECT_GROUP_TYPE$d = "حدد نوع المجموعة";
var ENTER_GROUP_PASSWORD$d = "أدخل كلمة مرور المجموعة";
var CREATE$d = "ابتكر";
var CREATE_POLL$d = "إنشاء استطلاع";
var QUESTION$d = "سؤال";
var ENTER_YOUR_QUESTION$d = "أدخل سؤالك";
var OPTIONS$d = "خيارات";
var ENTER_YOUR_OPTION$d = "أدخل الخيار الخاص بك";
var ADD_NEW_OPTION$d = "إضافة خيار جديد";
var VIEW_MEMBERS$d = "عرض الأعضاء";
var DETAILS$d = "التفاصيل";
var NOTIFICATIONS$d = "الإشعارات";
var OTHER$d = "أخرى";
var HELP$d = "مساعدة";
var REPORT_PROBLEM$d = "الإبلاغ عن مشكلة";
var GROUP_MEMBERS$d = "أعضاء المجموعة";
var BAN$d = "حظر";
var KICK$d = "ركلة";
var PICK_YOUR_EMOJI$d = "اختر الرمز التعبيري الخاص بك";
var PRIVATE_GROUP$d = "مجموعة خاصة";
var PROTECTED_GROUP$d = "مجموعة محمية";
var VISIT$d = "زيارة";
var ATTACH$d = "أرفق";
var OPEN_WHITEBOARD$d = "افتح لوح المعلومات";
var ATTACH_FILE$d = "أرفق ملف";
var GENERATING_REPLIES$d = "توليد الردود";
var ATTACH_VIDEO$d = "أرفق مقطع فيديو";
var ATTACH_AUDIO$d = "أرفق الصوت";
var ATTACH_IMAGE$d = "أرفق صورة";
var COLLABORATE_USING_DOCUMENT$d = "التعاون باستخدام مستند";
var COLLABORATE_USING_WHITEBOARD$d = "التعاون باستخدام لوحة بيضاء";
var SUGGEST_A_REPLY$d = "اقترح الرد";
var GENERATING_ICEBREAKERS$d = "توليد كاسحات الجليد";
var EMOJI$d = "رمز تعبيري";
var NO_REPLIES_FOUND$d = "لم يتم العثور على ردود";
var ENTER_YOUR_MESSAGE_HERE$d = "أدخل رسالتك هنا";
var NO_MESSAGES_FOUND$d = "لم يتم العثور على أية رسائل";
var THREAD$d = "خيط";
var COLLABORATIVE_DOCUMENT$d = "وثيقة تعاونية";
var COLLABORATIVE_WHITEBOARD$d = "السبورة التعاونية";
var ADD_REACTION$d = "إضافة رد فعل";
var NO_STICKERS_FOUND$d = "لم يتم العثور على ملصقات";
var REPLY_TO_THREAD$d = "الرد على الموضوع";
var REPLY_IN_THREAD$d = "الرد في الموضوع";
var VIEW$d = "عرض";
var DELETE_MESSAGE$d = "حذف رسالة";
var EDIT_MESSAGE$d = "تحرير رسالة";
var OWNER$d = "مالك";
var CHANGE_SCOPE$d = "تغيير النطاق";
var STICKER$d = "ملصق";
var LAST_ACTIVE_AT$d = "آخر عمل نشط";
var VOICE_CALL$d = "مكالمة صوتية";
var VIEW_DETAIL$d = "عرض التفاصيل";
var VOTES$d = "التصويت";
var VOTE$d = "تصويت";
var NO_VOTE$d = "لا يوجد تصويت";
var REACTED$d = "رد فعل";
var ADDED$d = "أضاف";
var SHOW_UNSAFE_CONTENT$d = "هل تريد بالتأكيد مشاهدة محتوى غير آمن؟";
var REACT_TO_MESSAGE$d = "الرد على رسالة";
var UNBANNED$d = "غير محظور";
var MADE$d = "صنع";
var CALL_UNANSWERED$d = "لم يتم الرد على المكالمة";
var MISSED_AUDIO_CALL$d = "مكالمة صوتية فائتة";
var ENTER_YOUR_PASSWORD$d = "أدخل كلمة المرور الخاصة بك";
var DRAW_DOCUMENT_TOGETHER$d = "افتح المستند لتحرير المحتوى معًا";
var DOCS$d = "مستندات";
var NO_RECORDS_FOUND$d = "لم يتم العثور على أية سجلات";
var LIVE_REACTION$d = "رد فعل مباشر";
var SMILEY_PEOPLE$d = "الابتسامات والأشخاص";
var DRAW_WHITEBOARD_TOGETHER$d = "افتح السبورة البيضاء للرسم معًا";
var ANIMALES_NATURE$d = "الحيوانات والطبيعة";
var FOOD_DRINK$d = "الطعام والشراب";
var OPEN_DOCUMENT$d = "افتح المستند";
var ACTIVITY$d = "نشاط";
var TRAVEL_PLACES$d = "السفر والأماكن";
var OBJECTS$d = "الكائنات";
var SYMBOLS$d = "الرموز";
var FLAGS$d = "أعلام";
var SENT$d = "أُرسلت";
var SEEN$d = "شوهد";
var DELIVERED$d = "تم التوصيل";
var READ$d = "اقرأ";
var MESSAGE_INFORMATION$d = "معلومات الرسالة";
var TRANSLATE_MESSAGE$d = "ترجمة رسالة";
var TRANSLATED_MESSAGE$d = "رسالة مترجمة";
var LEFT$d = "يسار";
var KICKED$d = "ركل";
var BANNED$d = "محظور";
var NEW_MESSAGES$d = "رسائل جديدة";
var NEW_MESSAGE$d = "رسالة جديدة";
var JUMP$d = "اقفز";
var SELECT_VIDEO_SOURCE$d = "حدد مصدر الفيديو";
var SELECT_INPUT_AUDIO_SOURCE$d = "حدد مصدر إدخال الصوت";
var SELECT_OUTPUT_AUDIO_SOURCE$d = "حدد مصدر إخراج الصوت";
var INITIATED_GROUP_CALL$d = "قام ببدء مكالمة جماعية";
var YOU_INITIATED_GROUP_CALL$d = "لقد بدأت مكالمة جماعية";
var IGNORE$d = "تجاهل";
var ON_ANOTHER_CALL$d = "في مكالمة أخرى";
var CREATING$d = "إنشاء";
var AVATAR$d = "أفاتار";
var ONGOING_CALL$d = "مكالمة مستمرة";
var YOU_ALREADY_ONGOING_CALL$d = "أنت بالفعل في مكالمة مستمرة";
var RESIZE$d = "تغيير الحجم";
var SETTINGS$d = "إعدادات";
var ACTIONS$d = "الإجراءات";
var VIEW_PROFILE$d = "عرض الملف الشخصي";
var SEND_MESSAGE_IN_PRIVATE$d = "أرسل رسالة بشكل خاص";
var DELETE$d = "حذف";
var DELETE_CONFIRM$d = "هل تريد بالتأكيد الحذف؟";
var CANCEL$d = "إلغاء";
var LEAVE_CONFIRM$d = "هل أنت متأكد أنك تريد مغادرة المجموعة؟";
var TRANSFER_CONFIRM$d = "أنت مالك المجموعة؛ يرجى نقل الملكية إلى أحد الأعضاء قبل مغادرة المجموعة";
var ADDING$d = "إضافة...";
var TRANSFER$d = "نقل";
var TRANSFER_OWNERSHIP$d = "نقل الملكية";
var TRANSFERRING$d = "نقل";
var YES$d = "نعم";
var NO$d = "لا";
var ANSWER$d = "الإجابة";
var ADD_ANOTHER_ANSWER$d = "إضافة إجابة أخرى";
var SET_THE_ANSWERS$d = "قم بتعيين الإجابات";
var TRY_AGAIN$d = "حاول مرة أخرى";
var INVALID_GROUP_NAME$d = "الرجاء إدخال اسم صالح للمجموعة والمحاولة مرة أخرى";
var INVALID_PASSWORD$d = "يرجى إدخال كلمة مرور صالحة للمجموعة والمحاولة مرة أخرى";
var INVALID_GROUP_TYPE$d = "الرجاء إدخال نوع صالح للمجموعة والمحاولة مرة أخرى";
var WRONG_PASSWORD$d = "يرجى إدخال كلمة المرور الصحيحة والمحاولة مرة أخرى";
var INVALID_POLL_QUESTION$d = "الرجاء إدخال السؤال المطلوب قبل إنشاء استطلاع";
var INVALID_POLL_OPTION$d = "يرجى إدخال الإجابة المطلوبة قبل إنشاء استطلاع";
var SAME_LANGUAGE_MESSAGE$d = "اللغة المحددة للترجمة مشابهة للغة الرسالة الأصلية";
var LEAVE$d = "أجازة";
var CLICK_TO_START_CONVERSATION$d = "انقر لبدء المحادثة";
var CUSTOM_MESSAGE_LOCATION$d = "📍 الموقع";
var SHARED_LOCATION$d = "موقع مشترك";
var IN_A_THREAD$d = "في موضوع";
var CALLS$d = "مكالمات";
var CALL_DETAILS$d = "تفاصيل المكالمة";
var OFFLINE$d = "غير متصل";
var POLLS$d = "استطلاعات";
var YOU$d = "أنت";
var PRIVACY$d = "الخصوصية";
var BLOCKED_USERS$d = "المستخدمون المحظورون";
var NO_PHOTOS$d = "لا توجد صور";
var NO_VIDEOS$d = "لا توجد مقاطع فيديو";
var NO_DOCUMENTS$d = "لا توجد مستندات";
var JOIN$d = "انضم";
var REMOVE$d = "إزالة";
var BLOCK$d = "بلوك";
var CHANGE_ROLE$d = "تغيير الدور";
var NEW_CHAT$d = "دردشة جديدة";
var FORM_COMPLETION_MESSAGE$d = "شكرًا لك على ملء النموذج.";
var HISTORY$d = "التاريخ";
var CANCELLED_AUDIO_CALL$d = "مكالمة صوتية ملغاة";
var CANCELLED_VIDEO_CALL$d = "مكالمة فيديو ملغاة";
var REJECTED_AUDIO_CALL$d = "مكالمة صوتية مرفوضة";
var REJECTED_VIDEO_CALL$d = "مكالمة فيديو مرفوضة";
var CANCELLED_CALL$d = "مكالمة ملغاة";
var UNANSWERED_CALL$d = "مكالمة لم يتم الرد عليها";
var RECORDING$d = "التسجيل";
var PARTICIPANTS$d = "المشاركين";
var CALL_HISTORY$d = "سجل المكالمات";
var NO_CALLS_FOUND$d = "لم يتم العثور على مكالمات";
var ONGOING_AUDIO_CALL$d = "مكالمة صوتية مستمرة";
var ONGOING_VIDEO_CALL$d = "مكالمة فيديو مستمرة";
var CALL_DETAIL$d = "تفاصيل المكالمة";
var FORM$d = "نموذج";
var CARD$d = "بطاقة";
var GENERATING_SUMMARY$d = "توليد الملخص";
var CONVERSATION_SUMMARY$d = "ملخص المحادثة";
var GENERATE_SUMMARY$d = "قم بإنشاء ملخص";
var COMETCHAT_BOT_FIRST_MESSAGE$d = "كيف يمكنني مساعدتك في هذه المحادثة؟ من فضلك اسألني سؤالاً وسأنصحك 🙂";
var COMETCHAT_ASK_BOT$d = "اسأل";
var COMETCHAT_ASK_AI_BOT$d = "اسأل روبوتات الذكاء الاصطناعي";
var COMETCHAT_ASK_BOT_SUBTITLE$d = "بوت الذكاء الاصطناعي";
var MENTIONS_LIMIT_WARNING_MESSAGE$d = "يمكنك ذكر ما يصل إلى 10 مرات في المرة الواحدة.";
var ALL$d = "جميع";
var CLICK_TO_REMOVE$d = "انقر للإزالة";
var OTHERS$d = "أخرى";
var AND$d = "رجل";
var translationAR = {
	INFO: INFO$d,
	REACT: REACT$d,
	EDIT: EDIT$d,
	MESSAGE_PRIVATELY: MESSAGE_PRIVATELY$d,
	TRANSLATE: TRANSLATE$d,
	USERS: USERS$d,
	CHATS: CHATS$d,
	WOULD__YOU_LIKE_TO_DELETE_THIS_CONVERSATION: WOULD__YOU_LIKE_TO_DELETE_THIS_CONVERSATION$d,
	GROUPS: GROUPS$d,
	SHARED: SHARED$d,
	SOUND_MANAGER: SOUND_MANAGER$d,
	THEME: THEME$d,
	LOCALIZE: LOCALIZE$d,
	CONVERSATION_LIST_ITEM: CONVERSATION_LIST_ITEM$d,
	DATA_ITEM: DATA_ITEM$d,
	STATUS_INDICATOR: STATUS_INDICATOR$d,
	BADGE_COUNT: BADGE_COUNT$d,
	MESSAGE_RECEIPT: MESSAGE_RECEIPT$d,
	MESSAGE: MESSAGE$d,
	RECEIPT_INFORMATION: RECEIPT_INFORMATION$d,
	NO_RECIPIENT: NO_RECIPIENT$d,
	NO_RECIPIENTS: NO_RECIPIENTS$d,
	CONVERSATIONS_WITH_MESSAGES: CONVERSATIONS_WITH_MESSAGES$d,
	CONVERSATIONS: CONVERSATIONS$d,
	CONVERSATION_LIST: CONVERSATION_LIST$d,
	MESSAGES: MESSAGES$d,
	MESSAGE_HEADER: MESSAGE_HEADER$d,
	MESSAGE_LIST: MESSAGE_LIST$d,
	MESSAGE_COMPOSER: MESSAGE_COMPOSER$d,
	USERS_WITH_MESSAGES: USERS_WITH_MESSAGES$d,
	USER_LIST: USER_LIST$d,
	GROUP_LIST: GROUP_LIST$d,
	GROUPS_WITH_MESSAGES: GROUPS_WITH_MESSAGES$d,
	NEW__GROUP: NEW__GROUP$d,
	PASSWORD: PASSWORD$d,
	CONTINUE: CONTINUE$d,
	NO_CHATS_SELECTED: NO_CHATS_SELECTED$d,
	NO_USERS_SELECTED: NO_USERS_SELECTED$d,
	NO_GROUPS_SELECTED: NO_GROUPS_SELECTED$d,
	SELECT_DAY: SELECT_DAY$d,
	SELECT_TIME: SELECT_TIME$d,
	NO_CALLS_SELECTED: NO_CALLS_SELECTED$d,
	SELECT__GROUP: SELECT__GROUP$d,
	SELECT__USER: SELECT__USER$d,
	GROUP_PASSWORD_BLANK: GROUP_PASSWORD_BLANK$d,
	GROUP_NAME_BLANK: GROUP_NAME_BLANK$d,
	GROUP_TYPE_BLANK: GROUP_TYPE_BLANK$d,
	DELETE_CONVERSATION: DELETE_CONVERSATION$d,
	ADD_TO_CHAT: ADD_TO_CHAT$d,
	MORE: MORE$d,
	COPY: COPY$d,
	VOICE_RECORDING: VOICE_RECORDING$d,
	MESSAGE_IMAGE: MESSAGE_IMAGE$d,
	MESSAGE_FILE: MESSAGE_FILE$d,
	MESSAGE_VIDEO: MESSAGE_VIDEO$d,
	MESSAGE_AUDIO: MESSAGE_AUDIO$d,
	CUSTOM_MESSAGE: CUSTOM_MESSAGE$d,
	SELECT_A_DATE: SELECT_A_DATE$d,
	TIME_ZONE: TIME_ZONE$d,
	MEETING_SCHEDULED: MEETING_SCHEDULED$d,
	SOMETHING_WRONG: SOMETHING_WRONG$d,
	MEETING_SLOT_BOOK: MEETING_SLOT_BOOK$d,
	MEETING_BOOK_NEW_SLOT: MEETING_BOOK_NEW_SLOT$d,
	MEETING_NO_SLOTS_AVAILABLE: MEETING_NO_SLOTS_AVAILABLE$d,
	MEETING_TRY_DIFFERENT_DATE: MEETING_TRY_DIFFERENT_DATE$d,
	NO_TIME_SLOTS_AVAILABLE: NO_TIME_SLOTS_AVAILABLE$d,
	SCHEDULE: SCHEDULE$d,
	MORE_TIMES: MORE_TIMES$d,
	MISSED_VOICE_CALL: MISSED_VOICE_CALL$d,
	MEET_WITH: MEET_WITH$d,
	MEETING_SCHEDULER: MEETING_SCHEDULER$d,
	MISSED_VIDEO_CALL: MISSED_VIDEO_CALL$d,
	CUSTOM_MESSAGE_POLL: CUSTOM_MESSAGE_POLL$d,
	CUSTOM_MESSAGE_STICKER: CUSTOM_MESSAGE_STICKER$d,
	CUSTOM_MESSAGE_DOCUMENT: CUSTOM_MESSAGE_DOCUMENT$d,
	CUSTOM_MESSAGE_WHITEBOARD: CUSTOM_MESSAGE_WHITEBOARD$d,
	ONLINE: ONLINE$d,
	ADMINISTRATOR: ADMINISTRATOR$d,
	ADMIN: ADMIN$d,
	MODERATOR: MODERATOR$d,
	PARTICIPANT: PARTICIPANT$d,
	PUBLIC: PUBLIC$d,
	PRIVATE: PRIVATE$d,
	PASSWORD_PROTECTED: PASSWORD_PROTECTED$d,
	PRIVACY_AND_SECURITY: PRIVACY_AND_SECURITY$d,
	PREFERENCES: PREFERENCES$d,
	MEMBERS: MEMBERS$d,
	MEMBER: MEMBER$d,
	TODAY: TODAY$d,
	YESTERDAY: YESTERDAY$d,
	SUNDAY: SUNDAY$d,
	MONDAY: MONDAY$d,
	TUESDAY: TUESDAY$d,
	WEDNESDAY: WEDNESDAY$d,
	THURSDAY: THURSDAY$d,
	FRIDAY: FRIDAY$d,
	SATURDAY: SATURDAY$d,
	TYPING: TYPING$d,
	IS_TYPING: IS_TYPING$d,
	CLOSE: CLOSE$d,
	ENTER_GROUP_NAME: ENTER_GROUP_NAME$d,
	ADD_MEMBERS: ADD_MEMBERS$d,
	SEND_MESSAGE: SEND_MESSAGE$d,
	UNBLOCK_USER: UNBLOCK_USER$d,
	BLOCK_USER: BLOCK_USER$d,
	DELETE_AND_EXIT: DELETE_AND_EXIT$d,
	LEAVE_GROUP: LEAVE_GROUP$d,
	CREATE_GROUP: CREATE_GROUP$d,
	SHARED_MEDIA: SHARED_MEDIA$d,
	SHARED_FILE: SHARED_FILE$d,
	VIDEO_CALL: VIDEO_CALL$d,
	AUDIO_CALL: AUDIO_CALL$d,
	LOADING: LOADING$d,
	REPLY: REPLY$d,
	REPLIES: REPLIES$d,
	AI: AI$d,
	SMART_REPLIES: SMART_REPLIES$d,
	CONVERSATION_STARTER: CONVERSATION_STARTER$d,
	LAUNCH: LAUNCH$d,
	SHARED_COLLABORATIVE_DOCUMENT: SHARED_COLLABORATIVE_DOCUMENT$d,
	SHARED_COLLABORATIVE_WHITEBOARD: SHARED_COLLABORATIVE_WHITEBOARD$d,
	CREATED_WHITEBOARD: CREATED_WHITEBOARD$d,
	CREATED_DOCUMENT: CREATED_DOCUMENT$d,
	PHOTOS: PHOTOS$d,
	VIDEOS: VIDEOS$d,
	DOCUMENT: DOCUMENT$d,
	YOU_DELETED_THIS_MESSAGE: YOU_DELETED_THIS_MESSAGE$d,
	THIS_MESSAGE_DELETED: THIS_MESSAGE_DELETED$d,
	MESSAGE_IS_DELETED: MESSAGE_IS_DELETED$d,
	VIEW_ON_YOUTUBE: VIEW_ON_YOUTUBE$d,
	SEARCH: SEARCH$d,
	NO_USERS_FOUND: NO_USERS_FOUND$d,
	ERROR: ERROR$d,
	NO_GROUPS_FOUND: NO_GROUPS_FOUND$d,
	NO_CHATS_FOUND: NO_CHATS_FOUND$d,
	CANT__LOAD__CHATS: CANT__LOAD__CHATS$d,
	MEDIA_MESSAGE: MEDIA_MESSAGE$d,
	INCOMING_AUDIO_CALL: INCOMING_AUDIO_CALL$d,
	INCOMING_VIDEO_CALL: INCOMING_VIDEO_CALL$d,
	DECLINE: DECLINE$d,
	ACCEPT: ACCEPT$d,
	CALL_INITIATED: CALL_INITIATED$d,
	OUTGOING_AUDIO_CALL: OUTGOING_AUDIO_CALL$d,
	OUTGOING_VIDEO_CALL: OUTGOING_VIDEO_CALL$d,
	CALL_REJECTED: CALL_REJECTED$d,
	REJECTED_CALL: REJECTED_CALL$d,
	CALL_ACCEPTED: CALL_ACCEPTED$d,
	OUTGOING_CALL: OUTGOING_CALL$d,
	INCOMING_CALL: INCOMING_CALL$d,
	MISSED_CALL: MISSED_CALL$d,
	JOINED: JOINED$d,
	LEFT_THE_CALL: LEFT_THE_CALL$d,
	UNANSWERED_AUDIO_CALL: UNANSWERED_AUDIO_CALL$d,
	UNANSWERED_VIDEO_CALL: UNANSWERED_VIDEO_CALL$d,
	CALL_ENDED: CALL_ENDED$d,
	CALL_CANCELLED: CALL_CANCELLED$d,
	CALL_BUSY: CALL_BUSY$d,
	CALLING: CALLING$d,
	ADD: ADD$d,
	NO_BANNED_MEMBERS_FOUND: NO_BANNED_MEMBERS_FOUND$d,
	BANNED_MEMBERS: BANNED_MEMBERS$d,
	NAME: NAME$d,
	SCOPE: SCOPE$d,
	UNBAN: UNBAN$d,
	SELECT_GROUP_TYPE: SELECT_GROUP_TYPE$d,
	ENTER_GROUP_PASSWORD: ENTER_GROUP_PASSWORD$d,
	CREATE: CREATE$d,
	CREATE_POLL: CREATE_POLL$d,
	QUESTION: QUESTION$d,
	ENTER_YOUR_QUESTION: ENTER_YOUR_QUESTION$d,
	OPTIONS: OPTIONS$d,
	ENTER_YOUR_OPTION: ENTER_YOUR_OPTION$d,
	ADD_NEW_OPTION: ADD_NEW_OPTION$d,
	VIEW_MEMBERS: VIEW_MEMBERS$d,
	DETAILS: DETAILS$d,
	NOTIFICATIONS: NOTIFICATIONS$d,
	OTHER: OTHER$d,
	HELP: HELP$d,
	REPORT_PROBLEM: REPORT_PROBLEM$d,
	GROUP_MEMBERS: GROUP_MEMBERS$d,
	BAN: BAN$d,
	KICK: KICK$d,
	PICK_YOUR_EMOJI: PICK_YOUR_EMOJI$d,
	PRIVATE_GROUP: PRIVATE_GROUP$d,
	PROTECTED_GROUP: PROTECTED_GROUP$d,
	VISIT: VISIT$d,
	ATTACH: ATTACH$d,
	OPEN_WHITEBOARD: OPEN_WHITEBOARD$d,
	ATTACH_FILE: ATTACH_FILE$d,
	GENERATING_REPLIES: GENERATING_REPLIES$d,
	ATTACH_VIDEO: ATTACH_VIDEO$d,
	ATTACH_AUDIO: ATTACH_AUDIO$d,
	ATTACH_IMAGE: ATTACH_IMAGE$d,
	COLLABORATE_USING_DOCUMENT: COLLABORATE_USING_DOCUMENT$d,
	COLLABORATE_USING_WHITEBOARD: COLLABORATE_USING_WHITEBOARD$d,
	SUGGEST_A_REPLY: SUGGEST_A_REPLY$d,
	GENERATING_ICEBREAKERS: GENERATING_ICEBREAKERS$d,
	EMOJI: EMOJI$d,
	NO_REPLIES_FOUND: NO_REPLIES_FOUND$d,
	ENTER_YOUR_MESSAGE_HERE: ENTER_YOUR_MESSAGE_HERE$d,
	NO_MESSAGES_FOUND: NO_MESSAGES_FOUND$d,
	THREAD: THREAD$d,
	COLLABORATIVE_DOCUMENT: COLLABORATIVE_DOCUMENT$d,
	COLLABORATIVE_WHITEBOARD: COLLABORATIVE_WHITEBOARD$d,
	ADD_REACTION: ADD_REACTION$d,
	NO_STICKERS_FOUND: NO_STICKERS_FOUND$d,
	REPLY_TO_THREAD: REPLY_TO_THREAD$d,
	REPLY_IN_THREAD: REPLY_IN_THREAD$d,
	VIEW: VIEW$d,
	DELETE_MESSAGE: DELETE_MESSAGE$d,
	EDIT_MESSAGE: EDIT_MESSAGE$d,
	OWNER: OWNER$d,
	CHANGE_SCOPE: CHANGE_SCOPE$d,
	STICKER: STICKER$d,
	LAST_ACTIVE_AT: LAST_ACTIVE_AT$d,
	VOICE_CALL: VOICE_CALL$d,
	VIEW_DETAIL: VIEW_DETAIL$d,
	VOTES: VOTES$d,
	VOTE: VOTE$d,
	NO_VOTE: NO_VOTE$d,
	REACTED: REACTED$d,
	ADDED: ADDED$d,
	SHOW_UNSAFE_CONTENT: SHOW_UNSAFE_CONTENT$d,
	REACT_TO_MESSAGE: REACT_TO_MESSAGE$d,
	UNBANNED: UNBANNED$d,
	MADE: MADE$d,
	CALL_UNANSWERED: CALL_UNANSWERED$d,
	MISSED_AUDIO_CALL: MISSED_AUDIO_CALL$d,
	ENTER_YOUR_PASSWORD: ENTER_YOUR_PASSWORD$d,
	DRAW_DOCUMENT_TOGETHER: DRAW_DOCUMENT_TOGETHER$d,
	DOCS: DOCS$d,
	NO_RECORDS_FOUND: NO_RECORDS_FOUND$d,
	LIVE_REACTION: LIVE_REACTION$d,
	SMILEY_PEOPLE: SMILEY_PEOPLE$d,
	DRAW_WHITEBOARD_TOGETHER: DRAW_WHITEBOARD_TOGETHER$d,
	ANIMALES_NATURE: ANIMALES_NATURE$d,
	FOOD_DRINK: FOOD_DRINK$d,
	OPEN_DOCUMENT: OPEN_DOCUMENT$d,
	ACTIVITY: ACTIVITY$d,
	TRAVEL_PLACES: TRAVEL_PLACES$d,
	OBJECTS: OBJECTS$d,
	SYMBOLS: SYMBOLS$d,
	FLAGS: FLAGS$d,
	SENT: SENT$d,
	SEEN: SEEN$d,
	DELIVERED: DELIVERED$d,
	READ: READ$d,
	MESSAGE_INFORMATION: MESSAGE_INFORMATION$d,
	TRANSLATE_MESSAGE: TRANSLATE_MESSAGE$d,
	TRANSLATED_MESSAGE: TRANSLATED_MESSAGE$d,
	LEFT: LEFT$d,
	KICKED: KICKED$d,
	BANNED: BANNED$d,
	NEW_MESSAGES: NEW_MESSAGES$d,
	NEW_MESSAGE: NEW_MESSAGE$d,
	JUMP: JUMP$d,
	SELECT_VIDEO_SOURCE: SELECT_VIDEO_SOURCE$d,
	SELECT_INPUT_AUDIO_SOURCE: SELECT_INPUT_AUDIO_SOURCE$d,
	SELECT_OUTPUT_AUDIO_SOURCE: SELECT_OUTPUT_AUDIO_SOURCE$d,
	INITIATED_GROUP_CALL: INITIATED_GROUP_CALL$d,
	YOU_INITIATED_GROUP_CALL: YOU_INITIATED_GROUP_CALL$d,
	IGNORE: IGNORE$d,
	ON_ANOTHER_CALL: ON_ANOTHER_CALL$d,
	CREATING: CREATING$d,
	AVATAR: AVATAR$d,
	ONGOING_CALL: ONGOING_CALL$d,
	YOU_ALREADY_ONGOING_CALL: YOU_ALREADY_ONGOING_CALL$d,
	RESIZE: RESIZE$d,
	SETTINGS: SETTINGS$d,
	ACTIONS: ACTIONS$d,
	VIEW_PROFILE: VIEW_PROFILE$d,
	SEND_MESSAGE_IN_PRIVATE: SEND_MESSAGE_IN_PRIVATE$d,
	DELETE: DELETE$d,
	DELETE_CONFIRM: DELETE_CONFIRM$d,
	CANCEL: CANCEL$d,
	LEAVE_CONFIRM: LEAVE_CONFIRM$d,
	TRANSFER_CONFIRM: TRANSFER_CONFIRM$d,
	ADDING: ADDING$d,
	TRANSFER: TRANSFER$d,
	TRANSFER_OWNERSHIP: TRANSFER_OWNERSHIP$d,
	TRANSFERRING: TRANSFERRING$d,
	YES: YES$d,
	NO: NO$d,
	ANSWER: ANSWER$d,
	ADD_ANOTHER_ANSWER: ADD_ANOTHER_ANSWER$d,
	SET_THE_ANSWERS: SET_THE_ANSWERS$d,
	TRY_AGAIN: TRY_AGAIN$d,
	INVALID_GROUP_NAME: INVALID_GROUP_NAME$d,
	INVALID_PASSWORD: INVALID_PASSWORD$d,
	INVALID_GROUP_TYPE: INVALID_GROUP_TYPE$d,
	WRONG_PASSWORD: WRONG_PASSWORD$d,
	INVALID_POLL_QUESTION: INVALID_POLL_QUESTION$d,
	INVALID_POLL_OPTION: INVALID_POLL_OPTION$d,
	SAME_LANGUAGE_MESSAGE: SAME_LANGUAGE_MESSAGE$d,
	LEAVE: LEAVE$d,
	CLICK_TO_START_CONVERSATION: CLICK_TO_START_CONVERSATION$d,
	CUSTOM_MESSAGE_LOCATION: CUSTOM_MESSAGE_LOCATION$d,
	SHARED_LOCATION: SHARED_LOCATION$d,
	IN_A_THREAD: IN_A_THREAD$d,
	CALLS: CALLS$d,
	CALL_DETAILS: CALL_DETAILS$d,
	OFFLINE: OFFLINE$d,
	POLLS: POLLS$d,
	YOU: YOU$d,
	PRIVACY: PRIVACY$d,
	BLOCKED_USERS: BLOCKED_USERS$d,
	"YOU'VE_BLOCKED": "لقد حظرت",
	NO_PHOTOS: NO_PHOTOS$d,
	NO_VIDEOS: NO_VIDEOS$d,
	NO_DOCUMENTS: NO_DOCUMENTS$d,
	JOIN: JOIN$d,
	REMOVE: REMOVE$d,
	BLOCK: BLOCK$d,
	CHANGE_ROLE: CHANGE_ROLE$d,
	NEW_CHAT: NEW_CHAT$d,
	FORM_COMPLETION_MESSAGE: FORM_COMPLETION_MESSAGE$d,
	HISTORY: HISTORY$d,
	CANCELLED_AUDIO_CALL: CANCELLED_AUDIO_CALL$d,
	CANCELLED_VIDEO_CALL: CANCELLED_VIDEO_CALL$d,
	REJECTED_AUDIO_CALL: REJECTED_AUDIO_CALL$d,
	REJECTED_VIDEO_CALL: REJECTED_VIDEO_CALL$d,
	CANCELLED_CALL: CANCELLED_CALL$d,
	UNANSWERED_CALL: UNANSWERED_CALL$d,
	RECORDING: RECORDING$d,
	PARTICIPANTS: PARTICIPANTS$d,
	CALL_HISTORY: CALL_HISTORY$d,
	NO_CALLS_FOUND: NO_CALLS_FOUND$d,
	ONGOING_AUDIO_CALL: ONGOING_AUDIO_CALL$d,
	ONGOING_VIDEO_CALL: ONGOING_VIDEO_CALL$d,
	CALL_DETAIL: CALL_DETAIL$d,
	FORM: FORM$d,
	CARD: CARD$d,
	GENERATING_SUMMARY: GENERATING_SUMMARY$d,
	CONVERSATION_SUMMARY: CONVERSATION_SUMMARY$d,
	GENERATE_SUMMARY: GENERATE_SUMMARY$d,
	COMETCHAT_BOT_FIRST_MESSAGE: COMETCHAT_BOT_FIRST_MESSAGE$d,
	COMETCHAT_ASK_BOT: COMETCHAT_ASK_BOT$d,
	COMETCHAT_ASK_AI_BOT: COMETCHAT_ASK_AI_BOT$d,
	COMETCHAT_ASK_BOT_SUBTITLE: COMETCHAT_ASK_BOT_SUBTITLE$d,
	MENTIONS_LIMIT_WARNING_MESSAGE: MENTIONS_LIMIT_WARNING_MESSAGE$d,
	ALL: ALL$d,
	CLICK_TO_REMOVE: CLICK_TO_REMOVE$d,
	OTHERS: OTHERS$d,
	AND: AND$d
};

var INFO$c = "Informationen";
var REACT$c = "Reagieren";
var EDIT$c = "Bearbeiten";
var MESSAGE_PRIVATELY$c = "Private Nachricht";
var TRANSLATE$c = "Übersetzen";
var USERS$c = "Nutzer";
var CHATS$c = "Chats";
var WOULD__YOU_LIKE_TO_DELETE_THIS_CONVERSATION$c = "Möchten Sie diese Konversation löschen? Diese Konversation wird von all Ihren Geräten gelöscht.";
var GROUPS$c = "Gruppen";
var SHARED$c = "Geteilt";
var SOUND_MANAGER$c = "Soundmanager";
var THEME$c = "Thema";
var LOCALIZE$c = "Lokalisieren";
var CONVERSATION_LIST_ITEM$c = "Element der Konversationsliste";
var DATA_ITEM$c = "Datenelement";
var STATUS_INDICATOR$c = "Statusanzeige";
var BADGE_COUNT$c = "Anzahl der Abzeichen";
var MESSAGE_RECEIPT$c = "Empfang der Nachricht";
var MESSAGE$c = "Nachricht";
var RECEIPT_INFORMATION$c = "Informationen zur Quittung";
var NO_RECIPIENT$c = "Kein Empfänger";
var NO_RECIPIENTS$c = "Keine Empfänger";
var CONVERSATIONS_WITH_MESSAGES$c = "Konversationen mit Nachrichten";
var CONVERSATIONS$c = "Konversationen";
var CONVERSATION_LIST$c = "Liste der Konversationen";
var MESSAGES$c = "Nachrichten";
var MESSAGE_HEADER$c = "Nachrichten-Header";
var MESSAGE_LIST$c = "Liste der Nachrichten";
var MESSAGE_COMPOSER$c = "NachrichtenverFASSER";
var USERS_WITH_MESSAGES$c = "Benutzer mit Nachrichten";
var USER_LIST$c = "Liste der Benutzer";
var GROUP_LIST$c = "Liste der Gruppen";
var GROUPS_WITH_MESSAGES$c = "Gruppen mit Nachrichten";
var NEW__GROUP$c = "Neue Gruppe";
var PASSWORD$c = "Passwort";
var CONTINUE$c = "Weiter";
var NO_CHATS_SELECTED$c = "Keine Chats ausgewählt";
var NO_USERS_SELECTED$c = "Keine Benutzer ausgewählt";
var NO_GROUPS_SELECTED$c = "Keine Gruppen ausgewählt";
var SELECT_DAY$c = "Wählen Sie einen Tag";
var SELECT_TIME$c = "Wählen Sie eine Uhrzeit";
var NO_CALLS_SELECTED$c = "Keine Anrufe ausgewählt";
var SELECT__GROUP$c = "Wählen Sie eine Gruppe aus, um mit dem Messaging zu beginnen";
var SELECT__USER$c = "Wählen Sie einen Benutzer aus, um mit dem Messaging zu beginnen";
var GROUP_PASSWORD_BLANK$c = "Das Gruppenpasswort darf nicht leer sein";
var GROUP_NAME_BLANK$c = "Der Gruppenname darf nicht leer sein";
var GROUP_TYPE_BLANK$c = "Der Gruppentyp darf nicht leer sein";
var DELETE_CONVERSATION$c = "Konversation löschen?";
var ADD_TO_CHAT$c = "Zum Chat hinzufügen";
var MORE$c = "Mehr";
var COPY$c = "Kopieren";
var VOICE_RECORDING$c = "Sprachaufzeichnung";
var MESSAGE_IMAGE$c = "📷 Bild";
var MESSAGE_FILE$c = "📁 Datei";
var MESSAGE_VIDEO$c = "📹 Video";
var MESSAGE_AUDIO$c = "🎵 Audio";
var CUSTOM_MESSAGE$c = "Du hast eine Nachricht";
var SELECT_A_DATE$c = "Wählen Sie ein Datum";
var TIME_ZONE$c = "Zeitzone";
var MEETING_SCHEDULED$c = "Ihr Meeting wurde geplant.";
var SOMETHING_WRONG$c = "Etwas ist schief gelaufen. Bitte versuchen Sie es erneut.";
var MEETING_SLOT_BOOK$c = "Das Zeitfenster ist nicht mehr verfügbar. Bitte wählen Sie ein anderes.";
var MEETING_BOOK_NEW_SLOT$c = "Neuen Slot buchen";
var MEETING_NO_SLOTS_AVAILABLE$c = "Für dieses Datum ist kein Zeitfenster verfügbar. Bitte versuchen Sie es mit einem anderen Datum.";
var MEETING_TRY_DIFFERENT_DATE$c = "Bitte versuchen Sie es mit einem anderen Datum.";
var NO_TIME_SLOTS_AVAILABLE$c = "Keine Zeitfenster verfügbar";
var SCHEDULE$c = "Zeitplan";
var MORE_TIMES$c = "Mehrmals";
var MISSED_VOICE_CALL$c = "Verpasster Sprachanruf";
var MEET_WITH$c = "Treffen Sie sich mit";
var MEETING_SCHEDULER$c = "Planer für Besprechungen";
var MISSED_VIDEO_CALL$c = "Videoanruf verpasst";
var CUSTOM_MESSAGE_POLL$c = "📊 Umfrage";
var CUSTOM_MESSAGE_STICKER$c = "💟 Aufkleber";
var CUSTOM_MESSAGE_DOCUMENT$c = "📃 Dokument";
var CUSTOM_MESSAGE_WHITEBOARD$c = "📝 Whiteboard";
var ONLINE$c = "Online";
var ADMINISTRATOR$c = "Administrator";
var ADMIN$c = "Admin";
var MODERATOR$c = "Moderator";
var PARTICIPANT$c = "Teilnehmer";
var PUBLIC$c = "Öffentlich";
var PRIVATE$c = "Privat";
var PASSWORD_PROTECTED$c = "Passwortgeschützt";
var PRIVACY_AND_SECURITY$c = "Datenschutz und Sicherheit";
var PREFERENCES$c = "Präferenzen";
var MEMBERS$c = "Mitglieder";
var MEMBER$c = "Mitglied";
var TODAY$c = "Heute";
var YESTERDAY$c = "Gestern";
var SUNDAY$c = "Sonntag";
var MONDAY$c = "Montag";
var TUESDAY$c = "Dienstag";
var WEDNESDAY$c = "Mittwoch";
var THURSDAY$c = "Donnerstag";
var FRIDAY$c = "Freitag";
var SATURDAY$c = "Samstag";
var TYPING$c = "tippen...";
var IS_TYPING$c = "tippt...";
var CLOSE$c = "Schliessen";
var ENTER_GROUP_NAME$c = "Geben Sie den Gruppennamen ein";
var ADD_MEMBERS$c = "Mitglieder hinzufügen";
var SEND_MESSAGE$c = "Nachricht senden";
var UNBLOCK_USER$c = "Benutzer entsperren";
var BLOCK_USER$c = "Benutzer blockieren";
var DELETE_AND_EXIT$c = "Löschen und beenden";
var LEAVE_GROUP$c = "Gruppe verlassen";
var CREATE_GROUP$c = "Gruppe erstellen";
var SHARED_MEDIA$c = "Geteilte Medien";
var SHARED_FILE$c = "Geteilte Datei";
var VIDEO_CALL$c = "Videoanruf";
var AUDIO_CALL$c = "Audioanruf";
var LOADING$c = "Wird geladen...";
var REPLY$c = "Antwort";
var REPLIES$c = "Antworten";
var AI$c = "AI";
var SMART_REPLIES$c = "Intelligente Antworten";
var CONVERSATION_STARTER$c = "Gesprächsstarter";
var LAUNCH$c = "Starten";
var SHARED_COLLABORATIVE_DOCUMENT$c = "hat ein kollaboratives Dokument geteilt";
var SHARED_COLLABORATIVE_WHITEBOARD$c = "hat ein kollaboratives Whiteboard geteilt";
var CREATED_WHITEBOARD$c = "Sie haben ein neues kollaboratives Whiteboard erstellt";
var CREATED_DOCUMENT$c = "Sie haben ein neues kollaboratives Dokument erstellt";
var PHOTOS$c = "Fotos";
var VIDEOS$c = "Videos";
var DOCUMENT$c = "Dokument";
var YOU_DELETED_THIS_MESSAGE$c = "⚠️ Du hast diese Nachricht gelöscht";
var THIS_MESSAGE_DELETED$c = "⚠️ Diese Nachricht wurde gelöscht";
var MESSAGE_IS_DELETED$c = "Nachricht ist gelöscht";
var VIEW_ON_YOUTUBE$c = "Auf Youtube ansehen";
var SEARCH$c = "Suche";
var NO_USERS_FOUND$c = "Keine Benutzer gefunden";
var ERROR$c = "Fehler";
var NO_GROUPS_FOUND$c = "Keine Gruppen gefunden";
var NO_CHATS_FOUND$c = "Keine Chats gefunden";
var CANT__LOAD__CHATS$c = "Chats können nicht geladen werden";
var MEDIA_MESSAGE$c = "Botschaft der Medien";
var INCOMING_AUDIO_CALL$c = "Eingehender Audioanruf";
var INCOMING_VIDEO_CALL$c = "Eingehender Videoanruf";
var DECLINE$c = "Rückgang";
var ACCEPT$c = "Akzeptieren";
var CALL_INITIATED$c = "Anruf initiiert";
var OUTGOING_AUDIO_CALL$c = "Ausgehender Audioanruf";
var OUTGOING_VIDEO_CALL$c = "Ausgehender Videoanruf";
var CALL_REJECTED$c = "Anruf abgelehnt";
var REJECTED_CALL$c = "abgelehnter Anruf";
var CALL_ACCEPTED$c = "Anruf angenommen";
var OUTGOING_CALL$c = "Ausgehender Anruf";
var INCOMING_CALL$c = "Eingehender Anruf";
var MISSED_CALL$c = "Verpasster Anruf";
var JOINED$c = "verbunden";
var LEFT_THE_CALL$c = "hat den Anruf verlassen";
var UNANSWERED_AUDIO_CALL$c = "Unbeantworteter Audioanruf";
var UNANSWERED_VIDEO_CALL$c = "Unbeantworteter Videoanruf";
var CALL_ENDED$c = "Anruf wurde beendet";
var CALL_CANCELLED$c = "Anruf storniert";
var CALL_BUSY$c = "Ruf beschäftigt an";
var CALLING$c = "Ich rufe an...";
var ADD$c = "Hinzufügen";
var NO_BANNED_MEMBERS_FOUND$c = "Keine gesperrten Mitglieder gefunden";
var BANNED_MEMBERS$c = "Gesperrte Mitglieder";
var NAME$c = "Name";
var SCOPE$c = "Geltungsbereich";
var UNBAN$c = "Sperre aufheben";
var SELECT_GROUP_TYPE$c = "Wählen Sie den Gruppentyp";
var ENTER_GROUP_PASSWORD$c = "Geben Sie das Gruppenpasswort ein";
var CREATE$c = "Erstellen";
var CREATE_POLL$c = "Umfrage erstellen";
var QUESTION$c = "Frage";
var ENTER_YOUR_QUESTION$c = "Gib deine Frage ein";
var OPTIONS$c = "Optionen";
var ENTER_YOUR_OPTION$c = "Geben Sie Ihre Option ein";
var ADD_NEW_OPTION$c = "Neue Option hinzufügen";
var VIEW_MEMBERS$c = "Mitglieder ansehen";
var DETAILS$c = "Einzelheiten";
var NOTIFICATIONS$c = "Benachrichtigungen";
var OTHER$c = "Andere";
var HELP$c = "Hilfe";
var REPORT_PROBLEM$c = "Ein Problem melden";
var GROUP_MEMBERS$c = "Mitglieder der Gruppe";
var BAN$c = "Bann";
var KICK$c = "Tritt";
var PICK_YOUR_EMOJI$c = "Wähle dein Emoji";
var PRIVATE_GROUP$c = "Private Gruppe";
var PROTECTED_GROUP$c = "Geschützte Gruppe";
var VISIT$c = "Besuch";
var ATTACH$c = "Anhängen";
var OPEN_WHITEBOARD$c = "Whiteboard öffnen";
var ATTACH_FILE$c = "Datei anhängen";
var GENERATING_REPLIES$c = "Antworten generieren";
var ATTACH_VIDEO$c = "Video anhängen";
var ATTACH_AUDIO$c = "Audio anhängen";
var ATTACH_IMAGE$c = "Bild anhängen";
var COLLABORATE_USING_DOCUMENT$c = "Mithilfe eines Dokuments zusammenarbeiten";
var COLLABORATE_USING_WHITEBOARD$c = "Arbeiten Sie mit einem Whiteboard zusammen";
var SUGGEST_A_REPLY$c = "Schlage eine Antwort vor";
var GENERATING_ICEBREAKERS$c = "Eisbrecher generieren";
var EMOJI$c = "Emoji";
var NO_REPLIES_FOUND$c = "Keine Antworten gefunden";
var ENTER_YOUR_MESSAGE_HERE$c = "Tragen Sie hier Ihre Nachricht ein";
var NO_MESSAGES_FOUND$c = "Keine Nachrichten gefunden";
var THREAD$c = "Gewinde";
var COLLABORATIVE_DOCUMENT$c = "Kollaboratives Dokument";
var COLLABORATIVE_WHITEBOARD$c = "Kollaboratives Whiteboard";
var ADD_REACTION$c = "Reaktion hinzufügen";
var NO_STICKERS_FOUND$c = "Keine Sticker gefunden";
var REPLY_TO_THREAD$c = "Auf Thread antworten";
var REPLY_IN_THREAD$c = "Im Thread antworten";
var VIEW$c = "Ansicht";
var DELETE_MESSAGE$c = "Nachricht löschen";
var EDIT_MESSAGE$c = "Nachricht bearbeiten";
var OWNER$c = "Besitzer";
var CHANGE_SCOPE$c = "Umfang ändern";
var STICKER$c = "Aufkleber";
var LAST_ACTIVE_AT$c = "Zuletzt aktiv am";
var VOICE_CALL$c = "Sprachanruf";
var VIEW_DETAIL$c = "Detail ansehen";
var VOTES$c = "Wahlen";
var VOTE$c = "Abstimmung";
var NO_VOTE$c = "Keine Abstimmung";
var REACTED$c = "reagiert";
var ADDED$c = "hinzugefügt";
var SHOW_UNSAFE_CONTENT$c = "Möchten Sie wirklich unsichere Inhalte sehen?";
var REACT_TO_MESSAGE$c = "Auf eine Nachricht reagieren";
var UNBANNED$c = "nicht gesperrt";
var MADE$c = "hergestellt";
var CALL_UNANSWERED$c = "Anruf unbeantwortet";
var MISSED_AUDIO_CALL$c = "Verpasster Audioanruf";
var ENTER_YOUR_PASSWORD$c = "Gib dein Passwort ein";
var DRAW_DOCUMENT_TOGETHER$c = "Dokument öffnen, um Inhalte gemeinsam zu bearbeiten";
var DOCS$c = "Dokumente";
var NO_RECORDS_FOUND$c = "Keine Datensätze gefunden";
var LIVE_REACTION$c = "Live-Reaktion";
var SMILEY_PEOPLE$c = "Smileys und Leute";
var DRAW_WHITEBOARD_TOGETHER$c = "Whiteboard öffnen, um gemeinsam zu zeichnen";
var ANIMALES_NATURE$c = "Tiere und Natur";
var FOOD_DRINK$c = "Essen & Trinken";
var OPEN_DOCUMENT$c = "Dokument öffnen";
var ACTIVITY$c = "Aktivität";
var TRAVEL_PLACES$c = "Reisen und Orte";
var OBJECTS$c = "Objekte";
var SYMBOLS$c = "Symbole";
var FLAGS$c = "Flaggen";
var SENT$c = "Gesendet";
var SEEN$c = "Gesehen";
var DELIVERED$c = "Geliefert";
var READ$c = "Lesen";
var MESSAGE_INFORMATION$c = "Informationen zur Nachricht";
var TRANSLATE_MESSAGE$c = "Nachricht übersetzen";
var TRANSLATED_MESSAGE$c = "Übersetzte Nachricht";
var LEFT$c = "links";
var KICKED$c = "getreten";
var BANNED$c = "unerlaubt";
var NEW_MESSAGES$c = "neue Nachrichten";
var NEW_MESSAGE$c = "neue Nachricht";
var JUMP$c = "Springen";
var SELECT_VIDEO_SOURCE$c = "Wählen Sie die Videoquelle";
var SELECT_INPUT_AUDIO_SOURCE$c = "Wählen Sie die Eingangs-Audioquelle";
var SELECT_OUTPUT_AUDIO_SOURCE$c = "Wählen Sie die Ausgangs-Audioquelle";
var INITIATED_GROUP_CALL$c = "hat einen Gruppenanruf initiiert";
var YOU_INITIATED_GROUP_CALL$c = "Sie haben einen Gruppenanruf initiiert";
var IGNORE$c = "Ignorieren";
var ON_ANOTHER_CALL$c = "ist in einem anderen Gespräch";
var CREATING$c = "Erstellen";
var AVATAR$c = "Avatar";
var ONGOING_CALL$c = "Laufender Anruf";
var YOU_ALREADY_ONGOING_CALL$c = "Sie befinden sich bereits in einem laufenden Gespräch";
var RESIZE$c = "Größe ändern";
var SETTINGS$c = "Einstellungen";
var ACTIONS$c = "Aktionen";
var VIEW_PROFILE$c = "Profil ansehen";
var SEND_MESSAGE_IN_PRIVATE$c = "Nachricht privat senden";
var DELETE$c = "Löschen";
var DELETE_CONFIRM$c = "Bist du sicher, dass du löschen möchtest?";
var CANCEL$c = "Stornieren";
var LEAVE_CONFIRM$c = "Bist du sicher, dass du die Gruppe verlassen willst?";
var TRANSFER_CONFIRM$c = "Du bist der Gruppenbesitzer; bitte übertrage das Eigentum an ein Mitglied, bevor du die Gruppe verlässt";
var ADDING$c = "Wird hinzugefügt...";
var TRANSFER$c = "Übertragung";
var TRANSFER_OWNERSHIP$c = "Inhaberschaft übertragen";
var TRANSFERRING$c = "Übertragung";
var YES$c = "Ja";
var NO$c = "Nein";
var ANSWER$c = "Antwort";
var ADD_ANOTHER_ANSWER$c = "Eine weitere Antwort hinzufügen";
var SET_THE_ANSWERS$c = "STELLE DIE ANTWORTEN EIN";
var TRY_AGAIN$c = "Versuche es noch einmal";
var INVALID_GROUP_NAME$c = "Bitte geben Sie einen gültigen Namen für die Gruppe ein und versuchen Sie es erneut";
var INVALID_PASSWORD$c = "Bitte geben Sie ein gültiges Passwort für die Gruppe ein und versuchen Sie es erneut";
var INVALID_GROUP_TYPE$c = "Bitte geben Sie einen gültigen Typ für die Gruppe ein und versuchen Sie es erneut";
var WRONG_PASSWORD$c = "Bitte geben Sie das richtige Passwort ein und versuchen Sie es erneut";
var INVALID_POLL_QUESTION$c = "Bitte geben Sie die erforderliche Frage ein, bevor Sie eine Umfrage erstellen";
var INVALID_POLL_OPTION$c = "Bitte geben Sie die erforderliche Antwort ein, bevor Sie eine Umfrage erstellen";
var SAME_LANGUAGE_MESSAGE$c = "Die gewählte Sprache für die Übersetzung ähnelt der Sprache der Originalnachricht";
var LEAVE$c = "Verlassen";
var CLICK_TO_START_CONVERSATION$c = "Klicken Sie hier, um das Gespräch zu starten";
var CUSTOM_MESSAGE_LOCATION$c = "📍 Standort";
var SHARED_LOCATION$c = "Gemeinsamer Standort";
var IN_A_THREAD$c = "In einem Thread";
var CALLS$c = "Anrufe";
var CALL_DETAILS$c = "Einzelheiten zum Anruf";
var OFFLINE$c = "Offline";
var POLLS$c = "Umfragen";
var YOU$c = "Du";
var PRIVACY$c = "Datenschutz";
var BLOCKED_USERS$c = "Gesperrte Nutzer";
var NO_PHOTOS$c = "Keine Fotos";
var NO_VIDEOS$c = "Keine Videos";
var NO_DOCUMENTS$c = "Keine Dokumente";
var JOIN$c = "Beitreten";
var REMOVE$c = "entfernen";
var BLOCK$c = "Blockieren";
var CHANGE_ROLE$c = "Rolle ändern";
var NEW_CHAT$c = "Neuer Chat";
var FORM_COMPLETION_MESSAGE$c = "Vielen Dank für das Ausfüllen des Formulars.";
var HISTORY$c = "Geschichte";
var CANCELLED_AUDIO_CALL$c = "Abgebrochener Audioanruf";
var CANCELLED_VIDEO_CALL$c = "Videoanruf abgesagt";
var REJECTED_AUDIO_CALL$c = "Abgelehnter Audioanruf";
var REJECTED_VIDEO_CALL$c = "Abgelehnter Videoanruf";
var CANCELLED_CALL$c = "Anruf storniert";
var UNANSWERED_CALL$c = "Unbeantworteter Anruf";
var RECORDING$c = "Aufnahme";
var PARTICIPANTS$c = "Teilnehmer";
var CALL_HISTORY$c = "Anrufliste";
var NO_CALLS_FOUND$c = "Keine Anrufe gefunden";
var ONGOING_AUDIO_CALL$c = "Laufender Audioanruf";
var ONGOING_VIDEO_CALL$c = "Laufender Videoanruf";
var CALL_DETAIL$c = "Detail des Anrufs";
var FORM$c = "Formular";
var CARD$c = "Karte";
var GENERATING_SUMMARY$c = "Zusammenfassung wird generiert";
var CONVERSATION_SUMMARY$c = "Zusammenfassung der Konversation";
var GENERATE_SUMMARY$c = "Generieren Sie eine Zusammenfassung";
var COMETCHAT_BOT_FIRST_MESSAGE$c = "Wie kann ich dir bei diesem Gespräch helfen? Bitte stell mir eine Frage und ich berate dich 🙂";
var COMETCHAT_ASK_BOT$c = "Frag";
var COMETCHAT_ASK_AI_BOT$c = "Fragen Sie KI-Bots";
var COMETCHAT_ASK_BOT_SUBTITLE$c = "KI-Bot";
var MENTIONS_LIMIT_WARNING_MESSAGE$c = "Sie können bis zu 10 Mal gleichzeitig erwähnen.";
var ALL$c = "Alle";
var CLICK_TO_REMOVE$c = "Zum Entfernen hier klicken";
var OTHERS$c = "andere";
var AND$c = "ein";
var translationDE = {
	INFO: INFO$c,
	REACT: REACT$c,
	EDIT: EDIT$c,
	MESSAGE_PRIVATELY: MESSAGE_PRIVATELY$c,
	TRANSLATE: TRANSLATE$c,
	USERS: USERS$c,
	CHATS: CHATS$c,
	WOULD__YOU_LIKE_TO_DELETE_THIS_CONVERSATION: WOULD__YOU_LIKE_TO_DELETE_THIS_CONVERSATION$c,
	GROUPS: GROUPS$c,
	SHARED: SHARED$c,
	SOUND_MANAGER: SOUND_MANAGER$c,
	THEME: THEME$c,
	LOCALIZE: LOCALIZE$c,
	CONVERSATION_LIST_ITEM: CONVERSATION_LIST_ITEM$c,
	DATA_ITEM: DATA_ITEM$c,
	STATUS_INDICATOR: STATUS_INDICATOR$c,
	BADGE_COUNT: BADGE_COUNT$c,
	MESSAGE_RECEIPT: MESSAGE_RECEIPT$c,
	MESSAGE: MESSAGE$c,
	RECEIPT_INFORMATION: RECEIPT_INFORMATION$c,
	NO_RECIPIENT: NO_RECIPIENT$c,
	NO_RECIPIENTS: NO_RECIPIENTS$c,
	CONVERSATIONS_WITH_MESSAGES: CONVERSATIONS_WITH_MESSAGES$c,
	CONVERSATIONS: CONVERSATIONS$c,
	CONVERSATION_LIST: CONVERSATION_LIST$c,
	MESSAGES: MESSAGES$c,
	MESSAGE_HEADER: MESSAGE_HEADER$c,
	MESSAGE_LIST: MESSAGE_LIST$c,
	MESSAGE_COMPOSER: MESSAGE_COMPOSER$c,
	USERS_WITH_MESSAGES: USERS_WITH_MESSAGES$c,
	USER_LIST: USER_LIST$c,
	GROUP_LIST: GROUP_LIST$c,
	GROUPS_WITH_MESSAGES: GROUPS_WITH_MESSAGES$c,
	NEW__GROUP: NEW__GROUP$c,
	PASSWORD: PASSWORD$c,
	CONTINUE: CONTINUE$c,
	NO_CHATS_SELECTED: NO_CHATS_SELECTED$c,
	NO_USERS_SELECTED: NO_USERS_SELECTED$c,
	NO_GROUPS_SELECTED: NO_GROUPS_SELECTED$c,
	SELECT_DAY: SELECT_DAY$c,
	SELECT_TIME: SELECT_TIME$c,
	NO_CALLS_SELECTED: NO_CALLS_SELECTED$c,
	SELECT__GROUP: SELECT__GROUP$c,
	SELECT__USER: SELECT__USER$c,
	GROUP_PASSWORD_BLANK: GROUP_PASSWORD_BLANK$c,
	GROUP_NAME_BLANK: GROUP_NAME_BLANK$c,
	GROUP_TYPE_BLANK: GROUP_TYPE_BLANK$c,
	DELETE_CONVERSATION: DELETE_CONVERSATION$c,
	ADD_TO_CHAT: ADD_TO_CHAT$c,
	MORE: MORE$c,
	COPY: COPY$c,
	VOICE_RECORDING: VOICE_RECORDING$c,
	MESSAGE_IMAGE: MESSAGE_IMAGE$c,
	MESSAGE_FILE: MESSAGE_FILE$c,
	MESSAGE_VIDEO: MESSAGE_VIDEO$c,
	MESSAGE_AUDIO: MESSAGE_AUDIO$c,
	CUSTOM_MESSAGE: CUSTOM_MESSAGE$c,
	SELECT_A_DATE: SELECT_A_DATE$c,
	TIME_ZONE: TIME_ZONE$c,
	MEETING_SCHEDULED: MEETING_SCHEDULED$c,
	SOMETHING_WRONG: SOMETHING_WRONG$c,
	MEETING_SLOT_BOOK: MEETING_SLOT_BOOK$c,
	MEETING_BOOK_NEW_SLOT: MEETING_BOOK_NEW_SLOT$c,
	MEETING_NO_SLOTS_AVAILABLE: MEETING_NO_SLOTS_AVAILABLE$c,
	MEETING_TRY_DIFFERENT_DATE: MEETING_TRY_DIFFERENT_DATE$c,
	NO_TIME_SLOTS_AVAILABLE: NO_TIME_SLOTS_AVAILABLE$c,
	SCHEDULE: SCHEDULE$c,
	MORE_TIMES: MORE_TIMES$c,
	MISSED_VOICE_CALL: MISSED_VOICE_CALL$c,
	MEET_WITH: MEET_WITH$c,
	MEETING_SCHEDULER: MEETING_SCHEDULER$c,
	MISSED_VIDEO_CALL: MISSED_VIDEO_CALL$c,
	CUSTOM_MESSAGE_POLL: CUSTOM_MESSAGE_POLL$c,
	CUSTOM_MESSAGE_STICKER: CUSTOM_MESSAGE_STICKER$c,
	CUSTOM_MESSAGE_DOCUMENT: CUSTOM_MESSAGE_DOCUMENT$c,
	CUSTOM_MESSAGE_WHITEBOARD: CUSTOM_MESSAGE_WHITEBOARD$c,
	ONLINE: ONLINE$c,
	ADMINISTRATOR: ADMINISTRATOR$c,
	ADMIN: ADMIN$c,
	MODERATOR: MODERATOR$c,
	PARTICIPANT: PARTICIPANT$c,
	PUBLIC: PUBLIC$c,
	PRIVATE: PRIVATE$c,
	PASSWORD_PROTECTED: PASSWORD_PROTECTED$c,
	PRIVACY_AND_SECURITY: PRIVACY_AND_SECURITY$c,
	PREFERENCES: PREFERENCES$c,
	MEMBERS: MEMBERS$c,
	MEMBER: MEMBER$c,
	TODAY: TODAY$c,
	YESTERDAY: YESTERDAY$c,
	SUNDAY: SUNDAY$c,
	MONDAY: MONDAY$c,
	TUESDAY: TUESDAY$c,
	WEDNESDAY: WEDNESDAY$c,
	THURSDAY: THURSDAY$c,
	FRIDAY: FRIDAY$c,
	SATURDAY: SATURDAY$c,
	TYPING: TYPING$c,
	IS_TYPING: IS_TYPING$c,
	CLOSE: CLOSE$c,
	ENTER_GROUP_NAME: ENTER_GROUP_NAME$c,
	ADD_MEMBERS: ADD_MEMBERS$c,
	SEND_MESSAGE: SEND_MESSAGE$c,
	UNBLOCK_USER: UNBLOCK_USER$c,
	BLOCK_USER: BLOCK_USER$c,
	DELETE_AND_EXIT: DELETE_AND_EXIT$c,
	LEAVE_GROUP: LEAVE_GROUP$c,
	CREATE_GROUP: CREATE_GROUP$c,
	SHARED_MEDIA: SHARED_MEDIA$c,
	SHARED_FILE: SHARED_FILE$c,
	VIDEO_CALL: VIDEO_CALL$c,
	AUDIO_CALL: AUDIO_CALL$c,
	LOADING: LOADING$c,
	REPLY: REPLY$c,
	REPLIES: REPLIES$c,
	AI: AI$c,
	SMART_REPLIES: SMART_REPLIES$c,
	CONVERSATION_STARTER: CONVERSATION_STARTER$c,
	LAUNCH: LAUNCH$c,
	SHARED_COLLABORATIVE_DOCUMENT: SHARED_COLLABORATIVE_DOCUMENT$c,
	SHARED_COLLABORATIVE_WHITEBOARD: SHARED_COLLABORATIVE_WHITEBOARD$c,
	CREATED_WHITEBOARD: CREATED_WHITEBOARD$c,
	CREATED_DOCUMENT: CREATED_DOCUMENT$c,
	PHOTOS: PHOTOS$c,
	VIDEOS: VIDEOS$c,
	DOCUMENT: DOCUMENT$c,
	YOU_DELETED_THIS_MESSAGE: YOU_DELETED_THIS_MESSAGE$c,
	THIS_MESSAGE_DELETED: THIS_MESSAGE_DELETED$c,
	MESSAGE_IS_DELETED: MESSAGE_IS_DELETED$c,
	VIEW_ON_YOUTUBE: VIEW_ON_YOUTUBE$c,
	SEARCH: SEARCH$c,
	NO_USERS_FOUND: NO_USERS_FOUND$c,
	ERROR: ERROR$c,
	NO_GROUPS_FOUND: NO_GROUPS_FOUND$c,
	NO_CHATS_FOUND: NO_CHATS_FOUND$c,
	CANT__LOAD__CHATS: CANT__LOAD__CHATS$c,
	MEDIA_MESSAGE: MEDIA_MESSAGE$c,
	INCOMING_AUDIO_CALL: INCOMING_AUDIO_CALL$c,
	INCOMING_VIDEO_CALL: INCOMING_VIDEO_CALL$c,
	DECLINE: DECLINE$c,
	ACCEPT: ACCEPT$c,
	CALL_INITIATED: CALL_INITIATED$c,
	OUTGOING_AUDIO_CALL: OUTGOING_AUDIO_CALL$c,
	OUTGOING_VIDEO_CALL: OUTGOING_VIDEO_CALL$c,
	CALL_REJECTED: CALL_REJECTED$c,
	REJECTED_CALL: REJECTED_CALL$c,
	CALL_ACCEPTED: CALL_ACCEPTED$c,
	OUTGOING_CALL: OUTGOING_CALL$c,
	INCOMING_CALL: INCOMING_CALL$c,
	MISSED_CALL: MISSED_CALL$c,
	JOINED: JOINED$c,
	LEFT_THE_CALL: LEFT_THE_CALL$c,
	UNANSWERED_AUDIO_CALL: UNANSWERED_AUDIO_CALL$c,
	UNANSWERED_VIDEO_CALL: UNANSWERED_VIDEO_CALL$c,
	CALL_ENDED: CALL_ENDED$c,
	CALL_CANCELLED: CALL_CANCELLED$c,
	CALL_BUSY: CALL_BUSY$c,
	CALLING: CALLING$c,
	ADD: ADD$c,
	NO_BANNED_MEMBERS_FOUND: NO_BANNED_MEMBERS_FOUND$c,
	BANNED_MEMBERS: BANNED_MEMBERS$c,
	NAME: NAME$c,
	SCOPE: SCOPE$c,
	UNBAN: UNBAN$c,
	SELECT_GROUP_TYPE: SELECT_GROUP_TYPE$c,
	ENTER_GROUP_PASSWORD: ENTER_GROUP_PASSWORD$c,
	CREATE: CREATE$c,
	CREATE_POLL: CREATE_POLL$c,
	QUESTION: QUESTION$c,
	ENTER_YOUR_QUESTION: ENTER_YOUR_QUESTION$c,
	OPTIONS: OPTIONS$c,
	ENTER_YOUR_OPTION: ENTER_YOUR_OPTION$c,
	ADD_NEW_OPTION: ADD_NEW_OPTION$c,
	VIEW_MEMBERS: VIEW_MEMBERS$c,
	DETAILS: DETAILS$c,
	NOTIFICATIONS: NOTIFICATIONS$c,
	OTHER: OTHER$c,
	HELP: HELP$c,
	REPORT_PROBLEM: REPORT_PROBLEM$c,
	GROUP_MEMBERS: GROUP_MEMBERS$c,
	BAN: BAN$c,
	KICK: KICK$c,
	PICK_YOUR_EMOJI: PICK_YOUR_EMOJI$c,
	PRIVATE_GROUP: PRIVATE_GROUP$c,
	PROTECTED_GROUP: PROTECTED_GROUP$c,
	VISIT: VISIT$c,
	ATTACH: ATTACH$c,
	OPEN_WHITEBOARD: OPEN_WHITEBOARD$c,
	ATTACH_FILE: ATTACH_FILE$c,
	GENERATING_REPLIES: GENERATING_REPLIES$c,
	ATTACH_VIDEO: ATTACH_VIDEO$c,
	ATTACH_AUDIO: ATTACH_AUDIO$c,
	ATTACH_IMAGE: ATTACH_IMAGE$c,
	COLLABORATE_USING_DOCUMENT: COLLABORATE_USING_DOCUMENT$c,
	COLLABORATE_USING_WHITEBOARD: COLLABORATE_USING_WHITEBOARD$c,
	SUGGEST_A_REPLY: SUGGEST_A_REPLY$c,
	GENERATING_ICEBREAKERS: GENERATING_ICEBREAKERS$c,
	EMOJI: EMOJI$c,
	NO_REPLIES_FOUND: NO_REPLIES_FOUND$c,
	ENTER_YOUR_MESSAGE_HERE: ENTER_YOUR_MESSAGE_HERE$c,
	NO_MESSAGES_FOUND: NO_MESSAGES_FOUND$c,
	THREAD: THREAD$c,
	COLLABORATIVE_DOCUMENT: COLLABORATIVE_DOCUMENT$c,
	COLLABORATIVE_WHITEBOARD: COLLABORATIVE_WHITEBOARD$c,
	ADD_REACTION: ADD_REACTION$c,
	NO_STICKERS_FOUND: NO_STICKERS_FOUND$c,
	REPLY_TO_THREAD: REPLY_TO_THREAD$c,
	REPLY_IN_THREAD: REPLY_IN_THREAD$c,
	VIEW: VIEW$c,
	DELETE_MESSAGE: DELETE_MESSAGE$c,
	EDIT_MESSAGE: EDIT_MESSAGE$c,
	OWNER: OWNER$c,
	CHANGE_SCOPE: CHANGE_SCOPE$c,
	STICKER: STICKER$c,
	LAST_ACTIVE_AT: LAST_ACTIVE_AT$c,
	VOICE_CALL: VOICE_CALL$c,
	VIEW_DETAIL: VIEW_DETAIL$c,
	VOTES: VOTES$c,
	VOTE: VOTE$c,
	NO_VOTE: NO_VOTE$c,
	REACTED: REACTED$c,
	ADDED: ADDED$c,
	SHOW_UNSAFE_CONTENT: SHOW_UNSAFE_CONTENT$c,
	REACT_TO_MESSAGE: REACT_TO_MESSAGE$c,
	UNBANNED: UNBANNED$c,
	MADE: MADE$c,
	CALL_UNANSWERED: CALL_UNANSWERED$c,
	MISSED_AUDIO_CALL: MISSED_AUDIO_CALL$c,
	ENTER_YOUR_PASSWORD: ENTER_YOUR_PASSWORD$c,
	DRAW_DOCUMENT_TOGETHER: DRAW_DOCUMENT_TOGETHER$c,
	DOCS: DOCS$c,
	NO_RECORDS_FOUND: NO_RECORDS_FOUND$c,
	LIVE_REACTION: LIVE_REACTION$c,
	SMILEY_PEOPLE: SMILEY_PEOPLE$c,
	DRAW_WHITEBOARD_TOGETHER: DRAW_WHITEBOARD_TOGETHER$c,
	ANIMALES_NATURE: ANIMALES_NATURE$c,
	FOOD_DRINK: FOOD_DRINK$c,
	OPEN_DOCUMENT: OPEN_DOCUMENT$c,
	ACTIVITY: ACTIVITY$c,
	TRAVEL_PLACES: TRAVEL_PLACES$c,
	OBJECTS: OBJECTS$c,
	SYMBOLS: SYMBOLS$c,
	FLAGS: FLAGS$c,
	SENT: SENT$c,
	SEEN: SEEN$c,
	DELIVERED: DELIVERED$c,
	READ: READ$c,
	MESSAGE_INFORMATION: MESSAGE_INFORMATION$c,
	TRANSLATE_MESSAGE: TRANSLATE_MESSAGE$c,
	TRANSLATED_MESSAGE: TRANSLATED_MESSAGE$c,
	LEFT: LEFT$c,
	KICKED: KICKED$c,
	BANNED: BANNED$c,
	NEW_MESSAGES: NEW_MESSAGES$c,
	NEW_MESSAGE: NEW_MESSAGE$c,
	JUMP: JUMP$c,
	SELECT_VIDEO_SOURCE: SELECT_VIDEO_SOURCE$c,
	SELECT_INPUT_AUDIO_SOURCE: SELECT_INPUT_AUDIO_SOURCE$c,
	SELECT_OUTPUT_AUDIO_SOURCE: SELECT_OUTPUT_AUDIO_SOURCE$c,
	INITIATED_GROUP_CALL: INITIATED_GROUP_CALL$c,
	YOU_INITIATED_GROUP_CALL: YOU_INITIATED_GROUP_CALL$c,
	IGNORE: IGNORE$c,
	ON_ANOTHER_CALL: ON_ANOTHER_CALL$c,
	CREATING: CREATING$c,
	AVATAR: AVATAR$c,
	ONGOING_CALL: ONGOING_CALL$c,
	YOU_ALREADY_ONGOING_CALL: YOU_ALREADY_ONGOING_CALL$c,
	RESIZE: RESIZE$c,
	SETTINGS: SETTINGS$c,
	ACTIONS: ACTIONS$c,
	VIEW_PROFILE: VIEW_PROFILE$c,
	SEND_MESSAGE_IN_PRIVATE: SEND_MESSAGE_IN_PRIVATE$c,
	DELETE: DELETE$c,
	DELETE_CONFIRM: DELETE_CONFIRM$c,
	CANCEL: CANCEL$c,
	LEAVE_CONFIRM: LEAVE_CONFIRM$c,
	TRANSFER_CONFIRM: TRANSFER_CONFIRM$c,
	ADDING: ADDING$c,
	TRANSFER: TRANSFER$c,
	TRANSFER_OWNERSHIP: TRANSFER_OWNERSHIP$c,
	TRANSFERRING: TRANSFERRING$c,
	YES: YES$c,
	NO: NO$c,
	ANSWER: ANSWER$c,
	ADD_ANOTHER_ANSWER: ADD_ANOTHER_ANSWER$c,
	SET_THE_ANSWERS: SET_THE_ANSWERS$c,
	TRY_AGAIN: TRY_AGAIN$c,
	INVALID_GROUP_NAME: INVALID_GROUP_NAME$c,
	INVALID_PASSWORD: INVALID_PASSWORD$c,
	INVALID_GROUP_TYPE: INVALID_GROUP_TYPE$c,
	WRONG_PASSWORD: WRONG_PASSWORD$c,
	INVALID_POLL_QUESTION: INVALID_POLL_QUESTION$c,
	INVALID_POLL_OPTION: INVALID_POLL_OPTION$c,
	SAME_LANGUAGE_MESSAGE: SAME_LANGUAGE_MESSAGE$c,
	LEAVE: LEAVE$c,
	CLICK_TO_START_CONVERSATION: CLICK_TO_START_CONVERSATION$c,
	CUSTOM_MESSAGE_LOCATION: CUSTOM_MESSAGE_LOCATION$c,
	SHARED_LOCATION: SHARED_LOCATION$c,
	IN_A_THREAD: IN_A_THREAD$c,
	CALLS: CALLS$c,
	CALL_DETAILS: CALL_DETAILS$c,
	OFFLINE: OFFLINE$c,
	POLLS: POLLS$c,
	YOU: YOU$c,
	PRIVACY: PRIVACY$c,
	BLOCKED_USERS: BLOCKED_USERS$c,
	"YOU'VE_BLOCKED": "Du hast geblockt",
	NO_PHOTOS: NO_PHOTOS$c,
	NO_VIDEOS: NO_VIDEOS$c,
	NO_DOCUMENTS: NO_DOCUMENTS$c,
	JOIN: JOIN$c,
	REMOVE: REMOVE$c,
	BLOCK: BLOCK$c,
	CHANGE_ROLE: CHANGE_ROLE$c,
	NEW_CHAT: NEW_CHAT$c,
	FORM_COMPLETION_MESSAGE: FORM_COMPLETION_MESSAGE$c,
	HISTORY: HISTORY$c,
	CANCELLED_AUDIO_CALL: CANCELLED_AUDIO_CALL$c,
	CANCELLED_VIDEO_CALL: CANCELLED_VIDEO_CALL$c,
	REJECTED_AUDIO_CALL: REJECTED_AUDIO_CALL$c,
	REJECTED_VIDEO_CALL: REJECTED_VIDEO_CALL$c,
	CANCELLED_CALL: CANCELLED_CALL$c,
	UNANSWERED_CALL: UNANSWERED_CALL$c,
	RECORDING: RECORDING$c,
	PARTICIPANTS: PARTICIPANTS$c,
	CALL_HISTORY: CALL_HISTORY$c,
	NO_CALLS_FOUND: NO_CALLS_FOUND$c,
	ONGOING_AUDIO_CALL: ONGOING_AUDIO_CALL$c,
	ONGOING_VIDEO_CALL: ONGOING_VIDEO_CALL$c,
	CALL_DETAIL: CALL_DETAIL$c,
	FORM: FORM$c,
	CARD: CARD$c,
	GENERATING_SUMMARY: GENERATING_SUMMARY$c,
	CONVERSATION_SUMMARY: CONVERSATION_SUMMARY$c,
	GENERATE_SUMMARY: GENERATE_SUMMARY$c,
	COMETCHAT_BOT_FIRST_MESSAGE: COMETCHAT_BOT_FIRST_MESSAGE$c,
	COMETCHAT_ASK_BOT: COMETCHAT_ASK_BOT$c,
	COMETCHAT_ASK_AI_BOT: COMETCHAT_ASK_AI_BOT$c,
	COMETCHAT_ASK_BOT_SUBTITLE: COMETCHAT_ASK_BOT_SUBTITLE$c,
	MENTIONS_LIMIT_WARNING_MESSAGE: MENTIONS_LIMIT_WARNING_MESSAGE$c,
	ALL: ALL$c,
	CLICK_TO_REMOVE: CLICK_TO_REMOVE$c,
	OTHERS: OTHERS$c,
	AND: AND$c
};

var INFO$b = "Info";
var REACT$b = "React";
var EDIT$b = "Edit";
var MESSAGE_PRIVATELY$b = "Message Privately";
var TRANSLATE$b = "Translate";
var USERS$b = "Users";
var CHATS$b = "Chats";
var WOULD__YOU_LIKE_TO_DELETE_THIS_CONVERSATION$b = "Would you like to delete this conversation? This conversation will be deleted from all of your devices.";
var GROUPS$b = "Groups";
var SHARED$b = "Shared";
var SOUND_MANAGER$b = "Sound Manager";
var THEME$b = "Theme";
var LOCALIZE$b = "Localize";
var CONVERSATION_LIST_ITEM$b = "Conversation List Item";
var DATA_ITEM$b = "Data Item";
var STATUS_INDICATOR$b = "Status Indicator";
var BADGE_COUNT$b = "Badge Count";
var MESSAGE_RECEIPT$b = "Message Receipt";
var MESSAGE$b = "Message";
var RECEIPT_INFORMATION$b = "Receipt Information";
var NO_RECIPIENT$b = "No Recipient";
var NO_RECIPIENTS$b = "No Recipients";
var CONVERSATIONS_WITH_MESSAGES$b = "Conversations With Messages";
var CONVERSATIONS$b = "Conversations";
var CONVERSATION_LIST$b = "Conversation List";
var MESSAGES$b = "Messages";
var MESSAGE_HEADER$b = "Message Header";
var MESSAGE_LIST$b = "Message List";
var MESSAGE_COMPOSER$b = "Message Composer";
var USERS_WITH_MESSAGES$b = "Users With Messages";
var USER_LIST$b = "User List";
var GROUP_LIST$b = "Group List";
var GROUPS_WITH_MESSAGES$b = "Groups With Messages";
var NEW__GROUP$b = "New Group";
var PASSWORD$b = "Password";
var CONTINUE$b = "Continue";
var NO_CHATS_SELECTED$b = "No Chats Selected";
var NO_USERS_SELECTED$b = "No Users Selected";
var NO_GROUPS_SELECTED$b = "No Groups Selected";
var SELECT_DAY$b = "Select a Day";
var SELECT_TIME$b = "Select a Time";
var NO_CALLS_SELECTED$b = "No Calls Selected";
var SELECT__GROUP$b = "Select a group to start messaging";
var SELECT__USER$b = "Select a user to start messaging";
var GROUP_PASSWORD_BLANK$b = "Group password cannot be blank";
var GROUP_NAME_BLANK$b = "Group name cannot be blank";
var GROUP_TYPE_BLANK$b = "Group type cannot be blank";
var DELETE_CONVERSATION$b = "Delete Conversation?";
var ADD_TO_CHAT$b = "Add to Chat";
var MORE$b = "More";
var COPY$b = "Copy";
var VOICE_RECORDING$b = "Voice Recording";
var MESSAGE_IMAGE$b = "📷 Image";
var MESSAGE_FILE$b = "📁 File";
var MESSAGE_VIDEO$b = "📹 Video";
var MESSAGE_AUDIO$b = "🎵 Audio";
var CUSTOM_MESSAGE$b = "You have a message";
var SELECT_A_DATE$b = "Select a date";
var TIME_ZONE$b = "Time Zone";
var MEETING_SCHEDULED$b = "Your meeting has been scheduled.";
var SOMETHING_WRONG$b = "Something went wrong. Please try again.";
var MEETING_SLOT_BOOK$b = "Time slot no longer available. Please choose another.";
var MEETING_BOOK_NEW_SLOT$b = "Book New Slot";
var MEETING_NO_SLOTS_AVAILABLE$b = "No time slot available for this date. Please try another date.";
var MEETING_TRY_DIFFERENT_DATE$b = "Please try a different date.";
var NO_TIME_SLOTS_AVAILABLE$b = "No Time slots available";
var SCHEDULE$b = "Schedule";
var MORE_TIMES$b = "More times";
var MISSED_VOICE_CALL$b = "Missed voice call";
var MEET_WITH$b = "Meet With";
var MEETING_SCHEDULER$b = "Meeting Scheduler";
var MISSED_VIDEO_CALL$b = "Missed video call";
var CUSTOM_MESSAGE_POLL$b = "📊 Poll";
var CUSTOM_MESSAGE_STICKER$b = "💟 Sticker";
var CUSTOM_MESSAGE_DOCUMENT$b = "📃 Document";
var CUSTOM_MESSAGE_WHITEBOARD$b = "📝 Whiteboard";
var ONLINE$b = "Online";
var ADMINISTRATOR$b = "Administrator";
var ADMIN$b = "Admin";
var MODERATOR$b = "Moderator";
var PARTICIPANT$b = "Participant";
var PUBLIC$b = "Public";
var PRIVATE$b = "Private";
var PASSWORD_PROTECTED$b = "Password Protected";
var PRIVACY_AND_SECURITY$b = "Privacy and Security";
var PREFERENCES$b = "Preferences";
var MEMBERS$b = "Members";
var MEMBER$b = "Member";
var TODAY$b = "Today";
var YESTERDAY$b = "Yesterday";
var SUNDAY$b = "Sunday";
var MONDAY$b = "Monday";
var TUESDAY$b = "Tuesday";
var WEDNESDAY$b = "Wednesday";
var THURSDAY$b = "Thursday";
var FRIDAY$b = "Friday";
var SATURDAY$b = "Saturday";
var TYPING$b = "typing...";
var IS_TYPING$b = "is typing...";
var CLOSE$b = "Close";
var ENTER_GROUP_NAME$b = "Enter group name";
var ADD_MEMBERS$b = "Add Members";
var SEND_MESSAGE$b = "Send Message";
var UNBLOCK_USER$b = "Unblock User";
var BLOCK_USER$b = "Block User";
var DELETE_AND_EXIT$b = "Delete and Exit";
var LEAVE_GROUP$b = "Leave Group";
var CREATE_GROUP$b = "Create Group";
var SHARED_MEDIA$b = "Shared Media";
var SHARED_FILE$b = "Shared File";
var VIDEO_CALL$b = "Video call";
var AUDIO_CALL$b = "Audio call";
var LOADING$b = "Loading...";
var REPLY$b = "Reply";
var REPLIES$b = "Replies";
var AI$b = "AI";
var SMART_REPLIES$b = "Smart Replies";
var CONVERSATION_STARTER$b = "Conversation Starter";
var LAUNCH$b = "Launch";
var SHARED_COLLABORATIVE_DOCUMENT$b = "has shared a collaborative document";
var SHARED_COLLABORATIVE_WHITEBOARD$b = "has shared a collaborative whiteboard";
var CREATED_WHITEBOARD$b = "You’ve created a new collaborative whiteboard";
var CREATED_DOCUMENT$b = "You’ve created a new collaborative document";
var PHOTOS$b = "Photos";
var VIDEOS$b = "Videos";
var DOCUMENT$b = "Document";
var YOU_DELETED_THIS_MESSAGE$b = "⚠️ You deleted this message";
var THIS_MESSAGE_DELETED$b = "⚠️ This message was deleted";
var MESSAGE_IS_DELETED$b = "Message is Deleted";
var VIEW_ON_YOUTUBE$b = "View on Youtube";
var SEARCH$b = "Search";
var NO_USERS_FOUND$b = "No users found";
var ERROR$b = "Error";
var NO_GROUPS_FOUND$b = "No groups found";
var NO_CHATS_FOUND$b = "No chats found";
var CANT__LOAD__CHATS$b = "Can't load chats";
var MEDIA_MESSAGE$b = "Media message";
var INCOMING_AUDIO_CALL$b = "Incoming audio call";
var INCOMING_VIDEO_CALL$b = "Incoming video call";
var DECLINE$b = "Decline";
var ACCEPT$b = "Accept";
var CALL_INITIATED$b = "Call initiated";
var OUTGOING_AUDIO_CALL$b = "Outgoing audio call";
var OUTGOING_VIDEO_CALL$b = "Outgoing video call";
var CALL_REJECTED$b = "Call rejected";
var REJECTED_CALL$b = "rejected call";
var CALL_ACCEPTED$b = "Call accepted";
var OUTGOING_CALL$b = "Outgoing call";
var INCOMING_CALL$b = "Incoming call";
var MISSED_CALL$b = "Missed call";
var JOINED$b = "joined";
var LEFT_THE_CALL$b = "left the call";
var UNANSWERED_AUDIO_CALL$b = "Unanswered audio call";
var UNANSWERED_VIDEO_CALL$b = "Unanswered video call";
var CALL_ENDED$b = "Call ended";
var CALL_CANCELLED$b = "Call cancelled";
var CALL_BUSY$b = "Call busy";
var CALLING$b = "Calling...";
var ADD$b = "Add";
var NO_BANNED_MEMBERS_FOUND$b = "No banned members found";
var BANNED_MEMBERS$b = "Banned Members";
var NAME$b = "Name";
var SCOPE$b = "Scope";
var UNBAN$b = "Unban";
var SELECT_GROUP_TYPE$b = "Select group type";
var ENTER_GROUP_PASSWORD$b = "Enter group password";
var CREATE$b = "Create";
var CREATE_POLL$b = "Create Poll";
var QUESTION$b = "Question";
var ENTER_YOUR_QUESTION$b = "Enter your question";
var OPTIONS$b = "Options";
var ENTER_YOUR_OPTION$b = "Enter your option";
var ADD_NEW_OPTION$b = "Add new option";
var VIEW_MEMBERS$b = "View Members";
var DETAILS$b = "Details";
var NOTIFICATIONS$b = "Notifications";
var OTHER$b = "Other";
var HELP$b = "Help";
var REPORT_PROBLEM$b = "Report a Problem";
var GROUP_MEMBERS$b = "Group Members";
var BAN$b = "Ban";
var KICK$b = "Kick";
var PICK_YOUR_EMOJI$b = "Pick your emoji";
var PRIVATE_GROUP$b = "Private Group";
var PROTECTED_GROUP$b = "Protected Group";
var VISIT$b = "Visit";
var ATTACH$b = "Attach";
var OPEN_WHITEBOARD$b = "Open Whiteboard";
var ATTACH_FILE$b = "Attach file";
var GENERATING_REPLIES$b = "Generating replies";
var ATTACH_VIDEO$b = "Attach video";
var ATTACH_AUDIO$b = "Attach audio";
var ATTACH_IMAGE$b = "Attach image";
var COLLABORATE_USING_DOCUMENT$b = "Collaborate using a document";
var COLLABORATE_USING_WHITEBOARD$b = "Collaborate using a whiteboard";
var SUGGEST_A_REPLY$b = "Suggest a reply";
var GENERATING_ICEBREAKERS$b = "Generating icebreakers";
var EMOJI$b = "Emoji";
var NO_REPLIES_FOUND$b = "No Replies Found";
var ENTER_YOUR_MESSAGE_HERE$b = "Enter your message here";
var NO_MESSAGES_FOUND$b = "No messages found";
var THREAD$b = "Thread";
var COLLABORATIVE_DOCUMENT$b = "Collaborative Document";
var COLLABORATIVE_WHITEBOARD$b = "Collaborative Whiteboard";
var ADD_REACTION$b = "Add reaction";
var NO_STICKERS_FOUND$b = "No stickers found";
var REPLY_TO_THREAD$b = "Reply to thread";
var REPLY_IN_THREAD$b = "Reply in thread";
var VIEW$b = "View";
var DELETE_MESSAGE$b = "Delete message";
var EDIT_MESSAGE$b = "Edit message";
var OWNER$b = "Owner";
var CHANGE_SCOPE$b = "Change Scope";
var STICKER$b = "Sticker";
var LAST_ACTIVE_AT$b = "Last Active At";
var VOICE_CALL$b = "Voice call";
var VIEW_DETAIL$b = "View Detail";
var VOTES$b = "votes";
var VOTE$b = "vote";
var NO_VOTE$b = "No vote";
var REACTED$b = "reacted";
var ADDED$b = "added";
var SHOW_UNSAFE_CONTENT$b = "Are you sure want to see unsafe content?";
var REACT_TO_MESSAGE$b = "React to a message";
var UNBANNED$b = "unbanned";
var MADE$b = "made";
var CALL_UNANSWERED$b = "Call unanswered";
var MISSED_AUDIO_CALL$b = "Missed audio call";
var ENTER_YOUR_PASSWORD$b = "Enter your password";
var DRAW_DOCUMENT_TOGETHER$b = "Open document to edit content together";
var DOCS$b = "Docs";
var NO_RECORDS_FOUND$b = "No records found";
var LIVE_REACTION$b = "Live Reaction";
var SMILEY_PEOPLE$b = "Smileys & People";
var DRAW_WHITEBOARD_TOGETHER$b = "Open whiteboard to draw together";
var ANIMALES_NATURE$b = "Animals & Nature";
var FOOD_DRINK$b = "Food & Drink";
var OPEN_DOCUMENT$b = "Open Document";
var ACTIVITY$b = "Activity";
var TRAVEL_PLACES$b = "Travel & Places";
var OBJECTS$b = "Objects";
var SYMBOLS$b = "Symbols";
var FLAGS$b = "Flags";
var SENT$b = "Sent";
var SEEN$b = "Seen";
var DELIVERED$b = "Delivered";
var READ$b = "Read";
var MESSAGE_INFORMATION$b = "Message Information";
var TRANSLATE_MESSAGE$b = "Translate message";
var TRANSLATED_MESSAGE$b = "Translated message";
var LEFT$b = "left";
var KICKED$b = "kicked";
var BANNED$b = "banned";
var NEW_MESSAGES$b = "new messages";
var NEW_MESSAGE$b = "new message";
var JUMP$b = "Jump";
var SELECT_VIDEO_SOURCE$b = "Select video source";
var SELECT_INPUT_AUDIO_SOURCE$b = "Select input audio source";
var SELECT_OUTPUT_AUDIO_SOURCE$b = "Select output audio source";
var INITIATED_GROUP_CALL$b = "has initiated a group call";
var YOU_INITIATED_GROUP_CALL$b = "You’ve initiated a group call";
var IGNORE$b = "Ignore";
var ON_ANOTHER_CALL$b = "is on another call";
var CREATING$b = "Creating";
var AVATAR$b = "Avatar";
var ONGOING_CALL$b = "Ongoing call";
var YOU_ALREADY_ONGOING_CALL$b = "You are already in an ongoing call";
var RESIZE$b = "Resize";
var SETTINGS$b = "Settings";
var ACTIONS$b = "Actions";
var VIEW_PROFILE$b = "View Profile";
var SEND_MESSAGE_IN_PRIVATE$b = "Send message privately";
var DELETE$b = "Delete";
var DELETE_CONFIRM$b = "Are you sure you want to delete?";
var CANCEL$b = "Cancel";
var LEAVE_CONFIRM$b = "Are you sure you want to leave the group?";
var TRANSFER_CONFIRM$b = "You are the group owner, please transfer ownership to a member before leaving the group";
var ADDING$b = "Adding...";
var TRANSFER$b = "Transfer";
var TRANSFER_OWNERSHIP$b = "Transfer Ownership";
var TRANSFERRING$b = "Transferring";
var YES$b = "Yes";
var NO$b = "No";
var ANSWER$b = "Answer";
var ADD_ANOTHER_ANSWER$b = "Add Another Answer";
var SET_THE_ANSWERS$b = "SET THE ANSWERS";
var TRY_AGAIN$b = "Try again";
var INVALID_GROUP_NAME$b = "Please enter a valid name for the group and try again";
var INVALID_PASSWORD$b = "Please enter a valid password for the group and try again";
var INVALID_GROUP_TYPE$b = "Please enter a valid type for the group and try again";
var WRONG_PASSWORD$b = "Please enter the correct password and try again";
var INVALID_POLL_QUESTION$b = "Please enter the required question before creating a poll";
var INVALID_POLL_OPTION$b = "Please enter the required answer before creating a poll";
var SAME_LANGUAGE_MESSAGE$b = "Selected language for translation is similar to the language of original message";
var LEAVE$b = "Leave";
var CLICK_TO_START_CONVERSATION$b = "Click to start conversation";
var CUSTOM_MESSAGE_LOCATION$b = "📍Location";
var SHARED_LOCATION$b = "Shared Location";
var IN_A_THREAD$b = "In a thread";
var CALLS$b = "Calls";
var CALL_DETAILS$b = "Call Details";
var OFFLINE$b = "Offline";
var POLLS$b = "Polls";
var YOU$b = "You";
var PRIVACY$b = "Privacy";
var BLOCKED_USERS$b = "Blocked Users";
var NO_PHOTOS$b = "No Photos";
var NO_VIDEOS$b = "No Videos";
var NO_DOCUMENTS$b = "No Documents";
var JOIN$b = "Join";
var REMOVE$b = "Remove";
var BLOCK$b = "Block";
var CHANGE_ROLE$b = "Change Role";
var NEW_CHAT$b = "New Chat";
var FORM_COMPLETION_MESSAGE$b = "Thank you for filling out the form.";
var HISTORY$b = "History";
var CANCELLED_AUDIO_CALL$b = "Cancelled audio call";
var CANCELLED_VIDEO_CALL$b = "Cancelled video call";
var REJECTED_AUDIO_CALL$b = "Rejected audio call";
var REJECTED_VIDEO_CALL$b = "Rejected video call";
var CANCELLED_CALL$b = "Cancelled call";
var UNANSWERED_CALL$b = "Unanswered call";
var RECORDING$b = "Recording";
var PARTICIPANTS$b = "Participants";
var CALL_HISTORY$b = "Call History";
var NO_CALLS_FOUND$b = "No Calls Found";
var ONGOING_AUDIO_CALL$b = "Ongoing audio call";
var ONGOING_VIDEO_CALL$b = "Ongoing video call";
var CALL_DETAIL$b = "Call Detail";
var FORM$b = "Form";
var CARD$b = "Card";
var GENERATING_SUMMARY$b = "Generating summary";
var CONVERSATION_SUMMARY$b = "Conversation summary";
var GENERATE_SUMMARY$b = "Generate a summary";
var COMETCHAT_BOT_FIRST_MESSAGE$b = "How can I help you with this conversation? Please ask me a question and I’ll advice you 🙂";
var COMETCHAT_ASK_BOT$b = "Ask";
var COMETCHAT_ASK_AI_BOT$b = "Ask AI Bots";
var COMETCHAT_ASK_BOT_SUBTITLE$b = "AI Bot";
var MENTIONS_LIMIT_WARNING_MESSAGE$b = "You can mention up to 10 times at a time.";
var ALL$b = "All";
var CLICK_TO_REMOVE$b = "Click to remove";
var OTHERS$b = "others";
var AND$b = "and";
var translationEN = {
	INFO: INFO$b,
	REACT: REACT$b,
	EDIT: EDIT$b,
	MESSAGE_PRIVATELY: MESSAGE_PRIVATELY$b,
	TRANSLATE: TRANSLATE$b,
	USERS: USERS$b,
	CHATS: CHATS$b,
	WOULD__YOU_LIKE_TO_DELETE_THIS_CONVERSATION: WOULD__YOU_LIKE_TO_DELETE_THIS_CONVERSATION$b,
	GROUPS: GROUPS$b,
	SHARED: SHARED$b,
	SOUND_MANAGER: SOUND_MANAGER$b,
	THEME: THEME$b,
	LOCALIZE: LOCALIZE$b,
	CONVERSATION_LIST_ITEM: CONVERSATION_LIST_ITEM$b,
	DATA_ITEM: DATA_ITEM$b,
	STATUS_INDICATOR: STATUS_INDICATOR$b,
	BADGE_COUNT: BADGE_COUNT$b,
	MESSAGE_RECEIPT: MESSAGE_RECEIPT$b,
	MESSAGE: MESSAGE$b,
	RECEIPT_INFORMATION: RECEIPT_INFORMATION$b,
	NO_RECIPIENT: NO_RECIPIENT$b,
	NO_RECIPIENTS: NO_RECIPIENTS$b,
	CONVERSATIONS_WITH_MESSAGES: CONVERSATIONS_WITH_MESSAGES$b,
	CONVERSATIONS: CONVERSATIONS$b,
	CONVERSATION_LIST: CONVERSATION_LIST$b,
	MESSAGES: MESSAGES$b,
	MESSAGE_HEADER: MESSAGE_HEADER$b,
	MESSAGE_LIST: MESSAGE_LIST$b,
	MESSAGE_COMPOSER: MESSAGE_COMPOSER$b,
	USERS_WITH_MESSAGES: USERS_WITH_MESSAGES$b,
	USER_LIST: USER_LIST$b,
	GROUP_LIST: GROUP_LIST$b,
	GROUPS_WITH_MESSAGES: GROUPS_WITH_MESSAGES$b,
	NEW__GROUP: NEW__GROUP$b,
	PASSWORD: PASSWORD$b,
	CONTINUE: CONTINUE$b,
	NO_CHATS_SELECTED: NO_CHATS_SELECTED$b,
	NO_USERS_SELECTED: NO_USERS_SELECTED$b,
	NO_GROUPS_SELECTED: NO_GROUPS_SELECTED$b,
	SELECT_DAY: SELECT_DAY$b,
	SELECT_TIME: SELECT_TIME$b,
	NO_CALLS_SELECTED: NO_CALLS_SELECTED$b,
	SELECT__GROUP: SELECT__GROUP$b,
	SELECT__USER: SELECT__USER$b,
	GROUP_PASSWORD_BLANK: GROUP_PASSWORD_BLANK$b,
	GROUP_NAME_BLANK: GROUP_NAME_BLANK$b,
	GROUP_TYPE_BLANK: GROUP_TYPE_BLANK$b,
	DELETE_CONVERSATION: DELETE_CONVERSATION$b,
	ADD_TO_CHAT: ADD_TO_CHAT$b,
	MORE: MORE$b,
	COPY: COPY$b,
	VOICE_RECORDING: VOICE_RECORDING$b,
	MESSAGE_IMAGE: MESSAGE_IMAGE$b,
	MESSAGE_FILE: MESSAGE_FILE$b,
	MESSAGE_VIDEO: MESSAGE_VIDEO$b,
	MESSAGE_AUDIO: MESSAGE_AUDIO$b,
	CUSTOM_MESSAGE: CUSTOM_MESSAGE$b,
	SELECT_A_DATE: SELECT_A_DATE$b,
	TIME_ZONE: TIME_ZONE$b,
	MEETING_SCHEDULED: MEETING_SCHEDULED$b,
	SOMETHING_WRONG: SOMETHING_WRONG$b,
	MEETING_SLOT_BOOK: MEETING_SLOT_BOOK$b,
	MEETING_BOOK_NEW_SLOT: MEETING_BOOK_NEW_SLOT$b,
	MEETING_NO_SLOTS_AVAILABLE: MEETING_NO_SLOTS_AVAILABLE$b,
	MEETING_TRY_DIFFERENT_DATE: MEETING_TRY_DIFFERENT_DATE$b,
	NO_TIME_SLOTS_AVAILABLE: NO_TIME_SLOTS_AVAILABLE$b,
	SCHEDULE: SCHEDULE$b,
	MORE_TIMES: MORE_TIMES$b,
	MISSED_VOICE_CALL: MISSED_VOICE_CALL$b,
	MEET_WITH: MEET_WITH$b,
	MEETING_SCHEDULER: MEETING_SCHEDULER$b,
	MISSED_VIDEO_CALL: MISSED_VIDEO_CALL$b,
	CUSTOM_MESSAGE_POLL: CUSTOM_MESSAGE_POLL$b,
	CUSTOM_MESSAGE_STICKER: CUSTOM_MESSAGE_STICKER$b,
	CUSTOM_MESSAGE_DOCUMENT: CUSTOM_MESSAGE_DOCUMENT$b,
	CUSTOM_MESSAGE_WHITEBOARD: CUSTOM_MESSAGE_WHITEBOARD$b,
	ONLINE: ONLINE$b,
	ADMINISTRATOR: ADMINISTRATOR$b,
	ADMIN: ADMIN$b,
	MODERATOR: MODERATOR$b,
	PARTICIPANT: PARTICIPANT$b,
	PUBLIC: PUBLIC$b,
	PRIVATE: PRIVATE$b,
	PASSWORD_PROTECTED: PASSWORD_PROTECTED$b,
	PRIVACY_AND_SECURITY: PRIVACY_AND_SECURITY$b,
	PREFERENCES: PREFERENCES$b,
	MEMBERS: MEMBERS$b,
	MEMBER: MEMBER$b,
	TODAY: TODAY$b,
	YESTERDAY: YESTERDAY$b,
	SUNDAY: SUNDAY$b,
	MONDAY: MONDAY$b,
	TUESDAY: TUESDAY$b,
	WEDNESDAY: WEDNESDAY$b,
	THURSDAY: THURSDAY$b,
	FRIDAY: FRIDAY$b,
	SATURDAY: SATURDAY$b,
	TYPING: TYPING$b,
	IS_TYPING: IS_TYPING$b,
	CLOSE: CLOSE$b,
	ENTER_GROUP_NAME: ENTER_GROUP_NAME$b,
	ADD_MEMBERS: ADD_MEMBERS$b,
	SEND_MESSAGE: SEND_MESSAGE$b,
	UNBLOCK_USER: UNBLOCK_USER$b,
	BLOCK_USER: BLOCK_USER$b,
	DELETE_AND_EXIT: DELETE_AND_EXIT$b,
	LEAVE_GROUP: LEAVE_GROUP$b,
	CREATE_GROUP: CREATE_GROUP$b,
	SHARED_MEDIA: SHARED_MEDIA$b,
	SHARED_FILE: SHARED_FILE$b,
	VIDEO_CALL: VIDEO_CALL$b,
	AUDIO_CALL: AUDIO_CALL$b,
	LOADING: LOADING$b,
	REPLY: REPLY$b,
	REPLIES: REPLIES$b,
	AI: AI$b,
	SMART_REPLIES: SMART_REPLIES$b,
	CONVERSATION_STARTER: CONVERSATION_STARTER$b,
	LAUNCH: LAUNCH$b,
	SHARED_COLLABORATIVE_DOCUMENT: SHARED_COLLABORATIVE_DOCUMENT$b,
	SHARED_COLLABORATIVE_WHITEBOARD: SHARED_COLLABORATIVE_WHITEBOARD$b,
	CREATED_WHITEBOARD: CREATED_WHITEBOARD$b,
	CREATED_DOCUMENT: CREATED_DOCUMENT$b,
	PHOTOS: PHOTOS$b,
	VIDEOS: VIDEOS$b,
	DOCUMENT: DOCUMENT$b,
	YOU_DELETED_THIS_MESSAGE: YOU_DELETED_THIS_MESSAGE$b,
	THIS_MESSAGE_DELETED: THIS_MESSAGE_DELETED$b,
	MESSAGE_IS_DELETED: MESSAGE_IS_DELETED$b,
	VIEW_ON_YOUTUBE: VIEW_ON_YOUTUBE$b,
	SEARCH: SEARCH$b,
	NO_USERS_FOUND: NO_USERS_FOUND$b,
	ERROR: ERROR$b,
	NO_GROUPS_FOUND: NO_GROUPS_FOUND$b,
	NO_CHATS_FOUND: NO_CHATS_FOUND$b,
	CANT__LOAD__CHATS: CANT__LOAD__CHATS$b,
	MEDIA_MESSAGE: MEDIA_MESSAGE$b,
	INCOMING_AUDIO_CALL: INCOMING_AUDIO_CALL$b,
	INCOMING_VIDEO_CALL: INCOMING_VIDEO_CALL$b,
	DECLINE: DECLINE$b,
	ACCEPT: ACCEPT$b,
	CALL_INITIATED: CALL_INITIATED$b,
	OUTGOING_AUDIO_CALL: OUTGOING_AUDIO_CALL$b,
	OUTGOING_VIDEO_CALL: OUTGOING_VIDEO_CALL$b,
	CALL_REJECTED: CALL_REJECTED$b,
	REJECTED_CALL: REJECTED_CALL$b,
	CALL_ACCEPTED: CALL_ACCEPTED$b,
	OUTGOING_CALL: OUTGOING_CALL$b,
	INCOMING_CALL: INCOMING_CALL$b,
	MISSED_CALL: MISSED_CALL$b,
	JOINED: JOINED$b,
	LEFT_THE_CALL: LEFT_THE_CALL$b,
	UNANSWERED_AUDIO_CALL: UNANSWERED_AUDIO_CALL$b,
	UNANSWERED_VIDEO_CALL: UNANSWERED_VIDEO_CALL$b,
	CALL_ENDED: CALL_ENDED$b,
	CALL_CANCELLED: CALL_CANCELLED$b,
	CALL_BUSY: CALL_BUSY$b,
	CALLING: CALLING$b,
	ADD: ADD$b,
	NO_BANNED_MEMBERS_FOUND: NO_BANNED_MEMBERS_FOUND$b,
	BANNED_MEMBERS: BANNED_MEMBERS$b,
	NAME: NAME$b,
	SCOPE: SCOPE$b,
	UNBAN: UNBAN$b,
	SELECT_GROUP_TYPE: SELECT_GROUP_TYPE$b,
	ENTER_GROUP_PASSWORD: ENTER_GROUP_PASSWORD$b,
	CREATE: CREATE$b,
	CREATE_POLL: CREATE_POLL$b,
	QUESTION: QUESTION$b,
	ENTER_YOUR_QUESTION: ENTER_YOUR_QUESTION$b,
	OPTIONS: OPTIONS$b,
	ENTER_YOUR_OPTION: ENTER_YOUR_OPTION$b,
	ADD_NEW_OPTION: ADD_NEW_OPTION$b,
	VIEW_MEMBERS: VIEW_MEMBERS$b,
	DETAILS: DETAILS$b,
	NOTIFICATIONS: NOTIFICATIONS$b,
	OTHER: OTHER$b,
	HELP: HELP$b,
	REPORT_PROBLEM: REPORT_PROBLEM$b,
	GROUP_MEMBERS: GROUP_MEMBERS$b,
	BAN: BAN$b,
	KICK: KICK$b,
	PICK_YOUR_EMOJI: PICK_YOUR_EMOJI$b,
	PRIVATE_GROUP: PRIVATE_GROUP$b,
	PROTECTED_GROUP: PROTECTED_GROUP$b,
	VISIT: VISIT$b,
	ATTACH: ATTACH$b,
	OPEN_WHITEBOARD: OPEN_WHITEBOARD$b,
	ATTACH_FILE: ATTACH_FILE$b,
	GENERATING_REPLIES: GENERATING_REPLIES$b,
	ATTACH_VIDEO: ATTACH_VIDEO$b,
	ATTACH_AUDIO: ATTACH_AUDIO$b,
	ATTACH_IMAGE: ATTACH_IMAGE$b,
	COLLABORATE_USING_DOCUMENT: COLLABORATE_USING_DOCUMENT$b,
	COLLABORATE_USING_WHITEBOARD: COLLABORATE_USING_WHITEBOARD$b,
	SUGGEST_A_REPLY: SUGGEST_A_REPLY$b,
	GENERATING_ICEBREAKERS: GENERATING_ICEBREAKERS$b,
	EMOJI: EMOJI$b,
	NO_REPLIES_FOUND: NO_REPLIES_FOUND$b,
	ENTER_YOUR_MESSAGE_HERE: ENTER_YOUR_MESSAGE_HERE$b,
	NO_MESSAGES_FOUND: NO_MESSAGES_FOUND$b,
	THREAD: THREAD$b,
	COLLABORATIVE_DOCUMENT: COLLABORATIVE_DOCUMENT$b,
	COLLABORATIVE_WHITEBOARD: COLLABORATIVE_WHITEBOARD$b,
	ADD_REACTION: ADD_REACTION$b,
	NO_STICKERS_FOUND: NO_STICKERS_FOUND$b,
	REPLY_TO_THREAD: REPLY_TO_THREAD$b,
	REPLY_IN_THREAD: REPLY_IN_THREAD$b,
	VIEW: VIEW$b,
	DELETE_MESSAGE: DELETE_MESSAGE$b,
	EDIT_MESSAGE: EDIT_MESSAGE$b,
	OWNER: OWNER$b,
	CHANGE_SCOPE: CHANGE_SCOPE$b,
	STICKER: STICKER$b,
	LAST_ACTIVE_AT: LAST_ACTIVE_AT$b,
	VOICE_CALL: VOICE_CALL$b,
	VIEW_DETAIL: VIEW_DETAIL$b,
	VOTES: VOTES$b,
	VOTE: VOTE$b,
	NO_VOTE: NO_VOTE$b,
	REACTED: REACTED$b,
	ADDED: ADDED$b,
	SHOW_UNSAFE_CONTENT: SHOW_UNSAFE_CONTENT$b,
	REACT_TO_MESSAGE: REACT_TO_MESSAGE$b,
	UNBANNED: UNBANNED$b,
	MADE: MADE$b,
	CALL_UNANSWERED: CALL_UNANSWERED$b,
	MISSED_AUDIO_CALL: MISSED_AUDIO_CALL$b,
	ENTER_YOUR_PASSWORD: ENTER_YOUR_PASSWORD$b,
	DRAW_DOCUMENT_TOGETHER: DRAW_DOCUMENT_TOGETHER$b,
	DOCS: DOCS$b,
	NO_RECORDS_FOUND: NO_RECORDS_FOUND$b,
	LIVE_REACTION: LIVE_REACTION$b,
	SMILEY_PEOPLE: SMILEY_PEOPLE$b,
	DRAW_WHITEBOARD_TOGETHER: DRAW_WHITEBOARD_TOGETHER$b,
	ANIMALES_NATURE: ANIMALES_NATURE$b,
	FOOD_DRINK: FOOD_DRINK$b,
	OPEN_DOCUMENT: OPEN_DOCUMENT$b,
	ACTIVITY: ACTIVITY$b,
	TRAVEL_PLACES: TRAVEL_PLACES$b,
	OBJECTS: OBJECTS$b,
	SYMBOLS: SYMBOLS$b,
	FLAGS: FLAGS$b,
	SENT: SENT$b,
	SEEN: SEEN$b,
	DELIVERED: DELIVERED$b,
	READ: READ$b,
	MESSAGE_INFORMATION: MESSAGE_INFORMATION$b,
	TRANSLATE_MESSAGE: TRANSLATE_MESSAGE$b,
	TRANSLATED_MESSAGE: TRANSLATED_MESSAGE$b,
	LEFT: LEFT$b,
	KICKED: KICKED$b,
	BANNED: BANNED$b,
	NEW_MESSAGES: NEW_MESSAGES$b,
	NEW_MESSAGE: NEW_MESSAGE$b,
	JUMP: JUMP$b,
	SELECT_VIDEO_SOURCE: SELECT_VIDEO_SOURCE$b,
	SELECT_INPUT_AUDIO_SOURCE: SELECT_INPUT_AUDIO_SOURCE$b,
	SELECT_OUTPUT_AUDIO_SOURCE: SELECT_OUTPUT_AUDIO_SOURCE$b,
	INITIATED_GROUP_CALL: INITIATED_GROUP_CALL$b,
	YOU_INITIATED_GROUP_CALL: YOU_INITIATED_GROUP_CALL$b,
	IGNORE: IGNORE$b,
	ON_ANOTHER_CALL: ON_ANOTHER_CALL$b,
	CREATING: CREATING$b,
	AVATAR: AVATAR$b,
	ONGOING_CALL: ONGOING_CALL$b,
	YOU_ALREADY_ONGOING_CALL: YOU_ALREADY_ONGOING_CALL$b,
	RESIZE: RESIZE$b,
	SETTINGS: SETTINGS$b,
	ACTIONS: ACTIONS$b,
	VIEW_PROFILE: VIEW_PROFILE$b,
	SEND_MESSAGE_IN_PRIVATE: SEND_MESSAGE_IN_PRIVATE$b,
	DELETE: DELETE$b,
	DELETE_CONFIRM: DELETE_CONFIRM$b,
	CANCEL: CANCEL$b,
	LEAVE_CONFIRM: LEAVE_CONFIRM$b,
	TRANSFER_CONFIRM: TRANSFER_CONFIRM$b,
	ADDING: ADDING$b,
	TRANSFER: TRANSFER$b,
	TRANSFER_OWNERSHIP: TRANSFER_OWNERSHIP$b,
	TRANSFERRING: TRANSFERRING$b,
	YES: YES$b,
	NO: NO$b,
	ANSWER: ANSWER$b,
	ADD_ANOTHER_ANSWER: ADD_ANOTHER_ANSWER$b,
	SET_THE_ANSWERS: SET_THE_ANSWERS$b,
	TRY_AGAIN: TRY_AGAIN$b,
	INVALID_GROUP_NAME: INVALID_GROUP_NAME$b,
	INVALID_PASSWORD: INVALID_PASSWORD$b,
	INVALID_GROUP_TYPE: INVALID_GROUP_TYPE$b,
	WRONG_PASSWORD: WRONG_PASSWORD$b,
	INVALID_POLL_QUESTION: INVALID_POLL_QUESTION$b,
	INVALID_POLL_OPTION: INVALID_POLL_OPTION$b,
	SAME_LANGUAGE_MESSAGE: SAME_LANGUAGE_MESSAGE$b,
	LEAVE: LEAVE$b,
	CLICK_TO_START_CONVERSATION: CLICK_TO_START_CONVERSATION$b,
	CUSTOM_MESSAGE_LOCATION: CUSTOM_MESSAGE_LOCATION$b,
	SHARED_LOCATION: SHARED_LOCATION$b,
	IN_A_THREAD: IN_A_THREAD$b,
	CALLS: CALLS$b,
	CALL_DETAILS: CALL_DETAILS$b,
	OFFLINE: OFFLINE$b,
	POLLS: POLLS$b,
	YOU: YOU$b,
	PRIVACY: PRIVACY$b,
	BLOCKED_USERS: BLOCKED_USERS$b,
	"YOU'VE_BLOCKED": "You've blocked",
	NO_PHOTOS: NO_PHOTOS$b,
	NO_VIDEOS: NO_VIDEOS$b,
	NO_DOCUMENTS: NO_DOCUMENTS$b,
	JOIN: JOIN$b,
	REMOVE: REMOVE$b,
	BLOCK: BLOCK$b,
	CHANGE_ROLE: CHANGE_ROLE$b,
	NEW_CHAT: NEW_CHAT$b,
	FORM_COMPLETION_MESSAGE: FORM_COMPLETION_MESSAGE$b,
	HISTORY: HISTORY$b,
	CANCELLED_AUDIO_CALL: CANCELLED_AUDIO_CALL$b,
	CANCELLED_VIDEO_CALL: CANCELLED_VIDEO_CALL$b,
	REJECTED_AUDIO_CALL: REJECTED_AUDIO_CALL$b,
	REJECTED_VIDEO_CALL: REJECTED_VIDEO_CALL$b,
	CANCELLED_CALL: CANCELLED_CALL$b,
	UNANSWERED_CALL: UNANSWERED_CALL$b,
	RECORDING: RECORDING$b,
	PARTICIPANTS: PARTICIPANTS$b,
	CALL_HISTORY: CALL_HISTORY$b,
	NO_CALLS_FOUND: NO_CALLS_FOUND$b,
	ONGOING_AUDIO_CALL: ONGOING_AUDIO_CALL$b,
	ONGOING_VIDEO_CALL: ONGOING_VIDEO_CALL$b,
	CALL_DETAIL: CALL_DETAIL$b,
	FORM: FORM$b,
	CARD: CARD$b,
	GENERATING_SUMMARY: GENERATING_SUMMARY$b,
	CONVERSATION_SUMMARY: CONVERSATION_SUMMARY$b,
	GENERATE_SUMMARY: GENERATE_SUMMARY$b,
	COMETCHAT_BOT_FIRST_MESSAGE: COMETCHAT_BOT_FIRST_MESSAGE$b,
	COMETCHAT_ASK_BOT: COMETCHAT_ASK_BOT$b,
	COMETCHAT_ASK_AI_BOT: COMETCHAT_ASK_AI_BOT$b,
	COMETCHAT_ASK_BOT_SUBTITLE: COMETCHAT_ASK_BOT_SUBTITLE$b,
	MENTIONS_LIMIT_WARNING_MESSAGE: MENTIONS_LIMIT_WARNING_MESSAGE$b,
	ALL: ALL$b,
	CLICK_TO_REMOVE: CLICK_TO_REMOVE$b,
	OTHERS: OTHERS$b,
	AND: AND$b
};

var INFO$a = "Información";
var REACT$a = "Reacciona";
var EDIT$a = "Editar";
var MESSAGE_PRIVATELY$a = "Mensaje privado";
var TRANSLATE$a = "Traducir";
var USERS$a = "Usuarios";
var CHATS$a = "Charlas";
var WOULD__YOU_LIKE_TO_DELETE_THIS_CONVERSATION$a = "¿Quieres eliminar esta conversación? Esta conversación se eliminará de todos tus dispositivos.";
var GROUPS$a = "Grupos";
var SHARED$a = "Compartido";
var SOUND_MANAGER$a = "Gestor de sonido";
var THEME$a = "Tema";
var LOCALIZE$a = "Localizar";
var CONVERSATION_LIST_ITEM$a = "Elemento de la lista de conversaciones";
var DATA_ITEM$a = "Elemento de datos";
var STATUS_INDICATOR$a = "Indicador de estado";
var BADGE_COUNT$a = "Recuento de distintivos";
var MESSAGE_RECEIPT$a = "Recepción del mensaje";
var MESSAGE$a = "Mensaje";
var RECEIPT_INFORMATION$a = "Información de recibo";
var NO_RECIPIENT$a = "Sin destinatario";
var NO_RECIPIENTS$a = "Sin destinatarios";
var CONVERSATIONS_WITH_MESSAGES$a = "Conversaciones con mensajes";
var CONVERSATIONS$a = "Conversaciones";
var CONVERSATION_LIST$a = "Lista de conversaciones";
var MESSAGES$a = "Mensajes";
var MESSAGE_HEADER$a = "Encabezado del mensaje";
var MESSAGE_LIST$a = "Lista de mensajes";
var MESSAGE_COMPOSER$a = "Compositor de mensajes";
var USERS_WITH_MESSAGES$a = "Usuarios con mensajes";
var USER_LIST$a = "Lista de usuarios";
var GROUP_LIST$a = "Lista de grupos";
var GROUPS_WITH_MESSAGES$a = "Grupos con mensajes";
var NEW__GROUP$a = "Nuevo grupo";
var PASSWORD$a = "Contraseña";
var CONTINUE$a = "Continuar";
var NO_CHATS_SELECTED$a = "No se ha seleccionado ningún chat";
var NO_USERS_SELECTED$a = "No se ha seleccionado ningún usuario";
var NO_GROUPS_SELECTED$a = "No se ha seleccionado ningún grupo";
var SELECT_DAY$a = "Selecciona un día";
var SELECT_TIME$a = "Selecciona una hora";
var NO_CALLS_SELECTED$a = "No se ha seleccionado ninguna llamada";
var SELECT__GROUP$a = "Selecciona un grupo para empezar a enviar mensajes";
var SELECT__USER$a = "Seleccione un usuario para iniciar la mensajería";
var GROUP_PASSWORD_BLANK$a = "La contraseña del grupo no puede estar en blanco";
var GROUP_NAME_BLANK$a = "El nombre del grupo no puede estar en blanco";
var GROUP_TYPE_BLANK$a = "El tipo de grupo no puede estar en blanco";
var DELETE_CONVERSATION$a = "¿Eliminar conversación?";
var ADD_TO_CHAT$a = "Añadir al chat";
var MORE$a = "Más";
var COPY$a = "Copiar";
var VOICE_RECORDING$a = "Grabación de voz";
var MESSAGE_IMAGE$a = "📷 Imagen";
var MESSAGE_FILE$a = "📁 Archivo";
var MESSAGE_VIDEO$a = "📹 Vídeo";
var MESSAGE_AUDIO$a = "🎵 Audio";
var CUSTOM_MESSAGE$a = "Tienes un mensaje";
var SELECT_A_DATE$a = "Selecciona una fecha";
var TIME_ZONE$a = "Zona horaria";
var MEETING_SCHEDULED$a = "Se ha programado su reunión.";
var SOMETHING_WRONG$a = "Algo salió mal. Por favor, inténtelo de nuevo.";
var MEETING_SLOT_BOOK$a = "La franja horaria ya no está disponible. Por favor, elige otro.";
var MEETING_BOOK_NEW_SLOT$a = "Reserva un nuevo espacio";
var MEETING_NO_SLOTS_AVAILABLE$a = "No hay franjas horarias disponibles para esta fecha. Por favor, prueba con otra fecha.";
var MEETING_TRY_DIFFERENT_DATE$a = "Por favor, prueba con una fecha diferente.";
var NO_TIME_SLOTS_AVAILABLE$a = "No hay franjas horarias disponibles";
var SCHEDULE$a = "Programar";
var MORE_TIMES$a = "Más veces";
var MISSED_VOICE_CALL$a = "Llamada de voz perdida";
var MEET_WITH$a = "Reúnase con";
var MEETING_SCHEDULER$a = "Programador de reuniones";
var MISSED_VIDEO_CALL$a = "Videollamada perdida";
var CUSTOM_MESSAGE_POLL$a = "📊 Encuesta";
var CUSTOM_MESSAGE_STICKER$a = "💟 Pegatina";
var CUSTOM_MESSAGE_DOCUMENT$a = "📃 Documento";
var CUSTOM_MESSAGE_WHITEBOARD$a = "📝 Pizarra";
var ONLINE$a = "En línea";
var ADMINISTRATOR$a = "Administrador";
var ADMIN$a = "Administrador";
var MODERATOR$a = "presentador";
var PARTICIPANT$a = "Participante";
var PUBLIC$a = "Público";
var PRIVATE$a = "Privada";
var PASSWORD_PROTECTED$a = "Protegido con contraseña";
var PRIVACY_AND_SECURITY$a = "Privacidad y seguridad";
var PREFERENCES$a = "Preferencias";
var MEMBERS$a = "Miembros";
var MEMBER$a = "Miembro";
var TODAY$a = "Hoy";
var YESTERDAY$a = "Ayer";
var SUNDAY$a = "domingo";
var MONDAY$a = "lunes";
var TUESDAY$a = "martes";
var WEDNESDAY$a = "miércoles";
var THURSDAY$a = "jueves";
var FRIDAY$a = "viernes";
var SATURDAY$a = "sábado";
var TYPING$a = "escribiendo...";
var IS_TYPING$a = "está escribiendo...";
var CLOSE$a = "Cerrar";
var ENTER_GROUP_NAME$a = "Introduzca el nombre del grupo";
var ADD_MEMBERS$a = "Agregar miembros";
var SEND_MESSAGE$a = "Enviar mensaje";
var UNBLOCK_USER$a = "Desbloquear usuario";
var BLOCK_USER$a = "Bloquear usuario";
var DELETE_AND_EXIT$a = "Eliminar y salir";
var LEAVE_GROUP$a = "Salir del grupo";
var CREATE_GROUP$a = "Crear grupo";
var SHARED_MEDIA$a = "Medios compartidos";
var SHARED_FILE$a = "Archivo compartido";
var VIDEO_CALL$a = "Videollamada";
var AUDIO_CALL$a = "Llamada de audio";
var LOADING$a = "Cargando...";
var REPLY$a = "respuesta";
var REPLIES$a = "respuestas";
var AI$a = "I.A.";
var SMART_REPLIES$a = "Respuestas inteligentes";
var CONVERSATION_STARTER$a = "Iniciador de conversación";
var LAUNCH$a = "Lanzar";
var SHARED_COLLABORATIVE_DOCUMENT$a = "ha compartido un documento colaborativo";
var SHARED_COLLABORATIVE_WHITEBOARD$a = "ha compartido una pizarra colaborativa";
var CREATED_WHITEBOARD$a = "Ha creado una nueva pizarra colaborativa";
var CREATED_DOCUMENT$a = "Has creado un nuevo documento colaborativo";
var PHOTOS$a = "Fotos";
var VIDEOS$a = "Vídeos";
var DOCUMENT$a = "Documento";
var YOU_DELETED_THIS_MESSAGE$a = "⚠️ Has eliminado este mensaje";
var THIS_MESSAGE_DELETED$a = "⚠️ Este mensaje se ha eliminado";
var MESSAGE_IS_DELETED$a = "El mensaje se ha eliminado";
var VIEW_ON_YOUTUBE$a = "Ver en Youtube";
var SEARCH$a = "Búsqueda";
var NO_USERS_FOUND$a = "No se ha encontrado ningún usuario";
var ERROR$a = "Error";
var NO_GROUPS_FOUND$a = "No se ha encontrado ningún grupo";
var NO_CHATS_FOUND$a = "No se han encontrado chats";
var CANT__LOAD__CHATS$a = "No se pueden cargar los chats";
var MEDIA_MESSAGE$a = "Mensaje para los medios";
var INCOMING_AUDIO_CALL$a = "Llamada de audio entrante";
var INCOMING_VIDEO_CALL$a = "Videollamada entrante";
var DECLINE$a = "Declinación";
var ACCEPT$a = "Aceptar";
var CALL_INITIATED$a = "Llamada iniciada";
var OUTGOING_AUDIO_CALL$a = "Llamada de audio saliente";
var OUTGOING_VIDEO_CALL$a = "Videollamada saliente";
var CALL_REJECTED$a = "Llamada rechazada";
var REJECTED_CALL$a = "llamada rechazada";
var CALL_ACCEPTED$a = "Llamada aceptada";
var OUTGOING_CALL$a = "Llamada saliente";
var INCOMING_CALL$a = "Llamada entrante";
var MISSED_CALL$a = "Llamada perdida";
var JOINED$a = "se unió";
var LEFT_THE_CALL$a = "dejó la llamada";
var UNANSWERED_AUDIO_CALL$a = "Llamada de audio sin respuesta";
var UNANSWERED_VIDEO_CALL$a = "Videollamada sin respuesta";
var CALL_ENDED$a = "Llamada finalizada";
var CALL_CANCELLED$a = "Llamada cancelada";
var CALL_BUSY$a = "Llamada ocupada";
var CALLING$a = "Llamando...";
var ADD$a = "Añadir";
var NO_BANNED_MEMBERS_FOUND$a = "No se ha encontrado ningún miembro prohibido";
var BANNED_MEMBERS$a = "Miembros prohibidos";
var NAME$a = "Nombre";
var SCOPE$a = "Alcance";
var UNBAN$a = "Unban";
var SELECT_GROUP_TYPE$a = "Seleccione el tipo de grupo";
var ENTER_GROUP_PASSWORD$a = "Ingresa la contraseña del grupo";
var CREATE$a = "Crear";
var CREATE_POLL$a = "Crear encuesta";
var QUESTION$a = "Pregunta";
var ENTER_YOUR_QUESTION$a = "Ingresa tu pregunta";
var OPTIONS$a = "Opciones";
var ENTER_YOUR_OPTION$a = "Ingresa tu opción";
var ADD_NEW_OPTION$a = "Añadir nueva opción";
var VIEW_MEMBERS$a = "Ver miembros";
var DETAILS$a = "Detalles";
var NOTIFICATIONS$a = "Notificaciones";
var OTHER$a = "Otros";
var HELP$a = "Ayuda";
var REPORT_PROBLEM$a = "Reportar un problema";
var GROUP_MEMBERS$a = "Miembros del grupo";
var BAN$a = "Prohibir";
var KICK$a = "Patada";
var PICK_YOUR_EMOJI$a = "Elige tu emoji";
var PRIVATE_GROUP$a = "Grupo privado";
var PROTECTED_GROUP$a = "Grupo protegido";
var VISIT$a = "Visita";
var ATTACH$a = "Adjuntar";
var OPEN_WHITEBOARD$a = "Pizarra abierta";
var ATTACH_FILE$a = "Adjuntar archivo";
var GENERATING_REPLIES$a = "Generar respuestas";
var ATTACH_VIDEO$a = "Adjuntar vídeo";
var ATTACH_AUDIO$a = "Adjuntar audio";
var ATTACH_IMAGE$a = "Adjuntar imagen";
var COLLABORATE_USING_DOCUMENT$a = "Colabore mediante un documento";
var COLLABORATE_USING_WHITEBOARD$a = "Colabore mediante una pizarra";
var SUGGEST_A_REPLY$a = "Sugerir una respuesta";
var GENERATING_ICEBREAKERS$a = "Generando rompehielos";
var EMOJI$a = "Emoji";
var NO_REPLIES_FOUND$a = "No se han encontrado respuestas";
var ENTER_YOUR_MESSAGE_HERE$a = "Introduce tu mensaje aquí";
var NO_MESSAGES_FOUND$a = "No se ha encontrado ningún mensaje";
var THREAD$a = "Hilo";
var COLLABORATIVE_DOCUMENT$a = "Documento colaborativo";
var COLLABORATIVE_WHITEBOARD$a = "Pizarra colaborativa";
var ADD_REACTION$a = "Añadir reacción";
var NO_STICKERS_FOUND$a = "No se han encontrado pegatinas";
var REPLY_TO_THREAD$a = "Responder al hilo";
var REPLY_IN_THREAD$a = "Responder en hilo";
var VIEW$a = "Ver";
var DELETE_MESSAGE$a = "Eliminar mensaje";
var EDIT_MESSAGE$a = "Editar mensaje";
var OWNER$a = "Dueño";
var CHANGE_SCOPE$a = "Cambiar ámbito";
var STICKER$a = "Adhesivo";
var LAST_ACTIVE_AT$a = "Último día activo";
var VOICE_CALL$a = "Llamada de voz";
var VIEW_DETAIL$a = "Ver detalle";
var VOTES$a = "vota";
var VOTE$a = "votar";
var NO_VOTE$a = "Sin voto";
var REACTED$a = "reaccionó";
var ADDED$a = "adicional";
var SHOW_UNSAFE_CONTENT$a = "¿Estás seguro de que quieres ver contenido no seguro?";
var REACT_TO_MESSAGE$a = "Reaccionar a un mensaje";
var UNBANNED$a = "no prohibido";
var MADE$a = "hecho";
var CALL_UNANSWERED$a = "Llamada sin respuesta";
var MISSED_AUDIO_CALL$a = "Llamada de audio perdida";
var ENTER_YOUR_PASSWORD$a = "Introduce tu contraseña";
var DRAW_DOCUMENT_TOGETHER$a = "Abra el documento para editar el contenido de forma conjunta";
var DOCS$a = "Documentos";
var NO_RECORDS_FOUND$a = "No se ha encontrado ningún registro";
var LIVE_REACTION$a = "Reacción en vivo";
var SMILEY_PEOPLE$a = "Sonrisas y personas";
var DRAW_WHITEBOARD_TOGETHER$a = "Abra la pizarra para dibujar juntos";
var ANIMALES_NATURE$a = "Animales y naturaleza";
var FOOD_DRINK$a = "Comida y bebida";
var OPEN_DOCUMENT$a = "Abrir documento";
var ACTIVITY$a = "Actividad";
var TRAVEL_PLACES$a = "Viajes y lugares";
var OBJECTS$a = "Objetos";
var SYMBOLS$a = "Símbolos";
var FLAGS$a = "Banderas";
var SENT$a = "Enviado";
var SEEN$a = "Visto";
var DELIVERED$a = "Entregado";
var READ$a = "Leer";
var MESSAGE_INFORMATION$a = "Información del mensaje";
var TRANSLATE_MESSAGE$a = "Traducir mensaje";
var TRANSLATED_MESSAGE$a = "Mensaje traducido";
var LEFT$a = "izquierda";
var KICKED$a = "pateado";
var BANNED$a = "prohibido";
var NEW_MESSAGES$a = "mensajes nuevos";
var NEW_MESSAGE$a = "mensaje nuevo";
var JUMP$a = "Salta";
var SELECT_VIDEO_SOURCE$a = "Seleccione la fuente de vídeo";
var SELECT_INPUT_AUDIO_SOURCE$a = "Seleccione la fuente de audio de entrada";
var SELECT_OUTPUT_AUDIO_SOURCE$a = "Seleccione la fuente de audio de salida";
var INITIATED_GROUP_CALL$a = "ha iniciado una llamada grupal";
var YOU_INITIATED_GROUP_CALL$a = "Has iniciado una llamada grupal";
var IGNORE$a = "Ignorar";
var ON_ANOTHER_CALL$a = "está en otra llamada";
var CREATING$a = "Creando";
var AVATAR$a = "Avatar";
var ONGOING_CALL$a = "Convocatoria en curso";
var YOU_ALREADY_ONGOING_CALL$a = "Ya estás en una llamada en curso";
var RESIZE$a = "Redimensionar";
var SETTINGS$a = "Ajustes";
var ACTIONS$a = "Acciones";
var VIEW_PROFILE$a = "Ver perfil";
var SEND_MESSAGE_IN_PRIVATE$a = "Enviar mensaje de forma privada";
var DELETE$a = "Borrar";
var DELETE_CONFIRM$a = "¿Estás seguro de que quieres eliminarlo?";
var CANCEL$a = "Cancelar";
var LEAVE_CONFIRM$a = "¿Estás seguro de que quieres dejar el grupo?";
var TRANSFER_CONFIRM$a = "Eres el propietario del grupo; transfiere la propiedad a un miembro antes de abandonar el grupo";
var ADDING$a = "Agregando...";
var TRANSFER$a = "Traslado";
var TRANSFER_OWNERSHIP$a = "Transferir la propiedad";
var TRANSFERRING$a = "Transferir";
var YES$a = "Sí";
var NO$a = "No";
var ANSWER$a = "Responder";
var ADD_ANOTHER_ANSWER$a = "Añadir otra respuesta";
var SET_THE_ANSWERS$a = "ESTABLECE LAS RESPUESTAS";
var TRY_AGAIN$a = "Inténtalo de nuevo";
var INVALID_GROUP_NAME$a = "Introduce un nombre válido para el grupo e inténtalo de nuevo";
var INVALID_PASSWORD$a = "Introduce una contraseña válida para el grupo e inténtalo de nuevo";
var INVALID_GROUP_TYPE$a = "Introduce un tipo válido para el grupo e inténtalo de nuevo";
var WRONG_PASSWORD$a = "Introduce la contraseña correcta e inténtalo de nuevo";
var INVALID_POLL_QUESTION$a = "Introduce la pregunta requerida antes de crear una encuesta";
var INVALID_POLL_OPTION$a = "Ingresa la respuesta requerida antes de crear una encuesta";
var SAME_LANGUAGE_MESSAGE$a = "El idioma seleccionado para la traducción es similar al idioma del mensaje original";
var LEAVE$a = "Salir";
var CLICK_TO_START_CONVERSATION$a = "Haga clic para iniciar la conversación";
var CUSTOM_MESSAGE_LOCATION$a = "📍 Ubicación";
var SHARED_LOCATION$a = "Ubicación compartida";
var IN_A_THREAD$a = "En un hilo";
var CALLS$a = "Convocatorias";
var CALL_DETAILS$a = "Detalles de la llamada";
var OFFLINE$a = "Fuera de línea";
var POLLS$a = "Encuestas";
var YOU$a = "Tú";
var PRIVACY$a = "Privacidad";
var BLOCKED_USERS$a = "Usuarios bloqueados";
var NO_PHOTOS$a = "No hay fotos";
var NO_VIDEOS$a = "No hay vídeos";
var NO_DOCUMENTS$a = "Sin documentos";
var JOIN$a = "Únete";
var REMOVE$a = "Eliminar";
var BLOCK$a = "Bloquear";
var CHANGE_ROLE$a = "Cambiar rol";
var NEW_CHAT$a = "Nuevo chat";
var FORM_COMPLETION_MESSAGE$a = "Gracias por rellenar el formulario.";
var HISTORY$a = "Historia";
var CANCELLED_AUDIO_CALL$a = "Llamada de audio cancelada";
var CANCELLED_VIDEO_CALL$a = "Videollamada cancelada";
var REJECTED_AUDIO_CALL$a = "Llamada de audio rechazada";
var REJECTED_VIDEO_CALL$a = "Videollamada rechazada";
var CANCELLED_CALL$a = "Llamada cancelada";
var UNANSWERED_CALL$a = "Llamada sin respuesta";
var RECORDING$a = "Grabación";
var PARTICIPANTS$a = "Participantes";
var CALL_HISTORY$a = "Historial de llamadas";
var NO_CALLS_FOUND$a = "No se han encontrado llamadas";
var ONGOING_AUDIO_CALL$a = "Llamada de audio en curso";
var ONGOING_VIDEO_CALL$a = "Videollamada en curso";
var CALL_DETAIL$a = "Detalle de la llamada";
var FORM$a = "Formulario";
var CARD$a = "Tarjeta";
var GENERATING_SUMMARY$a = "Generando un resumen";
var CONVERSATION_SUMMARY$a = "Resumen de la conversación";
var GENERATE_SUMMARY$a = "Generar un resumen";
var COMETCHAT_BOT_FIRST_MESSAGE$a = "¿Cómo puedo ayudarlo con esta conversación? Por favor, hazme una pregunta y te asesoraré 🙂";
var COMETCHAT_ASK_BOT$a = "Preguntar";
var COMETCHAT_ASK_AI_BOT$a = "Pregúntale a los bots de IA";
var COMETCHAT_ASK_BOT_SUBTITLE$a = "Bot de IA";
var MENTIONS_LIMIT_WARNING_MESSAGE$a = "Puedes mencionar hasta 10 veces a la vez.";
var ALL$a = "Todas";
var CLICK_TO_REMOVE$a = "Haga clic para eliminar";
var OTHERS$a = "otros";
var AND$a = "un";
var translationES = {
	INFO: INFO$a,
	REACT: REACT$a,
	EDIT: EDIT$a,
	MESSAGE_PRIVATELY: MESSAGE_PRIVATELY$a,
	TRANSLATE: TRANSLATE$a,
	USERS: USERS$a,
	CHATS: CHATS$a,
	WOULD__YOU_LIKE_TO_DELETE_THIS_CONVERSATION: WOULD__YOU_LIKE_TO_DELETE_THIS_CONVERSATION$a,
	GROUPS: GROUPS$a,
	SHARED: SHARED$a,
	SOUND_MANAGER: SOUND_MANAGER$a,
	THEME: THEME$a,
	LOCALIZE: LOCALIZE$a,
	CONVERSATION_LIST_ITEM: CONVERSATION_LIST_ITEM$a,
	DATA_ITEM: DATA_ITEM$a,
	STATUS_INDICATOR: STATUS_INDICATOR$a,
	BADGE_COUNT: BADGE_COUNT$a,
	MESSAGE_RECEIPT: MESSAGE_RECEIPT$a,
	MESSAGE: MESSAGE$a,
	RECEIPT_INFORMATION: RECEIPT_INFORMATION$a,
	NO_RECIPIENT: NO_RECIPIENT$a,
	NO_RECIPIENTS: NO_RECIPIENTS$a,
	CONVERSATIONS_WITH_MESSAGES: CONVERSATIONS_WITH_MESSAGES$a,
	CONVERSATIONS: CONVERSATIONS$a,
	CONVERSATION_LIST: CONVERSATION_LIST$a,
	MESSAGES: MESSAGES$a,
	MESSAGE_HEADER: MESSAGE_HEADER$a,
	MESSAGE_LIST: MESSAGE_LIST$a,
	MESSAGE_COMPOSER: MESSAGE_COMPOSER$a,
	USERS_WITH_MESSAGES: USERS_WITH_MESSAGES$a,
	USER_LIST: USER_LIST$a,
	GROUP_LIST: GROUP_LIST$a,
	GROUPS_WITH_MESSAGES: GROUPS_WITH_MESSAGES$a,
	NEW__GROUP: NEW__GROUP$a,
	PASSWORD: PASSWORD$a,
	CONTINUE: CONTINUE$a,
	NO_CHATS_SELECTED: NO_CHATS_SELECTED$a,
	NO_USERS_SELECTED: NO_USERS_SELECTED$a,
	NO_GROUPS_SELECTED: NO_GROUPS_SELECTED$a,
	SELECT_DAY: SELECT_DAY$a,
	SELECT_TIME: SELECT_TIME$a,
	NO_CALLS_SELECTED: NO_CALLS_SELECTED$a,
	SELECT__GROUP: SELECT__GROUP$a,
	SELECT__USER: SELECT__USER$a,
	GROUP_PASSWORD_BLANK: GROUP_PASSWORD_BLANK$a,
	GROUP_NAME_BLANK: GROUP_NAME_BLANK$a,
	GROUP_TYPE_BLANK: GROUP_TYPE_BLANK$a,
	DELETE_CONVERSATION: DELETE_CONVERSATION$a,
	ADD_TO_CHAT: ADD_TO_CHAT$a,
	MORE: MORE$a,
	COPY: COPY$a,
	VOICE_RECORDING: VOICE_RECORDING$a,
	MESSAGE_IMAGE: MESSAGE_IMAGE$a,
	MESSAGE_FILE: MESSAGE_FILE$a,
	MESSAGE_VIDEO: MESSAGE_VIDEO$a,
	MESSAGE_AUDIO: MESSAGE_AUDIO$a,
	CUSTOM_MESSAGE: CUSTOM_MESSAGE$a,
	SELECT_A_DATE: SELECT_A_DATE$a,
	TIME_ZONE: TIME_ZONE$a,
	MEETING_SCHEDULED: MEETING_SCHEDULED$a,
	SOMETHING_WRONG: SOMETHING_WRONG$a,
	MEETING_SLOT_BOOK: MEETING_SLOT_BOOK$a,
	MEETING_BOOK_NEW_SLOT: MEETING_BOOK_NEW_SLOT$a,
	MEETING_NO_SLOTS_AVAILABLE: MEETING_NO_SLOTS_AVAILABLE$a,
	MEETING_TRY_DIFFERENT_DATE: MEETING_TRY_DIFFERENT_DATE$a,
	NO_TIME_SLOTS_AVAILABLE: NO_TIME_SLOTS_AVAILABLE$a,
	SCHEDULE: SCHEDULE$a,
	MORE_TIMES: MORE_TIMES$a,
	MISSED_VOICE_CALL: MISSED_VOICE_CALL$a,
	MEET_WITH: MEET_WITH$a,
	MEETING_SCHEDULER: MEETING_SCHEDULER$a,
	MISSED_VIDEO_CALL: MISSED_VIDEO_CALL$a,
	CUSTOM_MESSAGE_POLL: CUSTOM_MESSAGE_POLL$a,
	CUSTOM_MESSAGE_STICKER: CUSTOM_MESSAGE_STICKER$a,
	CUSTOM_MESSAGE_DOCUMENT: CUSTOM_MESSAGE_DOCUMENT$a,
	CUSTOM_MESSAGE_WHITEBOARD: CUSTOM_MESSAGE_WHITEBOARD$a,
	ONLINE: ONLINE$a,
	ADMINISTRATOR: ADMINISTRATOR$a,
	ADMIN: ADMIN$a,
	MODERATOR: MODERATOR$a,
	PARTICIPANT: PARTICIPANT$a,
	PUBLIC: PUBLIC$a,
	PRIVATE: PRIVATE$a,
	PASSWORD_PROTECTED: PASSWORD_PROTECTED$a,
	PRIVACY_AND_SECURITY: PRIVACY_AND_SECURITY$a,
	PREFERENCES: PREFERENCES$a,
	MEMBERS: MEMBERS$a,
	MEMBER: MEMBER$a,
	TODAY: TODAY$a,
	YESTERDAY: YESTERDAY$a,
	SUNDAY: SUNDAY$a,
	MONDAY: MONDAY$a,
	TUESDAY: TUESDAY$a,
	WEDNESDAY: WEDNESDAY$a,
	THURSDAY: THURSDAY$a,
	FRIDAY: FRIDAY$a,
	SATURDAY: SATURDAY$a,
	TYPING: TYPING$a,
	IS_TYPING: IS_TYPING$a,
	CLOSE: CLOSE$a,
	ENTER_GROUP_NAME: ENTER_GROUP_NAME$a,
	ADD_MEMBERS: ADD_MEMBERS$a,
	SEND_MESSAGE: SEND_MESSAGE$a,
	UNBLOCK_USER: UNBLOCK_USER$a,
	BLOCK_USER: BLOCK_USER$a,
	DELETE_AND_EXIT: DELETE_AND_EXIT$a,
	LEAVE_GROUP: LEAVE_GROUP$a,
	CREATE_GROUP: CREATE_GROUP$a,
	SHARED_MEDIA: SHARED_MEDIA$a,
	SHARED_FILE: SHARED_FILE$a,
	VIDEO_CALL: VIDEO_CALL$a,
	AUDIO_CALL: AUDIO_CALL$a,
	LOADING: LOADING$a,
	REPLY: REPLY$a,
	REPLIES: REPLIES$a,
	AI: AI$a,
	SMART_REPLIES: SMART_REPLIES$a,
	CONVERSATION_STARTER: CONVERSATION_STARTER$a,
	LAUNCH: LAUNCH$a,
	SHARED_COLLABORATIVE_DOCUMENT: SHARED_COLLABORATIVE_DOCUMENT$a,
	SHARED_COLLABORATIVE_WHITEBOARD: SHARED_COLLABORATIVE_WHITEBOARD$a,
	CREATED_WHITEBOARD: CREATED_WHITEBOARD$a,
	CREATED_DOCUMENT: CREATED_DOCUMENT$a,
	PHOTOS: PHOTOS$a,
	VIDEOS: VIDEOS$a,
	DOCUMENT: DOCUMENT$a,
	YOU_DELETED_THIS_MESSAGE: YOU_DELETED_THIS_MESSAGE$a,
	THIS_MESSAGE_DELETED: THIS_MESSAGE_DELETED$a,
	MESSAGE_IS_DELETED: MESSAGE_IS_DELETED$a,
	VIEW_ON_YOUTUBE: VIEW_ON_YOUTUBE$a,
	SEARCH: SEARCH$a,
	NO_USERS_FOUND: NO_USERS_FOUND$a,
	ERROR: ERROR$a,
	NO_GROUPS_FOUND: NO_GROUPS_FOUND$a,
	NO_CHATS_FOUND: NO_CHATS_FOUND$a,
	CANT__LOAD__CHATS: CANT__LOAD__CHATS$a,
	MEDIA_MESSAGE: MEDIA_MESSAGE$a,
	INCOMING_AUDIO_CALL: INCOMING_AUDIO_CALL$a,
	INCOMING_VIDEO_CALL: INCOMING_VIDEO_CALL$a,
	DECLINE: DECLINE$a,
	ACCEPT: ACCEPT$a,
	CALL_INITIATED: CALL_INITIATED$a,
	OUTGOING_AUDIO_CALL: OUTGOING_AUDIO_CALL$a,
	OUTGOING_VIDEO_CALL: OUTGOING_VIDEO_CALL$a,
	CALL_REJECTED: CALL_REJECTED$a,
	REJECTED_CALL: REJECTED_CALL$a,
	CALL_ACCEPTED: CALL_ACCEPTED$a,
	OUTGOING_CALL: OUTGOING_CALL$a,
	INCOMING_CALL: INCOMING_CALL$a,
	MISSED_CALL: MISSED_CALL$a,
	JOINED: JOINED$a,
	LEFT_THE_CALL: LEFT_THE_CALL$a,
	UNANSWERED_AUDIO_CALL: UNANSWERED_AUDIO_CALL$a,
	UNANSWERED_VIDEO_CALL: UNANSWERED_VIDEO_CALL$a,
	CALL_ENDED: CALL_ENDED$a,
	CALL_CANCELLED: CALL_CANCELLED$a,
	CALL_BUSY: CALL_BUSY$a,
	CALLING: CALLING$a,
	ADD: ADD$a,
	NO_BANNED_MEMBERS_FOUND: NO_BANNED_MEMBERS_FOUND$a,
	BANNED_MEMBERS: BANNED_MEMBERS$a,
	NAME: NAME$a,
	SCOPE: SCOPE$a,
	UNBAN: UNBAN$a,
	SELECT_GROUP_TYPE: SELECT_GROUP_TYPE$a,
	ENTER_GROUP_PASSWORD: ENTER_GROUP_PASSWORD$a,
	CREATE: CREATE$a,
	CREATE_POLL: CREATE_POLL$a,
	QUESTION: QUESTION$a,
	ENTER_YOUR_QUESTION: ENTER_YOUR_QUESTION$a,
	OPTIONS: OPTIONS$a,
	ENTER_YOUR_OPTION: ENTER_YOUR_OPTION$a,
	ADD_NEW_OPTION: ADD_NEW_OPTION$a,
	VIEW_MEMBERS: VIEW_MEMBERS$a,
	DETAILS: DETAILS$a,
	NOTIFICATIONS: NOTIFICATIONS$a,
	OTHER: OTHER$a,
	HELP: HELP$a,
	REPORT_PROBLEM: REPORT_PROBLEM$a,
	GROUP_MEMBERS: GROUP_MEMBERS$a,
	BAN: BAN$a,
	KICK: KICK$a,
	PICK_YOUR_EMOJI: PICK_YOUR_EMOJI$a,
	PRIVATE_GROUP: PRIVATE_GROUP$a,
	PROTECTED_GROUP: PROTECTED_GROUP$a,
	VISIT: VISIT$a,
	ATTACH: ATTACH$a,
	OPEN_WHITEBOARD: OPEN_WHITEBOARD$a,
	ATTACH_FILE: ATTACH_FILE$a,
	GENERATING_REPLIES: GENERATING_REPLIES$a,
	ATTACH_VIDEO: ATTACH_VIDEO$a,
	ATTACH_AUDIO: ATTACH_AUDIO$a,
	ATTACH_IMAGE: ATTACH_IMAGE$a,
	COLLABORATE_USING_DOCUMENT: COLLABORATE_USING_DOCUMENT$a,
	COLLABORATE_USING_WHITEBOARD: COLLABORATE_USING_WHITEBOARD$a,
	SUGGEST_A_REPLY: SUGGEST_A_REPLY$a,
	GENERATING_ICEBREAKERS: GENERATING_ICEBREAKERS$a,
	EMOJI: EMOJI$a,
	NO_REPLIES_FOUND: NO_REPLIES_FOUND$a,
	ENTER_YOUR_MESSAGE_HERE: ENTER_YOUR_MESSAGE_HERE$a,
	NO_MESSAGES_FOUND: NO_MESSAGES_FOUND$a,
	THREAD: THREAD$a,
	COLLABORATIVE_DOCUMENT: COLLABORATIVE_DOCUMENT$a,
	COLLABORATIVE_WHITEBOARD: COLLABORATIVE_WHITEBOARD$a,
	ADD_REACTION: ADD_REACTION$a,
	NO_STICKERS_FOUND: NO_STICKERS_FOUND$a,
	REPLY_TO_THREAD: REPLY_TO_THREAD$a,
	REPLY_IN_THREAD: REPLY_IN_THREAD$a,
	VIEW: VIEW$a,
	DELETE_MESSAGE: DELETE_MESSAGE$a,
	EDIT_MESSAGE: EDIT_MESSAGE$a,
	OWNER: OWNER$a,
	CHANGE_SCOPE: CHANGE_SCOPE$a,
	STICKER: STICKER$a,
	LAST_ACTIVE_AT: LAST_ACTIVE_AT$a,
	VOICE_CALL: VOICE_CALL$a,
	VIEW_DETAIL: VIEW_DETAIL$a,
	VOTES: VOTES$a,
	VOTE: VOTE$a,
	NO_VOTE: NO_VOTE$a,
	REACTED: REACTED$a,
	ADDED: ADDED$a,
	SHOW_UNSAFE_CONTENT: SHOW_UNSAFE_CONTENT$a,
	REACT_TO_MESSAGE: REACT_TO_MESSAGE$a,
	UNBANNED: UNBANNED$a,
	MADE: MADE$a,
	CALL_UNANSWERED: CALL_UNANSWERED$a,
	MISSED_AUDIO_CALL: MISSED_AUDIO_CALL$a,
	ENTER_YOUR_PASSWORD: ENTER_YOUR_PASSWORD$a,
	DRAW_DOCUMENT_TOGETHER: DRAW_DOCUMENT_TOGETHER$a,
	DOCS: DOCS$a,
	NO_RECORDS_FOUND: NO_RECORDS_FOUND$a,
	LIVE_REACTION: LIVE_REACTION$a,
	SMILEY_PEOPLE: SMILEY_PEOPLE$a,
	DRAW_WHITEBOARD_TOGETHER: DRAW_WHITEBOARD_TOGETHER$a,
	ANIMALES_NATURE: ANIMALES_NATURE$a,
	FOOD_DRINK: FOOD_DRINK$a,
	OPEN_DOCUMENT: OPEN_DOCUMENT$a,
	ACTIVITY: ACTIVITY$a,
	TRAVEL_PLACES: TRAVEL_PLACES$a,
	OBJECTS: OBJECTS$a,
	SYMBOLS: SYMBOLS$a,
	FLAGS: FLAGS$a,
	SENT: SENT$a,
	SEEN: SEEN$a,
	DELIVERED: DELIVERED$a,
	READ: READ$a,
	MESSAGE_INFORMATION: MESSAGE_INFORMATION$a,
	TRANSLATE_MESSAGE: TRANSLATE_MESSAGE$a,
	TRANSLATED_MESSAGE: TRANSLATED_MESSAGE$a,
	LEFT: LEFT$a,
	KICKED: KICKED$a,
	BANNED: BANNED$a,
	NEW_MESSAGES: NEW_MESSAGES$a,
	NEW_MESSAGE: NEW_MESSAGE$a,
	JUMP: JUMP$a,
	SELECT_VIDEO_SOURCE: SELECT_VIDEO_SOURCE$a,
	SELECT_INPUT_AUDIO_SOURCE: SELECT_INPUT_AUDIO_SOURCE$a,
	SELECT_OUTPUT_AUDIO_SOURCE: SELECT_OUTPUT_AUDIO_SOURCE$a,
	INITIATED_GROUP_CALL: INITIATED_GROUP_CALL$a,
	YOU_INITIATED_GROUP_CALL: YOU_INITIATED_GROUP_CALL$a,
	IGNORE: IGNORE$a,
	ON_ANOTHER_CALL: ON_ANOTHER_CALL$a,
	CREATING: CREATING$a,
	AVATAR: AVATAR$a,
	ONGOING_CALL: ONGOING_CALL$a,
	YOU_ALREADY_ONGOING_CALL: YOU_ALREADY_ONGOING_CALL$a,
	RESIZE: RESIZE$a,
	SETTINGS: SETTINGS$a,
	ACTIONS: ACTIONS$a,
	VIEW_PROFILE: VIEW_PROFILE$a,
	SEND_MESSAGE_IN_PRIVATE: SEND_MESSAGE_IN_PRIVATE$a,
	DELETE: DELETE$a,
	DELETE_CONFIRM: DELETE_CONFIRM$a,
	CANCEL: CANCEL$a,
	LEAVE_CONFIRM: LEAVE_CONFIRM$a,
	TRANSFER_CONFIRM: TRANSFER_CONFIRM$a,
	ADDING: ADDING$a,
	TRANSFER: TRANSFER$a,
	TRANSFER_OWNERSHIP: TRANSFER_OWNERSHIP$a,
	TRANSFERRING: TRANSFERRING$a,
	YES: YES$a,
	NO: NO$a,
	ANSWER: ANSWER$a,
	ADD_ANOTHER_ANSWER: ADD_ANOTHER_ANSWER$a,
	SET_THE_ANSWERS: SET_THE_ANSWERS$a,
	TRY_AGAIN: TRY_AGAIN$a,
	INVALID_GROUP_NAME: INVALID_GROUP_NAME$a,
	INVALID_PASSWORD: INVALID_PASSWORD$a,
	INVALID_GROUP_TYPE: INVALID_GROUP_TYPE$a,
	WRONG_PASSWORD: WRONG_PASSWORD$a,
	INVALID_POLL_QUESTION: INVALID_POLL_QUESTION$a,
	INVALID_POLL_OPTION: INVALID_POLL_OPTION$a,
	SAME_LANGUAGE_MESSAGE: SAME_LANGUAGE_MESSAGE$a,
	LEAVE: LEAVE$a,
	CLICK_TO_START_CONVERSATION: CLICK_TO_START_CONVERSATION$a,
	CUSTOM_MESSAGE_LOCATION: CUSTOM_MESSAGE_LOCATION$a,
	SHARED_LOCATION: SHARED_LOCATION$a,
	IN_A_THREAD: IN_A_THREAD$a,
	CALLS: CALLS$a,
	CALL_DETAILS: CALL_DETAILS$a,
	OFFLINE: OFFLINE$a,
	POLLS: POLLS$a,
	YOU: YOU$a,
	PRIVACY: PRIVACY$a,
	BLOCKED_USERS: BLOCKED_USERS$a,
	"YOU'VE_BLOCKED": "Has bloqueado",
	NO_PHOTOS: NO_PHOTOS$a,
	NO_VIDEOS: NO_VIDEOS$a,
	NO_DOCUMENTS: NO_DOCUMENTS$a,
	JOIN: JOIN$a,
	REMOVE: REMOVE$a,
	BLOCK: BLOCK$a,
	CHANGE_ROLE: CHANGE_ROLE$a,
	NEW_CHAT: NEW_CHAT$a,
	FORM_COMPLETION_MESSAGE: FORM_COMPLETION_MESSAGE$a,
	HISTORY: HISTORY$a,
	CANCELLED_AUDIO_CALL: CANCELLED_AUDIO_CALL$a,
	CANCELLED_VIDEO_CALL: CANCELLED_VIDEO_CALL$a,
	REJECTED_AUDIO_CALL: REJECTED_AUDIO_CALL$a,
	REJECTED_VIDEO_CALL: REJECTED_VIDEO_CALL$a,
	CANCELLED_CALL: CANCELLED_CALL$a,
	UNANSWERED_CALL: UNANSWERED_CALL$a,
	RECORDING: RECORDING$a,
	PARTICIPANTS: PARTICIPANTS$a,
	CALL_HISTORY: CALL_HISTORY$a,
	NO_CALLS_FOUND: NO_CALLS_FOUND$a,
	ONGOING_AUDIO_CALL: ONGOING_AUDIO_CALL$a,
	ONGOING_VIDEO_CALL: ONGOING_VIDEO_CALL$a,
	CALL_DETAIL: CALL_DETAIL$a,
	FORM: FORM$a,
	CARD: CARD$a,
	GENERATING_SUMMARY: GENERATING_SUMMARY$a,
	CONVERSATION_SUMMARY: CONVERSATION_SUMMARY$a,
	GENERATE_SUMMARY: GENERATE_SUMMARY$a,
	COMETCHAT_BOT_FIRST_MESSAGE: COMETCHAT_BOT_FIRST_MESSAGE$a,
	COMETCHAT_ASK_BOT: COMETCHAT_ASK_BOT$a,
	COMETCHAT_ASK_AI_BOT: COMETCHAT_ASK_AI_BOT$a,
	COMETCHAT_ASK_BOT_SUBTITLE: COMETCHAT_ASK_BOT_SUBTITLE$a,
	MENTIONS_LIMIT_WARNING_MESSAGE: MENTIONS_LIMIT_WARNING_MESSAGE$a,
	ALL: ALL$a,
	CLICK_TO_REMOVE: CLICK_TO_REMOVE$a,
	OTHERS: OTHERS$a,
	AND: AND$a
};

var INFO$9 = "Infos";
var REACT$9 = "Réagir";
var EDIT$9 = "Modifier";
var MESSAGE_PRIVATELY$9 = "Message privé";
var TRANSLATE$9 = "Traduire";
var USERS$9 = "Les utilisateurs";
var CHATS$9 = "Discussions";
var WOULD__YOU_LIKE_TO_DELETE_THIS_CONVERSATION$9 = "Désirez-vous supprimer cette conversation ? Cette conversation sera supprimée de tous vos appareils.";
var GROUPS$9 = "Groupes";
var SHARED$9 = "Partagé";
var SOUND_MANAGER$9 = "Gestionnaire de sons";
var THEME$9 = "Thème";
var LOCALIZE$9 = "Localiser";
var CONVERSATION_LIST_ITEM$9 = "Élément de la liste des conversations";
var DATA_ITEM$9 = "Élément de données";
var STATUS_INDICATOR$9 = "Indicateur d'état";
var BADGE_COUNT$9 = "Nombre de badges";
var MESSAGE_RECEIPT$9 = "Réception du message";
var MESSAGE$9 = "Message";
var RECEIPT_INFORMATION$9 = "Informations sur le reçu";
var NO_RECIPIENT$9 = "Aucun destinataire";
var NO_RECIPIENTS$9 = "Aucun bénéficiaire";
var CONVERSATIONS_WITH_MESSAGES$9 = "Conversations avec messages";
var CONVERSATIONS$9 = "Conversations";
var CONVERSATION_LIST$9 = "Liste des conversations";
var MESSAGES$9 = "Messages";
var MESSAGE_HEADER$9 = "En-tête du message";
var MESSAGE_LIST$9 = "Liste des messages";
var MESSAGE_COMPOSER$9 = "Compositeur de messages";
var USERS_WITH_MESSAGES$9 = "Utilisateurs avec messages";
var USER_LIST$9 = "Liste des utilisateurs";
var GROUP_LIST$9 = "Liste des groupes";
var GROUPS_WITH_MESSAGES$9 = "Groupes contenant des messages";
var NEW__GROUP$9 = "Nouveau groupe";
var PASSWORD$9 = "Mot de passe";
var CONTINUE$9 = "Continuer";
var NO_CHATS_SELECTED$9 = "Aucune discussion sélectionnée";
var NO_USERS_SELECTED$9 = "Aucun utilisateur sélectionné";
var NO_GROUPS_SELECTED$9 = "Aucun groupe sélectionné";
var SELECT_DAY$9 = "Sélectionnez un jour";
var SELECT_TIME$9 = "Sélectionnez une heure";
var NO_CALLS_SELECTED$9 = "Aucun appel sélectionné";
var SELECT__GROUP$9 = "Sélectionnez un groupe pour commencer à envoyer des messages";
var SELECT__USER$9 = "Sélectionnez un utilisateur pour commencer à envoyer des messages";
var GROUP_PASSWORD_BLANK$9 = "Le mot de passe du groupe ne peut pas être vide";
var GROUP_NAME_BLANK$9 = "Le nom du groupe ne peut pas être vide";
var GROUP_TYPE_BLANK$9 = "Le type de groupe ne peut pas être vide";
var DELETE_CONVERSATION$9 = "Supprimer la conversation ?";
var ADD_TO_CHAT$9 = "Ajouter au chat";
var MORE$9 = "Plus";
var COPY$9 = "Copier";
var VOICE_RECORDING$9 = "Enregistrement vocal";
var MESSAGE_IMAGE$9 = "📷 Photo";
var MESSAGE_FILE$9 = "📁 Dossier";
var MESSAGE_VIDEO$9 = "📹 Vidéo";
var MESSAGE_AUDIO$9 = "🎵 Audio";
var CUSTOM_MESSAGE$9 = "Vous avez un message";
var SELECT_A_DATE$9 = "Sélectionnez une date";
var TIME_ZONE$9 = "Fuseau horaire";
var MEETING_SCHEDULED$9 = "Votre réunion a été programmée.";
var SOMETHING_WRONG$9 = "Quelque chose s'est mal passé. Veuillez réessayer.";
var MEETING_SLOT_BOOK$9 = "Le créneau horaire n'est plus disponible. Veuillez en choisir un autre.";
var MEETING_BOOK_NEW_SLOT$9 = "Réservez une nouvelle machine à sous";
var MEETING_NO_SLOTS_AVAILABLE$9 = "Aucun créneau horaire n'est disponible pour cette date. Veuillez essayer une autre date.";
var MEETING_TRY_DIFFERENT_DATE$9 = "Veuillez essayer une autre date.";
var NO_TIME_SLOTS_AVAILABLE$9 = "Aucun créneau horaire disponible";
var SCHEDULE$9 = "Calendrier";
var MORE_TIMES$9 = "Plus de fois";
var MISSED_VOICE_CALL$9 = "Appel vocal manqué";
var MEET_WITH$9 = "Rencontrez";
var MEETING_SCHEDULER$9 = "Planificateur de réunions";
var MISSED_VIDEO_CALL$9 = "Appel vidéo manqué";
var CUSTOM_MESSAGE_POLL$9 = "📊 Sondage";
var CUSTOM_MESSAGE_STICKER$9 = "💟 Autocollant";
var CUSTOM_MESSAGE_DOCUMENT$9 = "📃 Dossier";
var CUSTOM_MESSAGE_WHITEBOARD$9 = "📝 Tableau blanc";
var ONLINE$9 = "En ligne";
var ADMINISTRATOR$9 = "Administrateur";
var ADMIN$9 = "Administrateur";
var MODERATOR$9 = "présentateur";
var PARTICIPANT$9 = "Participant";
var PUBLIC$9 = "Publique";
var PRIVATE$9 = "Privé";
var PASSWORD_PROTECTED$9 = "Protection par mot de passe";
var PRIVACY_AND_SECURITY$9 = "Confidentialité et sécurité";
var PREFERENCES$9 = "Préférences";
var MEMBERS$9 = "Membres";
var MEMBER$9 = "Membre";
var TODAY$9 = "Aujourd'hui";
var YESTERDAY$9 = "Hier";
var SUNDAY$9 = "dimanche";
var MONDAY$9 = "Lundi";
var TUESDAY$9 = "Mardi";
var WEDNESDAY$9 = "Mercredi";
var THURSDAY$9 = "Jeudi";
var FRIDAY$9 = "Vendredi";
var SATURDAY$9 = "samedi";
var TYPING$9 = "dactylographie...";
var IS_TYPING$9 = "est en train de taper...";
var CLOSE$9 = "Fermer";
var ENTER_GROUP_NAME$9 = "Entrez le nom du groupe";
var ADD_MEMBERS$9 = "Ajouter des membres";
var SEND_MESSAGE$9 = "Envoyer un message";
var UNBLOCK_USER$9 = "Débloquer un utilisateur";
var BLOCK_USER$9 = "Bloquer l'utilisateur";
var DELETE_AND_EXIT$9 = "Supprimer et quitter";
var LEAVE_GROUP$9 = "Quitter le groupe";
var CREATE_GROUP$9 = "Créer un groupe";
var SHARED_MEDIA$9 = "Médias partagés";
var SHARED_FILE$9 = "Fichier partagé";
var VIDEO_CALL$9 = "Appel vidéo";
var AUDIO_CALL$9 = "Appel audio";
var LOADING$9 = "Chargement en cours...";
var REPLY$9 = "répondre";
var REPLIES$9 = "réponses";
var AI$9 = "IA";
var SMART_REPLIES$9 = "Réponses intelligentes";
var CONVERSATION_STARTER$9 = "Démarreur de conversation";
var LAUNCH$9 = "Lancement";
var SHARED_COLLABORATIVE_DOCUMENT$9 = "a partagé un document collaboratif";
var SHARED_COLLABORATIVE_WHITEBOARD$9 = "a partagé un tableau blanc collaboratif";
var CREATED_WHITEBOARD$9 = "Vous avez créé un nouveau tableau blanc collaboratif";
var CREATED_DOCUMENT$9 = "Vous avez créé un nouveau document collaboratif";
var PHOTOS$9 = "Des photos";
var VIDEOS$9 = "Vidéos";
var DOCUMENT$9 = "Document";
var YOU_DELETED_THIS_MESSAGE$9 = "⚠️ Vous avez supprimé ce message";
var THIS_MESSAGE_DELETED$9 = "⚠️ Ce message a été supprimé";
var MESSAGE_IS_DELETED$9 = "Le message est supprimé";
var VIEW_ON_YOUTUBE$9 = "Voir sur Youtube";
var SEARCH$9 = "Rechercher";
var NO_USERS_FOUND$9 = "Aucun utilisateur n'a été trouvé";
var ERROR$9 = "Erreur";
var NO_GROUPS_FOUND$9 = "Aucun groupe n'a été trouvé";
var NO_CHATS_FOUND$9 = "Aucune discussion trouvée";
var CANT__LOAD__CHATS$9 = "Impossible de charger les chats";
var MEDIA_MESSAGE$9 = "Message aux médias";
var INCOMING_AUDIO_CALL$9 = "Appel audio entrant";
var INCOMING_VIDEO_CALL$9 = "Appel vidéo entrant";
var DECLINE$9 = "Déclin";
var ACCEPT$9 = "Accepter";
var CALL_INITIATED$9 = "Appel lancé";
var OUTGOING_AUDIO_CALL$9 = "Appel audio sortant";
var OUTGOING_VIDEO_CALL$9 = "Appel vidéo sortant";
var CALL_REJECTED$9 = "Appel rejeté";
var REJECTED_CALL$9 = "appel rejeté";
var CALL_ACCEPTED$9 = "Appel accepté";
var OUTGOING_CALL$9 = "Appel sortant";
var INCOMING_CALL$9 = "Appel entrant";
var MISSED_CALL$9 = "Appel manqué";
var JOINED$9 = "joint";
var LEFT_THE_CALL$9 = "a quitté l'appel";
var UNANSWERED_AUDIO_CALL$9 = "Appel audio sans réponse";
var UNANSWERED_VIDEO_CALL$9 = "Appel vidéo sans réponse";
var CALL_ENDED$9 = "L'appel est terminé";
var CALL_CANCELLED$9 = "Appel annulé";
var CALL_BUSY$9 = "Appel occupé";
var CALLING$9 = "J'appelle...";
var ADD$9 = "Ajouter";
var NO_BANNED_MEMBERS_FOUND$9 = "Aucun membre banni n'a été trouvé";
var BANNED_MEMBERS$9 = "Membres bannis";
var NAME$9 = "Nom";
var SCOPE$9 = "Portée";
var UNBAN$9 = "Unban";
var SELECT_GROUP_TYPE$9 = "Sélectionnez le type de groupe";
var ENTER_GROUP_PASSWORD$9 = "Entrez le mot de passe du groupe";
var CREATE$9 = "Créez";
var CREATE_POLL$9 = "Créer un sondage";
var QUESTION$9 = "Question";
var ENTER_YOUR_QUESTION$9 = "Entrez votre question";
var OPTIONS$9 = "Options";
var ENTER_YOUR_OPTION$9 = "Entrez votre option";
var ADD_NEW_OPTION$9 = "Ajouter une nouvelle option";
var VIEW_MEMBERS$9 = "Afficher les membres";
var DETAILS$9 = "Détails";
var NOTIFICATIONS$9 = "Notifications";
var OTHER$9 = "Autres";
var HELP$9 = "Aide";
var REPORT_PROBLEM$9 = "Signaler un problème";
var GROUP_MEMBERS$9 = "Membres du groupe";
var BAN$9 = "Interdiction";
var KICK$9 = "Kick";
var PICK_YOUR_EMOJI$9 = "Choisissez votre emoji";
var PRIVATE_GROUP$9 = "Groupe privé";
var PROTECTED_GROUP$9 = "Groupe protégé";
var VISIT$9 = "Visitez";
var ATTACH$9 = "Joindre";
var OPEN_WHITEBOARD$9 = "Tableau blanc ouvert";
var ATTACH_FILE$9 = "Joindre un fichier";
var GENERATING_REPLIES$9 = "Génération de réponses";
var ATTACH_VIDEO$9 = "Joindre une vidéo";
var ATTACH_AUDIO$9 = "Joindre un fichier audio";
var ATTACH_IMAGE$9 = "Joindre une image";
var COLLABORATE_USING_DOCUMENT$9 = "Collaborez à l'aide d'un document";
var COLLABORATE_USING_WHITEBOARD$9 = "Collaborez à l'aide d'un tableau blanc";
var SUGGEST_A_REPLY$9 = "Suggérer une réponse";
var GENERATING_ICEBREAKERS$9 = "Génération de brise-glaces";
var EMOJI$9 = "Emoji";
var NO_REPLIES_FOUND$9 = "Aucune réponse trouvée";
var ENTER_YOUR_MESSAGE_HERE$9 = "Entrez votre message ici";
var NO_MESSAGES_FOUND$9 = "Aucun message n'a été trouvé";
var THREAD$9 = "fil";
var COLLABORATIVE_DOCUMENT$9 = "Document collaboratif";
var COLLABORATIVE_WHITEBOARD$9 = "Tableau blanc collaboratif";
var ADD_REACTION$9 = "Ajouter une réaction";
var NO_STICKERS_FOUND$9 = "Aucun autocollant n'a été trouvé";
var REPLY_TO_THREAD$9 = "Répondre au fil";
var REPLY_IN_THREAD$9 = "Répondre dans le fil";
var VIEW$9 = "Afficher";
var DELETE_MESSAGE$9 = "Supprimer le message";
var EDIT_MESSAGE$9 = "Modifier le message";
var OWNER$9 = "Propriétaire";
var CHANGE_SCOPE$9 = "Modifier la portée";
var STICKER$9 = "Autocollant";
var LAST_ACTIVE_AT$9 = "Dernière activité";
var VOICE_CALL$9 = "Appel vocal";
var VIEW_DETAIL$9 = "Afficher les détails";
var VOTES$9 = "votes";
var VOTE$9 = "vote";
var NO_VOTE$9 = "Pas de vote";
var REACTED$9 = "réagissait";
var ADDED$9 = "ajoutée";
var SHOW_UNSAFE_CONTENT$9 = "Êtes-vous sûr de vouloir voir du contenu non sécurisé ?";
var REACT_TO_MESSAGE$9 = "Réagir à un message";
var UNBANNED$9 = "non banni";
var MADE$9 = "confectionné";
var CALL_UNANSWERED$9 = "Appel sans réponse";
var MISSED_AUDIO_CALL$9 = "Appel audio manqué";
var ENTER_YOUR_PASSWORD$9 = "Entrez votre mot de passe";
var DRAW_DOCUMENT_TOGETHER$9 = "Ouvrez le document pour modifier le contenu ensemble";
var DOCS$9 = "Docs";
var NO_RECORDS_FOUND$9 = "Aucun enregistrement n'a été trouvé";
var LIVE_REACTION$9 = "Réaction en direct";
var SMILEY_PEOPLE$9 = "Smileys et personnages";
var DRAW_WHITEBOARD_TOGETHER$9 = "Ouvrez le tableau blanc pour dessiner ensemble";
var ANIMALES_NATURE$9 = "Animaux et nature";
var FOOD_DRINK$9 = "Nourriture et boisson";
var OPEN_DOCUMENT$9 = "Ouvrir le document";
var ACTIVITY$9 = "Activité";
var TRAVEL_PLACES$9 = "Voyages et lieux";
var OBJECTS$9 = "Objets";
var SYMBOLS$9 = "Symboles";
var FLAGS$9 = "Drapeaux";
var SENT$9 = "Envoyé";
var SEEN$9 = "Vu";
var DELIVERED$9 = "Livré";
var READ$9 = "Lisez";
var MESSAGE_INFORMATION$9 = "Informations sur le message";
var TRANSLATE_MESSAGE$9 = "Traduire le message";
var TRANSLATED_MESSAGE$9 = "Message traduit";
var LEFT$9 = "parti";
var KICKED$9 = "coup de pied";
var BANNED$9 = "interdit";
var NEW_MESSAGES$9 = "nouveaux messages";
var NEW_MESSAGE$9 = "nouveau message";
var JUMP$9 = "Sauter";
var SELECT_VIDEO_SOURCE$9 = "Sélectionnez la source vidéo";
var SELECT_INPUT_AUDIO_SOURCE$9 = "Sélectionnez la source audio d'entrée";
var SELECT_OUTPUT_AUDIO_SOURCE$9 = "Sélectionnez la source audio de sortie";
var INITIATED_GROUP_CALL$9 = "a lancé un appel de groupe";
var YOU_INITIATED_GROUP_CALL$9 = "Vous avez lancé un appel de groupe";
var IGNORE$9 = "Ignorer";
var ON_ANOTHER_CALL$9 = "est sur un autre appel";
var CREATING$9 = "Création";
var AVATAR$9 = "Avatar";
var ONGOING_CALL$9 = "Appel en cours";
var YOU_ALREADY_ONGOING_CALL$9 = "Vous êtes déjà inscrit à un appel en cours";
var RESIZE$9 = "Redimensionner";
var SETTINGS$9 = "Réglages";
var ACTIONS$9 = "Actions";
var VIEW_PROFILE$9 = "Afficher le profil";
var SEND_MESSAGE_IN_PRIVATE$9 = "Envoyer un message en privé";
var DELETE$9 = "Supprimer";
var DELETE_CONFIRM$9 = "Êtes-vous sûr de vouloir supprimer ?";
var CANCEL$9 = "Annuler";
var LEAVE_CONFIRM$9 = "Es-tu sûr de vouloir quitter le groupe ?";
var TRANSFER_CONFIRM$9 = "Vous êtes le propriétaire du groupe ; veuillez transférer la propriété à un membre avant de quitter le groupe";
var ADDING$9 = "Ajouter...";
var TRANSFER$9 = "Transfert";
var TRANSFER_OWNERSHIP$9 = "Transférer la propriété";
var TRANSFERRING$9 = "Transférer";
var YES$9 = "Oui";
var NO$9 = "Non";
var ANSWER$9 = "Réponse";
var ADD_ANOTHER_ANSWER$9 = "Ajouter une autre réponse";
var SET_THE_ANSWERS$9 = "DÉFINISSEZ LES RÉPONSES";
var TRY_AGAIN$9 = "Essayez à nouveau";
var INVALID_GROUP_NAME$9 = "Entrez un nom valide pour le groupe et réessayez";
var INVALID_PASSWORD$9 = "Entrez un mot de passe valide pour le groupe et réessayez";
var INVALID_GROUP_TYPE$9 = "Entrez un type valide pour le groupe et réessayez";
var WRONG_PASSWORD$9 = "Entrez le mot de passe correct et réessayez";
var INVALID_POLL_QUESTION$9 = "Veuillez saisir la question requise avant de créer un sondage";
var INVALID_POLL_OPTION$9 = "Veuillez saisir la réponse requise avant de créer un sondage";
var SAME_LANGUAGE_MESSAGE$9 = "La langue sélectionnée pour la traduction est similaire à la langue du message d'origine";
var LEAVE$9 = "Partir";
var CLICK_TO_START_CONVERSATION$9 = "Cliquez pour démarrer la conversation";
var CUSTOM_MESSAGE_LOCATION$9 = "📍 Lieu";
var SHARED_LOCATION$9 = "Emplacement partagé";
var IN_A_THREAD$9 = "Dans un fil";
var CALLS$9 = "Appels";
var CALL_DETAILS$9 = "Détails de l'appel";
var OFFLINE$9 = "Hors ligne";
var POLLS$9 = "Sondages";
var YOU$9 = "Vous";
var PRIVACY$9 = "Confidentialité";
var BLOCKED_USERS$9 = "Utilisateurs bloqués";
var NO_PHOTOS$9 = "Pas de photos";
var NO_VIDEOS$9 = "Pas de vidéos";
var NO_DOCUMENTS$9 = "Aucun document";
var JOIN$9 = "Joignez-vous";
var REMOVE$9 = "Supprimer";
var BLOCK$9 = "Bloquer";
var CHANGE_ROLE$9 = "Changer de rôle";
var NEW_CHAT$9 = "Nouveau chat";
var FORM_COMPLETION_MESSAGE$9 = "Merci d'avoir rempli le formulaire.";
var HISTORY$9 = "L'histoire";
var CANCELLED_AUDIO_CALL$9 = "Appel audio annulé";
var CANCELLED_VIDEO_CALL$9 = "Appel vidéo annulé";
var REJECTED_AUDIO_CALL$9 = "Appel audio rejeté";
var REJECTED_VIDEO_CALL$9 = "Appel vidéo rejeté";
var CANCELLED_CALL$9 = "Appel annulé";
var UNANSWERED_CALL$9 = "Appel sans réponse";
var RECORDING$9 = "Enregistrement";
var PARTICIPANTS$9 = "Les participants";
var CALL_HISTORY$9 = "Historique des appels";
var NO_CALLS_FOUND$9 = "Aucun appel trouvé";
var ONGOING_AUDIO_CALL$9 = "Appel audio en cours";
var ONGOING_VIDEO_CALL$9 = "Appel vidéo en cours";
var CALL_DETAIL$9 = "Détail de l'appel";
var FORM$9 = "Formulaire";
var CARD$9 = "Carte";
var GENERATING_SUMMARY$9 = "Génération d'un résumé";
var CONVERSATION_SUMMARY$9 = "Résumé de la conversation";
var GENERATE_SUMMARY$9 = "Générer un résumé";
var COMETCHAT_BOT_FIRST_MESSAGE$9 = "Comment puis-je vous aider dans cette conversation ? Posez-moi une question et je vous conseillerai 🙂";
var COMETCHAT_ASK_BOT$9 = "Demandez";
var COMETCHAT_ASK_AI_BOT$9 = "Demandez à AI Bots";
var COMETCHAT_ASK_BOT_SUBTITLE$9 = "Robot IA";
var MENTIONS_LIMIT_WARNING_MESSAGE$9 = "Vous pouvez mentionner jusqu'à 10 fois à la fois.";
var ALL$9 = "Tous";
var CLICK_TO_REMOVE$9 = "Cliquez pour supprimer";
var OTHERS$9 = "autres";
var AND$9 = "un";
var translationFR = {
	INFO: INFO$9,
	REACT: REACT$9,
	EDIT: EDIT$9,
	MESSAGE_PRIVATELY: MESSAGE_PRIVATELY$9,
	TRANSLATE: TRANSLATE$9,
	USERS: USERS$9,
	CHATS: CHATS$9,
	WOULD__YOU_LIKE_TO_DELETE_THIS_CONVERSATION: WOULD__YOU_LIKE_TO_DELETE_THIS_CONVERSATION$9,
	GROUPS: GROUPS$9,
	SHARED: SHARED$9,
	SOUND_MANAGER: SOUND_MANAGER$9,
	THEME: THEME$9,
	LOCALIZE: LOCALIZE$9,
	CONVERSATION_LIST_ITEM: CONVERSATION_LIST_ITEM$9,
	DATA_ITEM: DATA_ITEM$9,
	STATUS_INDICATOR: STATUS_INDICATOR$9,
	BADGE_COUNT: BADGE_COUNT$9,
	MESSAGE_RECEIPT: MESSAGE_RECEIPT$9,
	MESSAGE: MESSAGE$9,
	RECEIPT_INFORMATION: RECEIPT_INFORMATION$9,
	NO_RECIPIENT: NO_RECIPIENT$9,
	NO_RECIPIENTS: NO_RECIPIENTS$9,
	CONVERSATIONS_WITH_MESSAGES: CONVERSATIONS_WITH_MESSAGES$9,
	CONVERSATIONS: CONVERSATIONS$9,
	CONVERSATION_LIST: CONVERSATION_LIST$9,
	MESSAGES: MESSAGES$9,
	MESSAGE_HEADER: MESSAGE_HEADER$9,
	MESSAGE_LIST: MESSAGE_LIST$9,
	MESSAGE_COMPOSER: MESSAGE_COMPOSER$9,
	USERS_WITH_MESSAGES: USERS_WITH_MESSAGES$9,
	USER_LIST: USER_LIST$9,
	GROUP_LIST: GROUP_LIST$9,
	GROUPS_WITH_MESSAGES: GROUPS_WITH_MESSAGES$9,
	NEW__GROUP: NEW__GROUP$9,
	PASSWORD: PASSWORD$9,
	CONTINUE: CONTINUE$9,
	NO_CHATS_SELECTED: NO_CHATS_SELECTED$9,
	NO_USERS_SELECTED: NO_USERS_SELECTED$9,
	NO_GROUPS_SELECTED: NO_GROUPS_SELECTED$9,
	SELECT_DAY: SELECT_DAY$9,
	SELECT_TIME: SELECT_TIME$9,
	NO_CALLS_SELECTED: NO_CALLS_SELECTED$9,
	SELECT__GROUP: SELECT__GROUP$9,
	SELECT__USER: SELECT__USER$9,
	GROUP_PASSWORD_BLANK: GROUP_PASSWORD_BLANK$9,
	GROUP_NAME_BLANK: GROUP_NAME_BLANK$9,
	GROUP_TYPE_BLANK: GROUP_TYPE_BLANK$9,
	DELETE_CONVERSATION: DELETE_CONVERSATION$9,
	ADD_TO_CHAT: ADD_TO_CHAT$9,
	MORE: MORE$9,
	COPY: COPY$9,
	VOICE_RECORDING: VOICE_RECORDING$9,
	MESSAGE_IMAGE: MESSAGE_IMAGE$9,
	MESSAGE_FILE: MESSAGE_FILE$9,
	MESSAGE_VIDEO: MESSAGE_VIDEO$9,
	MESSAGE_AUDIO: MESSAGE_AUDIO$9,
	CUSTOM_MESSAGE: CUSTOM_MESSAGE$9,
	SELECT_A_DATE: SELECT_A_DATE$9,
	TIME_ZONE: TIME_ZONE$9,
	MEETING_SCHEDULED: MEETING_SCHEDULED$9,
	SOMETHING_WRONG: SOMETHING_WRONG$9,
	MEETING_SLOT_BOOK: MEETING_SLOT_BOOK$9,
	MEETING_BOOK_NEW_SLOT: MEETING_BOOK_NEW_SLOT$9,
	MEETING_NO_SLOTS_AVAILABLE: MEETING_NO_SLOTS_AVAILABLE$9,
	MEETING_TRY_DIFFERENT_DATE: MEETING_TRY_DIFFERENT_DATE$9,
	NO_TIME_SLOTS_AVAILABLE: NO_TIME_SLOTS_AVAILABLE$9,
	SCHEDULE: SCHEDULE$9,
	MORE_TIMES: MORE_TIMES$9,
	MISSED_VOICE_CALL: MISSED_VOICE_CALL$9,
	MEET_WITH: MEET_WITH$9,
	MEETING_SCHEDULER: MEETING_SCHEDULER$9,
	MISSED_VIDEO_CALL: MISSED_VIDEO_CALL$9,
	CUSTOM_MESSAGE_POLL: CUSTOM_MESSAGE_POLL$9,
	CUSTOM_MESSAGE_STICKER: CUSTOM_MESSAGE_STICKER$9,
	CUSTOM_MESSAGE_DOCUMENT: CUSTOM_MESSAGE_DOCUMENT$9,
	CUSTOM_MESSAGE_WHITEBOARD: CUSTOM_MESSAGE_WHITEBOARD$9,
	ONLINE: ONLINE$9,
	ADMINISTRATOR: ADMINISTRATOR$9,
	ADMIN: ADMIN$9,
	MODERATOR: MODERATOR$9,
	PARTICIPANT: PARTICIPANT$9,
	PUBLIC: PUBLIC$9,
	PRIVATE: PRIVATE$9,
	PASSWORD_PROTECTED: PASSWORD_PROTECTED$9,
	PRIVACY_AND_SECURITY: PRIVACY_AND_SECURITY$9,
	PREFERENCES: PREFERENCES$9,
	MEMBERS: MEMBERS$9,
	MEMBER: MEMBER$9,
	TODAY: TODAY$9,
	YESTERDAY: YESTERDAY$9,
	SUNDAY: SUNDAY$9,
	MONDAY: MONDAY$9,
	TUESDAY: TUESDAY$9,
	WEDNESDAY: WEDNESDAY$9,
	THURSDAY: THURSDAY$9,
	FRIDAY: FRIDAY$9,
	SATURDAY: SATURDAY$9,
	TYPING: TYPING$9,
	IS_TYPING: IS_TYPING$9,
	CLOSE: CLOSE$9,
	ENTER_GROUP_NAME: ENTER_GROUP_NAME$9,
	ADD_MEMBERS: ADD_MEMBERS$9,
	SEND_MESSAGE: SEND_MESSAGE$9,
	UNBLOCK_USER: UNBLOCK_USER$9,
	BLOCK_USER: BLOCK_USER$9,
	DELETE_AND_EXIT: DELETE_AND_EXIT$9,
	LEAVE_GROUP: LEAVE_GROUP$9,
	CREATE_GROUP: CREATE_GROUP$9,
	SHARED_MEDIA: SHARED_MEDIA$9,
	SHARED_FILE: SHARED_FILE$9,
	VIDEO_CALL: VIDEO_CALL$9,
	AUDIO_CALL: AUDIO_CALL$9,
	LOADING: LOADING$9,
	REPLY: REPLY$9,
	REPLIES: REPLIES$9,
	AI: AI$9,
	SMART_REPLIES: SMART_REPLIES$9,
	CONVERSATION_STARTER: CONVERSATION_STARTER$9,
	LAUNCH: LAUNCH$9,
	SHARED_COLLABORATIVE_DOCUMENT: SHARED_COLLABORATIVE_DOCUMENT$9,
	SHARED_COLLABORATIVE_WHITEBOARD: SHARED_COLLABORATIVE_WHITEBOARD$9,
	CREATED_WHITEBOARD: CREATED_WHITEBOARD$9,
	CREATED_DOCUMENT: CREATED_DOCUMENT$9,
	PHOTOS: PHOTOS$9,
	VIDEOS: VIDEOS$9,
	DOCUMENT: DOCUMENT$9,
	YOU_DELETED_THIS_MESSAGE: YOU_DELETED_THIS_MESSAGE$9,
	THIS_MESSAGE_DELETED: THIS_MESSAGE_DELETED$9,
	MESSAGE_IS_DELETED: MESSAGE_IS_DELETED$9,
	VIEW_ON_YOUTUBE: VIEW_ON_YOUTUBE$9,
	SEARCH: SEARCH$9,
	NO_USERS_FOUND: NO_USERS_FOUND$9,
	ERROR: ERROR$9,
	NO_GROUPS_FOUND: NO_GROUPS_FOUND$9,
	NO_CHATS_FOUND: NO_CHATS_FOUND$9,
	CANT__LOAD__CHATS: CANT__LOAD__CHATS$9,
	MEDIA_MESSAGE: MEDIA_MESSAGE$9,
	INCOMING_AUDIO_CALL: INCOMING_AUDIO_CALL$9,
	INCOMING_VIDEO_CALL: INCOMING_VIDEO_CALL$9,
	DECLINE: DECLINE$9,
	ACCEPT: ACCEPT$9,
	CALL_INITIATED: CALL_INITIATED$9,
	OUTGOING_AUDIO_CALL: OUTGOING_AUDIO_CALL$9,
	OUTGOING_VIDEO_CALL: OUTGOING_VIDEO_CALL$9,
	CALL_REJECTED: CALL_REJECTED$9,
	REJECTED_CALL: REJECTED_CALL$9,
	CALL_ACCEPTED: CALL_ACCEPTED$9,
	OUTGOING_CALL: OUTGOING_CALL$9,
	INCOMING_CALL: INCOMING_CALL$9,
	MISSED_CALL: MISSED_CALL$9,
	JOINED: JOINED$9,
	LEFT_THE_CALL: LEFT_THE_CALL$9,
	UNANSWERED_AUDIO_CALL: UNANSWERED_AUDIO_CALL$9,
	UNANSWERED_VIDEO_CALL: UNANSWERED_VIDEO_CALL$9,
	CALL_ENDED: CALL_ENDED$9,
	CALL_CANCELLED: CALL_CANCELLED$9,
	CALL_BUSY: CALL_BUSY$9,
	CALLING: CALLING$9,
	ADD: ADD$9,
	NO_BANNED_MEMBERS_FOUND: NO_BANNED_MEMBERS_FOUND$9,
	BANNED_MEMBERS: BANNED_MEMBERS$9,
	NAME: NAME$9,
	SCOPE: SCOPE$9,
	UNBAN: UNBAN$9,
	SELECT_GROUP_TYPE: SELECT_GROUP_TYPE$9,
	ENTER_GROUP_PASSWORD: ENTER_GROUP_PASSWORD$9,
	CREATE: CREATE$9,
	CREATE_POLL: CREATE_POLL$9,
	QUESTION: QUESTION$9,
	ENTER_YOUR_QUESTION: ENTER_YOUR_QUESTION$9,
	OPTIONS: OPTIONS$9,
	ENTER_YOUR_OPTION: ENTER_YOUR_OPTION$9,
	ADD_NEW_OPTION: ADD_NEW_OPTION$9,
	VIEW_MEMBERS: VIEW_MEMBERS$9,
	DETAILS: DETAILS$9,
	NOTIFICATIONS: NOTIFICATIONS$9,
	OTHER: OTHER$9,
	HELP: HELP$9,
	REPORT_PROBLEM: REPORT_PROBLEM$9,
	GROUP_MEMBERS: GROUP_MEMBERS$9,
	BAN: BAN$9,
	KICK: KICK$9,
	PICK_YOUR_EMOJI: PICK_YOUR_EMOJI$9,
	PRIVATE_GROUP: PRIVATE_GROUP$9,
	PROTECTED_GROUP: PROTECTED_GROUP$9,
	VISIT: VISIT$9,
	ATTACH: ATTACH$9,
	OPEN_WHITEBOARD: OPEN_WHITEBOARD$9,
	ATTACH_FILE: ATTACH_FILE$9,
	GENERATING_REPLIES: GENERATING_REPLIES$9,
	ATTACH_VIDEO: ATTACH_VIDEO$9,
	ATTACH_AUDIO: ATTACH_AUDIO$9,
	ATTACH_IMAGE: ATTACH_IMAGE$9,
	COLLABORATE_USING_DOCUMENT: COLLABORATE_USING_DOCUMENT$9,
	COLLABORATE_USING_WHITEBOARD: COLLABORATE_USING_WHITEBOARD$9,
	SUGGEST_A_REPLY: SUGGEST_A_REPLY$9,
	GENERATING_ICEBREAKERS: GENERATING_ICEBREAKERS$9,
	EMOJI: EMOJI$9,
	NO_REPLIES_FOUND: NO_REPLIES_FOUND$9,
	ENTER_YOUR_MESSAGE_HERE: ENTER_YOUR_MESSAGE_HERE$9,
	NO_MESSAGES_FOUND: NO_MESSAGES_FOUND$9,
	THREAD: THREAD$9,
	COLLABORATIVE_DOCUMENT: COLLABORATIVE_DOCUMENT$9,
	COLLABORATIVE_WHITEBOARD: COLLABORATIVE_WHITEBOARD$9,
	ADD_REACTION: ADD_REACTION$9,
	NO_STICKERS_FOUND: NO_STICKERS_FOUND$9,
	REPLY_TO_THREAD: REPLY_TO_THREAD$9,
	REPLY_IN_THREAD: REPLY_IN_THREAD$9,
	VIEW: VIEW$9,
	DELETE_MESSAGE: DELETE_MESSAGE$9,
	EDIT_MESSAGE: EDIT_MESSAGE$9,
	OWNER: OWNER$9,
	CHANGE_SCOPE: CHANGE_SCOPE$9,
	STICKER: STICKER$9,
	LAST_ACTIVE_AT: LAST_ACTIVE_AT$9,
	VOICE_CALL: VOICE_CALL$9,
	VIEW_DETAIL: VIEW_DETAIL$9,
	VOTES: VOTES$9,
	VOTE: VOTE$9,
	NO_VOTE: NO_VOTE$9,
	REACTED: REACTED$9,
	ADDED: ADDED$9,
	SHOW_UNSAFE_CONTENT: SHOW_UNSAFE_CONTENT$9,
	REACT_TO_MESSAGE: REACT_TO_MESSAGE$9,
	UNBANNED: UNBANNED$9,
	MADE: MADE$9,
	CALL_UNANSWERED: CALL_UNANSWERED$9,
	MISSED_AUDIO_CALL: MISSED_AUDIO_CALL$9,
	ENTER_YOUR_PASSWORD: ENTER_YOUR_PASSWORD$9,
	DRAW_DOCUMENT_TOGETHER: DRAW_DOCUMENT_TOGETHER$9,
	DOCS: DOCS$9,
	NO_RECORDS_FOUND: NO_RECORDS_FOUND$9,
	LIVE_REACTION: LIVE_REACTION$9,
	SMILEY_PEOPLE: SMILEY_PEOPLE$9,
	DRAW_WHITEBOARD_TOGETHER: DRAW_WHITEBOARD_TOGETHER$9,
	ANIMALES_NATURE: ANIMALES_NATURE$9,
	FOOD_DRINK: FOOD_DRINK$9,
	OPEN_DOCUMENT: OPEN_DOCUMENT$9,
	ACTIVITY: ACTIVITY$9,
	TRAVEL_PLACES: TRAVEL_PLACES$9,
	OBJECTS: OBJECTS$9,
	SYMBOLS: SYMBOLS$9,
	FLAGS: FLAGS$9,
	SENT: SENT$9,
	SEEN: SEEN$9,
	DELIVERED: DELIVERED$9,
	READ: READ$9,
	MESSAGE_INFORMATION: MESSAGE_INFORMATION$9,
	TRANSLATE_MESSAGE: TRANSLATE_MESSAGE$9,
	TRANSLATED_MESSAGE: TRANSLATED_MESSAGE$9,
	LEFT: LEFT$9,
	KICKED: KICKED$9,
	BANNED: BANNED$9,
	NEW_MESSAGES: NEW_MESSAGES$9,
	NEW_MESSAGE: NEW_MESSAGE$9,
	JUMP: JUMP$9,
	SELECT_VIDEO_SOURCE: SELECT_VIDEO_SOURCE$9,
	SELECT_INPUT_AUDIO_SOURCE: SELECT_INPUT_AUDIO_SOURCE$9,
	SELECT_OUTPUT_AUDIO_SOURCE: SELECT_OUTPUT_AUDIO_SOURCE$9,
	INITIATED_GROUP_CALL: INITIATED_GROUP_CALL$9,
	YOU_INITIATED_GROUP_CALL: YOU_INITIATED_GROUP_CALL$9,
	IGNORE: IGNORE$9,
	ON_ANOTHER_CALL: ON_ANOTHER_CALL$9,
	CREATING: CREATING$9,
	AVATAR: AVATAR$9,
	ONGOING_CALL: ONGOING_CALL$9,
	YOU_ALREADY_ONGOING_CALL: YOU_ALREADY_ONGOING_CALL$9,
	RESIZE: RESIZE$9,
	SETTINGS: SETTINGS$9,
	ACTIONS: ACTIONS$9,
	VIEW_PROFILE: VIEW_PROFILE$9,
	SEND_MESSAGE_IN_PRIVATE: SEND_MESSAGE_IN_PRIVATE$9,
	DELETE: DELETE$9,
	DELETE_CONFIRM: DELETE_CONFIRM$9,
	CANCEL: CANCEL$9,
	LEAVE_CONFIRM: LEAVE_CONFIRM$9,
	TRANSFER_CONFIRM: TRANSFER_CONFIRM$9,
	ADDING: ADDING$9,
	TRANSFER: TRANSFER$9,
	TRANSFER_OWNERSHIP: TRANSFER_OWNERSHIP$9,
	TRANSFERRING: TRANSFERRING$9,
	YES: YES$9,
	NO: NO$9,
	ANSWER: ANSWER$9,
	ADD_ANOTHER_ANSWER: ADD_ANOTHER_ANSWER$9,
	SET_THE_ANSWERS: SET_THE_ANSWERS$9,
	TRY_AGAIN: TRY_AGAIN$9,
	INVALID_GROUP_NAME: INVALID_GROUP_NAME$9,
	INVALID_PASSWORD: INVALID_PASSWORD$9,
	INVALID_GROUP_TYPE: INVALID_GROUP_TYPE$9,
	WRONG_PASSWORD: WRONG_PASSWORD$9,
	INVALID_POLL_QUESTION: INVALID_POLL_QUESTION$9,
	INVALID_POLL_OPTION: INVALID_POLL_OPTION$9,
	SAME_LANGUAGE_MESSAGE: SAME_LANGUAGE_MESSAGE$9,
	LEAVE: LEAVE$9,
	CLICK_TO_START_CONVERSATION: CLICK_TO_START_CONVERSATION$9,
	CUSTOM_MESSAGE_LOCATION: CUSTOM_MESSAGE_LOCATION$9,
	SHARED_LOCATION: SHARED_LOCATION$9,
	IN_A_THREAD: IN_A_THREAD$9,
	CALLS: CALLS$9,
	CALL_DETAILS: CALL_DETAILS$9,
	OFFLINE: OFFLINE$9,
	POLLS: POLLS$9,
	YOU: YOU$9,
	PRIVACY: PRIVACY$9,
	BLOCKED_USERS: BLOCKED_USERS$9,
	"YOU'VE_BLOCKED": "Vous avez bloqué",
	NO_PHOTOS: NO_PHOTOS$9,
	NO_VIDEOS: NO_VIDEOS$9,
	NO_DOCUMENTS: NO_DOCUMENTS$9,
	JOIN: JOIN$9,
	REMOVE: REMOVE$9,
	BLOCK: BLOCK$9,
	CHANGE_ROLE: CHANGE_ROLE$9,
	NEW_CHAT: NEW_CHAT$9,
	FORM_COMPLETION_MESSAGE: FORM_COMPLETION_MESSAGE$9,
	HISTORY: HISTORY$9,
	CANCELLED_AUDIO_CALL: CANCELLED_AUDIO_CALL$9,
	CANCELLED_VIDEO_CALL: CANCELLED_VIDEO_CALL$9,
	REJECTED_AUDIO_CALL: REJECTED_AUDIO_CALL$9,
	REJECTED_VIDEO_CALL: REJECTED_VIDEO_CALL$9,
	CANCELLED_CALL: CANCELLED_CALL$9,
	UNANSWERED_CALL: UNANSWERED_CALL$9,
	RECORDING: RECORDING$9,
	PARTICIPANTS: PARTICIPANTS$9,
	CALL_HISTORY: CALL_HISTORY$9,
	NO_CALLS_FOUND: NO_CALLS_FOUND$9,
	ONGOING_AUDIO_CALL: ONGOING_AUDIO_CALL$9,
	ONGOING_VIDEO_CALL: ONGOING_VIDEO_CALL$9,
	CALL_DETAIL: CALL_DETAIL$9,
	FORM: FORM$9,
	CARD: CARD$9,
	GENERATING_SUMMARY: GENERATING_SUMMARY$9,
	CONVERSATION_SUMMARY: CONVERSATION_SUMMARY$9,
	GENERATE_SUMMARY: GENERATE_SUMMARY$9,
	COMETCHAT_BOT_FIRST_MESSAGE: COMETCHAT_BOT_FIRST_MESSAGE$9,
	COMETCHAT_ASK_BOT: COMETCHAT_ASK_BOT$9,
	COMETCHAT_ASK_AI_BOT: COMETCHAT_ASK_AI_BOT$9,
	COMETCHAT_ASK_BOT_SUBTITLE: COMETCHAT_ASK_BOT_SUBTITLE$9,
	MENTIONS_LIMIT_WARNING_MESSAGE: MENTIONS_LIMIT_WARNING_MESSAGE$9,
	ALL: ALL$9,
	CLICK_TO_REMOVE: CLICK_TO_REMOVE$9,
	OTHERS: OTHERS$9,
	AND: AND$9
};

var INFO$8 = "जानकारी";
var REACT$8 = "रिएक्ट";
var EDIT$8 = "संपादित करें";
var MESSAGE_PRIVATELY$8 = "निजी तौर पर संदेश";
var TRANSLATE$8 = "ट्रांसलेट करें";
var USERS$8 = "यूज़र";
var CHATS$8 = "चैट्स";
var WOULD__YOU_LIKE_TO_DELETE_THIS_CONVERSATION$8 = "क्या आप इस वार्तालाप को मिटाना चाहेंगे? यह वार्तालाप आपके सभी डिवाइस से हटा दिया जाएगा।";
var GROUPS$8 = "ग्रुप्स";
var SHARED$8 = "शेयर्ड";
var SOUND_MANAGER$8 = "साउंड मैनेजर";
var THEME$8 = "थीम";
var LOCALIZE$8 = "लोकलाइज़ करें";
var CONVERSATION_LIST_ITEM$8 = "वार्तालाप सूची आइटम";
var DATA_ITEM$8 = "डेटा आइटम";
var STATUS_INDICATOR$8 = "स्टेटस इंडिकेटर";
var BADGE_COUNT$8 = "बैज काउंट";
var MESSAGE_RECEIPT$8 = "संदेश रसीद";
var MESSAGE$8 = "सन्देश";
var RECEIPT_INFORMATION$8 = "रसीद की जानकारी";
var NO_RECIPIENT$8 = "कोई प्राप्तकर्ता नहीं";
var NO_RECIPIENTS$8 = "कोई प्राप्तकर्ता नहीं";
var CONVERSATIONS_WITH_MESSAGES$8 = "संदेशों के साथ वार्तालाप";
var CONVERSATIONS$8 = "वार्तालाप";
var CONVERSATION_LIST$8 = "वार्तालाप सूची";
var MESSAGES$8 = "सन्देश";
var MESSAGE_HEADER$8 = "संदेश शीर्षलेख";
var MESSAGE_LIST$8 = "संदेश सूची";
var MESSAGE_COMPOSER$8 = "संदेश कंपोज़र";
var USERS_WITH_MESSAGES$8 = "संदेश वाले उपयोगकर्ता";
var USER_LIST$8 = "यूज़र लिस्ट";
var GROUP_LIST$8 = "समूह सूची";
var GROUPS_WITH_MESSAGES$8 = "संदेशों के साथ समूह";
var NEW__GROUP$8 = "नया समूह";
var PASSWORD$8 = "पासवर्ड";
var CONTINUE$8 = "जारी रखें";
var NO_CHATS_SELECTED$8 = "कोई चैट नहीं चुनी गई";
var NO_USERS_SELECTED$8 = "कोई उपयोगकर्ता नहीं चुना गया";
var NO_GROUPS_SELECTED$8 = "कोई समूह नहीं चुना गया";
var SELECT_DAY$8 = "एक दिन चुनें";
var SELECT_TIME$8 = "एक समय चुनें";
var NO_CALLS_SELECTED$8 = "कोई कॉल नहीं चुनी गई";
var SELECT__GROUP$8 = "मैसेजिंग शुरू करने के लिए ग्रुप चुनें";
var SELECT__USER$8 = "मैसेजिंग शुरू करने के लिए एक उपयोगकर्ता का चयन करें";
var GROUP_PASSWORD_BLANK$8 = "ग्रुप पासवर्ड खाली नहीं हो सकता";
var GROUP_NAME_BLANK$8 = "समूह का नाम रिक्त नहीं हो सकता";
var GROUP_TYPE_BLANK$8 = "समूह का प्रकार रिक्त नहीं हो सकता";
var DELETE_CONVERSATION$8 = "बातचीत मिटाएँ?";
var ADD_TO_CHAT$8 = "चैट में जोड़ें";
var MORE$8 = "ज़्यादा";
var COPY$8 = "कॉपी करें";
var VOICE_RECORDING$8 = "वॉइस रिकॉर्डिंग";
var MESSAGE_IMAGE$8 = "📷 छवि";
var MESSAGE_FILE$8 = "📁 फ़ाइल";
var MESSAGE_VIDEO$8 = "📹 वीडियो";
var MESSAGE_AUDIO$8 = "🎵 ऑडियो";
var CUSTOM_MESSAGE$8 = "आपके पास एक संदेश है";
var SELECT_A_DATE$8 = "एक तारीख चुनें";
var TIME_ZONE$8 = "टाइम ज़ोन";
var MEETING_SCHEDULED$8 = "आपकी मीटिंग शेड्यूल कर दी गई है।";
var SOMETHING_WRONG$8 = "कुछ गड़बड़ हो गई। कृपया फिर से कोशिश करें।";
var MEETING_SLOT_BOOK$8 = "टाइम स्लॉट अब उपलब्ध नहीं है। कृपया कोई दूसरा चुनें।";
var MEETING_BOOK_NEW_SLOT$8 = "नया स्लॉट बुक करें";
var MEETING_NO_SLOTS_AVAILABLE$8 = "इस तिथि के लिए कोई समय स्लॉट उपलब्ध नहीं है। कृपया कोई और तारीख आज़माएँ।";
var MEETING_TRY_DIFFERENT_DATE$8 = "कृपया कोई दूसरी तारीख आज़माएँ।";
var NO_TIME_SLOTS_AVAILABLE$8 = "कोई टाइम स्लॉट उपलब्ध नहीं";
var SCHEDULE$8 = "शेड्यूल";
var MORE_TIMES$8 = "ज़्यादा बार";
var MISSED_VOICE_CALL$8 = "मिस्ड वॉइस कॉल";
var MEET_WITH$8 = "के साथ मिलें";
var MEETING_SCHEDULER$8 = "मीटिंग शेड्यूलर";
var MISSED_VIDEO_CALL$8 = "मिस्ड वीडियो कॉल";
var CUSTOM_MESSAGE_POLL$8 = "📊 पोल";
var CUSTOM_MESSAGE_STICKER$8 = "💟 स्टिकर";
var CUSTOM_MESSAGE_DOCUMENT$8 = "📃 दस्तावेज़";
var CUSTOM_MESSAGE_WHITEBOARD$8 = "📝 व्हाइटबोर्ड";
var ONLINE$8 = "ऑनलाइन";
var ADMINISTRATOR$8 = "प्रशासक";
var ADMIN$8 = "एडमिन";
var MODERATOR$8 = "प्रस्तुतकर्ता";
var PARTICIPANT$8 = "प्रतिभागी";
var PUBLIC$8 = "पब्लिक";
var PRIVATE$8 = "निजी";
var PASSWORD_PROTECTED$8 = "पासवर्ड प्रोटेक्टेड";
var PRIVACY_AND_SECURITY$8 = "गोपनीयता और सुरक्षा";
var PREFERENCES$8 = "प्राथमिकताएं";
var MEMBERS$8 = "सदस्य";
var MEMBER$8 = "सदस्य";
var TODAY$8 = "टुडे";
var YESTERDAY$8 = "कल";
var SUNDAY$8 = "रविवार";
var MONDAY$8 = "सोमवार";
var TUESDAY$8 = "मंगलवार";
var WEDNESDAY$8 = "बुधवार";
var THURSDAY$8 = "गुरुवार";
var FRIDAY$8 = "शुक्रवार";
var SATURDAY$8 = "शनिवार";
var TYPING$8 = "टाइप कर रहा है...";
var IS_TYPING$8 = "टाइप कर रहा है...";
var CLOSE$8 = "बंद करें";
var ENTER_GROUP_NAME$8 = "ग्रुप का नाम दर्ज करें";
var ADD_MEMBERS$8 = "सदस्य जोड़ें";
var SEND_MESSAGE$8 = "सन्देश भेजो";
var UNBLOCK_USER$8 = "यूज़र को अनब्लॉक करें";
var BLOCK_USER$8 = "उपयोगकर्ता को ब्लॉक करें";
var DELETE_AND_EXIT$8 = "हटाएँ और बाहर निकलें";
var LEAVE_GROUP$8 = "लीव ग्रुप";
var CREATE_GROUP$8 = "ग्रुप बनाएं";
var SHARED_MEDIA$8 = "शेयर्ड मीडिया";
var SHARED_FILE$8 = "शेयर की गई फ़ाइल";
var VIDEO_CALL$8 = "वीडियो कॉल";
var AUDIO_CALL$8 = "ऑडियो कॉल";
var LOADING$8 = "लोड हो रहा है...";
var REPLY$8 = "उत्तर दें";
var REPLIES$8 = "उत्तर";
var AI$8 = "एआई";
var SMART_REPLIES$8 = "स्मार्ट जवाब";
var CONVERSATION_STARTER$8 = "वार्तालाप स्टार्टर";
var LAUNCH$8 = "लांच";
var SHARED_COLLABORATIVE_DOCUMENT$8 = "ने एक सहयोगी दस्तावेज़ साझा किया है";
var SHARED_COLLABORATIVE_WHITEBOARD$8 = "ने एक सहयोगी व्हाइटबोर्ड साझा किया है";
var CREATED_WHITEBOARD$8 = "आपने एक नया सहयोगी व्हाइटबोर्ड बनाया है";
var CREATED_DOCUMENT$8 = "आपने एक नया सहयोगी दस्तावेज़ बनाया है";
var PHOTOS$8 = "फ़ोटोज़";
var VIDEOS$8 = "वीडियो";
var DOCUMENT$8 = "दस्तावेज़";
var YOU_DELETED_THIS_MESSAGE$8 = "⚠️ आपने यह संदेश डिलीट कर दिया";
var THIS_MESSAGE_DELETED$8 = "⚠️ यह संदेश हटा दिया गया था";
var MESSAGE_IS_DELETED$8 = "संदेश हटा दिया गया है";
var VIEW_ON_YOUTUBE$8 = "यूट्यूब पर देखें";
var SEARCH$8 = "सर्च करें";
var NO_USERS_FOUND$8 = "कोई यूज़र नहीं मिला";
var ERROR$8 = "एरर";
var NO_GROUPS_FOUND$8 = "कोई समूह नहीं मिला";
var NO_CHATS_FOUND$8 = "कोई चैट नहीं मिली";
var CANT__LOAD__CHATS$8 = "चैट लोड नहीं कर पा रहे";
var MEDIA_MESSAGE$8 = "मीडिया संदेश";
var INCOMING_AUDIO_CALL$8 = "इनकमिंग ऑडियो कॉल";
var INCOMING_VIDEO_CALL$8 = "इनकमिंग वीडियो कॉल";
var DECLINE$8 = "डिक्लाइन";
var ACCEPT$8 = "स्वीकारें";
var CALL_INITIATED$8 = "कॉल शुरू किया गया";
var OUTGOING_AUDIO_CALL$8 = "आउटगोइंग ऑडियो कॉल";
var OUTGOING_VIDEO_CALL$8 = "आउटगोइंग वीडियो कॉल";
var CALL_REJECTED$8 = "कॉल अस्वीकृत";
var REJECTED_CALL$8 = "अस्वीकृत कॉल";
var CALL_ACCEPTED$8 = "कॉल स्वीकार किया गया";
var OUTGOING_CALL$8 = "आउटगोइंग कॉल";
var INCOMING_CALL$8 = "इनकमिंग कॉल";
var MISSED_CALL$8 = "मिस्ड कॉल";
var JOINED$8 = "शामिल हो गए";
var LEFT_THE_CALL$8 = "कॉल छोड़ दिया";
var UNANSWERED_AUDIO_CALL$8 = "अनुत्तरित ऑडियो कॉल";
var UNANSWERED_VIDEO_CALL$8 = "अनुत्तरित वीडियो कॉल";
var CALL_ENDED$8 = "कॉल समाप्त हुआ";
var CALL_CANCELLED$8 = "कॉल कैंसिल किया गया";
var CALL_BUSY$8 = "व्यस्त को कॉल करें";
var CALLING$8 = "कॉलिंग...।";
var ADD$8 = "जोड़ें";
var NO_BANNED_MEMBERS_FOUND$8 = "कोई प्रतिबंधित सदस्य नहीं मिला";
var BANNED_MEMBERS$8 = "प्रतिबंधित सदस्य";
var NAME$8 = "नाम";
var SCOPE$8 = "स्कोप";
var UNBAN$8 = "अनबन";
var SELECT_GROUP_TYPE$8 = "ग्रुप क़िस्म चुनें";
var ENTER_GROUP_PASSWORD$8 = "ग्रुप पासवर्ड डालें";
var CREATE$8 = "बनाएँ";
var CREATE_POLL$8 = "पोल बनाएं";
var QUESTION$8 = "सवाल";
var ENTER_YOUR_QUESTION$8 = "अपना प्रश्न दर्ज करें";
var OPTIONS$8 = "ऑप्शन्स";
var ENTER_YOUR_OPTION$8 = "अपना विकल्प दर्ज करें";
var ADD_NEW_OPTION$8 = "नया विकल्प जोड़ें";
var VIEW_MEMBERS$8 = "सदस्यों को देखें";
var DETAILS$8 = "विवरण";
var NOTIFICATIONS$8 = "सूचनाएं";
var OTHER$8 = "अन्य";
var HELP$8 = "मदद";
var REPORT_PROBLEM$8 = "समस्या की रिपोर्ट करें";
var GROUP_MEMBERS$8 = "ग्रुप के सदस्य";
var BAN$8 = "बैन";
var KICK$8 = "किक";
var PICK_YOUR_EMOJI$8 = "अपना इमोजी चुनें";
var PRIVATE_GROUP$8 = "प्राइवेट ग्रुप";
var PROTECTED_GROUP$8 = "संरक्षित समूह";
var VISIT$8 = "विजिट करें";
var ATTACH$8 = "अटैच करें";
var OPEN_WHITEBOARD$8 = "व्हाइटबोर्ड खोलें";
var ATTACH_FILE$8 = "फ़ाइल संलग्न करें";
var GENERATING_REPLIES$8 = "जवाब जनरेट कर रहा";
var ATTACH_VIDEO$8 = "वीडियो संलग्न करें";
var ATTACH_AUDIO$8 = "ऑडियो अटैच करें";
var ATTACH_IMAGE$8 = "छवि संलग्न करें";
var COLLABORATE_USING_DOCUMENT$8 = "दस्तावेज़ का उपयोग करके सहयोग करें";
var COLLABORATE_USING_WHITEBOARD$8 = "व्हाइटबोर्ड का उपयोग करके सहयोग करें";
var SUGGEST_A_REPLY$8 = "जवाब सुझाएं";
var GENERATING_ICEBREAKERS$8 = "आइसब्रेकर बनाना";
var EMOJI$8 = "इमोजी";
var NO_REPLIES_FOUND$8 = "कोई जवाब नहीं मिला";
var ENTER_YOUR_MESSAGE_HERE$8 = "अपना संदेश यहां दर्ज करें";
var NO_MESSAGES_FOUND$8 = "कोई संदेश नहीं मिला";
var THREAD$8 = "थ्रेड";
var COLLABORATIVE_DOCUMENT$8 = "सहयोगात्मक दस्तावेज़";
var COLLABORATIVE_WHITEBOARD$8 = "सहयोगात्मक व्हाइटबोर्ड";
var ADD_REACTION$8 = "प्रतिक्रिया जोड़ें";
var NO_STICKERS_FOUND$8 = "कोई स्टिकर नहीं मिला";
var REPLY_TO_THREAD$8 = "थ्रेड का जवाब दें";
var REPLY_IN_THREAD$8 = "थ्रेड में जवाब दें";
var VIEW$8 = "देखें";
var DELETE_MESSAGE$8 = "संदेश मिटाएँ";
var EDIT_MESSAGE$8 = "संदेश संपादित करें";
var OWNER$8 = "मालिक";
var CHANGE_SCOPE$8 = "स्कोप बदलें";
var STICKER$8 = "स्टिकर";
var LAST_ACTIVE_AT$8 = "पिछली बार सक्रिय";
var VOICE_CALL$8 = "वॉइस कॉल";
var VIEW_DETAIL$8 = "विस्तार से देखें";
var VOTES$8 = "वोट";
var VOTE$8 = "वोट";
var NO_VOTE$8 = "कोई वोट नहीं";
var REACTED$8 = "प्रतिक्रिया व्यक्त की";
var ADDED$8 = "जोड़ा गया";
var SHOW_UNSAFE_CONTENT$8 = "क्या आप वाकई असुरक्षित सामग्री देखना चाहते हैं?";
var REACT_TO_MESSAGE$8 = "किसी संदेश पर प्रतिक्रिया दें";
var UNBANNED$8 = "अप्रतिबंधित";
var MADE$8 = "बनाया";
var CALL_UNANSWERED$8 = "कॉल अनुत्तरित";
var MISSED_AUDIO_CALL$8 = "मिस्ड ऑडियो कॉल";
var ENTER_YOUR_PASSWORD$8 = "अपना पासवर्ड डालें";
var DRAW_DOCUMENT_TOGETHER$8 = "सामग्री को एक साथ संपादित करने के लिए दस्तावेज़ खोलें";
var DOCS$8 = "डॉक्स";
var NO_RECORDS_FOUND$8 = "कोई रिकॉर्ड नहीं मिला";
var LIVE_REACTION$8 = "लाइव रिएक्शन";
var SMILEY_PEOPLE$8 = "स्माइलीज एंड पीपल";
var DRAW_WHITEBOARD_TOGETHER$8 = "एक साथ खींचने के लिए व्हाइटबोर्ड खोलें";
var ANIMALES_NATURE$8 = "पशु और प्रकृति";
var FOOD_DRINK$8 = "खाना और पीना";
var OPEN_DOCUMENT$8 = "दस्तावेज़ खोलें";
var ACTIVITY$8 = "गतिविधि";
var TRAVEL_PLACES$8 = "यात्रा और स्थान";
var OBJECTS$8 = "ऑब्जेक्ट्स";
var SYMBOLS$8 = "सिंबल";
var FLAGS$8 = "फ्लैग्स";
var SENT$8 = "भेजा गया";
var SEEN$8 = "देखा गया";
var DELIVERED$8 = "डिलीवर किया";
var READ$8 = "पढ़ें";
var MESSAGE_INFORMATION$8 = "संदेश की जानकारी";
var TRANSLATE_MESSAGE$8 = "संदेश का अनुवाद करें";
var TRANSLATED_MESSAGE$8 = "अनुवादित संदेश";
var LEFT$8 = "छोड़ दिया है";
var KICKED$8 = "लात मारी";
var BANNED$8 = "बारित";
var NEW_MESSAGES$8 = "नए संदेश";
var NEW_MESSAGE$8 = "नया संदेश";
var JUMP$8 = "जंप";
var SELECT_VIDEO_SOURCE$8 = "वीडियो स्रोत चुनें";
var SELECT_INPUT_AUDIO_SOURCE$8 = "इनपुट ऑडियो स्रोत का चयन करें";
var SELECT_OUTPUT_AUDIO_SOURCE$8 = "आउटपुट ऑडियो स्रोत चुनें";
var INITIATED_GROUP_CALL$8 = "समूह कॉल शुरू किया है";
var YOU_INITIATED_GROUP_CALL$8 = "आपने ग्रुप कॉल शुरू किया है";
var IGNORE$8 = "ध्यान न दें";
var ON_ANOTHER_CALL$8 = "एक और कॉल पर है";
var CREATING$8 = "बनाना";
var AVATAR$8 = "पुनर्जन्म";
var ONGOING_CALL$8 = "चल रही कॉल";
var YOU_ALREADY_ONGOING_CALL$8 = "आप पहले से चल रही कॉल में हैं";
var RESIZE$8 = "आकार बदलें";
var SETTINGS$8 = "सेटिंग्स";
var ACTIONS$8 = "क्रियाएँ";
var VIEW_PROFILE$8 = "प्रोफ़ाइल देखें";
var SEND_MESSAGE_IN_PRIVATE$8 = "संदेश निजी तौर पर भेजें";
var DELETE$8 = "मिटाएँ";
var DELETE_CONFIRM$8 = "क्या आप वाकई डिलीट करना चाहते हैं?";
var CANCEL$8 = "कैंसिल करें";
var LEAVE_CONFIRM$8 = "क्या आप वाकई समूह छोड़ना चाहते हैं?";
var TRANSFER_CONFIRM$8 = "आप समूह के स्वामी हैं; कृपया समूह छोड़ने से पहले किसी सदस्य को स्वामित्व हस्तांतरित करें";
var ADDING$8 = "जोड़ रहा है...";
var TRANSFER$8 = "ट्रांसफ़र";
var TRANSFER_OWNERSHIP$8 = "ट्रांसफर ओनरशिप";
var TRANSFERRING$8 = "ट्रांसफर किया जा रहा है";
var YES$8 = "हाँ";
var NO$8 = "नहीं";
var ANSWER$8 = "उत्तर";
var ADD_ANOTHER_ANSWER$8 = "एक और जवाब जोड़ें";
var SET_THE_ANSWERS$8 = "उत्तर सेट करें";
var TRY_AGAIN$8 = "फिर से कोशिश करें";
var INVALID_GROUP_NAME$8 = "कृपया ग्रुप के लिए मान्य नाम दर्ज़ करें और फिर से कोशिश करें";
var INVALID_PASSWORD$8 = "कृपया ग्रुप के लिए एक मान्य पासवर्ड डालें और फिर से कोशिश करें";
var INVALID_GROUP_TYPE$8 = "कृपया समूह के लिए एक मान्य प्रकार दर्ज करें और फिर से कोशिश करें";
var WRONG_PASSWORD$8 = "कृपया सही पासवर्ड डालें और फिर से कोशिश करें";
var INVALID_POLL_QUESTION$8 = "पोल बनाने से पहले कृपया आवश्यक प्रश्न दर्ज करें";
var INVALID_POLL_OPTION$8 = "पोल बनाने से पहले कृपया आवश्यक उत्तर दर्ज करें";
var SAME_LANGUAGE_MESSAGE$8 = "अनुवाद के लिए चुनी गई भाषा मूल संदेश की भाषा के समान है";
var LEAVE$8 = "लीव";
var CLICK_TO_START_CONVERSATION$8 = "बातचीत शुरू करने के लिए क्लिक करें";
var CUSTOM_MESSAGE_LOCATION$8 = "📍 स्थान";
var SHARED_LOCATION$8 = "साझा किया गया स्थान";
var IN_A_THREAD$8 = "एक सूत्र में";
var CALLS$8 = "कॉल्स";
var CALL_DETAILS$8 = "कॉल की जानकारी";
var OFFLINE$8 = "ऑफ़लाइन";
var POLLS$8 = "पोल";
var YOU$8 = "आप";
var PRIVACY$8 = "प्राइवेसी";
var BLOCKED_USERS$8 = "ब्लॉक किए गए यूज़र";
var NO_PHOTOS$8 = "कोई फ़ोटो नहीं";
var NO_VIDEOS$8 = "कोई वीडियो नहीं";
var NO_DOCUMENTS$8 = "कोई दस्तावेज़ नहीं";
var JOIN$8 = "जुड़ें";
var REMOVE$8 = "हटाएँ";
var BLOCK$8 = "ब्लॉक";
var CHANGE_ROLE$8 = "भूमिका बदलें";
var NEW_CHAT$8 = "नई चैट";
var FORM_COMPLETION_MESSAGE$8 = "फ़ॉर्म भरने के लिए धन्यवाद।";
var HISTORY$8 = "इतिहास";
var CANCELLED_AUDIO_CALL$8 = "रद्द किया गया ऑडियो कॉल";
var CANCELLED_VIDEO_CALL$8 = "रद्द किया गया वीडियो कॉल";
var REJECTED_AUDIO_CALL$8 = "अस्वीकृत ऑडियो कॉल";
var REJECTED_VIDEO_CALL$8 = "अस्वीकृत वीडियो कॉल";
var CANCELLED_CALL$8 = "रद्द की गई कॉल";
var UNANSWERED_CALL$8 = "अनुत्तरित कॉल";
var RECORDING$8 = "रिकॉर्डिंग";
var PARTICIPANTS$8 = "प्रतिभागी";
var CALL_HISTORY$8 = "कॉल हिस्ट्री";
var NO_CALLS_FOUND$8 = "कोई कॉल नहीं मिली";
var ONGOING_AUDIO_CALL$8 = "ऑडियो कॉल चल रही है";
var ONGOING_VIDEO_CALL$8 = "वीडियो कॉल जारी है";
var CALL_DETAIL$8 = "कॉल विवरण";
var FORM$8 = "प्रपत्र";
var CARD$8 = "कार्ड";
var GENERATING_SUMMARY$8 = "सारांश तैयार कर रहा है";
var CONVERSATION_SUMMARY$8 = "बातचीत का सारांश";
var GENERATE_SUMMARY$8 = "सारांश जेनरेट करें";
var COMETCHAT_BOT_FIRST_MESSAGE$8 = "मैं इस बातचीत में आपकी मदद कैसे कर सकता हूं? कृपया मुझसे एक प्रश्न पूछें और मैं आपको सलाह दूंगा 🙂";
var COMETCHAT_ASK_BOT$8 = "पूछो";
var COMETCHAT_ASK_AI_BOT$8 = "AI बॉट्स से पूछें";
var COMETCHAT_ASK_BOT_SUBTITLE$8 = "एआई बॉट";
var MENTIONS_LIMIT_WARNING_MESSAGE$8 = "आप एक बार में अधिकतम 10 बार तक उल्लेख कर सकते हैं।";
var ALL$8 = "सभी";
var CLICK_TO_REMOVE$8 = "हटाने के लिए क्लिक करें";
var OTHERS$8 = "अन्य लोगों";
var AND$8 = "एक";
var translationHI = {
	INFO: INFO$8,
	REACT: REACT$8,
	EDIT: EDIT$8,
	MESSAGE_PRIVATELY: MESSAGE_PRIVATELY$8,
	TRANSLATE: TRANSLATE$8,
	USERS: USERS$8,
	CHATS: CHATS$8,
	WOULD__YOU_LIKE_TO_DELETE_THIS_CONVERSATION: WOULD__YOU_LIKE_TO_DELETE_THIS_CONVERSATION$8,
	GROUPS: GROUPS$8,
	SHARED: SHARED$8,
	SOUND_MANAGER: SOUND_MANAGER$8,
	THEME: THEME$8,
	LOCALIZE: LOCALIZE$8,
	CONVERSATION_LIST_ITEM: CONVERSATION_LIST_ITEM$8,
	DATA_ITEM: DATA_ITEM$8,
	STATUS_INDICATOR: STATUS_INDICATOR$8,
	BADGE_COUNT: BADGE_COUNT$8,
	MESSAGE_RECEIPT: MESSAGE_RECEIPT$8,
	MESSAGE: MESSAGE$8,
	RECEIPT_INFORMATION: RECEIPT_INFORMATION$8,
	NO_RECIPIENT: NO_RECIPIENT$8,
	NO_RECIPIENTS: NO_RECIPIENTS$8,
	CONVERSATIONS_WITH_MESSAGES: CONVERSATIONS_WITH_MESSAGES$8,
	CONVERSATIONS: CONVERSATIONS$8,
	CONVERSATION_LIST: CONVERSATION_LIST$8,
	MESSAGES: MESSAGES$8,
	MESSAGE_HEADER: MESSAGE_HEADER$8,
	MESSAGE_LIST: MESSAGE_LIST$8,
	MESSAGE_COMPOSER: MESSAGE_COMPOSER$8,
	USERS_WITH_MESSAGES: USERS_WITH_MESSAGES$8,
	USER_LIST: USER_LIST$8,
	GROUP_LIST: GROUP_LIST$8,
	GROUPS_WITH_MESSAGES: GROUPS_WITH_MESSAGES$8,
	NEW__GROUP: NEW__GROUP$8,
	PASSWORD: PASSWORD$8,
	CONTINUE: CONTINUE$8,
	NO_CHATS_SELECTED: NO_CHATS_SELECTED$8,
	NO_USERS_SELECTED: NO_USERS_SELECTED$8,
	NO_GROUPS_SELECTED: NO_GROUPS_SELECTED$8,
	SELECT_DAY: SELECT_DAY$8,
	SELECT_TIME: SELECT_TIME$8,
	NO_CALLS_SELECTED: NO_CALLS_SELECTED$8,
	SELECT__GROUP: SELECT__GROUP$8,
	SELECT__USER: SELECT__USER$8,
	GROUP_PASSWORD_BLANK: GROUP_PASSWORD_BLANK$8,
	GROUP_NAME_BLANK: GROUP_NAME_BLANK$8,
	GROUP_TYPE_BLANK: GROUP_TYPE_BLANK$8,
	DELETE_CONVERSATION: DELETE_CONVERSATION$8,
	ADD_TO_CHAT: ADD_TO_CHAT$8,
	MORE: MORE$8,
	COPY: COPY$8,
	VOICE_RECORDING: VOICE_RECORDING$8,
	MESSAGE_IMAGE: MESSAGE_IMAGE$8,
	MESSAGE_FILE: MESSAGE_FILE$8,
	MESSAGE_VIDEO: MESSAGE_VIDEO$8,
	MESSAGE_AUDIO: MESSAGE_AUDIO$8,
	CUSTOM_MESSAGE: CUSTOM_MESSAGE$8,
	SELECT_A_DATE: SELECT_A_DATE$8,
	TIME_ZONE: TIME_ZONE$8,
	MEETING_SCHEDULED: MEETING_SCHEDULED$8,
	SOMETHING_WRONG: SOMETHING_WRONG$8,
	MEETING_SLOT_BOOK: MEETING_SLOT_BOOK$8,
	MEETING_BOOK_NEW_SLOT: MEETING_BOOK_NEW_SLOT$8,
	MEETING_NO_SLOTS_AVAILABLE: MEETING_NO_SLOTS_AVAILABLE$8,
	MEETING_TRY_DIFFERENT_DATE: MEETING_TRY_DIFFERENT_DATE$8,
	NO_TIME_SLOTS_AVAILABLE: NO_TIME_SLOTS_AVAILABLE$8,
	SCHEDULE: SCHEDULE$8,
	MORE_TIMES: MORE_TIMES$8,
	MISSED_VOICE_CALL: MISSED_VOICE_CALL$8,
	MEET_WITH: MEET_WITH$8,
	MEETING_SCHEDULER: MEETING_SCHEDULER$8,
	MISSED_VIDEO_CALL: MISSED_VIDEO_CALL$8,
	CUSTOM_MESSAGE_POLL: CUSTOM_MESSAGE_POLL$8,
	CUSTOM_MESSAGE_STICKER: CUSTOM_MESSAGE_STICKER$8,
	CUSTOM_MESSAGE_DOCUMENT: CUSTOM_MESSAGE_DOCUMENT$8,
	CUSTOM_MESSAGE_WHITEBOARD: CUSTOM_MESSAGE_WHITEBOARD$8,
	ONLINE: ONLINE$8,
	ADMINISTRATOR: ADMINISTRATOR$8,
	ADMIN: ADMIN$8,
	MODERATOR: MODERATOR$8,
	PARTICIPANT: PARTICIPANT$8,
	PUBLIC: PUBLIC$8,
	PRIVATE: PRIVATE$8,
	PASSWORD_PROTECTED: PASSWORD_PROTECTED$8,
	PRIVACY_AND_SECURITY: PRIVACY_AND_SECURITY$8,
	PREFERENCES: PREFERENCES$8,
	MEMBERS: MEMBERS$8,
	MEMBER: MEMBER$8,
	TODAY: TODAY$8,
	YESTERDAY: YESTERDAY$8,
	SUNDAY: SUNDAY$8,
	MONDAY: MONDAY$8,
	TUESDAY: TUESDAY$8,
	WEDNESDAY: WEDNESDAY$8,
	THURSDAY: THURSDAY$8,
	FRIDAY: FRIDAY$8,
	SATURDAY: SATURDAY$8,
	TYPING: TYPING$8,
	IS_TYPING: IS_TYPING$8,
	CLOSE: CLOSE$8,
	ENTER_GROUP_NAME: ENTER_GROUP_NAME$8,
	ADD_MEMBERS: ADD_MEMBERS$8,
	SEND_MESSAGE: SEND_MESSAGE$8,
	UNBLOCK_USER: UNBLOCK_USER$8,
	BLOCK_USER: BLOCK_USER$8,
	DELETE_AND_EXIT: DELETE_AND_EXIT$8,
	LEAVE_GROUP: LEAVE_GROUP$8,
	CREATE_GROUP: CREATE_GROUP$8,
	SHARED_MEDIA: SHARED_MEDIA$8,
	SHARED_FILE: SHARED_FILE$8,
	VIDEO_CALL: VIDEO_CALL$8,
	AUDIO_CALL: AUDIO_CALL$8,
	LOADING: LOADING$8,
	REPLY: REPLY$8,
	REPLIES: REPLIES$8,
	AI: AI$8,
	SMART_REPLIES: SMART_REPLIES$8,
	CONVERSATION_STARTER: CONVERSATION_STARTER$8,
	LAUNCH: LAUNCH$8,
	SHARED_COLLABORATIVE_DOCUMENT: SHARED_COLLABORATIVE_DOCUMENT$8,
	SHARED_COLLABORATIVE_WHITEBOARD: SHARED_COLLABORATIVE_WHITEBOARD$8,
	CREATED_WHITEBOARD: CREATED_WHITEBOARD$8,
	CREATED_DOCUMENT: CREATED_DOCUMENT$8,
	PHOTOS: PHOTOS$8,
	VIDEOS: VIDEOS$8,
	DOCUMENT: DOCUMENT$8,
	YOU_DELETED_THIS_MESSAGE: YOU_DELETED_THIS_MESSAGE$8,
	THIS_MESSAGE_DELETED: THIS_MESSAGE_DELETED$8,
	MESSAGE_IS_DELETED: MESSAGE_IS_DELETED$8,
	VIEW_ON_YOUTUBE: VIEW_ON_YOUTUBE$8,
	SEARCH: SEARCH$8,
	NO_USERS_FOUND: NO_USERS_FOUND$8,
	ERROR: ERROR$8,
	NO_GROUPS_FOUND: NO_GROUPS_FOUND$8,
	NO_CHATS_FOUND: NO_CHATS_FOUND$8,
	CANT__LOAD__CHATS: CANT__LOAD__CHATS$8,
	MEDIA_MESSAGE: MEDIA_MESSAGE$8,
	INCOMING_AUDIO_CALL: INCOMING_AUDIO_CALL$8,
	INCOMING_VIDEO_CALL: INCOMING_VIDEO_CALL$8,
	DECLINE: DECLINE$8,
	ACCEPT: ACCEPT$8,
	CALL_INITIATED: CALL_INITIATED$8,
	OUTGOING_AUDIO_CALL: OUTGOING_AUDIO_CALL$8,
	OUTGOING_VIDEO_CALL: OUTGOING_VIDEO_CALL$8,
	CALL_REJECTED: CALL_REJECTED$8,
	REJECTED_CALL: REJECTED_CALL$8,
	CALL_ACCEPTED: CALL_ACCEPTED$8,
	OUTGOING_CALL: OUTGOING_CALL$8,
	INCOMING_CALL: INCOMING_CALL$8,
	MISSED_CALL: MISSED_CALL$8,
	JOINED: JOINED$8,
	LEFT_THE_CALL: LEFT_THE_CALL$8,
	UNANSWERED_AUDIO_CALL: UNANSWERED_AUDIO_CALL$8,
	UNANSWERED_VIDEO_CALL: UNANSWERED_VIDEO_CALL$8,
	CALL_ENDED: CALL_ENDED$8,
	CALL_CANCELLED: CALL_CANCELLED$8,
	CALL_BUSY: CALL_BUSY$8,
	CALLING: CALLING$8,
	ADD: ADD$8,
	NO_BANNED_MEMBERS_FOUND: NO_BANNED_MEMBERS_FOUND$8,
	BANNED_MEMBERS: BANNED_MEMBERS$8,
	NAME: NAME$8,
	SCOPE: SCOPE$8,
	UNBAN: UNBAN$8,
	SELECT_GROUP_TYPE: SELECT_GROUP_TYPE$8,
	ENTER_GROUP_PASSWORD: ENTER_GROUP_PASSWORD$8,
	CREATE: CREATE$8,
	CREATE_POLL: CREATE_POLL$8,
	QUESTION: QUESTION$8,
	ENTER_YOUR_QUESTION: ENTER_YOUR_QUESTION$8,
	OPTIONS: OPTIONS$8,
	ENTER_YOUR_OPTION: ENTER_YOUR_OPTION$8,
	ADD_NEW_OPTION: ADD_NEW_OPTION$8,
	VIEW_MEMBERS: VIEW_MEMBERS$8,
	DETAILS: DETAILS$8,
	NOTIFICATIONS: NOTIFICATIONS$8,
	OTHER: OTHER$8,
	HELP: HELP$8,
	REPORT_PROBLEM: REPORT_PROBLEM$8,
	GROUP_MEMBERS: GROUP_MEMBERS$8,
	BAN: BAN$8,
	KICK: KICK$8,
	PICK_YOUR_EMOJI: PICK_YOUR_EMOJI$8,
	PRIVATE_GROUP: PRIVATE_GROUP$8,
	PROTECTED_GROUP: PROTECTED_GROUP$8,
	VISIT: VISIT$8,
	ATTACH: ATTACH$8,
	OPEN_WHITEBOARD: OPEN_WHITEBOARD$8,
	ATTACH_FILE: ATTACH_FILE$8,
	GENERATING_REPLIES: GENERATING_REPLIES$8,
	ATTACH_VIDEO: ATTACH_VIDEO$8,
	ATTACH_AUDIO: ATTACH_AUDIO$8,
	ATTACH_IMAGE: ATTACH_IMAGE$8,
	COLLABORATE_USING_DOCUMENT: COLLABORATE_USING_DOCUMENT$8,
	COLLABORATE_USING_WHITEBOARD: COLLABORATE_USING_WHITEBOARD$8,
	SUGGEST_A_REPLY: SUGGEST_A_REPLY$8,
	GENERATING_ICEBREAKERS: GENERATING_ICEBREAKERS$8,
	EMOJI: EMOJI$8,
	NO_REPLIES_FOUND: NO_REPLIES_FOUND$8,
	ENTER_YOUR_MESSAGE_HERE: ENTER_YOUR_MESSAGE_HERE$8,
	NO_MESSAGES_FOUND: NO_MESSAGES_FOUND$8,
	THREAD: THREAD$8,
	COLLABORATIVE_DOCUMENT: COLLABORATIVE_DOCUMENT$8,
	COLLABORATIVE_WHITEBOARD: COLLABORATIVE_WHITEBOARD$8,
	ADD_REACTION: ADD_REACTION$8,
	NO_STICKERS_FOUND: NO_STICKERS_FOUND$8,
	REPLY_TO_THREAD: REPLY_TO_THREAD$8,
	REPLY_IN_THREAD: REPLY_IN_THREAD$8,
	VIEW: VIEW$8,
	DELETE_MESSAGE: DELETE_MESSAGE$8,
	EDIT_MESSAGE: EDIT_MESSAGE$8,
	OWNER: OWNER$8,
	CHANGE_SCOPE: CHANGE_SCOPE$8,
	STICKER: STICKER$8,
	LAST_ACTIVE_AT: LAST_ACTIVE_AT$8,
	VOICE_CALL: VOICE_CALL$8,
	VIEW_DETAIL: VIEW_DETAIL$8,
	VOTES: VOTES$8,
	VOTE: VOTE$8,
	NO_VOTE: NO_VOTE$8,
	REACTED: REACTED$8,
	ADDED: ADDED$8,
	SHOW_UNSAFE_CONTENT: SHOW_UNSAFE_CONTENT$8,
	REACT_TO_MESSAGE: REACT_TO_MESSAGE$8,
	UNBANNED: UNBANNED$8,
	MADE: MADE$8,
	CALL_UNANSWERED: CALL_UNANSWERED$8,
	MISSED_AUDIO_CALL: MISSED_AUDIO_CALL$8,
	ENTER_YOUR_PASSWORD: ENTER_YOUR_PASSWORD$8,
	DRAW_DOCUMENT_TOGETHER: DRAW_DOCUMENT_TOGETHER$8,
	DOCS: DOCS$8,
	NO_RECORDS_FOUND: NO_RECORDS_FOUND$8,
	LIVE_REACTION: LIVE_REACTION$8,
	SMILEY_PEOPLE: SMILEY_PEOPLE$8,
	DRAW_WHITEBOARD_TOGETHER: DRAW_WHITEBOARD_TOGETHER$8,
	ANIMALES_NATURE: ANIMALES_NATURE$8,
	FOOD_DRINK: FOOD_DRINK$8,
	OPEN_DOCUMENT: OPEN_DOCUMENT$8,
	ACTIVITY: ACTIVITY$8,
	TRAVEL_PLACES: TRAVEL_PLACES$8,
	OBJECTS: OBJECTS$8,
	SYMBOLS: SYMBOLS$8,
	FLAGS: FLAGS$8,
	SENT: SENT$8,
	SEEN: SEEN$8,
	DELIVERED: DELIVERED$8,
	READ: READ$8,
	MESSAGE_INFORMATION: MESSAGE_INFORMATION$8,
	TRANSLATE_MESSAGE: TRANSLATE_MESSAGE$8,
	TRANSLATED_MESSAGE: TRANSLATED_MESSAGE$8,
	LEFT: LEFT$8,
	KICKED: KICKED$8,
	BANNED: BANNED$8,
	NEW_MESSAGES: NEW_MESSAGES$8,
	NEW_MESSAGE: NEW_MESSAGE$8,
	JUMP: JUMP$8,
	SELECT_VIDEO_SOURCE: SELECT_VIDEO_SOURCE$8,
	SELECT_INPUT_AUDIO_SOURCE: SELECT_INPUT_AUDIO_SOURCE$8,
	SELECT_OUTPUT_AUDIO_SOURCE: SELECT_OUTPUT_AUDIO_SOURCE$8,
	INITIATED_GROUP_CALL: INITIATED_GROUP_CALL$8,
	YOU_INITIATED_GROUP_CALL: YOU_INITIATED_GROUP_CALL$8,
	IGNORE: IGNORE$8,
	ON_ANOTHER_CALL: ON_ANOTHER_CALL$8,
	CREATING: CREATING$8,
	AVATAR: AVATAR$8,
	ONGOING_CALL: ONGOING_CALL$8,
	YOU_ALREADY_ONGOING_CALL: YOU_ALREADY_ONGOING_CALL$8,
	RESIZE: RESIZE$8,
	SETTINGS: SETTINGS$8,
	ACTIONS: ACTIONS$8,
	VIEW_PROFILE: VIEW_PROFILE$8,
	SEND_MESSAGE_IN_PRIVATE: SEND_MESSAGE_IN_PRIVATE$8,
	DELETE: DELETE$8,
	DELETE_CONFIRM: DELETE_CONFIRM$8,
	CANCEL: CANCEL$8,
	LEAVE_CONFIRM: LEAVE_CONFIRM$8,
	TRANSFER_CONFIRM: TRANSFER_CONFIRM$8,
	ADDING: ADDING$8,
	TRANSFER: TRANSFER$8,
	TRANSFER_OWNERSHIP: TRANSFER_OWNERSHIP$8,
	TRANSFERRING: TRANSFERRING$8,
	YES: YES$8,
	NO: NO$8,
	ANSWER: ANSWER$8,
	ADD_ANOTHER_ANSWER: ADD_ANOTHER_ANSWER$8,
	SET_THE_ANSWERS: SET_THE_ANSWERS$8,
	TRY_AGAIN: TRY_AGAIN$8,
	INVALID_GROUP_NAME: INVALID_GROUP_NAME$8,
	INVALID_PASSWORD: INVALID_PASSWORD$8,
	INVALID_GROUP_TYPE: INVALID_GROUP_TYPE$8,
	WRONG_PASSWORD: WRONG_PASSWORD$8,
	INVALID_POLL_QUESTION: INVALID_POLL_QUESTION$8,
	INVALID_POLL_OPTION: INVALID_POLL_OPTION$8,
	SAME_LANGUAGE_MESSAGE: SAME_LANGUAGE_MESSAGE$8,
	LEAVE: LEAVE$8,
	CLICK_TO_START_CONVERSATION: CLICK_TO_START_CONVERSATION$8,
	CUSTOM_MESSAGE_LOCATION: CUSTOM_MESSAGE_LOCATION$8,
	SHARED_LOCATION: SHARED_LOCATION$8,
	IN_A_THREAD: IN_A_THREAD$8,
	CALLS: CALLS$8,
	CALL_DETAILS: CALL_DETAILS$8,
	OFFLINE: OFFLINE$8,
	POLLS: POLLS$8,
	YOU: YOU$8,
	PRIVACY: PRIVACY$8,
	BLOCKED_USERS: BLOCKED_USERS$8,
	"YOU'VE_BLOCKED": "आपने ब्लॉक कर दिया है",
	NO_PHOTOS: NO_PHOTOS$8,
	NO_VIDEOS: NO_VIDEOS$8,
	NO_DOCUMENTS: NO_DOCUMENTS$8,
	JOIN: JOIN$8,
	REMOVE: REMOVE$8,
	BLOCK: BLOCK$8,
	CHANGE_ROLE: CHANGE_ROLE$8,
	NEW_CHAT: NEW_CHAT$8,
	FORM_COMPLETION_MESSAGE: FORM_COMPLETION_MESSAGE$8,
	HISTORY: HISTORY$8,
	CANCELLED_AUDIO_CALL: CANCELLED_AUDIO_CALL$8,
	CANCELLED_VIDEO_CALL: CANCELLED_VIDEO_CALL$8,
	REJECTED_AUDIO_CALL: REJECTED_AUDIO_CALL$8,
	REJECTED_VIDEO_CALL: REJECTED_VIDEO_CALL$8,
	CANCELLED_CALL: CANCELLED_CALL$8,
	UNANSWERED_CALL: UNANSWERED_CALL$8,
	RECORDING: RECORDING$8,
	PARTICIPANTS: PARTICIPANTS$8,
	CALL_HISTORY: CALL_HISTORY$8,
	NO_CALLS_FOUND: NO_CALLS_FOUND$8,
	ONGOING_AUDIO_CALL: ONGOING_AUDIO_CALL$8,
	ONGOING_VIDEO_CALL: ONGOING_VIDEO_CALL$8,
	CALL_DETAIL: CALL_DETAIL$8,
	FORM: FORM$8,
	CARD: CARD$8,
	GENERATING_SUMMARY: GENERATING_SUMMARY$8,
	CONVERSATION_SUMMARY: CONVERSATION_SUMMARY$8,
	GENERATE_SUMMARY: GENERATE_SUMMARY$8,
	COMETCHAT_BOT_FIRST_MESSAGE: COMETCHAT_BOT_FIRST_MESSAGE$8,
	COMETCHAT_ASK_BOT: COMETCHAT_ASK_BOT$8,
	COMETCHAT_ASK_AI_BOT: COMETCHAT_ASK_AI_BOT$8,
	COMETCHAT_ASK_BOT_SUBTITLE: COMETCHAT_ASK_BOT_SUBTITLE$8,
	MENTIONS_LIMIT_WARNING_MESSAGE: MENTIONS_LIMIT_WARNING_MESSAGE$8,
	ALL: ALL$8,
	CLICK_TO_REMOVE: CLICK_TO_REMOVE$8,
	OTHERS: OTHERS$8,
	AND: AND$8
};

var INFO$7 = "Maklumat";
var REACT$7 = "Bertindak balas";
var EDIT$7 = "Sunting";
var MESSAGE_PRIVATELY$7 = "Mesej Persendirian";
var TRANSLATE$7 = "Terjemah";
var USERS$7 = "Pengguna";
var CHATS$7 = "Sembang";
var WOULD__YOU_LIKE_TO_DELETE_THIS_CONVERSATION$7 = "Adakah anda ingin memadamkan perbualan ini? Perbualan ini akan dipadamkan dari semua peranti anda.";
var GROUPS$7 = "Kumpulan";
var SHARED$7 = "Dikongsi";
var SOUND_MANAGER$7 = "Pengurus bunyi";
var THEME$7 = "Tema";
var LOCALIZE$7 = "Melokalisasikan";
var CONVERSATION_LIST_ITEM$7 = "Item Senarai Perbualan";
var DATA_ITEM$7 = "Item Data";
var STATUS_INDICATOR$7 = "Penunjuk Status";
var BADGE_COUNT$7 = "Kiraan lencana";
var MESSAGE_RECEIPT$7 = "Penerimaan Mesej";
var MESSAGE$7 = "Pesanan";
var RECEIPT_INFORMATION$7 = "Maklumat Resit";
var NO_RECIPIENT$7 = "Tiada Penerima";
var NO_RECIPIENTS$7 = "Tiada Penerima";
var CONVERSATIONS_WITH_MESSAGES$7 = "Perbualan Dengan Mesej";
var CONVERSATIONS$7 = "Perbualan";
var CONVERSATION_LIST$7 = "Senarai Perbualan";
var MESSAGES$7 = "Mesej";
var MESSAGE_HEADER$7 = "Tajuk Mesej";
var MESSAGE_LIST$7 = "Senarai Mesej";
var MESSAGE_COMPOSER$7 = "Komposer Mesej";
var USERS_WITH_MESSAGES$7 = "Pengguna Dengan Mesej";
var USER_LIST$7 = "Senarai Pengguna";
var GROUP_LIST$7 = "Senarai Kumpulan";
var GROUPS_WITH_MESSAGES$7 = "Kumpulan Dengan Mesej";
var NEW__GROUP$7 = "Kumpulan Baru";
var PASSWORD$7 = "Kata Laluan";
var CONTINUE$7 = "Teruskan";
var NO_CHATS_SELECTED$7 = "Tiada Sembang Dipilih";
var NO_USERS_SELECTED$7 = "Tiada Pengguna Yang Dipilih";
var NO_GROUPS_SELECTED$7 = "Tiada Kumpulan Terpilih";
var SELECT_DAY$7 = "Pilih Hari";
var SELECT_TIME$7 = "Pilih Masa";
var NO_CALLS_SELECTED$7 = "Tiada Panggilan Dipilih";
var SELECT__GROUP$7 = "Pilih kumpulan untuk memulakan pemesejan";
var SELECT__USER$7 = "Pilih pengguna untuk memulakan pemesejan";
var GROUP_PASSWORD_BLANK$7 = "Kata laluan kumpulan tidak boleh kosong";
var GROUP_NAME_BLANK$7 = "Nama kumpulan tidak boleh kosong";
var GROUP_TYPE_BLANK$7 = "Jenis kumpulan tidak boleh kosong";
var DELETE_CONVERSATION$7 = "Padam Perbualan?";
var ADD_TO_CHAT$7 = "Tambah ke Sembang";
var MORE$7 = "Lagi";
var COPY$7 = "Salin";
var VOICE_RECORDING$7 = "Rakaman Suara";
var MESSAGE_IMAGE$7 = "📷 Imej";
var MESSAGE_FILE$7 = "📁 Fail";
var MESSAGE_VIDEO$7 = "📹 Video";
var MESSAGE_AUDIO$7 = "🎵 Audio";
var CUSTOM_MESSAGE$7 = "Anda mempunyai mesej";
var SELECT_A_DATE$7 = "Pilih tarikh";
var TIME_ZONE$7 = "Zon Waktu";
var MEETING_SCHEDULED$7 = "Mesyuarat anda telah dijadualkan.";
var SOMETHING_WRONG$7 = "Ada yang salah. Sila cuba lagi.";
var MEETING_SLOT_BOOK$7 = "Slot masa tidak lagi tersedia. Sila pilih yang lain.";
var MEETING_BOOK_NEW_SLOT$7 = "Tempah Slot Baru";
var MEETING_NO_SLOTS_AVAILABLE$7 = "Tiada slot masa tersedia untuk tarikh ini. Sila cuba tarikh lain.";
var MEETING_TRY_DIFFERENT_DATE$7 = "Sila cuba tarikh yang berbeza.";
var NO_TIME_SLOTS_AVAILABLE$7 = "Tiada slot masa tersedia";
var SCHEDULE$7 = "Jadual";
var MORE_TIMES$7 = "Lebih banyak kali";
var MISSED_VOICE_CALL$7 = "Panggilan suara terlepas";
var MEET_WITH$7 = "Bertemu Dengan";
var MEETING_SCHEDULER$7 = "Penjadual Mesyuarat";
var MISSED_VIDEO_CALL$7 = "Panggilan video terlepas";
var CUSTOM_MESSAGE_POLL$7 = "📊 Undian";
var CUSTOM_MESSAGE_STICKER$7 = "💟 Pelekat";
var CUSTOM_MESSAGE_DOCUMENT$7 = "📃 Dokumen";
var CUSTOM_MESSAGE_WHITEBOARD$7 = "📝 Papan putih";
var ONLINE$7 = "Dalam Talian";
var ADMINISTRATOR$7 = "Pentadbir";
var ADMIN$7 = "Pentadbir";
var MODERATOR$7 = "penyampai";
var PARTICIPANT$7 = "Peserta";
var PUBLIC$7 = "Awam";
var PRIVATE$7 = "Persendirian";
var PASSWORD_PROTECTED$7 = "Kata Laluan Dilindungi";
var PRIVACY_AND_SECURITY$7 = "Privasi dan Keselamatan";
var PREFERENCES$7 = "Keutamaan";
var MEMBERS$7 = "Ahli";
var MEMBER$7 = "Angota";
var TODAY$7 = "Hari ini";
var YESTERDAY$7 = "Semalam";
var SUNDAY$7 = "Ahad";
var MONDAY$7 = "Isnin";
var TUESDAY$7 = "Selasa";
var WEDNESDAY$7 = "Rabu";
var THURSDAY$7 = "Khamis";
var FRIDAY$7 = "Jumaat";
var SATURDAY$7 = "Sabtu";
var TYPING$7 = "menaip...";
var IS_TYPING$7 = "sedang menaip...";
var CLOSE$7 = "Tutup";
var ENTER_GROUP_NAME$7 = "Masukkan nama kumpulan";
var ADD_MEMBERS$7 = "Tambah Ahli";
var SEND_MESSAGE$7 = "Hantar Mesej";
var UNBLOCK_USER$7 = "Nyahsekat Pengguna";
var BLOCK_USER$7 = "Sekat Pengguna";
var DELETE_AND_EXIT$7 = "Padam dan Keluar";
var LEAVE_GROUP$7 = "Tinggalkan Kumpulan";
var CREATE_GROUP$7 = "Buat Kumpulan";
var SHARED_MEDIA$7 = "Media Dikongsi";
var SHARED_FILE$7 = "Fail Dikongsi";
var VIDEO_CALL$7 = "Panggilan video";
var AUDIO_CALL$7 = "Panggilan audio";
var LOADING$7 = "Memuatkan...";
var REPLY$7 = "jawapan";
var REPLIES$7 = "balasannya";
var AI$7 = "KECERDASAN BUATAN";
var SMART_REPLIES$7 = "Balasan Pintar";
var CONVERSATION_STARTER$7 = "Permulaan Perbualan";
var LAUNCH$7 = "Pelancaran";
var SHARED_COLLABORATIVE_DOCUMENT$7 = "telah berkongsi dokumen kolaboratif";
var SHARED_COLLABORATIVE_WHITEBOARD$7 = "telah berkongsi papan putih kolaboratif";
var CREATED_WHITEBOARD$7 = "Anda telah mencipta papan putih kolaboratif baru";
var CREATED_DOCUMENT$7 = "Anda telah mencipta dokumen kolaboratif baru";
var PHOTOS$7 = "Gambar";
var VIDEOS$7 = "Video";
var DOCUMENT$7 = "Dokumen";
var YOU_DELETED_THIS_MESSAGE$7 = "⚠️ Anda memadamkan mesej ini";
var THIS_MESSAGE_DELETED$7 = "⚠️ Mesej ini telah dipadamkan";
var MESSAGE_IS_DELETED$7 = "Mesej dipadamkan";
var VIEW_ON_YOUTUBE$7 = "Lihat di Youtube";
var SEARCH$7 = "Cari";
var NO_USERS_FOUND$7 = "Tiada pengguna ditemui";
var ERROR$7 = "Ralat";
var NO_GROUPS_FOUND$7 = "Tiada kumpulan ditemui";
var NO_CHATS_FOUND$7 = "Tiada sembang ditemui";
var CANT__LOAD__CHATS$7 = "Tidak boleh memuatkan sembang";
var MEDIA_MESSAGE$7 = "Mesej media";
var INCOMING_AUDIO_CALL$7 = "Panggilan audio masuk";
var INCOMING_VIDEO_CALL$7 = "Panggilan video masuk";
var DECLINE$7 = "Menolak";
var ACCEPT$7 = "Terima";
var CALL_INITIATED$7 = "Panggilan dimulakan";
var OUTGOING_AUDIO_CALL$7 = "Panggilan audio keluar";
var OUTGOING_VIDEO_CALL$7 = "Panggilan video keluar";
var CALL_REJECTED$7 = "Panggilan ditolak";
var REJECTED_CALL$7 = "panggilan ditolak";
var CALL_ACCEPTED$7 = "Panggilan diterima";
var OUTGOING_CALL$7 = "Panggilan keluar";
var INCOMING_CALL$7 = "Panggilan masuk";
var MISSED_CALL$7 = "Panggilan tidak dijawab";
var JOINED$7 = "menyertai";
var LEFT_THE_CALL$7 = "meninggalkan panggilan";
var UNANSWERED_AUDIO_CALL$7 = "Panggilan audio yang tidak dijawab";
var UNANSWERED_VIDEO_CALL$7 = "Panggilan video yang tidak dijawab";
var CALL_ENDED$7 = "Panggilan berakhir";
var CALL_CANCELLED$7 = "Panggilan dibatalkan";
var CALL_BUSY$7 = "Panggilan sibuk";
var CALLING$7 = "Memanggil...";
var ADD$7 = "Tambah";
var NO_BANNED_MEMBERS_FOUND$7 = "Tiada ahli yang dilarang ditemui";
var BANNED_MEMBERS$7 = "Ahli yang diharamkan";
var NAME$7 = "Nama";
var SCOPE$7 = "Skop";
var UNBAN$7 = "Unban";
var SELECT_GROUP_TYPE$7 = "Pilih jenis kumpulan";
var ENTER_GROUP_PASSWORD$7 = "Masukkan kata laluan kumpulan";
var CREATE$7 = "Buat";
var CREATE_POLL$7 = "Buat Undian";
var QUESTION$7 = "Soalan";
var ENTER_YOUR_QUESTION$7 = "Masukkan soalan anda";
var OPTIONS$7 = "Pilihan";
var ENTER_YOUR_OPTION$7 = "Masukkan pilihan anda";
var ADD_NEW_OPTION$7 = "Tambah pilihan baru";
var VIEW_MEMBERS$7 = "Lihat Ahli";
var DETAILS$7 = "Butiran";
var NOTIFICATIONS$7 = "Pemberitahuan";
var OTHER$7 = "Lain-lain";
var HELP$7 = "Bantuan";
var REPORT_PROBLEM$7 = "Laporkan Masalah";
var GROUP_MEMBERS$7 = "Ahli Kumpulan";
var BAN$7 = "Larangan";
var KICK$7 = "Tendang";
var PICK_YOUR_EMOJI$7 = "Pilih emoji anda";
var PRIVATE_GROUP$7 = "Kumpulan Swasta";
var PROTECTED_GROUP$7 = "Kumpulan yang dilindungi";
var VISIT$7 = "Lawatan";
var ATTACH$7 = "Lampirkan";
var OPEN_WHITEBOARD$7 = "Buka Papan Putih";
var ATTACH_FILE$7 = "Lampirkan fail";
var GENERATING_REPLIES$7 = "Menjana balasan";
var ATTACH_VIDEO$7 = "Lampirkan video";
var ATTACH_AUDIO$7 = "Lampirkan audio";
var ATTACH_IMAGE$7 = "Lampirkan imej";
var COLLABORATE_USING_DOCUMENT$7 = "Bekerjasama menggunakan dokumen";
var COLLABORATE_USING_WHITEBOARD$7 = "Bekerjasama menggunakan papan putih";
var SUGGEST_A_REPLY$7 = "Cadangkan balasan";
var GENERATING_ICEBREAKERS$7 = "Menjana pemecah ais";
var EMOJI$7 = "Emotikon";
var NO_REPLIES_FOUND$7 = "Tiada Balasan Ditemui";
var ENTER_YOUR_MESSAGE_HERE$7 = "Masukkan mesej anda di sini";
var NO_MESSAGES_FOUND$7 = "Tiada mesej ditemui";
var THREAD$7 = "Benang";
var COLLABORATIVE_DOCUMENT$7 = "Dokumen Kolaboratif";
var COLLABORATIVE_WHITEBOARD$7 = "Papan Putih Kolaboratif";
var ADD_REACTION$7 = "Tambah tindak balas";
var NO_STICKERS_FOUND$7 = "Tiada pelekat ditemui";
var REPLY_TO_THREAD$7 = "Balas kepada thread";
var REPLY_IN_THREAD$7 = "Balas dalam thread";
var VIEW$7 = "Lihat";
var DELETE_MESSAGE$7 = "Padamkan mesej";
var EDIT_MESSAGE$7 = "Edit mesej";
var OWNER$7 = "Pemilik";
var CHANGE_SCOPE$7 = "Tukar Skop";
var STICKER$7 = "Pelekat";
var LAST_ACTIVE_AT$7 = "Terakhir Aktif Di";
var VOICE_CALL$7 = "Panggilan suara";
var VIEW_DETAIL$7 = "Lihat Butiran";
var VOTES$7 = "undi";
var VOTE$7 = "undi";
var NO_VOTE$7 = "Tiada undi";
var REACTED$7 = "bertindak balas";
var ADDED$7 = "campurkan";
var SHOW_UNSAFE_CONTENT$7 = "Adakah anda pasti mahu melihat kandungan yang tidak selamat?";
var REACT_TO_MESSAGE$7 = "Bertindak balas terhadap mesej";
var UNBANNED$7 = "tidak diharamkan";
var MADE$7 = "diperbuat";
var CALL_UNANSWERED$7 = "Panggilan tidak dijawab";
var MISSED_AUDIO_CALL$7 = "Panggilan audio terlepas";
var ENTER_YOUR_PASSWORD$7 = "Masukkan kata laluan anda";
var DRAW_DOCUMENT_TOGETHER$7 = "Buka dokumen untuk mengedit kandungan bersama-sama";
var DOCS$7 = "Dokumen";
var NO_RECORDS_FOUND$7 = "Tiada rekod ditemui";
var LIVE_REACTION$7 = "Reaksi Langsung";
var SMILEY_PEOPLE$7 = "Senyuman & Orang";
var DRAW_WHITEBOARD_TOGETHER$7 = "Buka papan putih untuk menggambar bersama";
var ANIMALES_NATURE$7 = "Haiwan & Alam";
var FOOD_DRINK$7 = "Makanan & Minuman";
var OPEN_DOCUMENT$7 = "Buka Dokumen";
var ACTIVITY$7 = "Aktiviti";
var TRAVEL_PLACES$7 = "Perjalanan & Tempat";
var OBJECTS$7 = "Objek";
var SYMBOLS$7 = "Simbol";
var FLAGS$7 = "Bendera";
var SENT$7 = "Menghantar";
var SEEN$7 = "Dilihat";
var DELIVERED$7 = "Dihantar";
var READ$7 = "Baca";
var MESSAGE_INFORMATION$7 = "Maklumat Mesej";
var TRANSLATE_MESSAGE$7 = "Terjemah mesej";
var TRANSLATED_MESSAGE$7 = "Mesej diterjemahkan";
var LEFT$7 = "ditinggalkan";
var KICKED$7 = "ditendang";
var BANNED$7 = "diharamkan";
var NEW_MESSAGES$7 = "mesej baru";
var NEW_MESSAGE$7 = "mesej baru";
var JUMP$7 = "Lompat";
var SELECT_VIDEO_SOURCE$7 = "Pilih sumber video";
var SELECT_INPUT_AUDIO_SOURCE$7 = "Pilih sumber audio input";
var SELECT_OUTPUT_AUDIO_SOURCE$7 = "Pilih sumber audio output";
var INITIATED_GROUP_CALL$7 = "telah memulakan panggilan kumpulan";
var YOU_INITIATED_GROUP_CALL$7 = "Anda telah memulakan panggilan kumpulan";
var IGNORE$7 = "Abaikan";
var ON_ANOTHER_CALL$7 = "sedang dalam panggilan lain";
var CREATING$7 = "Mewujudkan";
var AVATAR$7 = "Avatar";
var ONGOING_CALL$7 = "Panggilan berterusan";
var YOU_ALREADY_ONGOING_CALL$7 = "Anda sudah dalam panggilan berterusan";
var RESIZE$7 = "Ubah saiz";
var SETTINGS$7 = "Tetapan";
var ACTIONS$7 = "Tindakan";
var VIEW_PROFILE$7 = "Lihat Profil";
var SEND_MESSAGE_IN_PRIVATE$7 = "Hantar mesej secara peribadi";
var DELETE$7 = "Padam";
var DELETE_CONFIRM$7 = "Adakah anda pasti mahu memadam?";
var CANCEL$7 = "Batalkan";
var LEAVE_CONFIRM$7 = "Adakah anda pasti mahu meninggalkan kumpulan itu?";
var TRANSFER_CONFIRM$7 = "Anda adalah pemilik kumpulan; sila pindahkan pemilikan kepada ahli sebelum meninggalkan kumpulan";
var ADDING$7 = "Menambah...";
var TRANSFER$7 = "Pemindahan";
var TRANSFER_OWNERSHIP$7 = "Pemindahan Pemilikan";
var TRANSFERRING$7 = "Memindahkan";
var YES$7 = "Ya";
var NO$7 = "Tidak";
var ANSWER$7 = "Jawapan";
var ADD_ANOTHER_ANSWER$7 = "Tambah Jawapan Lain";
var SET_THE_ANSWERS$7 = "TETAPKAN JAWAPAN";
var TRY_AGAIN$7 = "Cuba lagi";
var INVALID_GROUP_NAME$7 = "Sila masukkan nama yang sah untuk kumpulan dan cuba lagi";
var INVALID_PASSWORD$7 = "Sila masukkan kata laluan yang sah untuk kumpulan dan cuba lagi";
var INVALID_GROUP_TYPE$7 = "Sila masukkan jenis yang sah untuk kumpulan dan cuba lagi";
var WRONG_PASSWORD$7 = "Sila masukkan kata laluan yang betul dan cuba lagi";
var INVALID_POLL_QUESTION$7 = "Sila masukkan soalan yang diperlukan sebelum membuat pengundian";
var INVALID_POLL_OPTION$7 = "Sila masukkan jawapan yang diperlukan sebelum membuat pengundian";
var SAME_LANGUAGE_MESSAGE$7 = "Bahasa terpilih untuk terjemahan adalah serupa dengan bahasa mesej asal";
var LEAVE$7 = "Tinggalkan";
var CLICK_TO_START_CONVERSATION$7 = "Klik untuk memulakan perbualan";
var CUSTOM_MESSAGE_LOCATION$7 = "📍 Lokasi";
var SHARED_LOCATION$7 = "Lokasi Dikongsi";
var IN_A_THREAD$7 = "Dalam benang";
var CALLS$7 = "Panggilan";
var CALL_DETAILS$7 = "Butiran Panggilan";
var OFFLINE$7 = "Luar talian";
var POLLS$7 = "Undian";
var YOU$7 = "Anda";
var PRIVACY$7 = "Privasi";
var BLOCKED_USERS$7 = "Pengguna yang disekat";
var NO_PHOTOS$7 = "Tiada Foto";
var NO_VIDEOS$7 = "Tiada Video";
var NO_DOCUMENTS$7 = "Tiada Dokumen";
var JOIN$7 = "Sertai";
var REMOVE$7 = "Keluarkan";
var BLOCK$7 = "Sekat";
var CHANGE_ROLE$7 = "Tukar Peranan";
var NEW_CHAT$7 = "Sembang Baru";
var FORM_COMPLETION_MESSAGE$7 = "Terima kasih kerana mengisi borang.";
var HISTORY$7 = "Sejarah";
var CANCELLED_AUDIO_CALL$7 = "Panggilan audio yang dibatalkan";
var CANCELLED_VIDEO_CALL$7 = "Panggilan video dibatalkan";
var REJECTED_AUDIO_CALL$7 = "Panggilan audio ditolak";
var REJECTED_VIDEO_CALL$7 = "Panggilan video ditolak";
var CANCELLED_CALL$7 = "Panggilan dibatalkan";
var UNANSWERED_CALL$7 = "Panggilan tidak dijawab";
var RECORDING$7 = "Rakaman";
var PARTICIPANTS$7 = "Peserta";
var CALL_HISTORY$7 = "Sejarah Panggilan";
var NO_CALLS_FOUND$7 = "Tiada Panggilan Ditemui";
var ONGOING_AUDIO_CALL$7 = "Panggilan audio berterusan";
var ONGOING_VIDEO_CALL$7 = "Panggilan video berterusan";
var CALL_DETAIL$7 = "Butiran Panggilan";
var FORM$7 = "Borang";
var CARD$7 = "Kad";
var GENERATING_SUMMARY$7 = "Menjana ringkasan";
var CONVERSATION_SUMMARY$7 = "Ringkasan perbualan";
var GENERATE_SUMMARY$7 = "Menjana ringkasan";
var COMETCHAT_BOT_FIRST_MESSAGE$7 = "Bagaimana saya boleh membantu anda dalam perbualan ini? Sila tanya saya soalan dan saya akan memberi nasihat kepada anda 🙂";
var COMETCHAT_ASK_BOT$7 = "Tanya";
var COMETCHAT_ASK_AI_BOT$7 = "Tanya AI Bots";
var COMETCHAT_ASK_BOT_SUBTITLE$7 = "AI Bot";
var MENTIONS_LIMIT_WARNING_MESSAGE$7 = "Anda boleh menyebut sehingga 10 kali pada satu masa.";
var ALL$7 = "Semua";
var CLICK_TO_REMOVE$7 = "Klik untuk membuang";
var OTHERS$7 = "lain";
var AND$7 = "suatu";
var translationMS = {
	INFO: INFO$7,
	REACT: REACT$7,
	EDIT: EDIT$7,
	MESSAGE_PRIVATELY: MESSAGE_PRIVATELY$7,
	TRANSLATE: TRANSLATE$7,
	USERS: USERS$7,
	CHATS: CHATS$7,
	WOULD__YOU_LIKE_TO_DELETE_THIS_CONVERSATION: WOULD__YOU_LIKE_TO_DELETE_THIS_CONVERSATION$7,
	GROUPS: GROUPS$7,
	SHARED: SHARED$7,
	SOUND_MANAGER: SOUND_MANAGER$7,
	THEME: THEME$7,
	LOCALIZE: LOCALIZE$7,
	CONVERSATION_LIST_ITEM: CONVERSATION_LIST_ITEM$7,
	DATA_ITEM: DATA_ITEM$7,
	STATUS_INDICATOR: STATUS_INDICATOR$7,
	BADGE_COUNT: BADGE_COUNT$7,
	MESSAGE_RECEIPT: MESSAGE_RECEIPT$7,
	MESSAGE: MESSAGE$7,
	RECEIPT_INFORMATION: RECEIPT_INFORMATION$7,
	NO_RECIPIENT: NO_RECIPIENT$7,
	NO_RECIPIENTS: NO_RECIPIENTS$7,
	CONVERSATIONS_WITH_MESSAGES: CONVERSATIONS_WITH_MESSAGES$7,
	CONVERSATIONS: CONVERSATIONS$7,
	CONVERSATION_LIST: CONVERSATION_LIST$7,
	MESSAGES: MESSAGES$7,
	MESSAGE_HEADER: MESSAGE_HEADER$7,
	MESSAGE_LIST: MESSAGE_LIST$7,
	MESSAGE_COMPOSER: MESSAGE_COMPOSER$7,
	USERS_WITH_MESSAGES: USERS_WITH_MESSAGES$7,
	USER_LIST: USER_LIST$7,
	GROUP_LIST: GROUP_LIST$7,
	GROUPS_WITH_MESSAGES: GROUPS_WITH_MESSAGES$7,
	NEW__GROUP: NEW__GROUP$7,
	PASSWORD: PASSWORD$7,
	CONTINUE: CONTINUE$7,
	NO_CHATS_SELECTED: NO_CHATS_SELECTED$7,
	NO_USERS_SELECTED: NO_USERS_SELECTED$7,
	NO_GROUPS_SELECTED: NO_GROUPS_SELECTED$7,
	SELECT_DAY: SELECT_DAY$7,
	SELECT_TIME: SELECT_TIME$7,
	NO_CALLS_SELECTED: NO_CALLS_SELECTED$7,
	SELECT__GROUP: SELECT__GROUP$7,
	SELECT__USER: SELECT__USER$7,
	GROUP_PASSWORD_BLANK: GROUP_PASSWORD_BLANK$7,
	GROUP_NAME_BLANK: GROUP_NAME_BLANK$7,
	GROUP_TYPE_BLANK: GROUP_TYPE_BLANK$7,
	DELETE_CONVERSATION: DELETE_CONVERSATION$7,
	ADD_TO_CHAT: ADD_TO_CHAT$7,
	MORE: MORE$7,
	COPY: COPY$7,
	VOICE_RECORDING: VOICE_RECORDING$7,
	MESSAGE_IMAGE: MESSAGE_IMAGE$7,
	MESSAGE_FILE: MESSAGE_FILE$7,
	MESSAGE_VIDEO: MESSAGE_VIDEO$7,
	MESSAGE_AUDIO: MESSAGE_AUDIO$7,
	CUSTOM_MESSAGE: CUSTOM_MESSAGE$7,
	SELECT_A_DATE: SELECT_A_DATE$7,
	TIME_ZONE: TIME_ZONE$7,
	MEETING_SCHEDULED: MEETING_SCHEDULED$7,
	SOMETHING_WRONG: SOMETHING_WRONG$7,
	MEETING_SLOT_BOOK: MEETING_SLOT_BOOK$7,
	MEETING_BOOK_NEW_SLOT: MEETING_BOOK_NEW_SLOT$7,
	MEETING_NO_SLOTS_AVAILABLE: MEETING_NO_SLOTS_AVAILABLE$7,
	MEETING_TRY_DIFFERENT_DATE: MEETING_TRY_DIFFERENT_DATE$7,
	NO_TIME_SLOTS_AVAILABLE: NO_TIME_SLOTS_AVAILABLE$7,
	SCHEDULE: SCHEDULE$7,
	MORE_TIMES: MORE_TIMES$7,
	MISSED_VOICE_CALL: MISSED_VOICE_CALL$7,
	MEET_WITH: MEET_WITH$7,
	MEETING_SCHEDULER: MEETING_SCHEDULER$7,
	MISSED_VIDEO_CALL: MISSED_VIDEO_CALL$7,
	CUSTOM_MESSAGE_POLL: CUSTOM_MESSAGE_POLL$7,
	CUSTOM_MESSAGE_STICKER: CUSTOM_MESSAGE_STICKER$7,
	CUSTOM_MESSAGE_DOCUMENT: CUSTOM_MESSAGE_DOCUMENT$7,
	CUSTOM_MESSAGE_WHITEBOARD: CUSTOM_MESSAGE_WHITEBOARD$7,
	ONLINE: ONLINE$7,
	ADMINISTRATOR: ADMINISTRATOR$7,
	ADMIN: ADMIN$7,
	MODERATOR: MODERATOR$7,
	PARTICIPANT: PARTICIPANT$7,
	PUBLIC: PUBLIC$7,
	PRIVATE: PRIVATE$7,
	PASSWORD_PROTECTED: PASSWORD_PROTECTED$7,
	PRIVACY_AND_SECURITY: PRIVACY_AND_SECURITY$7,
	PREFERENCES: PREFERENCES$7,
	MEMBERS: MEMBERS$7,
	MEMBER: MEMBER$7,
	TODAY: TODAY$7,
	YESTERDAY: YESTERDAY$7,
	SUNDAY: SUNDAY$7,
	MONDAY: MONDAY$7,
	TUESDAY: TUESDAY$7,
	WEDNESDAY: WEDNESDAY$7,
	THURSDAY: THURSDAY$7,
	FRIDAY: FRIDAY$7,
	SATURDAY: SATURDAY$7,
	TYPING: TYPING$7,
	IS_TYPING: IS_TYPING$7,
	CLOSE: CLOSE$7,
	ENTER_GROUP_NAME: ENTER_GROUP_NAME$7,
	ADD_MEMBERS: ADD_MEMBERS$7,
	SEND_MESSAGE: SEND_MESSAGE$7,
	UNBLOCK_USER: UNBLOCK_USER$7,
	BLOCK_USER: BLOCK_USER$7,
	DELETE_AND_EXIT: DELETE_AND_EXIT$7,
	LEAVE_GROUP: LEAVE_GROUP$7,
	CREATE_GROUP: CREATE_GROUP$7,
	SHARED_MEDIA: SHARED_MEDIA$7,
	SHARED_FILE: SHARED_FILE$7,
	VIDEO_CALL: VIDEO_CALL$7,
	AUDIO_CALL: AUDIO_CALL$7,
	LOADING: LOADING$7,
	REPLY: REPLY$7,
	REPLIES: REPLIES$7,
	AI: AI$7,
	SMART_REPLIES: SMART_REPLIES$7,
	CONVERSATION_STARTER: CONVERSATION_STARTER$7,
	LAUNCH: LAUNCH$7,
	SHARED_COLLABORATIVE_DOCUMENT: SHARED_COLLABORATIVE_DOCUMENT$7,
	SHARED_COLLABORATIVE_WHITEBOARD: SHARED_COLLABORATIVE_WHITEBOARD$7,
	CREATED_WHITEBOARD: CREATED_WHITEBOARD$7,
	CREATED_DOCUMENT: CREATED_DOCUMENT$7,
	PHOTOS: PHOTOS$7,
	VIDEOS: VIDEOS$7,
	DOCUMENT: DOCUMENT$7,
	YOU_DELETED_THIS_MESSAGE: YOU_DELETED_THIS_MESSAGE$7,
	THIS_MESSAGE_DELETED: THIS_MESSAGE_DELETED$7,
	MESSAGE_IS_DELETED: MESSAGE_IS_DELETED$7,
	VIEW_ON_YOUTUBE: VIEW_ON_YOUTUBE$7,
	SEARCH: SEARCH$7,
	NO_USERS_FOUND: NO_USERS_FOUND$7,
	ERROR: ERROR$7,
	NO_GROUPS_FOUND: NO_GROUPS_FOUND$7,
	NO_CHATS_FOUND: NO_CHATS_FOUND$7,
	CANT__LOAD__CHATS: CANT__LOAD__CHATS$7,
	MEDIA_MESSAGE: MEDIA_MESSAGE$7,
	INCOMING_AUDIO_CALL: INCOMING_AUDIO_CALL$7,
	INCOMING_VIDEO_CALL: INCOMING_VIDEO_CALL$7,
	DECLINE: DECLINE$7,
	ACCEPT: ACCEPT$7,
	CALL_INITIATED: CALL_INITIATED$7,
	OUTGOING_AUDIO_CALL: OUTGOING_AUDIO_CALL$7,
	OUTGOING_VIDEO_CALL: OUTGOING_VIDEO_CALL$7,
	CALL_REJECTED: CALL_REJECTED$7,
	REJECTED_CALL: REJECTED_CALL$7,
	CALL_ACCEPTED: CALL_ACCEPTED$7,
	OUTGOING_CALL: OUTGOING_CALL$7,
	INCOMING_CALL: INCOMING_CALL$7,
	MISSED_CALL: MISSED_CALL$7,
	JOINED: JOINED$7,
	LEFT_THE_CALL: LEFT_THE_CALL$7,
	UNANSWERED_AUDIO_CALL: UNANSWERED_AUDIO_CALL$7,
	UNANSWERED_VIDEO_CALL: UNANSWERED_VIDEO_CALL$7,
	CALL_ENDED: CALL_ENDED$7,
	CALL_CANCELLED: CALL_CANCELLED$7,
	CALL_BUSY: CALL_BUSY$7,
	CALLING: CALLING$7,
	ADD: ADD$7,
	NO_BANNED_MEMBERS_FOUND: NO_BANNED_MEMBERS_FOUND$7,
	BANNED_MEMBERS: BANNED_MEMBERS$7,
	NAME: NAME$7,
	SCOPE: SCOPE$7,
	UNBAN: UNBAN$7,
	SELECT_GROUP_TYPE: SELECT_GROUP_TYPE$7,
	ENTER_GROUP_PASSWORD: ENTER_GROUP_PASSWORD$7,
	CREATE: CREATE$7,
	CREATE_POLL: CREATE_POLL$7,
	QUESTION: QUESTION$7,
	ENTER_YOUR_QUESTION: ENTER_YOUR_QUESTION$7,
	OPTIONS: OPTIONS$7,
	ENTER_YOUR_OPTION: ENTER_YOUR_OPTION$7,
	ADD_NEW_OPTION: ADD_NEW_OPTION$7,
	VIEW_MEMBERS: VIEW_MEMBERS$7,
	DETAILS: DETAILS$7,
	NOTIFICATIONS: NOTIFICATIONS$7,
	OTHER: OTHER$7,
	HELP: HELP$7,
	REPORT_PROBLEM: REPORT_PROBLEM$7,
	GROUP_MEMBERS: GROUP_MEMBERS$7,
	BAN: BAN$7,
	KICK: KICK$7,
	PICK_YOUR_EMOJI: PICK_YOUR_EMOJI$7,
	PRIVATE_GROUP: PRIVATE_GROUP$7,
	PROTECTED_GROUP: PROTECTED_GROUP$7,
	VISIT: VISIT$7,
	ATTACH: ATTACH$7,
	OPEN_WHITEBOARD: OPEN_WHITEBOARD$7,
	ATTACH_FILE: ATTACH_FILE$7,
	GENERATING_REPLIES: GENERATING_REPLIES$7,
	ATTACH_VIDEO: ATTACH_VIDEO$7,
	ATTACH_AUDIO: ATTACH_AUDIO$7,
	ATTACH_IMAGE: ATTACH_IMAGE$7,
	COLLABORATE_USING_DOCUMENT: COLLABORATE_USING_DOCUMENT$7,
	COLLABORATE_USING_WHITEBOARD: COLLABORATE_USING_WHITEBOARD$7,
	SUGGEST_A_REPLY: SUGGEST_A_REPLY$7,
	GENERATING_ICEBREAKERS: GENERATING_ICEBREAKERS$7,
	EMOJI: EMOJI$7,
	NO_REPLIES_FOUND: NO_REPLIES_FOUND$7,
	ENTER_YOUR_MESSAGE_HERE: ENTER_YOUR_MESSAGE_HERE$7,
	NO_MESSAGES_FOUND: NO_MESSAGES_FOUND$7,
	THREAD: THREAD$7,
	COLLABORATIVE_DOCUMENT: COLLABORATIVE_DOCUMENT$7,
	COLLABORATIVE_WHITEBOARD: COLLABORATIVE_WHITEBOARD$7,
	ADD_REACTION: ADD_REACTION$7,
	NO_STICKERS_FOUND: NO_STICKERS_FOUND$7,
	REPLY_TO_THREAD: REPLY_TO_THREAD$7,
	REPLY_IN_THREAD: REPLY_IN_THREAD$7,
	VIEW: VIEW$7,
	DELETE_MESSAGE: DELETE_MESSAGE$7,
	EDIT_MESSAGE: EDIT_MESSAGE$7,
	OWNER: OWNER$7,
	CHANGE_SCOPE: CHANGE_SCOPE$7,
	STICKER: STICKER$7,
	LAST_ACTIVE_AT: LAST_ACTIVE_AT$7,
	VOICE_CALL: VOICE_CALL$7,
	VIEW_DETAIL: VIEW_DETAIL$7,
	VOTES: VOTES$7,
	VOTE: VOTE$7,
	NO_VOTE: NO_VOTE$7,
	REACTED: REACTED$7,
	ADDED: ADDED$7,
	SHOW_UNSAFE_CONTENT: SHOW_UNSAFE_CONTENT$7,
	REACT_TO_MESSAGE: REACT_TO_MESSAGE$7,
	UNBANNED: UNBANNED$7,
	MADE: MADE$7,
	CALL_UNANSWERED: CALL_UNANSWERED$7,
	MISSED_AUDIO_CALL: MISSED_AUDIO_CALL$7,
	ENTER_YOUR_PASSWORD: ENTER_YOUR_PASSWORD$7,
	DRAW_DOCUMENT_TOGETHER: DRAW_DOCUMENT_TOGETHER$7,
	DOCS: DOCS$7,
	NO_RECORDS_FOUND: NO_RECORDS_FOUND$7,
	LIVE_REACTION: LIVE_REACTION$7,
	SMILEY_PEOPLE: SMILEY_PEOPLE$7,
	DRAW_WHITEBOARD_TOGETHER: DRAW_WHITEBOARD_TOGETHER$7,
	ANIMALES_NATURE: ANIMALES_NATURE$7,
	FOOD_DRINK: FOOD_DRINK$7,
	OPEN_DOCUMENT: OPEN_DOCUMENT$7,
	ACTIVITY: ACTIVITY$7,
	TRAVEL_PLACES: TRAVEL_PLACES$7,
	OBJECTS: OBJECTS$7,
	SYMBOLS: SYMBOLS$7,
	FLAGS: FLAGS$7,
	SENT: SENT$7,
	SEEN: SEEN$7,
	DELIVERED: DELIVERED$7,
	READ: READ$7,
	MESSAGE_INFORMATION: MESSAGE_INFORMATION$7,
	TRANSLATE_MESSAGE: TRANSLATE_MESSAGE$7,
	TRANSLATED_MESSAGE: TRANSLATED_MESSAGE$7,
	LEFT: LEFT$7,
	KICKED: KICKED$7,
	BANNED: BANNED$7,
	NEW_MESSAGES: NEW_MESSAGES$7,
	NEW_MESSAGE: NEW_MESSAGE$7,
	JUMP: JUMP$7,
	SELECT_VIDEO_SOURCE: SELECT_VIDEO_SOURCE$7,
	SELECT_INPUT_AUDIO_SOURCE: SELECT_INPUT_AUDIO_SOURCE$7,
	SELECT_OUTPUT_AUDIO_SOURCE: SELECT_OUTPUT_AUDIO_SOURCE$7,
	INITIATED_GROUP_CALL: INITIATED_GROUP_CALL$7,
	YOU_INITIATED_GROUP_CALL: YOU_INITIATED_GROUP_CALL$7,
	IGNORE: IGNORE$7,
	ON_ANOTHER_CALL: ON_ANOTHER_CALL$7,
	CREATING: CREATING$7,
	AVATAR: AVATAR$7,
	ONGOING_CALL: ONGOING_CALL$7,
	YOU_ALREADY_ONGOING_CALL: YOU_ALREADY_ONGOING_CALL$7,
	RESIZE: RESIZE$7,
	SETTINGS: SETTINGS$7,
	ACTIONS: ACTIONS$7,
	VIEW_PROFILE: VIEW_PROFILE$7,
	SEND_MESSAGE_IN_PRIVATE: SEND_MESSAGE_IN_PRIVATE$7,
	DELETE: DELETE$7,
	DELETE_CONFIRM: DELETE_CONFIRM$7,
	CANCEL: CANCEL$7,
	LEAVE_CONFIRM: LEAVE_CONFIRM$7,
	TRANSFER_CONFIRM: TRANSFER_CONFIRM$7,
	ADDING: ADDING$7,
	TRANSFER: TRANSFER$7,
	TRANSFER_OWNERSHIP: TRANSFER_OWNERSHIP$7,
	TRANSFERRING: TRANSFERRING$7,
	YES: YES$7,
	NO: NO$7,
	ANSWER: ANSWER$7,
	ADD_ANOTHER_ANSWER: ADD_ANOTHER_ANSWER$7,
	SET_THE_ANSWERS: SET_THE_ANSWERS$7,
	TRY_AGAIN: TRY_AGAIN$7,
	INVALID_GROUP_NAME: INVALID_GROUP_NAME$7,
	INVALID_PASSWORD: INVALID_PASSWORD$7,
	INVALID_GROUP_TYPE: INVALID_GROUP_TYPE$7,
	WRONG_PASSWORD: WRONG_PASSWORD$7,
	INVALID_POLL_QUESTION: INVALID_POLL_QUESTION$7,
	INVALID_POLL_OPTION: INVALID_POLL_OPTION$7,
	SAME_LANGUAGE_MESSAGE: SAME_LANGUAGE_MESSAGE$7,
	LEAVE: LEAVE$7,
	CLICK_TO_START_CONVERSATION: CLICK_TO_START_CONVERSATION$7,
	CUSTOM_MESSAGE_LOCATION: CUSTOM_MESSAGE_LOCATION$7,
	SHARED_LOCATION: SHARED_LOCATION$7,
	IN_A_THREAD: IN_A_THREAD$7,
	CALLS: CALLS$7,
	CALL_DETAILS: CALL_DETAILS$7,
	OFFLINE: OFFLINE$7,
	POLLS: POLLS$7,
	YOU: YOU$7,
	PRIVACY: PRIVACY$7,
	BLOCKED_USERS: BLOCKED_USERS$7,
	"YOU'VE_BLOCKED": "Anda telah menyekat",
	NO_PHOTOS: NO_PHOTOS$7,
	NO_VIDEOS: NO_VIDEOS$7,
	NO_DOCUMENTS: NO_DOCUMENTS$7,
	JOIN: JOIN$7,
	REMOVE: REMOVE$7,
	BLOCK: BLOCK$7,
	CHANGE_ROLE: CHANGE_ROLE$7,
	NEW_CHAT: NEW_CHAT$7,
	FORM_COMPLETION_MESSAGE: FORM_COMPLETION_MESSAGE$7,
	HISTORY: HISTORY$7,
	CANCELLED_AUDIO_CALL: CANCELLED_AUDIO_CALL$7,
	CANCELLED_VIDEO_CALL: CANCELLED_VIDEO_CALL$7,
	REJECTED_AUDIO_CALL: REJECTED_AUDIO_CALL$7,
	REJECTED_VIDEO_CALL: REJECTED_VIDEO_CALL$7,
	CANCELLED_CALL: CANCELLED_CALL$7,
	UNANSWERED_CALL: UNANSWERED_CALL$7,
	RECORDING: RECORDING$7,
	PARTICIPANTS: PARTICIPANTS$7,
	CALL_HISTORY: CALL_HISTORY$7,
	NO_CALLS_FOUND: NO_CALLS_FOUND$7,
	ONGOING_AUDIO_CALL: ONGOING_AUDIO_CALL$7,
	ONGOING_VIDEO_CALL: ONGOING_VIDEO_CALL$7,
	CALL_DETAIL: CALL_DETAIL$7,
	FORM: FORM$7,
	CARD: CARD$7,
	GENERATING_SUMMARY: GENERATING_SUMMARY$7,
	CONVERSATION_SUMMARY: CONVERSATION_SUMMARY$7,
	GENERATE_SUMMARY: GENERATE_SUMMARY$7,
	COMETCHAT_BOT_FIRST_MESSAGE: COMETCHAT_BOT_FIRST_MESSAGE$7,
	COMETCHAT_ASK_BOT: COMETCHAT_ASK_BOT$7,
	COMETCHAT_ASK_AI_BOT: COMETCHAT_ASK_AI_BOT$7,
	COMETCHAT_ASK_BOT_SUBTITLE: COMETCHAT_ASK_BOT_SUBTITLE$7,
	MENTIONS_LIMIT_WARNING_MESSAGE: MENTIONS_LIMIT_WARNING_MESSAGE$7,
	ALL: ALL$7,
	CLICK_TO_REMOVE: CLICK_TO_REMOVE$7,
	OTHERS: OTHERS$7,
	AND: AND$7
};

var INFO$6 = "Informações";
var REACT$6 = "Reaja";
var EDIT$6 = "Editar";
var MESSAGE_PRIVATELY$6 = "Mensagem privada";
var TRANSLATE$6 = "Traduza";
var USERS$6 = "Usuários";
var CHATS$6 = "Conversa";
var WOULD__YOU_LIKE_TO_DELETE_THIS_CONVERSATION$6 = "Você gostaria de excluir esta conversa? Essa conversa será excluída de todos os seus dispositivos.";
var GROUPS$6 = "Grupos";
var SHARED$6 = "Compartilhado";
var SOUND_MANAGER$6 = "Gerenciador de som";
var THEME$6 = "Tema";
var LOCALIZE$6 = "Localizar";
var CONVERSATION_LIST_ITEM$6 = "Item da lista de conversas";
var DATA_ITEM$6 = "Item de dados";
var STATUS_INDICATOR$6 = "Indicador de status";
var BADGE_COUNT$6 = "Contagem de emblemas";
var MESSAGE_RECEIPT$6 = "Recibo de mensagem";
var MESSAGE$6 = "Mensagem";
var RECEIPT_INFORMATION$6 = "Informações sobre o recibo";
var NO_RECIPIENT$6 = "Nenhum destinatário";
var NO_RECIPIENTS$6 = "Sem destinatários";
var CONVERSATIONS_WITH_MESSAGES$6 = "Conversas com mensagens";
var CONVERSATIONS$6 = "Conversas";
var CONVERSATION_LIST$6 = "Lista de conversas";
var MESSAGES$6 = "Mensagens";
var MESSAGE_HEADER$6 = "cabeçalho da mensagem";
var MESSAGE_LIST$6 = "Lista de mensagens";
var MESSAGE_COMPOSER$6 = "Compositor de mensagens";
var USERS_WITH_MESSAGES$6 = "Usuários com mensagens";
var USER_LIST$6 = "Lista de usuários";
var GROUP_LIST$6 = "Lista de grupos";
var GROUPS_WITH_MESSAGES$6 = "Grupos com mensagens";
var NEW__GROUP$6 = "Novo grupo";
var PASSWORD$6 = "Senha";
var CONTINUE$6 = "Continuar";
var NO_CHATS_SELECTED$6 = "Nenhum bate-papo selecionado";
var NO_USERS_SELECTED$6 = "Nenhum usuário selecionado";
var NO_GROUPS_SELECTED$6 = "Nenhum grupo selecionado";
var SELECT_DAY$6 = "Selecione um dia";
var SELECT_TIME$6 = "Selecione um horário";
var NO_CALLS_SELECTED$6 = "Nenhuma chamada selecionada";
var SELECT__GROUP$6 = "Selecione um grupo para começar a enviar mensagens";
var SELECT__USER$6 = "Selecione um usuário para começar a enviar mensagens";
var GROUP_PASSWORD_BLANK$6 = "A senha do grupo não pode ficar em branco";
var GROUP_NAME_BLANK$6 = "O nome do grupo não pode ficar em branco";
var GROUP_TYPE_BLANK$6 = "O tipo de grupo não pode ficar em branco";
var DELETE_CONVERSATION$6 = "Excluir conversa?";
var ADD_TO_CHAT$6 = "Adicionar ao chat";
var MORE$6 = "Mais";
var COPY$6 = "Copiar";
var VOICE_RECORDING$6 = "Gravação de voz";
var MESSAGE_IMAGE$6 = "📷 Imagem";
var MESSAGE_FILE$6 = "📁 Arquivo";
var MESSAGE_VIDEO$6 = "📹 Vídeo";
var MESSAGE_AUDIO$6 = "🎵 Áudio";
var CUSTOM_MESSAGE$6 = "Você tem uma mensagem";
var SELECT_A_DATE$6 = "Selecione uma data";
var TIME_ZONE$6 = "Fuso horário";
var MEETING_SCHEDULED$6 = "Sua reunião foi agendada.";
var SOMETHING_WRONG$6 = "Algo deu errado. Por favor, tente novamente.";
var MEETING_SLOT_BOOK$6 = "O intervalo de tempo não está mais disponível. Por favor, escolha outro.";
var MEETING_BOOK_NEW_SLOT$6 = "Reserve um novo slot";
var MEETING_NO_SLOTS_AVAILABLE$6 = "Não há horário disponível para esta data. Por favor, tente outra data.";
var MEETING_TRY_DIFFERENT_DATE$6 = "Por favor, tente uma data diferente.";
var NO_TIME_SLOTS_AVAILABLE$6 = "Não há horários disponíveis";
var SCHEDULE$6 = "Cronograma";
var MORE_TIMES$6 = "Mais vezes";
var MISSED_VOICE_CALL$6 = "Chamada de voz perdida";
var MEET_WITH$6 = "Encontre-se com";
var MEETING_SCHEDULER$6 = "Agendador de reuniões";
var MISSED_VIDEO_CALL$6 = "Chamada de vídeo perdida";
var CUSTOM_MESSAGE_POLL$6 = "📊 Enquete";
var CUSTOM_MESSAGE_STICKER$6 = "💟 Adesivo";
var CUSTOM_MESSAGE_DOCUMENT$6 = "📃 Documento";
var CUSTOM_MESSAGE_WHITEBOARD$6 = "📝 Quadro branco";
var ONLINE$6 = "On-line";
var ADMINISTRATOR$6 = "Administrador";
var ADMIN$6 = "Administrador";
var MODERATOR$6 = "apresentadora";
var PARTICIPANT$6 = "Participante";
var PUBLIC$6 = "Público";
var PRIVATE$6 = "Privado";
var PASSWORD_PROTECTED$6 = "Protegido por senha";
var PRIVACY_AND_SECURITY$6 = "Privacidade e segurança";
var PREFERENCES$6 = "Preferências";
var MEMBERS$6 = "Membros";
var MEMBER$6 = "Membro";
var TODAY$6 = "Hoje";
var YESTERDAY$6 = "Ontem";
var SUNDAY$6 = "domingo";
var MONDAY$6 = "Segunda-feira";
var TUESDAY$6 = "terça";
var WEDNESDAY$6 = "Quarta-feira";
var THURSDAY$6 = "Quinta-feira";
var FRIDAY$6 = "Sexta-feira";
var SATURDAY$6 = "sábado";
var TYPING$6 = "digitando...";
var IS_TYPING$6 = "está digitando...";
var CLOSE$6 = "Fechar";
var ENTER_GROUP_NAME$6 = "Insira o nome do grupo";
var ADD_MEMBERS$6 = "Adicionar membros";
var SEND_MESSAGE$6 = "Enviar mensagem";
var UNBLOCK_USER$6 = "Desbloquear usuário";
var BLOCK_USER$6 = "Bloquear usuário";
var DELETE_AND_EXIT$6 = "Excluir e sair";
var LEAVE_GROUP$6 = "Sair do grupo";
var CREATE_GROUP$6 = "Criar grupo";
var SHARED_MEDIA$6 = "Mídia compartilhada";
var SHARED_FILE$6 = "Arquivo compartilhado";
var VIDEO_CALL$6 = "Chamada de vídeo";
var AUDIO_CALL$6 = "Chamada de áudio";
var LOADING$6 = "Carregando...";
var REPLY$6 = "resposta";
var REPLIES$6 = "respostas";
var AI$6 = "AI";
var SMART_REPLIES$6 = "Respostas inteligentes";
var CONVERSATION_STARTER$6 = "Iniciador de conversa";
var LAUNCH$6 = "Lançamento";
var SHARED_COLLABORATIVE_DOCUMENT$6 = "compartilhou um documento colaborativo";
var SHARED_COLLABORATIVE_WHITEBOARD$6 = "compartilhou um quadro branco colaborativo";
var CREATED_WHITEBOARD$6 = "Você criou um novo quadro branco colaborativo";
var CREATED_DOCUMENT$6 = "Você criou um novo documento colaborativo";
var PHOTOS$6 = "Fotos";
var VIDEOS$6 = "Vídeos";
var DOCUMENT$6 = "Documento";
var YOU_DELETED_THIS_MESSAGE$6 = "⚠️ Você excluiu esta mensagem";
var THIS_MESSAGE_DELETED$6 = "⚠️ Esta mensagem foi excluída";
var MESSAGE_IS_DELETED$6 = "A mensagem foi excluída";
var VIEW_ON_YOUTUBE$6 = "Ver no Youtube";
var SEARCH$6 = "Pesquisar";
var NO_USERS_FOUND$6 = "Nenhum usuário encontrado";
var ERROR$6 = "Erro";
var NO_GROUPS_FOUND$6 = "Nenhum grupo encontrado";
var NO_CHATS_FOUND$6 = "Nenhum bate-papo encontrado";
var CANT__LOAD__CHATS$6 = "Não consigo carregar bate-papos";
var MEDIA_MESSAGE$6 = "Mensagem de mídia";
var INCOMING_AUDIO_CALL$6 = "Chamada de áudio recebida";
var INCOMING_VIDEO_CALL$6 = "Chamada de vídeo recebida";
var DECLINE$6 = "Declínio";
var ACCEPT$6 = "Aceitar";
var CALL_INITIATED$6 = "Chamada iniciada";
var OUTGOING_AUDIO_CALL$6 = "Chamada de áudio de saída";
var OUTGOING_VIDEO_CALL$6 = "Chamada de vídeo de saída";
var CALL_REJECTED$6 = "Chamada rejeitada";
var REJECTED_CALL$6 = "chamada rejeitada";
var CALL_ACCEPTED$6 = "Chamada aceita";
var OUTGOING_CALL$6 = "Chamada de saída";
var INCOMING_CALL$6 = "Chamada recebida";
var MISSED_CALL$6 = "Chamada perdida";
var JOINED$6 = "ingressou";
var LEFT_THE_CALL$6 = "deixou a ligação";
var UNANSWERED_AUDIO_CALL$6 = "Chamada de áudio não atendida";
var UNANSWERED_VIDEO_CALL$6 = "Chamada de vídeo não atendida";
var CALL_ENDED$6 = "Chamada encerrada";
var CALL_CANCELLED$6 = "Chamada cancelada";
var CALL_BUSY$6 = "Chamada ocupada";
var CALLING$6 = "Chamando...";
var ADD$6 = "Adicionar";
var NO_BANNED_MEMBERS_FOUND$6 = "Nenhum membro banido foi encontrado";
var BANNED_MEMBERS$6 = "Membros banidos";
var NAME$6 = "Nome";
var SCOPE$6 = "Escopo";
var UNBAN$6 = "Unban";
var SELECT_GROUP_TYPE$6 = "Selecione o tipo de grupo";
var ENTER_GROUP_PASSWORD$6 = "Digite a senha do grupo";
var CREATE$6 = "Criar";
var CREATE_POLL$6 = "Criar enquete";
var QUESTION$6 = "Pergunta";
var ENTER_YOUR_QUESTION$6 = "Insira sua pergunta";
var OPTIONS$6 = "Opções";
var ENTER_YOUR_OPTION$6 = "Insira sua opção";
var ADD_NEW_OPTION$6 = "Adicionar nova opção";
var VIEW_MEMBERS$6 = "Exibir membros";
var DETAILS$6 = "Detalhes";
var NOTIFICATIONS$6 = "Notificações";
var OTHER$6 = "Outros";
var HELP$6 = "Socorro";
var REPORT_PROBLEM$6 = "Relatar um problema";
var GROUP_MEMBERS$6 = "Membros do grupo";
var BAN$6 = "Banir";
var KICK$6 = "Chute";
var PICK_YOUR_EMOJI$6 = "Escolha seu emoji";
var PRIVATE_GROUP$6 = "Grupo privado";
var PROTECTED_GROUP$6 = "Grupo protegido";
var VISIT$6 = "Visita";
var ATTACH$6 = "Anexar";
var OPEN_WHITEBOARD$6 = "Quadro branco aberto";
var ATTACH_FILE$6 = "Anexar arquivo";
var GENERATING_REPLIES$6 = "Gerando respostas";
var ATTACH_VIDEO$6 = "Anexar vídeo";
var ATTACH_AUDIO$6 = "Anexar áudio";
var ATTACH_IMAGE$6 = "Anexar imagem";
var COLLABORATE_USING_DOCUMENT$6 = "Colabore usando um documento";
var COLLABORATE_USING_WHITEBOARD$6 = "Colabore usando um quadro branco";
var SUGGEST_A_REPLY$6 = "Sugira uma resposta";
var GENERATING_ICEBREAKERS$6 = "Gerando quebra-gelos";
var EMOJI$6 = "Emoji";
var NO_REPLIES_FOUND$6 = "Nenhuma resposta encontrada";
var ENTER_YOUR_MESSAGE_HERE$6 = "Digite sua mensagem aqui";
var NO_MESSAGES_FOUND$6 = "Nenhuma mensagem encontrada";
var THREAD$6 = "Tópico";
var COLLABORATIVE_DOCUMENT$6 = "Documento colaborativo";
var COLLABORATIVE_WHITEBOARD$6 = "Quadro branco colaborativo";
var ADD_REACTION$6 = "Adicionar reação";
var NO_STICKERS_FOUND$6 = "Nenhum adesivo encontrado";
var REPLY_TO_THREAD$6 = "Responder ao tópico";
var REPLY_IN_THREAD$6 = "Responder no tópico";
var VIEW$6 = "Visualizar";
var DELETE_MESSAGE$6 = "Excluir mensagem";
var EDIT_MESSAGE$6 = "Editar mensagem";
var OWNER$6 = "Proprietário";
var CHANGE_SCOPE$6 = "Escopo da alteração";
var STICKER$6 = "Adesivo";
var LAST_ACTIVE_AT$6 = "Ativo pela última vez em";
var VOICE_CALL$6 = "Chamada de voz";
var VIEW_DETAIL$6 = "Exibir detalhes";
var VOTES$6 = "vota";
var VOTE$6 = "votar";
var NO_VOTE$6 = "Sem voto";
var REACTED$6 = "reagiu";
var ADDED$6 = "adicionada";
var SHOW_UNSAFE_CONTENT$6 = "Tem certeza de que deseja ver conteúdo não seguro?";
var REACT_TO_MESSAGE$6 = "Reagir a uma mensagem";
var UNBANNED$6 = "desbanido";
var MADE$6 = "fez";
var CALL_UNANSWERED$6 = "Chamada não atendida";
var MISSED_AUDIO_CALL$6 = "Chamada de áudio perdida";
var ENTER_YOUR_PASSWORD$6 = "Digite sua senha";
var DRAW_DOCUMENT_TOGETHER$6 = "Abra o documento para editar o conteúdo em conjunto";
var DOCS$6 = "Documentos";
var NO_RECORDS_FOUND$6 = "Nenhum registro encontrado";
var LIVE_REACTION$6 = "Reação ao vivo";
var SMILEY_PEOPLE$6 = "Smileys e pessoas";
var DRAW_WHITEBOARD_TOGETHER$6 = "Abra o quadro branco para desenhar juntos";
var ANIMALES_NATURE$6 = "Animais e natureza";
var FOOD_DRINK$6 = "Comida e bebida";
var OPEN_DOCUMENT$6 = "Abrir documento";
var ACTIVITY$6 = "Atividade";
var TRAVEL_PLACES$6 = "Viagens e lugares";
var OBJECTS$6 = "Objetos";
var SYMBOLS$6 = "Símbolos";
var FLAGS$6 = "Bandeiras";
var SENT$6 = "Enviado";
var SEEN$6 = "Visto";
var DELIVERED$6 = "Entregue";
var READ$6 = "Leia";
var MESSAGE_INFORMATION$6 = "Informações da mensagem";
var TRANSLATE_MESSAGE$6 = "Traduzir mensagem";
var TRANSLATED_MESSAGE$6 = "Mensagem traduzida";
var LEFT$6 = "esquerdo";
var KICKED$6 = "chutado";
var BANNED$6 = "banido";
var NEW_MESSAGES$6 = "novas mensagens";
var NEW_MESSAGE$6 = "nova mensagem";
var JUMP$6 = "Saltar";
var SELECT_VIDEO_SOURCE$6 = "Selecione a fonte de vídeo";
var SELECT_INPUT_AUDIO_SOURCE$6 = "Selecione a fonte de áudio de entrada";
var SELECT_OUTPUT_AUDIO_SOURCE$6 = "Selecione a fonte de áudio de saída";
var INITIATED_GROUP_CALL$6 = "iniciou uma chamada em grupo";
var YOU_INITIATED_GROUP_CALL$6 = "Você iniciou uma chamada em grupo";
var IGNORE$6 = "Ignora";
var ON_ANOTHER_CALL$6 = "está em outra ligação";
var CREATING$6 = "Criando";
var AVATAR$6 = "Avatar";
var ONGOING_CALL$6 = "Chamada em andamento";
var YOU_ALREADY_ONGOING_CALL$6 = "Você já está em uma chamada em andamento";
var RESIZE$6 = "Redimensionar";
var SETTINGS$6 = "Configurações";
var ACTIONS$6 = "Ações";
var VIEW_PROFILE$6 = "Exibir perfil";
var SEND_MESSAGE_IN_PRIVATE$6 = "Enviar mensagem de forma privada";
var DELETE$6 = "Excluir";
var DELETE_CONFIRM$6 = "Tem certeza de que deseja excluir?";
var CANCEL$6 = "Cancelar";
var LEAVE_CONFIRM$6 = "Tem certeza de que quer sair do grupo?";
var TRANSFER_CONFIRM$6 = "Você é o proprietário do grupo; transfira a propriedade para um membro antes de sair do grupo";
var ADDING$6 = "Adicionando...";
var TRANSFER$6 = "Transferência";
var TRANSFER_OWNERSHIP$6 = "Transferir propriedade";
var TRANSFERRING$6 = "Transferindo";
var YES$6 = "sim";
var NO$6 = "Não";
var ANSWER$6 = "Resposta";
var ADD_ANOTHER_ANSWER$6 = "Adicionar outra resposta";
var SET_THE_ANSWERS$6 = "DEFINA AS RESPOSTAS";
var TRY_AGAIN$6 = "Tente novamente";
var INVALID_GROUP_NAME$6 = "Insira um nome válido para o grupo e tente novamente";
var INVALID_PASSWORD$6 = "Insira uma senha válida para o grupo e tente novamente";
var INVALID_GROUP_TYPE$6 = "Insira um tipo válido para o grupo e tente novamente";
var WRONG_PASSWORD$6 = "Digite a senha correta e tente novamente";
var INVALID_POLL_QUESTION$6 = "Insira a pergunta necessária antes de criar uma enquete";
var INVALID_POLL_OPTION$6 = "Insira a resposta necessária antes de criar uma enquete";
var SAME_LANGUAGE_MESSAGE$6 = "O idioma selecionado para tradução é semelhante ao idioma da mensagem original";
var LEAVE$6 = "Sair";
var CLICK_TO_START_CONVERSATION$6 = "Clique para iniciar a conversa";
var CUSTOM_MESSAGE_LOCATION$6 = "📍 Localização";
var SHARED_LOCATION$6 = "Localização compartilhada";
var IN_A_THREAD$6 = "Em um tópico";
var CALLS$6 = "Chamadas";
var CALL_DETAILS$6 = "Detalhes da chamada";
var OFFLINE$6 = "Off-line";
var POLLS$6 = "Enquetes";
var YOU$6 = "Você";
var PRIVACY$6 = "Privacidade";
var BLOCKED_USERS$6 = "Usuários bloqueados";
var NO_PHOTOS$6 = "Sem fotos";
var NO_VIDEOS$6 = "Sem vídeos";
var NO_DOCUMENTS$6 = "Sem documentos";
var JOIN$6 = "Unir";
var REMOVE$6 = "Remover";
var BLOCK$6 = "Bloquear";
var CHANGE_ROLE$6 = "Alterar função";
var NEW_CHAT$6 = "Novo bate-papo";
var FORM_COMPLETION_MESSAGE$6 = "Obrigado por preencher o formulário.";
var HISTORY$6 = "História";
var CANCELLED_AUDIO_CALL$6 = "Chamada de áudio cancelada";
var CANCELLED_VIDEO_CALL$6 = "Chamada de vídeo cancelada";
var REJECTED_AUDIO_CALL$6 = "Chamada de áudio rejeitada";
var REJECTED_VIDEO_CALL$6 = "Chamada de vídeo rejeitada";
var CANCELLED_CALL$6 = "Chamada cancelada";
var UNANSWERED_CALL$6 = "Chamada não atendida";
var RECORDING$6 = "Gravação";
var PARTICIPANTS$6 = "Participantes";
var CALL_HISTORY$6 = "Histórico de chamadas";
var NO_CALLS_FOUND$6 = "Nenhuma chamada encontrada";
var ONGOING_AUDIO_CALL$6 = "Chamada de áudio em andamento";
var ONGOING_VIDEO_CALL$6 = "Chamada de vídeo em andamento";
var CALL_DETAIL$6 = "Detalhe da chamada";
var FORM$6 = "Formulário";
var CARD$6 = "Cartão";
var GENERATING_SUMMARY$6 = "Gerando resumo";
var CONVERSATION_SUMMARY$6 = "Resumo da conversa";
var GENERATE_SUMMARY$6 = "Gere um resumo";
var COMETCHAT_BOT_FIRST_MESSAGE$6 = "Como posso te ajudar com essa conversa? Por favor, me faça uma pergunta e eu vou te aconselhar 🙂";
var COMETCHAT_ASK_BOT$6 = "Pergunte";
var COMETCHAT_ASK_AI_BOT$6 = "Pergunte aos robôs de IA";
var COMETCHAT_ASK_BOT_SUBTITLE$6 = "Robô de IA";
var MENTIONS_LIMIT_WARNING_MESSAGE$6 = "Você pode mencionar até 10 vezes por vez.";
var ALL$6 = "Todos";
var CLICK_TO_REMOVE$6 = "Clique para remover";
var OTHERS$6 = "outras";
var AND$6 = "uma";
var translationPT = {
	INFO: INFO$6,
	REACT: REACT$6,
	EDIT: EDIT$6,
	MESSAGE_PRIVATELY: MESSAGE_PRIVATELY$6,
	TRANSLATE: TRANSLATE$6,
	USERS: USERS$6,
	CHATS: CHATS$6,
	WOULD__YOU_LIKE_TO_DELETE_THIS_CONVERSATION: WOULD__YOU_LIKE_TO_DELETE_THIS_CONVERSATION$6,
	GROUPS: GROUPS$6,
	SHARED: SHARED$6,
	SOUND_MANAGER: SOUND_MANAGER$6,
	THEME: THEME$6,
	LOCALIZE: LOCALIZE$6,
	CONVERSATION_LIST_ITEM: CONVERSATION_LIST_ITEM$6,
	DATA_ITEM: DATA_ITEM$6,
	STATUS_INDICATOR: STATUS_INDICATOR$6,
	BADGE_COUNT: BADGE_COUNT$6,
	MESSAGE_RECEIPT: MESSAGE_RECEIPT$6,
	MESSAGE: MESSAGE$6,
	RECEIPT_INFORMATION: RECEIPT_INFORMATION$6,
	NO_RECIPIENT: NO_RECIPIENT$6,
	NO_RECIPIENTS: NO_RECIPIENTS$6,
	CONVERSATIONS_WITH_MESSAGES: CONVERSATIONS_WITH_MESSAGES$6,
	CONVERSATIONS: CONVERSATIONS$6,
	CONVERSATION_LIST: CONVERSATION_LIST$6,
	MESSAGES: MESSAGES$6,
	MESSAGE_HEADER: MESSAGE_HEADER$6,
	MESSAGE_LIST: MESSAGE_LIST$6,
	MESSAGE_COMPOSER: MESSAGE_COMPOSER$6,
	USERS_WITH_MESSAGES: USERS_WITH_MESSAGES$6,
	USER_LIST: USER_LIST$6,
	GROUP_LIST: GROUP_LIST$6,
	GROUPS_WITH_MESSAGES: GROUPS_WITH_MESSAGES$6,
	NEW__GROUP: NEW__GROUP$6,
	PASSWORD: PASSWORD$6,
	CONTINUE: CONTINUE$6,
	NO_CHATS_SELECTED: NO_CHATS_SELECTED$6,
	NO_USERS_SELECTED: NO_USERS_SELECTED$6,
	NO_GROUPS_SELECTED: NO_GROUPS_SELECTED$6,
	SELECT_DAY: SELECT_DAY$6,
	SELECT_TIME: SELECT_TIME$6,
	NO_CALLS_SELECTED: NO_CALLS_SELECTED$6,
	SELECT__GROUP: SELECT__GROUP$6,
	SELECT__USER: SELECT__USER$6,
	GROUP_PASSWORD_BLANK: GROUP_PASSWORD_BLANK$6,
	GROUP_NAME_BLANK: GROUP_NAME_BLANK$6,
	GROUP_TYPE_BLANK: GROUP_TYPE_BLANK$6,
	DELETE_CONVERSATION: DELETE_CONVERSATION$6,
	ADD_TO_CHAT: ADD_TO_CHAT$6,
	MORE: MORE$6,
	COPY: COPY$6,
	VOICE_RECORDING: VOICE_RECORDING$6,
	MESSAGE_IMAGE: MESSAGE_IMAGE$6,
	MESSAGE_FILE: MESSAGE_FILE$6,
	MESSAGE_VIDEO: MESSAGE_VIDEO$6,
	MESSAGE_AUDIO: MESSAGE_AUDIO$6,
	CUSTOM_MESSAGE: CUSTOM_MESSAGE$6,
	SELECT_A_DATE: SELECT_A_DATE$6,
	TIME_ZONE: TIME_ZONE$6,
	MEETING_SCHEDULED: MEETING_SCHEDULED$6,
	SOMETHING_WRONG: SOMETHING_WRONG$6,
	MEETING_SLOT_BOOK: MEETING_SLOT_BOOK$6,
	MEETING_BOOK_NEW_SLOT: MEETING_BOOK_NEW_SLOT$6,
	MEETING_NO_SLOTS_AVAILABLE: MEETING_NO_SLOTS_AVAILABLE$6,
	MEETING_TRY_DIFFERENT_DATE: MEETING_TRY_DIFFERENT_DATE$6,
	NO_TIME_SLOTS_AVAILABLE: NO_TIME_SLOTS_AVAILABLE$6,
	SCHEDULE: SCHEDULE$6,
	MORE_TIMES: MORE_TIMES$6,
	MISSED_VOICE_CALL: MISSED_VOICE_CALL$6,
	MEET_WITH: MEET_WITH$6,
	MEETING_SCHEDULER: MEETING_SCHEDULER$6,
	MISSED_VIDEO_CALL: MISSED_VIDEO_CALL$6,
	CUSTOM_MESSAGE_POLL: CUSTOM_MESSAGE_POLL$6,
	CUSTOM_MESSAGE_STICKER: CUSTOM_MESSAGE_STICKER$6,
	CUSTOM_MESSAGE_DOCUMENT: CUSTOM_MESSAGE_DOCUMENT$6,
	CUSTOM_MESSAGE_WHITEBOARD: CUSTOM_MESSAGE_WHITEBOARD$6,
	ONLINE: ONLINE$6,
	ADMINISTRATOR: ADMINISTRATOR$6,
	ADMIN: ADMIN$6,
	MODERATOR: MODERATOR$6,
	PARTICIPANT: PARTICIPANT$6,
	PUBLIC: PUBLIC$6,
	PRIVATE: PRIVATE$6,
	PASSWORD_PROTECTED: PASSWORD_PROTECTED$6,
	PRIVACY_AND_SECURITY: PRIVACY_AND_SECURITY$6,
	PREFERENCES: PREFERENCES$6,
	MEMBERS: MEMBERS$6,
	MEMBER: MEMBER$6,
	TODAY: TODAY$6,
	YESTERDAY: YESTERDAY$6,
	SUNDAY: SUNDAY$6,
	MONDAY: MONDAY$6,
	TUESDAY: TUESDAY$6,
	WEDNESDAY: WEDNESDAY$6,
	THURSDAY: THURSDAY$6,
	FRIDAY: FRIDAY$6,
	SATURDAY: SATURDAY$6,
	TYPING: TYPING$6,
	IS_TYPING: IS_TYPING$6,
	CLOSE: CLOSE$6,
	ENTER_GROUP_NAME: ENTER_GROUP_NAME$6,
	ADD_MEMBERS: ADD_MEMBERS$6,
	SEND_MESSAGE: SEND_MESSAGE$6,
	UNBLOCK_USER: UNBLOCK_USER$6,
	BLOCK_USER: BLOCK_USER$6,
	DELETE_AND_EXIT: DELETE_AND_EXIT$6,
	LEAVE_GROUP: LEAVE_GROUP$6,
	CREATE_GROUP: CREATE_GROUP$6,
	SHARED_MEDIA: SHARED_MEDIA$6,
	SHARED_FILE: SHARED_FILE$6,
	VIDEO_CALL: VIDEO_CALL$6,
	AUDIO_CALL: AUDIO_CALL$6,
	LOADING: LOADING$6,
	REPLY: REPLY$6,
	REPLIES: REPLIES$6,
	AI: AI$6,
	SMART_REPLIES: SMART_REPLIES$6,
	CONVERSATION_STARTER: CONVERSATION_STARTER$6,
	LAUNCH: LAUNCH$6,
	SHARED_COLLABORATIVE_DOCUMENT: SHARED_COLLABORATIVE_DOCUMENT$6,
	SHARED_COLLABORATIVE_WHITEBOARD: SHARED_COLLABORATIVE_WHITEBOARD$6,
	CREATED_WHITEBOARD: CREATED_WHITEBOARD$6,
	CREATED_DOCUMENT: CREATED_DOCUMENT$6,
	PHOTOS: PHOTOS$6,
	VIDEOS: VIDEOS$6,
	DOCUMENT: DOCUMENT$6,
	YOU_DELETED_THIS_MESSAGE: YOU_DELETED_THIS_MESSAGE$6,
	THIS_MESSAGE_DELETED: THIS_MESSAGE_DELETED$6,
	MESSAGE_IS_DELETED: MESSAGE_IS_DELETED$6,
	VIEW_ON_YOUTUBE: VIEW_ON_YOUTUBE$6,
	SEARCH: SEARCH$6,
	NO_USERS_FOUND: NO_USERS_FOUND$6,
	ERROR: ERROR$6,
	NO_GROUPS_FOUND: NO_GROUPS_FOUND$6,
	NO_CHATS_FOUND: NO_CHATS_FOUND$6,
	CANT__LOAD__CHATS: CANT__LOAD__CHATS$6,
	MEDIA_MESSAGE: MEDIA_MESSAGE$6,
	INCOMING_AUDIO_CALL: INCOMING_AUDIO_CALL$6,
	INCOMING_VIDEO_CALL: INCOMING_VIDEO_CALL$6,
	DECLINE: DECLINE$6,
	ACCEPT: ACCEPT$6,
	CALL_INITIATED: CALL_INITIATED$6,
	OUTGOING_AUDIO_CALL: OUTGOING_AUDIO_CALL$6,
	OUTGOING_VIDEO_CALL: OUTGOING_VIDEO_CALL$6,
	CALL_REJECTED: CALL_REJECTED$6,
	REJECTED_CALL: REJECTED_CALL$6,
	CALL_ACCEPTED: CALL_ACCEPTED$6,
	OUTGOING_CALL: OUTGOING_CALL$6,
	INCOMING_CALL: INCOMING_CALL$6,
	MISSED_CALL: MISSED_CALL$6,
	JOINED: JOINED$6,
	LEFT_THE_CALL: LEFT_THE_CALL$6,
	UNANSWERED_AUDIO_CALL: UNANSWERED_AUDIO_CALL$6,
	UNANSWERED_VIDEO_CALL: UNANSWERED_VIDEO_CALL$6,
	CALL_ENDED: CALL_ENDED$6,
	CALL_CANCELLED: CALL_CANCELLED$6,
	CALL_BUSY: CALL_BUSY$6,
	CALLING: CALLING$6,
	ADD: ADD$6,
	NO_BANNED_MEMBERS_FOUND: NO_BANNED_MEMBERS_FOUND$6,
	BANNED_MEMBERS: BANNED_MEMBERS$6,
	NAME: NAME$6,
	SCOPE: SCOPE$6,
	UNBAN: UNBAN$6,
	SELECT_GROUP_TYPE: SELECT_GROUP_TYPE$6,
	ENTER_GROUP_PASSWORD: ENTER_GROUP_PASSWORD$6,
	CREATE: CREATE$6,
	CREATE_POLL: CREATE_POLL$6,
	QUESTION: QUESTION$6,
	ENTER_YOUR_QUESTION: ENTER_YOUR_QUESTION$6,
	OPTIONS: OPTIONS$6,
	ENTER_YOUR_OPTION: ENTER_YOUR_OPTION$6,
	ADD_NEW_OPTION: ADD_NEW_OPTION$6,
	VIEW_MEMBERS: VIEW_MEMBERS$6,
	DETAILS: DETAILS$6,
	NOTIFICATIONS: NOTIFICATIONS$6,
	OTHER: OTHER$6,
	HELP: HELP$6,
	REPORT_PROBLEM: REPORT_PROBLEM$6,
	GROUP_MEMBERS: GROUP_MEMBERS$6,
	BAN: BAN$6,
	KICK: KICK$6,
	PICK_YOUR_EMOJI: PICK_YOUR_EMOJI$6,
	PRIVATE_GROUP: PRIVATE_GROUP$6,
	PROTECTED_GROUP: PROTECTED_GROUP$6,
	VISIT: VISIT$6,
	ATTACH: ATTACH$6,
	OPEN_WHITEBOARD: OPEN_WHITEBOARD$6,
	ATTACH_FILE: ATTACH_FILE$6,
	GENERATING_REPLIES: GENERATING_REPLIES$6,
	ATTACH_VIDEO: ATTACH_VIDEO$6,
	ATTACH_AUDIO: ATTACH_AUDIO$6,
	ATTACH_IMAGE: ATTACH_IMAGE$6,
	COLLABORATE_USING_DOCUMENT: COLLABORATE_USING_DOCUMENT$6,
	COLLABORATE_USING_WHITEBOARD: COLLABORATE_USING_WHITEBOARD$6,
	SUGGEST_A_REPLY: SUGGEST_A_REPLY$6,
	GENERATING_ICEBREAKERS: GENERATING_ICEBREAKERS$6,
	EMOJI: EMOJI$6,
	NO_REPLIES_FOUND: NO_REPLIES_FOUND$6,
	ENTER_YOUR_MESSAGE_HERE: ENTER_YOUR_MESSAGE_HERE$6,
	NO_MESSAGES_FOUND: NO_MESSAGES_FOUND$6,
	THREAD: THREAD$6,
	COLLABORATIVE_DOCUMENT: COLLABORATIVE_DOCUMENT$6,
	COLLABORATIVE_WHITEBOARD: COLLABORATIVE_WHITEBOARD$6,
	ADD_REACTION: ADD_REACTION$6,
	NO_STICKERS_FOUND: NO_STICKERS_FOUND$6,
	REPLY_TO_THREAD: REPLY_TO_THREAD$6,
	REPLY_IN_THREAD: REPLY_IN_THREAD$6,
	VIEW: VIEW$6,
	DELETE_MESSAGE: DELETE_MESSAGE$6,
	EDIT_MESSAGE: EDIT_MESSAGE$6,
	OWNER: OWNER$6,
	CHANGE_SCOPE: CHANGE_SCOPE$6,
	STICKER: STICKER$6,
	LAST_ACTIVE_AT: LAST_ACTIVE_AT$6,
	VOICE_CALL: VOICE_CALL$6,
	VIEW_DETAIL: VIEW_DETAIL$6,
	VOTES: VOTES$6,
	VOTE: VOTE$6,
	NO_VOTE: NO_VOTE$6,
	REACTED: REACTED$6,
	ADDED: ADDED$6,
	SHOW_UNSAFE_CONTENT: SHOW_UNSAFE_CONTENT$6,
	REACT_TO_MESSAGE: REACT_TO_MESSAGE$6,
	UNBANNED: UNBANNED$6,
	MADE: MADE$6,
	CALL_UNANSWERED: CALL_UNANSWERED$6,
	MISSED_AUDIO_CALL: MISSED_AUDIO_CALL$6,
	ENTER_YOUR_PASSWORD: ENTER_YOUR_PASSWORD$6,
	DRAW_DOCUMENT_TOGETHER: DRAW_DOCUMENT_TOGETHER$6,
	DOCS: DOCS$6,
	NO_RECORDS_FOUND: NO_RECORDS_FOUND$6,
	LIVE_REACTION: LIVE_REACTION$6,
	SMILEY_PEOPLE: SMILEY_PEOPLE$6,
	DRAW_WHITEBOARD_TOGETHER: DRAW_WHITEBOARD_TOGETHER$6,
	ANIMALES_NATURE: ANIMALES_NATURE$6,
	FOOD_DRINK: FOOD_DRINK$6,
	OPEN_DOCUMENT: OPEN_DOCUMENT$6,
	ACTIVITY: ACTIVITY$6,
	TRAVEL_PLACES: TRAVEL_PLACES$6,
	OBJECTS: OBJECTS$6,
	SYMBOLS: SYMBOLS$6,
	FLAGS: FLAGS$6,
	SENT: SENT$6,
	SEEN: SEEN$6,
	DELIVERED: DELIVERED$6,
	READ: READ$6,
	MESSAGE_INFORMATION: MESSAGE_INFORMATION$6,
	TRANSLATE_MESSAGE: TRANSLATE_MESSAGE$6,
	TRANSLATED_MESSAGE: TRANSLATED_MESSAGE$6,
	LEFT: LEFT$6,
	KICKED: KICKED$6,
	BANNED: BANNED$6,
	NEW_MESSAGES: NEW_MESSAGES$6,
	NEW_MESSAGE: NEW_MESSAGE$6,
	JUMP: JUMP$6,
	SELECT_VIDEO_SOURCE: SELECT_VIDEO_SOURCE$6,
	SELECT_INPUT_AUDIO_SOURCE: SELECT_INPUT_AUDIO_SOURCE$6,
	SELECT_OUTPUT_AUDIO_SOURCE: SELECT_OUTPUT_AUDIO_SOURCE$6,
	INITIATED_GROUP_CALL: INITIATED_GROUP_CALL$6,
	YOU_INITIATED_GROUP_CALL: YOU_INITIATED_GROUP_CALL$6,
	IGNORE: IGNORE$6,
	ON_ANOTHER_CALL: ON_ANOTHER_CALL$6,
	CREATING: CREATING$6,
	AVATAR: AVATAR$6,
	ONGOING_CALL: ONGOING_CALL$6,
	YOU_ALREADY_ONGOING_CALL: YOU_ALREADY_ONGOING_CALL$6,
	RESIZE: RESIZE$6,
	SETTINGS: SETTINGS$6,
	ACTIONS: ACTIONS$6,
	VIEW_PROFILE: VIEW_PROFILE$6,
	SEND_MESSAGE_IN_PRIVATE: SEND_MESSAGE_IN_PRIVATE$6,
	DELETE: DELETE$6,
	DELETE_CONFIRM: DELETE_CONFIRM$6,
	CANCEL: CANCEL$6,
	LEAVE_CONFIRM: LEAVE_CONFIRM$6,
	TRANSFER_CONFIRM: TRANSFER_CONFIRM$6,
	ADDING: ADDING$6,
	TRANSFER: TRANSFER$6,
	TRANSFER_OWNERSHIP: TRANSFER_OWNERSHIP$6,
	TRANSFERRING: TRANSFERRING$6,
	YES: YES$6,
	NO: NO$6,
	ANSWER: ANSWER$6,
	ADD_ANOTHER_ANSWER: ADD_ANOTHER_ANSWER$6,
	SET_THE_ANSWERS: SET_THE_ANSWERS$6,
	TRY_AGAIN: TRY_AGAIN$6,
	INVALID_GROUP_NAME: INVALID_GROUP_NAME$6,
	INVALID_PASSWORD: INVALID_PASSWORD$6,
	INVALID_GROUP_TYPE: INVALID_GROUP_TYPE$6,
	WRONG_PASSWORD: WRONG_PASSWORD$6,
	INVALID_POLL_QUESTION: INVALID_POLL_QUESTION$6,
	INVALID_POLL_OPTION: INVALID_POLL_OPTION$6,
	SAME_LANGUAGE_MESSAGE: SAME_LANGUAGE_MESSAGE$6,
	LEAVE: LEAVE$6,
	CLICK_TO_START_CONVERSATION: CLICK_TO_START_CONVERSATION$6,
	CUSTOM_MESSAGE_LOCATION: CUSTOM_MESSAGE_LOCATION$6,
	SHARED_LOCATION: SHARED_LOCATION$6,
	IN_A_THREAD: IN_A_THREAD$6,
	CALLS: CALLS$6,
	CALL_DETAILS: CALL_DETAILS$6,
	OFFLINE: OFFLINE$6,
	POLLS: POLLS$6,
	YOU: YOU$6,
	PRIVACY: PRIVACY$6,
	BLOCKED_USERS: BLOCKED_USERS$6,
	"YOU'VE_BLOCKED": "Você bloqueou",
	NO_PHOTOS: NO_PHOTOS$6,
	NO_VIDEOS: NO_VIDEOS$6,
	NO_DOCUMENTS: NO_DOCUMENTS$6,
	JOIN: JOIN$6,
	REMOVE: REMOVE$6,
	BLOCK: BLOCK$6,
	CHANGE_ROLE: CHANGE_ROLE$6,
	NEW_CHAT: NEW_CHAT$6,
	FORM_COMPLETION_MESSAGE: FORM_COMPLETION_MESSAGE$6,
	HISTORY: HISTORY$6,
	CANCELLED_AUDIO_CALL: CANCELLED_AUDIO_CALL$6,
	CANCELLED_VIDEO_CALL: CANCELLED_VIDEO_CALL$6,
	REJECTED_AUDIO_CALL: REJECTED_AUDIO_CALL$6,
	REJECTED_VIDEO_CALL: REJECTED_VIDEO_CALL$6,
	CANCELLED_CALL: CANCELLED_CALL$6,
	UNANSWERED_CALL: UNANSWERED_CALL$6,
	RECORDING: RECORDING$6,
	PARTICIPANTS: PARTICIPANTS$6,
	CALL_HISTORY: CALL_HISTORY$6,
	NO_CALLS_FOUND: NO_CALLS_FOUND$6,
	ONGOING_AUDIO_CALL: ONGOING_AUDIO_CALL$6,
	ONGOING_VIDEO_CALL: ONGOING_VIDEO_CALL$6,
	CALL_DETAIL: CALL_DETAIL$6,
	FORM: FORM$6,
	CARD: CARD$6,
	GENERATING_SUMMARY: GENERATING_SUMMARY$6,
	CONVERSATION_SUMMARY: CONVERSATION_SUMMARY$6,
	GENERATE_SUMMARY: GENERATE_SUMMARY$6,
	COMETCHAT_BOT_FIRST_MESSAGE: COMETCHAT_BOT_FIRST_MESSAGE$6,
	COMETCHAT_ASK_BOT: COMETCHAT_ASK_BOT$6,
	COMETCHAT_ASK_AI_BOT: COMETCHAT_ASK_AI_BOT$6,
	COMETCHAT_ASK_BOT_SUBTITLE: COMETCHAT_ASK_BOT_SUBTITLE$6,
	MENTIONS_LIMIT_WARNING_MESSAGE: MENTIONS_LIMIT_WARNING_MESSAGE$6,
	ALL: ALL$6,
	CLICK_TO_REMOVE: CLICK_TO_REMOVE$6,
	OTHERS: OTHERS$6,
	AND: AND$6
};

var INFO$5 = "Информация";
var REACT$5 = "React";
var EDIT$5 = "Редактировать";
var MESSAGE_PRIVATELY$5 = "Сообщение конфиденциально";
var TRANSLATE$5 = "Перевести";
var USERS$5 = "Пользователи";
var CHATS$5 = "Чаты";
var WOULD__YOU_LIKE_TO_DELETE_THIS_CONVERSATION$5 = "Хотите удалить этот разговор? Этот разговор будет удален со всех ваших устройств.";
var GROUPS$5 = "Группы";
var SHARED$5 = "Общий";
var SOUND_MANAGER$5 = "Звуковой менеджер";
var THEME$5 = "Тема";
var LOCALIZE$5 = "Локализация";
var CONVERSATION_LIST_ITEM$5 = "Элемент списка бесед";
var DATA_ITEM$5 = "Элемент данных";
var STATUS_INDICATOR$5 = "Индикатор состояния";
var BADGE_COUNT$5 = "Количество бейджей";
var MESSAGE_RECEIPT$5 = "Получение сообщения";
var MESSAGE$5 = "Послание";
var RECEIPT_INFORMATION$5 = "Информация о чеке";
var NO_RECIPIENT$5 = "Получателя нет";
var NO_RECIPIENTS$5 = "Получателей нет";
var CONVERSATIONS_WITH_MESSAGES$5 = "Беседы с сообщениями";
var CONVERSATIONS$5 = "Беседы";
var CONVERSATION_LIST$5 = "Список разговоров";
var MESSAGES$5 = "Сообщения";
var MESSAGE_HEADER$5 = "Заголовок сообщения";
var MESSAGE_LIST$5 = "Список сообщений";
var MESSAGE_COMPOSER$5 = "Композитор сообщений";
var USERS_WITH_MESSAGES$5 = "Пользователи с сообщениями";
var USER_LIST$5 = "Список пользователей";
var GROUP_LIST$5 = "Список групп";
var GROUPS_WITH_MESSAGES$5 = "Группы с сообщениями";
var NEW__GROUP$5 = "Новая группа";
var PASSWORD$5 = "Пароль";
var CONTINUE$5 = "Продолжить";
var NO_CHATS_SELECTED$5 = "Чаты не выбраны";
var NO_USERS_SELECTED$5 = "Не выбрано ни одного пользователя";
var NO_GROUPS_SELECTED$5 = "Не выбрано ни одной группы";
var SELECT_DAY$5 = "Выберите день";
var SELECT_TIME$5 = "Выберите время";
var NO_CALLS_SELECTED$5 = "Вызовы не выбраны";
var SELECT__GROUP$5 = "Выберите группу, чтобы начать обмен сообщениями";
var SELECT__USER$5 = "Выберите пользователя, чтобы начать обмен сообщениями";
var GROUP_PASSWORD_BLANK$5 = "Пароль группы не может быть пустым";
var GROUP_NAME_BLANK$5 = "Имя группы не может быть пустым";
var GROUP_TYPE_BLANK$5 = "Тип группы не может быть пустым";
var DELETE_CONVERSATION$5 = "Удалить беседу?";
var ADD_TO_CHAT$5 = "Добавить в чат";
var MORE$5 = "Больше";
var COPY$5 = "Копировать";
var VOICE_RECORDING$5 = "Запись голоса";
var MESSAGE_IMAGE$5 = "📷 Изображение";
var MESSAGE_FILE$5 = "📁 Файл";
var MESSAGE_VIDEO$5 = "📹 Видео";
var MESSAGE_AUDIO$5 = "🎵 Аудио";
var CUSTOM_MESSAGE$5 = "У вас есть сообщение";
var SELECT_A_DATE$5 = "Выберите дату";
var TIME_ZONE$5 = "Часовой пояс";
var MEETING_SCHEDULED$5 = "Ваша встреча запланирована.";
var SOMETHING_WRONG$5 = "Что-то пошло не так. Пожалуйста, попробуйте еще раз.";
var MEETING_SLOT_BOOK$5 = "Временной интервал больше не доступен. Пожалуйста, выберите другое.";
var MEETING_BOOK_NEW_SLOT$5 = "Забронируйте новый слот";
var MEETING_NO_SLOTS_AVAILABLE$5 = "Временной интервал на эту дату недоступен. Пожалуйста, попробуйте другую дату.";
var MEETING_TRY_DIFFERENT_DATE$5 = "Пожалуйста, попробуйте другую дату.";
var NO_TIME_SLOTS_AVAILABLE$5 = "Временных слотов нет";
var SCHEDULE$5 = "Расписание";
var MORE_TIMES$5 = "Больше раз";
var MISSED_VOICE_CALL$5 = "Пропущенный голосовой вызов";
var MEET_WITH$5 = "Встретьтесь с";
var MEETING_SCHEDULER$5 = "Планировщик собраний";
var MISSED_VIDEO_CALL$5 = "Пропущенный видеозвонок";
var CUSTOM_MESSAGE_POLL$5 = "📊 Опрос";
var CUSTOM_MESSAGE_STICKER$5 = "💟 Наклейка";
var CUSTOM_MESSAGE_DOCUMENT$5 = "📃 Документ";
var CUSTOM_MESSAGE_WHITEBOARD$5 = "📝 Белая доска";
var ONLINE$5 = "Онлайн";
var ADMINISTRATOR$5 = "Администратор";
var ADMIN$5 = "Администратор";
var MODERATOR$5 = "ведущий";
var PARTICIPANT$5 = "Участник";
var PUBLIC$5 = "Общественность";
var PRIVATE$5 = "Частное";
var PASSWORD_PROTECTED$5 = "Защищено паролем";
var PRIVACY_AND_SECURITY$5 = "Конфиденциальность и безопасность";
var PREFERENCES$5 = "Предпочтения";
var MEMBERS$5 = "Члены";
var MEMBER$5 = "Член";
var TODAY$5 = "Сегодня";
var YESTERDAY$5 = "Вчера";
var SUNDAY$5 = "Воскресенье";
var MONDAY$5 = "понедельник";
var TUESDAY$5 = "вторник";
var WEDNESDAY$5 = "Среда";
var THURSDAY$5 = "Четверг";
var FRIDAY$5 = "пятница";
var SATURDAY$5 = "суббота";
var TYPING$5 = "набрав...";
var IS_TYPING$5 = "печатает...";
var CLOSE$5 = "Закрыть";
var ENTER_GROUP_NAME$5 = "Введите имя группы";
var ADD_MEMBERS$5 = "Добавить участников";
var SEND_MESSAGE$5 = "Отправить сообщение";
var UNBLOCK_USER$5 = "Разблокировать пользователя";
var BLOCK_USER$5 = "Заблокировать пользователя";
var DELETE_AND_EXIT$5 = "Удалить и выйти";
var LEAVE_GROUP$5 = "Покинуть группу";
var CREATE_GROUP$5 = "Создать группу";
var SHARED_MEDIA$5 = "Общие медиафайлы";
var SHARED_FILE$5 = "Общий файл";
var VIDEO_CALL$5 = "Видеозвонок";
var AUDIO_CALL$5 = "Звуковой звонок";
var LOADING$5 = "Загрузка...";
var REPLY$5 = "ответить";
var REPLIES$5 = "ответы";
var AI$5 = "ИСКУССТВЕННЫЙ ИНТЕЛЛЕКТ";
var SMART_REPLIES$5 = "Умные ответы";
var CONVERSATION_STARTER$5 = "Начало беседы";
var LAUNCH$5 = "Запуск";
var SHARED_COLLABORATIVE_DOCUMENT$5 = "поделился совместным документом";
var SHARED_COLLABORATIVE_WHITEBOARD$5 = "поделился совместной доской";
var CREATED_WHITEBOARD$5 = "Вы создали новую доску для совместной работы";
var CREATED_DOCUMENT$5 = "Вы создали новый совместный документ";
var PHOTOS$5 = "Фотографии";
var VIDEOS$5 = "Видеоролики";
var DOCUMENT$5 = "Документ";
var YOU_DELETED_THIS_MESSAGE$5 = "⚠️ Вы удалили это сообщение";
var THIS_MESSAGE_DELETED$5 = "⚠️ Это сообщение было удалено";
var MESSAGE_IS_DELETED$5 = "Сообщение удалено";
var VIEW_ON_YOUTUBE$5 = "Смотреть на Youtube";
var SEARCH$5 = "Поиск";
var NO_USERS_FOUND$5 = "Пользователи не найдены";
var ERROR$5 = "Ошибка";
var NO_GROUPS_FOUND$5 = "Группы не найдены";
var NO_CHATS_FOUND$5 = "Чаты не найдены";
var CANT__LOAD__CHATS$5 = "Не удается загрузить чаты";
var MEDIA_MESSAGE$5 = "Сообщение для СМИ";
var INCOMING_AUDIO_CALL$5 = "Входящий аудиозвонок";
var INCOMING_VIDEO_CALL$5 = "Входящий видеозвонок";
var DECLINE$5 = "Снижение";
var ACCEPT$5 = "Принять";
var CALL_INITIATED$5 = "Вызов инициирован";
var OUTGOING_AUDIO_CALL$5 = "Исходящий аудиозвонок";
var OUTGOING_VIDEO_CALL$5 = "Исходящий видеозвонок";
var CALL_REJECTED$5 = "Вызов отклонен";
var REJECTED_CALL$5 = "отклоненный звонок";
var CALL_ACCEPTED$5 = "Вызов принят";
var OUTGOING_CALL$5 = "Исходящий звонок";
var INCOMING_CALL$5 = "Входящий звонок";
var MISSED_CALL$5 = "Пропущенный звонок";
var JOINED$5 = "совместный";
var LEFT_THE_CALL$5 = "оставил звонок";
var UNANSWERED_AUDIO_CALL$5 = "Звуковой звонок без ответа";
var UNANSWERED_VIDEO_CALL$5 = "Видеозвонок без ответа";
var CALL_ENDED$5 = "Звонок завершен";
var CALL_CANCELLED$5 = "Вызов отменен";
var CALL_BUSY$5 = "Звонок занят";
var CALLING$5 = "Звоню...";
var ADD$5 = "Добавить";
var NO_BANNED_MEMBERS_FOUND$5 = "Забаненных участников не найдено";
var BANNED_MEMBERS$5 = "Забаненные участники";
var NAME$5 = "Имя";
var SCOPE$5 = "Область применения";
var UNBAN$5 = "Разбанить";
var SELECT_GROUP_TYPE$5 = "Выберите тип группы";
var ENTER_GROUP_PASSWORD$5 = "Введите групповой пароль";
var CREATE$5 = "Создайте";
var CREATE_POLL$5 = "Создать опрос";
var QUESTION$5 = "Вопрос";
var ENTER_YOUR_QUESTION$5 = "Введите свой вопрос";
var OPTIONS$5 = "Опции";
var ENTER_YOUR_OPTION$5 = "Введите свой вариант";
var ADD_NEW_OPTION$5 = "Добавить новую опцию";
var VIEW_MEMBERS$5 = "Показать участников";
var DETAILS$5 = "Подробности";
var NOTIFICATIONS$5 = "Уведомления";
var OTHER$5 = "Другой";
var HELP$5 = "Помощь";
var REPORT_PROBLEM$5 = "Сообщить о проблеме";
var GROUP_MEMBERS$5 = "Члены группы";
var BAN$5 = "Запрет";
var KICK$5 = "Пинать";
var PICK_YOUR_EMOJI$5 = "Выберите свой смайлик";
var PRIVATE_GROUP$5 = "Частная группа";
var PROTECTED_GROUP$5 = "Защищенная группа";
var VISIT$5 = "Посетите";
var ATTACH$5 = "Прикрепить";
var OPEN_WHITEBOARD$5 = "Открытая доска";
var ATTACH_FILE$5 = "Прикрепить файл";
var GENERATING_REPLIES$5 = "Генерация ответов";
var ATTACH_VIDEO$5 = "Прикрепите видео";
var ATTACH_AUDIO$5 = "Прикрепите аудио";
var ATTACH_IMAGE$5 = "Прикрепите изображение";
var COLLABORATE_USING_DOCUMENT$5 = "Совместная работа с помощью документа";
var COLLABORATE_USING_WHITEBOARD$5 = "Сотрудничайте с помощью белой доски";
var SUGGEST_A_REPLY$5 = "Предложите ответ";
var GENERATING_ICEBREAKERS$5 = "Генерация ледоколов";
var EMOJI$5 = "смайлик";
var NO_REPLIES_FOUND$5 = "Ответов не найдено";
var ENTER_YOUR_MESSAGE_HERE$5 = "Введите здесь свое сообщение";
var NO_MESSAGES_FOUND$5 = "Сообщения не найдены";
var THREAD$5 = "Тема";
var COLLABORATIVE_DOCUMENT$5 = "Совместный документ";
var COLLABORATIVE_WHITEBOARD$5 = "Белая доска для совместной работы";
var ADD_REACTION$5 = "Добавить реакцию";
var NO_STICKERS_FOUND$5 = "Стикеры не найдены";
var REPLY_TO_THREAD$5 = "Ответить на тему";
var REPLY_IN_THREAD$5 = "Ответ в теме";
var VIEW$5 = "Вид";
var DELETE_MESSAGE$5 = "Удалить сообщение";
var EDIT_MESSAGE$5 = "Изменить сообщение";
var OWNER$5 = "Владелец";
var CHANGE_SCOPE$5 = "Изменить область";
var STICKER$5 = "Наклейка";
var LAST_ACTIVE_AT$5 = "Последнее активное сообщение";
var VOICE_CALL$5 = "Голосовой вызов";
var VIEW_DETAIL$5 = "Показать подробности";
var VOTES$5 = "голосов";
var VOTE$5 = "голосования";
var NO_VOTE$5 = "Нет голосования";
var REACTED$5 = "отреагировал";
var ADDED$5 = "добавил";
var SHOW_UNSAFE_CONTENT$5 = "Вы действительно хотите увидеть небезопасный контент?";
var REACT_TO_MESSAGE$5 = "Реагировать на сообщение";
var UNBANNED$5 = "разблокирован";
var MADE$5 = "сделал";
var CALL_UNANSWERED$5 = "Звонок без ответа";
var MISSED_AUDIO_CALL$5 = "Пропущенный аудиозвонок";
var ENTER_YOUR_PASSWORD$5 = "Введите свой пароль";
var DRAW_DOCUMENT_TOGETHER$5 = "Откройте документ для совместного редактирования содержимого";
var DOCS$5 = "Документы";
var NO_RECORDS_FOUND$5 = "Записей не найдено";
var LIVE_REACTION$5 = "Живая реакция";
var SMILEY_PEOPLE$5 = "Смайлы и люди";
var DRAW_WHITEBOARD_TOGETHER$5 = "Откройте доску, чтобы рисовать вместе";
var ANIMALES_NATURE$5 = "Животные и природа";
var FOOD_DRINK$5 = "Еда и напитки";
var OPEN_DOCUMENT$5 = "Открыть документ";
var ACTIVITY$5 = "Активность";
var TRAVEL_PLACES$5 = "Путешествия и места";
var OBJECTS$5 = "Объекты";
var SYMBOLS$5 = "Символы";
var FLAGS$5 = "Флаги";
var SENT$5 = "Отправлено";
var SEEN$5 = "Увиденное";
var DELIVERED$5 = "Доставлено";
var READ$5 = "Прочтите";
var MESSAGE_INFORMATION$5 = "Информация о сообщении";
var TRANSLATE_MESSAGE$5 = "Перевести сообщение";
var TRANSLATED_MESSAGE$5 = "Переведенное сообщение";
var LEFT$5 = "левый";
var KICKED$5 = "били ногами";
var BANNED$5 = "запретили";
var NEW_MESSAGES$5 = "новые сообщения";
var NEW_MESSAGE$5 = "новое сообщение";
var JUMP$5 = "Прыжок";
var SELECT_VIDEO_SOURCE$5 = "Выберите источник видео";
var SELECT_INPUT_AUDIO_SOURCE$5 = "Выберите источник входного звука";
var SELECT_OUTPUT_AUDIO_SOURCE$5 = "Выберите выходной источник звука";
var INITIATED_GROUP_CALL$5 = "инициировал групповой звонок";
var YOU_INITIATED_GROUP_CALL$5 = "Вы инициировали групповой звонок";
var IGNORE$5 = "Проигнорировать";
var ON_ANOTHER_CALL$5 = "звонит по другому звонку";
var CREATING$5 = "Создание";
var AVATAR$5 = "Аватар";
var ONGOING_CALL$5 = "Постоянный звонок";
var YOU_ALREADY_ONGOING_CALL$5 = "Вы уже на постоянном звонке";
var RESIZE$5 = "Изменить размер";
var SETTINGS$5 = "Настройки";
var ACTIONS$5 = "Действия";
var VIEW_PROFILE$5 = "Показать профиль";
var SEND_MESSAGE_IN_PRIVATE$5 = "Отправить сообщение конфиденциально";
var DELETE$5 = "Удалить";
var DELETE_CONFIRM$5 = "Вы действительно хотите удалить?";
var CANCEL$5 = "Отменить";
var LEAVE_CONFIRM$5 = "Вы уверены, что хотите покинуть группу?";
var TRANSFER_CONFIRM$5 = "Вы являетесь владельцем группы; пожалуйста, передайте право собственности члену перед тем, как покинуть группу";
var ADDING$5 = "Добавление...";
var TRANSFER$5 = "Трансфер";
var TRANSFER_OWNERSHIP$5 = "Передача права собственности";
var TRANSFERRING$5 = "Передача";
var YES$5 = "Да";
var NO$5 = "Нет";
var ANSWER$5 = "Ответ";
var ADD_ANOTHER_ANSWER$5 = "Добавить еще один ответ";
var SET_THE_ANSWERS$5 = "ЗАДАЙТЕ ОТВЕТЫ";
var TRY_AGAIN$5 = "Попробуй еще раз";
var INVALID_GROUP_NAME$5 = "Введите действительное имя группы и повторите попытку";
var INVALID_PASSWORD$5 = "Введите действительный пароль для группы и повторите попытку";
var INVALID_GROUP_TYPE$5 = "Введите правильный тип группы и повторите попытку";
var WRONG_PASSWORD$5 = "Пожалуйста, введите правильный пароль и попробуйте снова";
var INVALID_POLL_QUESTION$5 = "Пожалуйста, введите необходимый вопрос перед созданием опроса";
var INVALID_POLL_OPTION$5 = "Пожалуйста, введите требуемый ответ перед созданием опроса";
var SAME_LANGUAGE_MESSAGE$5 = "Выбранный язык для перевода аналогичен языку оригинального сообщения";
var LEAVE$5 = "Уехать";
var CLICK_TO_START_CONVERSATION$5 = "Нажмите, чтобы начать разговор";
var CUSTOM_MESSAGE_LOCATION$5 = "📍 Местонахождение";
var SHARED_LOCATION$5 = "Общее местоположение";
var IN_A_THREAD$5 = "В теме";
var CALLS$5 = "Звонки";
var CALL_DETAILS$5 = "Сведения о звонке";
var OFFLINE$5 = "Не в сети";
var POLLS$5 = "Опросы";
var YOU$5 = "Ты";
var PRIVACY$5 = "Конфиденциальность";
var BLOCKED_USERS$5 = "Заблокированные пользователи";
var NO_PHOTOS$5 = "Нет фотографий";
var NO_VIDEOS$5 = "Нет видео";
var NO_DOCUMENTS$5 = "Нет документов";
var JOIN$5 = "Присоединяйтесь";
var REMOVE$5 = "Удалить";
var BLOCK$5 = "Блокировать";
var CHANGE_ROLE$5 = "Изменить роль";
var NEW_CHAT$5 = "Новый чат";
var FORM_COMPLETION_MESSAGE$5 = "Спасибо за заполнение формы.";
var HISTORY$5 = "История";
var CANCELLED_AUDIO_CALL$5 = "Отмененный аудиозвонок";
var CANCELLED_VIDEO_CALL$5 = "Отмененный видеозвонок";
var REJECTED_AUDIO_CALL$5 = "Отклоненный аудиозвонок";
var REJECTED_VIDEO_CALL$5 = "Отклоненный видеозвонок";
var CANCELLED_CALL$5 = "Отмененный звонок";
var UNANSWERED_CALL$5 = "Звонок без ответа";
var RECORDING$5 = "Запись";
var PARTICIPANTS$5 = "Участники";
var CALL_HISTORY$5 = "История звонков";
var NO_CALLS_FOUND$5 = "Звонки не найдены";
var ONGOING_AUDIO_CALL$5 = "Продолжающийся аудиозвонок";
var ONGOING_VIDEO_CALL$5 = "Продолжающийся видеозвонок";
var CALL_DETAIL$5 = "Сведения о звонке";
var FORM$5 = "Форма";
var CARD$5 = "Карточка";
var GENERATING_SUMMARY$5 = "Создание сводки";
var CONVERSATION_SUMMARY$5 = "Краткое содержание беседы";
var GENERATE_SUMMARY$5 = "Сгенерируйте резюме";
var COMETCHAT_BOT_FIRST_MESSAGE$5 = "Чем я могу помочь вам в этом разговоре? Пожалуйста, задайте мне вопрос, и я вам посоветую 🙂";
var COMETCHAT_ASK_BOT$5 = "Спросите";
var COMETCHAT_ASK_AI_BOT$5 = "Спросите роботов AI";
var COMETCHAT_ASK_BOT_SUBTITLE$5 = "ИИ-бот";
var MENTIONS_LIMIT_WARNING_MESSAGE$5 = "За раз можно упомянуть до 10 раз.";
var ALL$5 = "Все";
var CLICK_TO_REMOVE$5 = "Нажмите, чтобы удалить";
var OTHERS$5 = "другие";
var AND$5 = "_";
var translationRU = {
	INFO: INFO$5,
	REACT: REACT$5,
	EDIT: EDIT$5,
	MESSAGE_PRIVATELY: MESSAGE_PRIVATELY$5,
	TRANSLATE: TRANSLATE$5,
	USERS: USERS$5,
	CHATS: CHATS$5,
	WOULD__YOU_LIKE_TO_DELETE_THIS_CONVERSATION: WOULD__YOU_LIKE_TO_DELETE_THIS_CONVERSATION$5,
	GROUPS: GROUPS$5,
	SHARED: SHARED$5,
	SOUND_MANAGER: SOUND_MANAGER$5,
	THEME: THEME$5,
	LOCALIZE: LOCALIZE$5,
	CONVERSATION_LIST_ITEM: CONVERSATION_LIST_ITEM$5,
	DATA_ITEM: DATA_ITEM$5,
	STATUS_INDICATOR: STATUS_INDICATOR$5,
	BADGE_COUNT: BADGE_COUNT$5,
	MESSAGE_RECEIPT: MESSAGE_RECEIPT$5,
	MESSAGE: MESSAGE$5,
	RECEIPT_INFORMATION: RECEIPT_INFORMATION$5,
	NO_RECIPIENT: NO_RECIPIENT$5,
	NO_RECIPIENTS: NO_RECIPIENTS$5,
	CONVERSATIONS_WITH_MESSAGES: CONVERSATIONS_WITH_MESSAGES$5,
	CONVERSATIONS: CONVERSATIONS$5,
	CONVERSATION_LIST: CONVERSATION_LIST$5,
	MESSAGES: MESSAGES$5,
	MESSAGE_HEADER: MESSAGE_HEADER$5,
	MESSAGE_LIST: MESSAGE_LIST$5,
	MESSAGE_COMPOSER: MESSAGE_COMPOSER$5,
	USERS_WITH_MESSAGES: USERS_WITH_MESSAGES$5,
	USER_LIST: USER_LIST$5,
	GROUP_LIST: GROUP_LIST$5,
	GROUPS_WITH_MESSAGES: GROUPS_WITH_MESSAGES$5,
	NEW__GROUP: NEW__GROUP$5,
	PASSWORD: PASSWORD$5,
	CONTINUE: CONTINUE$5,
	NO_CHATS_SELECTED: NO_CHATS_SELECTED$5,
	NO_USERS_SELECTED: NO_USERS_SELECTED$5,
	NO_GROUPS_SELECTED: NO_GROUPS_SELECTED$5,
	SELECT_DAY: SELECT_DAY$5,
	SELECT_TIME: SELECT_TIME$5,
	NO_CALLS_SELECTED: NO_CALLS_SELECTED$5,
	SELECT__GROUP: SELECT__GROUP$5,
	SELECT__USER: SELECT__USER$5,
	GROUP_PASSWORD_BLANK: GROUP_PASSWORD_BLANK$5,
	GROUP_NAME_BLANK: GROUP_NAME_BLANK$5,
	GROUP_TYPE_BLANK: GROUP_TYPE_BLANK$5,
	DELETE_CONVERSATION: DELETE_CONVERSATION$5,
	ADD_TO_CHAT: ADD_TO_CHAT$5,
	MORE: MORE$5,
	COPY: COPY$5,
	VOICE_RECORDING: VOICE_RECORDING$5,
	MESSAGE_IMAGE: MESSAGE_IMAGE$5,
	MESSAGE_FILE: MESSAGE_FILE$5,
	MESSAGE_VIDEO: MESSAGE_VIDEO$5,
	MESSAGE_AUDIO: MESSAGE_AUDIO$5,
	CUSTOM_MESSAGE: CUSTOM_MESSAGE$5,
	SELECT_A_DATE: SELECT_A_DATE$5,
	TIME_ZONE: TIME_ZONE$5,
	MEETING_SCHEDULED: MEETING_SCHEDULED$5,
	SOMETHING_WRONG: SOMETHING_WRONG$5,
	MEETING_SLOT_BOOK: MEETING_SLOT_BOOK$5,
	MEETING_BOOK_NEW_SLOT: MEETING_BOOK_NEW_SLOT$5,
	MEETING_NO_SLOTS_AVAILABLE: MEETING_NO_SLOTS_AVAILABLE$5,
	MEETING_TRY_DIFFERENT_DATE: MEETING_TRY_DIFFERENT_DATE$5,
	NO_TIME_SLOTS_AVAILABLE: NO_TIME_SLOTS_AVAILABLE$5,
	SCHEDULE: SCHEDULE$5,
	MORE_TIMES: MORE_TIMES$5,
	MISSED_VOICE_CALL: MISSED_VOICE_CALL$5,
	MEET_WITH: MEET_WITH$5,
	MEETING_SCHEDULER: MEETING_SCHEDULER$5,
	MISSED_VIDEO_CALL: MISSED_VIDEO_CALL$5,
	CUSTOM_MESSAGE_POLL: CUSTOM_MESSAGE_POLL$5,
	CUSTOM_MESSAGE_STICKER: CUSTOM_MESSAGE_STICKER$5,
	CUSTOM_MESSAGE_DOCUMENT: CUSTOM_MESSAGE_DOCUMENT$5,
	CUSTOM_MESSAGE_WHITEBOARD: CUSTOM_MESSAGE_WHITEBOARD$5,
	ONLINE: ONLINE$5,
	ADMINISTRATOR: ADMINISTRATOR$5,
	ADMIN: ADMIN$5,
	MODERATOR: MODERATOR$5,
	PARTICIPANT: PARTICIPANT$5,
	PUBLIC: PUBLIC$5,
	PRIVATE: PRIVATE$5,
	PASSWORD_PROTECTED: PASSWORD_PROTECTED$5,
	PRIVACY_AND_SECURITY: PRIVACY_AND_SECURITY$5,
	PREFERENCES: PREFERENCES$5,
	MEMBERS: MEMBERS$5,
	MEMBER: MEMBER$5,
	TODAY: TODAY$5,
	YESTERDAY: YESTERDAY$5,
	SUNDAY: SUNDAY$5,
	MONDAY: MONDAY$5,
	TUESDAY: TUESDAY$5,
	WEDNESDAY: WEDNESDAY$5,
	THURSDAY: THURSDAY$5,
	FRIDAY: FRIDAY$5,
	SATURDAY: SATURDAY$5,
	TYPING: TYPING$5,
	IS_TYPING: IS_TYPING$5,
	CLOSE: CLOSE$5,
	ENTER_GROUP_NAME: ENTER_GROUP_NAME$5,
	ADD_MEMBERS: ADD_MEMBERS$5,
	SEND_MESSAGE: SEND_MESSAGE$5,
	UNBLOCK_USER: UNBLOCK_USER$5,
	BLOCK_USER: BLOCK_USER$5,
	DELETE_AND_EXIT: DELETE_AND_EXIT$5,
	LEAVE_GROUP: LEAVE_GROUP$5,
	CREATE_GROUP: CREATE_GROUP$5,
	SHARED_MEDIA: SHARED_MEDIA$5,
	SHARED_FILE: SHARED_FILE$5,
	VIDEO_CALL: VIDEO_CALL$5,
	AUDIO_CALL: AUDIO_CALL$5,
	LOADING: LOADING$5,
	REPLY: REPLY$5,
	REPLIES: REPLIES$5,
	AI: AI$5,
	SMART_REPLIES: SMART_REPLIES$5,
	CONVERSATION_STARTER: CONVERSATION_STARTER$5,
	LAUNCH: LAUNCH$5,
	SHARED_COLLABORATIVE_DOCUMENT: SHARED_COLLABORATIVE_DOCUMENT$5,
	SHARED_COLLABORATIVE_WHITEBOARD: SHARED_COLLABORATIVE_WHITEBOARD$5,
	CREATED_WHITEBOARD: CREATED_WHITEBOARD$5,
	CREATED_DOCUMENT: CREATED_DOCUMENT$5,
	PHOTOS: PHOTOS$5,
	VIDEOS: VIDEOS$5,
	DOCUMENT: DOCUMENT$5,
	YOU_DELETED_THIS_MESSAGE: YOU_DELETED_THIS_MESSAGE$5,
	THIS_MESSAGE_DELETED: THIS_MESSAGE_DELETED$5,
	MESSAGE_IS_DELETED: MESSAGE_IS_DELETED$5,
	VIEW_ON_YOUTUBE: VIEW_ON_YOUTUBE$5,
	SEARCH: SEARCH$5,
	NO_USERS_FOUND: NO_USERS_FOUND$5,
	ERROR: ERROR$5,
	NO_GROUPS_FOUND: NO_GROUPS_FOUND$5,
	NO_CHATS_FOUND: NO_CHATS_FOUND$5,
	CANT__LOAD__CHATS: CANT__LOAD__CHATS$5,
	MEDIA_MESSAGE: MEDIA_MESSAGE$5,
	INCOMING_AUDIO_CALL: INCOMING_AUDIO_CALL$5,
	INCOMING_VIDEO_CALL: INCOMING_VIDEO_CALL$5,
	DECLINE: DECLINE$5,
	ACCEPT: ACCEPT$5,
	CALL_INITIATED: CALL_INITIATED$5,
	OUTGOING_AUDIO_CALL: OUTGOING_AUDIO_CALL$5,
	OUTGOING_VIDEO_CALL: OUTGOING_VIDEO_CALL$5,
	CALL_REJECTED: CALL_REJECTED$5,
	REJECTED_CALL: REJECTED_CALL$5,
	CALL_ACCEPTED: CALL_ACCEPTED$5,
	OUTGOING_CALL: OUTGOING_CALL$5,
	INCOMING_CALL: INCOMING_CALL$5,
	MISSED_CALL: MISSED_CALL$5,
	JOINED: JOINED$5,
	LEFT_THE_CALL: LEFT_THE_CALL$5,
	UNANSWERED_AUDIO_CALL: UNANSWERED_AUDIO_CALL$5,
	UNANSWERED_VIDEO_CALL: UNANSWERED_VIDEO_CALL$5,
	CALL_ENDED: CALL_ENDED$5,
	CALL_CANCELLED: CALL_CANCELLED$5,
	CALL_BUSY: CALL_BUSY$5,
	CALLING: CALLING$5,
	ADD: ADD$5,
	NO_BANNED_MEMBERS_FOUND: NO_BANNED_MEMBERS_FOUND$5,
	BANNED_MEMBERS: BANNED_MEMBERS$5,
	NAME: NAME$5,
	SCOPE: SCOPE$5,
	UNBAN: UNBAN$5,
	SELECT_GROUP_TYPE: SELECT_GROUP_TYPE$5,
	ENTER_GROUP_PASSWORD: ENTER_GROUP_PASSWORD$5,
	CREATE: CREATE$5,
	CREATE_POLL: CREATE_POLL$5,
	QUESTION: QUESTION$5,
	ENTER_YOUR_QUESTION: ENTER_YOUR_QUESTION$5,
	OPTIONS: OPTIONS$5,
	ENTER_YOUR_OPTION: ENTER_YOUR_OPTION$5,
	ADD_NEW_OPTION: ADD_NEW_OPTION$5,
	VIEW_MEMBERS: VIEW_MEMBERS$5,
	DETAILS: DETAILS$5,
	NOTIFICATIONS: NOTIFICATIONS$5,
	OTHER: OTHER$5,
	HELP: HELP$5,
	REPORT_PROBLEM: REPORT_PROBLEM$5,
	GROUP_MEMBERS: GROUP_MEMBERS$5,
	BAN: BAN$5,
	KICK: KICK$5,
	PICK_YOUR_EMOJI: PICK_YOUR_EMOJI$5,
	PRIVATE_GROUP: PRIVATE_GROUP$5,
	PROTECTED_GROUP: PROTECTED_GROUP$5,
	VISIT: VISIT$5,
	ATTACH: ATTACH$5,
	OPEN_WHITEBOARD: OPEN_WHITEBOARD$5,
	ATTACH_FILE: ATTACH_FILE$5,
	GENERATING_REPLIES: GENERATING_REPLIES$5,
	ATTACH_VIDEO: ATTACH_VIDEO$5,
	ATTACH_AUDIO: ATTACH_AUDIO$5,
	ATTACH_IMAGE: ATTACH_IMAGE$5,
	COLLABORATE_USING_DOCUMENT: COLLABORATE_USING_DOCUMENT$5,
	COLLABORATE_USING_WHITEBOARD: COLLABORATE_USING_WHITEBOARD$5,
	SUGGEST_A_REPLY: SUGGEST_A_REPLY$5,
	GENERATING_ICEBREAKERS: GENERATING_ICEBREAKERS$5,
	EMOJI: EMOJI$5,
	NO_REPLIES_FOUND: NO_REPLIES_FOUND$5,
	ENTER_YOUR_MESSAGE_HERE: ENTER_YOUR_MESSAGE_HERE$5,
	NO_MESSAGES_FOUND: NO_MESSAGES_FOUND$5,
	THREAD: THREAD$5,
	COLLABORATIVE_DOCUMENT: COLLABORATIVE_DOCUMENT$5,
	COLLABORATIVE_WHITEBOARD: COLLABORATIVE_WHITEBOARD$5,
	ADD_REACTION: ADD_REACTION$5,
	NO_STICKERS_FOUND: NO_STICKERS_FOUND$5,
	REPLY_TO_THREAD: REPLY_TO_THREAD$5,
	REPLY_IN_THREAD: REPLY_IN_THREAD$5,
	VIEW: VIEW$5,
	DELETE_MESSAGE: DELETE_MESSAGE$5,
	EDIT_MESSAGE: EDIT_MESSAGE$5,
	OWNER: OWNER$5,
	CHANGE_SCOPE: CHANGE_SCOPE$5,
	STICKER: STICKER$5,
	LAST_ACTIVE_AT: LAST_ACTIVE_AT$5,
	VOICE_CALL: VOICE_CALL$5,
	VIEW_DETAIL: VIEW_DETAIL$5,
	VOTES: VOTES$5,
	VOTE: VOTE$5,
	NO_VOTE: NO_VOTE$5,
	REACTED: REACTED$5,
	ADDED: ADDED$5,
	SHOW_UNSAFE_CONTENT: SHOW_UNSAFE_CONTENT$5,
	REACT_TO_MESSAGE: REACT_TO_MESSAGE$5,
	UNBANNED: UNBANNED$5,
	MADE: MADE$5,
	CALL_UNANSWERED: CALL_UNANSWERED$5,
	MISSED_AUDIO_CALL: MISSED_AUDIO_CALL$5,
	ENTER_YOUR_PASSWORD: ENTER_YOUR_PASSWORD$5,
	DRAW_DOCUMENT_TOGETHER: DRAW_DOCUMENT_TOGETHER$5,
	DOCS: DOCS$5,
	NO_RECORDS_FOUND: NO_RECORDS_FOUND$5,
	LIVE_REACTION: LIVE_REACTION$5,
	SMILEY_PEOPLE: SMILEY_PEOPLE$5,
	DRAW_WHITEBOARD_TOGETHER: DRAW_WHITEBOARD_TOGETHER$5,
	ANIMALES_NATURE: ANIMALES_NATURE$5,
	FOOD_DRINK: FOOD_DRINK$5,
	OPEN_DOCUMENT: OPEN_DOCUMENT$5,
	ACTIVITY: ACTIVITY$5,
	TRAVEL_PLACES: TRAVEL_PLACES$5,
	OBJECTS: OBJECTS$5,
	SYMBOLS: SYMBOLS$5,
	FLAGS: FLAGS$5,
	SENT: SENT$5,
	SEEN: SEEN$5,
	DELIVERED: DELIVERED$5,
	READ: READ$5,
	MESSAGE_INFORMATION: MESSAGE_INFORMATION$5,
	TRANSLATE_MESSAGE: TRANSLATE_MESSAGE$5,
	TRANSLATED_MESSAGE: TRANSLATED_MESSAGE$5,
	LEFT: LEFT$5,
	KICKED: KICKED$5,
	BANNED: BANNED$5,
	NEW_MESSAGES: NEW_MESSAGES$5,
	NEW_MESSAGE: NEW_MESSAGE$5,
	JUMP: JUMP$5,
	SELECT_VIDEO_SOURCE: SELECT_VIDEO_SOURCE$5,
	SELECT_INPUT_AUDIO_SOURCE: SELECT_INPUT_AUDIO_SOURCE$5,
	SELECT_OUTPUT_AUDIO_SOURCE: SELECT_OUTPUT_AUDIO_SOURCE$5,
	INITIATED_GROUP_CALL: INITIATED_GROUP_CALL$5,
	YOU_INITIATED_GROUP_CALL: YOU_INITIATED_GROUP_CALL$5,
	IGNORE: IGNORE$5,
	ON_ANOTHER_CALL: ON_ANOTHER_CALL$5,
	CREATING: CREATING$5,
	AVATAR: AVATAR$5,
	ONGOING_CALL: ONGOING_CALL$5,
	YOU_ALREADY_ONGOING_CALL: YOU_ALREADY_ONGOING_CALL$5,
	RESIZE: RESIZE$5,
	SETTINGS: SETTINGS$5,
	ACTIONS: ACTIONS$5,
	VIEW_PROFILE: VIEW_PROFILE$5,
	SEND_MESSAGE_IN_PRIVATE: SEND_MESSAGE_IN_PRIVATE$5,
	DELETE: DELETE$5,
	DELETE_CONFIRM: DELETE_CONFIRM$5,
	CANCEL: CANCEL$5,
	LEAVE_CONFIRM: LEAVE_CONFIRM$5,
	TRANSFER_CONFIRM: TRANSFER_CONFIRM$5,
	ADDING: ADDING$5,
	TRANSFER: TRANSFER$5,
	TRANSFER_OWNERSHIP: TRANSFER_OWNERSHIP$5,
	TRANSFERRING: TRANSFERRING$5,
	YES: YES$5,
	NO: NO$5,
	ANSWER: ANSWER$5,
	ADD_ANOTHER_ANSWER: ADD_ANOTHER_ANSWER$5,
	SET_THE_ANSWERS: SET_THE_ANSWERS$5,
	TRY_AGAIN: TRY_AGAIN$5,
	INVALID_GROUP_NAME: INVALID_GROUP_NAME$5,
	INVALID_PASSWORD: INVALID_PASSWORD$5,
	INVALID_GROUP_TYPE: INVALID_GROUP_TYPE$5,
	WRONG_PASSWORD: WRONG_PASSWORD$5,
	INVALID_POLL_QUESTION: INVALID_POLL_QUESTION$5,
	INVALID_POLL_OPTION: INVALID_POLL_OPTION$5,
	SAME_LANGUAGE_MESSAGE: SAME_LANGUAGE_MESSAGE$5,
	LEAVE: LEAVE$5,
	CLICK_TO_START_CONVERSATION: CLICK_TO_START_CONVERSATION$5,
	CUSTOM_MESSAGE_LOCATION: CUSTOM_MESSAGE_LOCATION$5,
	SHARED_LOCATION: SHARED_LOCATION$5,
	IN_A_THREAD: IN_A_THREAD$5,
	CALLS: CALLS$5,
	CALL_DETAILS: CALL_DETAILS$5,
	OFFLINE: OFFLINE$5,
	POLLS: POLLS$5,
	YOU: YOU$5,
	PRIVACY: PRIVACY$5,
	BLOCKED_USERS: BLOCKED_USERS$5,
	"YOU'VE_BLOCKED": "Вы заблокировали",
	NO_PHOTOS: NO_PHOTOS$5,
	NO_VIDEOS: NO_VIDEOS$5,
	NO_DOCUMENTS: NO_DOCUMENTS$5,
	JOIN: JOIN$5,
	REMOVE: REMOVE$5,
	BLOCK: BLOCK$5,
	CHANGE_ROLE: CHANGE_ROLE$5,
	NEW_CHAT: NEW_CHAT$5,
	FORM_COMPLETION_MESSAGE: FORM_COMPLETION_MESSAGE$5,
	HISTORY: HISTORY$5,
	CANCELLED_AUDIO_CALL: CANCELLED_AUDIO_CALL$5,
	CANCELLED_VIDEO_CALL: CANCELLED_VIDEO_CALL$5,
	REJECTED_AUDIO_CALL: REJECTED_AUDIO_CALL$5,
	REJECTED_VIDEO_CALL: REJECTED_VIDEO_CALL$5,
	CANCELLED_CALL: CANCELLED_CALL$5,
	UNANSWERED_CALL: UNANSWERED_CALL$5,
	RECORDING: RECORDING$5,
	PARTICIPANTS: PARTICIPANTS$5,
	CALL_HISTORY: CALL_HISTORY$5,
	NO_CALLS_FOUND: NO_CALLS_FOUND$5,
	ONGOING_AUDIO_CALL: ONGOING_AUDIO_CALL$5,
	ONGOING_VIDEO_CALL: ONGOING_VIDEO_CALL$5,
	CALL_DETAIL: CALL_DETAIL$5,
	FORM: FORM$5,
	CARD: CARD$5,
	GENERATING_SUMMARY: GENERATING_SUMMARY$5,
	CONVERSATION_SUMMARY: CONVERSATION_SUMMARY$5,
	GENERATE_SUMMARY: GENERATE_SUMMARY$5,
	COMETCHAT_BOT_FIRST_MESSAGE: COMETCHAT_BOT_FIRST_MESSAGE$5,
	COMETCHAT_ASK_BOT: COMETCHAT_ASK_BOT$5,
	COMETCHAT_ASK_AI_BOT: COMETCHAT_ASK_AI_BOT$5,
	COMETCHAT_ASK_BOT_SUBTITLE: COMETCHAT_ASK_BOT_SUBTITLE$5,
	MENTIONS_LIMIT_WARNING_MESSAGE: MENTIONS_LIMIT_WARNING_MESSAGE$5,
	ALL: ALL$5,
	CLICK_TO_REMOVE: CLICK_TO_REMOVE$5,
	OTHERS: OTHERS$5,
	AND: AND$5
};

var INFO$4 = "信息";
var REACT$4 = "做出反应";
var EDIT$4 = "编辑";
var MESSAGE_PRIVATELY$4 = "私下留言";
var TRANSLATE$4 = "翻译";
var USERS$4 = "用户";
var CHATS$4 = "聊天";
var WOULD__YOU_LIKE_TO_DELETE_THIS_CONVERSATION$4 = "你想删除这个对话吗？此对话将从您的所有设备中删除。";
var GROUPS$4 = "群组";
var SHARED$4 = "共享的";
var SOUND_MANAGER$4 = "声音管理器";
var THEME$4 = "主题";
var LOCALIZE$4 = "本地化";
var CONVERSATION_LIST_ITEM$4 = "对话清单项目";
var DATA_ITEM$4 = "数据项";
var STATUS_INDICATOR$4 = "状态指示器";
var BADGE_COUNT$4 = "徽章数量";
var MESSAGE_RECEIPT$4 = "留言回执";
var MESSAGE$4 = "留言";
var RECEIPT_INFORMATION$4 = "收据信息";
var NO_RECIPIENT$4 = "没有收件人";
var NO_RECIPIENTS$4 = "没有收件人";
var CONVERSATIONS_WITH_MESSAGES$4 = "带消息的对话";
var CONVERSATIONS$4 = "对话";
var CONVERSATION_LIST$4 = "对话清单";
var MESSAGES$4 = "消息";
var MESSAGE_HEADER$4 = "留言标题";
var MESSAGE_LIST$4 = "留言清单";
var MESSAGE_COMPOSER$4 = "消息编辑器";
var USERS_WITH_MESSAGES$4 = "有消息的用户";
var USER_LIST$4 = "用户名单";
var GROUP_LIST$4 = "群组名单";
var GROUPS_WITH_MESSAGES$4 = "包含消息的群组";
var NEW__GROUP$4 = "新群组";
var PASSWORD$4 = "密码";
var CONTINUE$4 = "继续";
var NO_CHATS_SELECTED$4 = "未选择任何聊天记录";
var NO_USERS_SELECTED$4 = "未选择任何用户";
var NO_GROUPS_SELECTED$4 = "未选择任何群组";
var SELECT_DAY$4 = "选择一天";
var SELECT_TIME$4 = "选择时间";
var NO_CALLS_SELECTED$4 = "未选择任何呼叫";
var SELECT__GROUP$4 = "选择一个群组开始发送消息";
var SELECT__USER$4 = "选择一个用户开始发送消息";
var GROUP_PASSWORD_BLANK$4 = "群组密码不能为空";
var GROUP_NAME_BLANK$4 = "群组名称不能为空";
var GROUP_TYPE_BLANK$4 = "群组类型不能为空";
var DELETE_CONVERSATION$4 = "删除对话？";
var ADD_TO_CHAT$4 = "加入聊天";
var MORE$4 = "更多";
var COPY$4 = "复制";
var VOICE_RECORDING$4 = "语音录制";
var MESSAGE_IMAGE$4 = "📷 图片";
var MESSAGE_FILE$4 = "📁 文件";
var MESSAGE_VIDEO$4 = "📹 视频";
var MESSAGE_AUDIO$4 = "🎵 音频";
var CUSTOM_MESSAGE$4 = "你有一条消息";
var SELECT_A_DATE$4 = "选择一个日期";
var TIME_ZONE$4 = "时区";
var MEETING_SCHEDULED$4 = "您的会议已经安排好了。";
var SOMETHING_WRONG$4 = "出了点问题。请再试一次。";
var MEETING_SLOT_BOOK$4 = "时段不再可用。请选择另一个。";
var MEETING_BOOK_NEW_SLOT$4 = "预订新老虎机";
var MEETING_NO_SLOTS_AVAILABLE$4 = "此日期没有时间段。请尝试其他日期。";
var MEETING_TRY_DIFFERENT_DATE$4 = "请尝试不同的日期。";
var NO_TIME_SLOTS_AVAILABLE$4 = "没有可用的时段";
var SCHEDULE$4 = "日程安排";
var MORE_TIMES$4 = "更多次数";
var MISSED_VOICE_CALL$4 = "未接语音通话";
var MEET_WITH$4 = "与... 见面";
var MEETING_SCHEDULER$4 = "会议安排器";
var MISSED_VIDEO_CALL$4 = "错过了视频通话";
var CUSTOM_MESSAGE_POLL$4 = "📊 投票";
var CUSTOM_MESSAGE_STICKER$4 = "💟 贴纸";
var CUSTOM_MESSAGE_DOCUMENT$4 = "📃 文档";
var CUSTOM_MESSAGE_WHITEBOARD$4 = "📝 白板";
var ONLINE$4 = "在线";
var ADMINISTRATOR$4 = "管理员";
var ADMIN$4 = "管理员";
var MODERATOR$4 = "演示者";
var PARTICIPANT$4 = "参与者";
var PUBLIC$4 = "公开";
var PRIVATE$4 = "私人";
var PASSWORD_PROTECTED$4 = "密码保护";
var PRIVACY_AND_SECURITY$4 = "隐私和安全";
var PREFERENCES$4 = "首选项";
var MEMBERS$4 = "会员";
var MEMBER$4 = "会员";
var TODAY$4 = "今天";
var YESTERDAY$4 = "昨天";
var SUNDAY$4 = "星期日";
var MONDAY$4 = "星期一";
var TUESDAY$4 = "星期二";
var WEDNESDAY$4 = "周三";
var THURSDAY$4 = "星期四";
var FRIDAY$4 = "星期五";
var SATURDAY$4 = "星期六";
var TYPING$4 = "正在输入...";
var IS_TYPING$4 = "正在打字...";
var CLOSE$4 = "关闭";
var ENTER_GROUP_NAME$4 = "输入群组名称";
var ADD_MEMBERS$4 = "添加成员";
var SEND_MESSAGE$4 = "发送消息";
var UNBLOCK_USER$4 = "解除屏蔽用户";
var BLOCK_USER$4 = "屏蔽用户";
var DELETE_AND_EXIT$4 = "删除并退出";
var LEAVE_GROUP$4 = "离开群组";
var CREATE_GROUP$4 = "创建群组";
var SHARED_MEDIA$4 = "共享媒体";
var SHARED_FILE$4 = "共享文件";
var VIDEO_CALL$4 = "视频通话";
var AUDIO_CALL$4 = "音频通话";
var LOADING$4 = "加载中...";
var REPLY$4 = "答复";
var REPLIES$4 = "回复";
var AI$4 = "AI";
var SMART_REPLIES$4 = "智能回复";
var CONVERSATION_STARTER$4 = "对话入门";
var LAUNCH$4 = "启动";
var SHARED_COLLABORATIVE_DOCUMENT$4 = "共享了一份协作文档";
var SHARED_COLLABORATIVE_WHITEBOARD$4 = "共享了协作白板";
var CREATED_WHITEBOARD$4 = "你已经创建了一个新的协作白板";
var CREATED_DOCUMENT$4 = "你已经创建了一个新的协作文档";
var PHOTOS$4 = "照片";
var VIDEOS$4 = "视频";
var DOCUMENT$4 = "文档";
var YOU_DELETED_THIS_MESSAGE$4 = "⚠️ 你删除了这条消息";
var THIS_MESSAGE_DELETED$4 = "⚠️ 此消息已删除";
var MESSAGE_IS_DELETED$4 = "留言已删除";
var VIEW_ON_YOUTUBE$4 = "在优酷上观看";
var SEARCH$4 = "搜寻";
var NO_USERS_FOUND$4 = "未找到用户";
var ERROR$4 = "错误";
var NO_GROUPS_FOUND$4 = "未找到群组";
var NO_CHATS_FOUND$4 = "未找到聊天记录";
var CANT__LOAD__CHATS$4 = "无法加载聊天记录";
var MEDIA_MESSAGE$4 = "媒体消息";
var INCOMING_AUDIO_CALL$4 = "来电语音";
var INCOMING_VIDEO_CALL$4 = "来电视频通话";
var DECLINE$4 = "拒绝";
var ACCEPT$4 = "接受";
var CALL_INITIATED$4 = "呼叫已启动";
var OUTGOING_AUDIO_CALL$4 = "拨出语音通话";
var OUTGOING_VIDEO_CALL$4 = "拨出视频通话";
var CALL_REJECTED$4 = "呼叫被拒绝";
var REJECTED_CALL$4 = "呼叫被拒绝";
var CALL_ACCEPTED$4 = "通话已接受";
var OUTGOING_CALL$4 = "拨出电话";
var INCOMING_CALL$4 = "来电";
var MISSED_CALL$4 = "未接来电";
var JOINED$4 = "已加入";
var LEFT_THE_CALL$4 = "离开了电话";
var UNANSWERED_AUDIO_CALL$4 = "未接听的语音通话";
var UNANSWERED_VIDEO_CALL$4 = "未接听的视频通话";
var CALL_ENDED$4 = "通话已结束";
var CALL_CANCELLED$4 = "通话已取消";
var CALL_BUSY$4 = "通话忙碌";
var CALLING$4 = "正在打电话...";
var ADD$4 = "添加";
var NO_BANNED_MEMBERS_FOUND$4 = "未找到被禁会员";
var BANNED_MEMBERS$4 = "被禁止的会员";
var NAME$4 = "姓名";
var SCOPE$4 = "范围";
var UNBAN$4 = "取消封禁";
var SELECT_GROUP_TYPE$4 = "选择群组类型";
var ENTER_GROUP_PASSWORD$4 = "输入群组密码";
var CREATE$4 = "创建";
var CREATE_POLL$4 = "创建投票";
var QUESTION$4 = "问题";
var ENTER_YOUR_QUESTION$4 = "输入你的问题";
var OPTIONS$4 = "选项";
var ENTER_YOUR_OPTION$4 = "输入您的选项";
var ADD_NEW_OPTION$4 = "添加新选项";
var VIEW_MEMBERS$4 = "查看会员";
var DETAILS$4 = "详情";
var NOTIFICATIONS$4 = "通知";
var OTHER$4 = "其他";
var HELP$4 = "帮帮我";
var REPORT_PROBLEM$4 = "报告问题";
var GROUP_MEMBERS$4 = "小组成员";
var BAN$4 = "禁令";
var KICK$4 = "踢";
var PICK_YOUR_EMOJI$4 = "选择你的表情符号";
var PRIVATE_GROUP$4 = "私人群组";
var PROTECTED_GROUP$4 = "受保护群组";
var VISIT$4 = "参观";
var ATTACH$4 = "附上";
var OPEN_WHITEBOARD$4 = "打开白板";
var ATTACH_FILE$4 = "附上文件";
var GENERATING_REPLIES$4 = "生成回复";
var ATTACH_VIDEO$4 = "附上视频";
var ATTACH_AUDIO$4 = "附加音频";
var ATTACH_IMAGE$4 = "附上图片";
var COLLABORATE_USING_DOCUMENT$4 = "使用文档进行协作";
var COLLABORATE_USING_WHITEBOARD$4 = "使用白板进行协作";
var SUGGEST_A_REPLY$4 = "建议回复";
var GENERATING_ICEBREAKERS$4 = "生成破冰船";
var EMOJI$4 = "表情符号";
var NO_REPLIES_FOUND$4 = "未找到回复";
var ENTER_YOUR_MESSAGE_HERE$4 = "在这里输入你的信息";
var NO_MESSAGES_FOUND$4 = "未找到任何消息";
var THREAD$4 = "线程";
var COLLABORATIVE_DOCUMENT$4 = "协作文档";
var COLLABORATIVE_WHITEBOARD$4 = "协作白板";
var ADD_REACTION$4 = "添加反应";
var NO_STICKERS_FOUND$4 = "未找到贴纸";
var REPLY_TO_THREAD$4 = "回复话题";
var REPLY_IN_THREAD$4 = "在话题中回复";
var VIEW$4 = "查看";
var DELETE_MESSAGE$4 = "删除留言";
var EDIT_MESSAGE$4 = "编辑消息";
var OWNER$4 = "所有者";
var CHANGE_SCOPE$4 = "变更范围";
var STICKER$4 = "贴纸";
var LAST_ACTIVE_AT$4 = "上次活跃时间";
var VOICE_CALL$4 = "语音通话";
var VIEW_DETAIL$4 = "查看详情";
var VOTES$4 = "选票";
var VOTE$4 = "投票";
var NO_VOTE$4 = "不投票";
var REACTED$4 = "反应";
var ADDED$4 = "添加";
var SHOW_UNSAFE_CONTENT$4 = "您确定要查看不安全的内容吗？";
var REACT_TO_MESSAGE$4 = "对消息做出反应";
var UNBANNED$4 = "未被禁止";
var MADE$4 = "制作";
var CALL_UNANSWERED$4 = "来电未接听";
var MISSED_AUDIO_CALL$4 = "错过的语音通话";
var ENTER_YOUR_PASSWORD$4 = "输入你的密码";
var DRAW_DOCUMENT_TOGETHER$4 = "打开文档一起编辑内容";
var DOCS$4 = "文档";
var NO_RECORDS_FOUND$4 = "未找到任何记录";
var LIVE_REACTION$4 = "现场反应";
var SMILEY_PEOPLE$4 = "笑脸与人物";
var DRAW_WHITEBOARD_TOGETHER$4 = "打开白板一起画画";
var ANIMALES_NATURE$4 = "动物与自然";
var FOOD_DRINK$4 = "食物和饮料";
var OPEN_DOCUMENT$4 = "打开文档";
var ACTIVITY$4 = "活动";
var TRAVEL_PLACES$4 = "旅行与地点";
var OBJECTS$4 = "物体";
var SYMBOLS$4 = "符号";
var FLAGS$4 = "旗帜";
var SENT$4 = "已发送";
var SEEN$4 = "看见了";
var DELIVERED$4 = "已交付";
var READ$4 = "阅读";
var MESSAGE_INFORMATION$4 = "留言信息";
var TRANSLATE_MESSAGE$4 = "翻译消息";
var TRANSLATED_MESSAGE$4 = "已翻译的消息";
var LEFT$4 = "左边";
var KICKED$4 = "被踢的";
var BANNED$4 = "禁止";
var NEW_MESSAGES$4 = "新消息";
var NEW_MESSAGE$4 = "新消息";
var JUMP$4 = "跳";
var SELECT_VIDEO_SOURCE$4 = "选择视频来源";
var SELECT_INPUT_AUDIO_SOURCE$4 = "选择输入音频源";
var SELECT_OUTPUT_AUDIO_SOURCE$4 = "选择输出音频源";
var INITIATED_GROUP_CALL$4 = "已发起群组通话";
var YOU_INITIATED_GROUP_CALL$4 = "你发起了群组通话";
var IGNORE$4 = "忽略";
var ON_ANOTHER_CALL$4 = "正在接另一个电话";
var CREATING$4 = "正在创建";
var AVATAR$4 = "阿凡达";
var ONGOING_CALL$4 = "正在进行的通话";
var YOU_ALREADY_ONGOING_CALL$4 = "您已经在通话中";
var RESIZE$4 = "调整大小";
var SETTINGS$4 = "设置";
var ACTIONS$4 = "行动";
var VIEW_PROFILE$4 = "查看个人资料";
var SEND_MESSAGE_IN_PRIVATE$4 = "私下发送消息";
var DELETE$4 = "删除";
var DELETE_CONFIRM$4 = "你确定要删除吗？";
var CANCEL$4 = "取消";
var LEAVE_CONFIRM$4 = "你确定要离开群组吗？";
var TRANSFER_CONFIRM$4 = "您是群组所有者；请在离开群组前将所有权转让给成员";
var ADDING$4 = "正在添加...";
var TRANSFER$4 = "转移";
var TRANSFER_OWNERSHIP$4 = "转让所有权";
var TRANSFERRING$4 = "转移";
var YES$4 = "是的";
var NO$4 = "没有";
var ANSWER$4 = "回答";
var ADD_ANOTHER_ANSWER$4 = "添加另一个答案";
var SET_THE_ANSWERS$4 = "设定答案";
var TRY_AGAIN$4 = "再试一次";
var INVALID_GROUP_NAME$4 = "请输入群组的有效名称，然后重试";
var INVALID_PASSWORD$4 = "请输入群组的有效密码并重试";
var INVALID_GROUP_TYPE$4 = "请输入群组的有效类型，然后重试";
var WRONG_PASSWORD$4 = "请输入正确的密码并重试";
var INVALID_POLL_QUESTION$4 = "在创建投票之前，请输入必填的问题";
var INVALID_POLL_OPTION$4 = "在创建投票之前，请输入所需的答案";
var SAME_LANGUAGE_MESSAGE$4 = "选择的翻译语言与原始消息的语言类似";
var LEAVE$4 = "离开";
var CLICK_TO_START_CONVERSATION$4 = "点击开始对话";
var CUSTOM_MESSAGE_LOCATION$4 = "📍 位置";
var SHARED_LOCATION$4 = "共享位置";
var IN_A_THREAD$4 = "在一个话题中";
var CALLS$4 = "通话";
var CALL_DETAILS$4 = "通话详情";
var OFFLINE$4 = "离线";
var POLLS$4 = "民意调查";
var YOU$4 = "你";
var PRIVACY$4 = "隐私";
var BLOCKED_USERS$4 = "被封锁的用户";
var NO_PHOTOS$4 = "没有照片";
var NO_VIDEOS$4 = "没有视频";
var NO_DOCUMENTS$4 = "没有文件";
var JOIN$4 = "加入";
var REMOVE$4 = "移除";
var BLOCK$4 = "阻止";
var CHANGE_ROLE$4 = "变更角色";
var NEW_CHAT$4 = "新聊天";
var FORM_COMPLETION_MESSAGE$4 = "感谢您填写表格。";
var HISTORY$4 = "历史";
var CANCELLED_AUDIO_CALL$4 = "取消了语音通话";
var CANCELLED_VIDEO_CALL$4 = "视频通话已取消";
var REJECTED_AUDIO_CALL$4 = "音频通话被拒绝";
var REJECTED_VIDEO_CALL$4 = "视频通话被拒绝";
var CANCELLED_CALL$4 = "已取消通话";
var UNANSWERED_CALL$4 = "未接电话";
var RECORDING$4 = "录音";
var PARTICIPANTS$4 = "参与者";
var CALL_HISTORY$4 = "通话记录";
var NO_CALLS_FOUND$4 = "未找到来电";
var ONGOING_AUDIO_CALL$4 = "正在进行的音频通话";
var ONGOING_VIDEO_CALL$4 = "正在进行的视频通话";
var CALL_DETAIL$4 = "通话详情";
var FORM$4 = "表格";
var CARD$4 = "卡片";
var GENERATING_SUMMARY$4 = "生成摘要";
var CONVERSATION_SUMMARY$4 = "对话摘要";
var GENERATE_SUMMARY$4 = "生成摘要";
var COMETCHAT_BOT_FIRST_MESSAGE$4 = "我怎样才能帮助你完成这次对话？请问我一个问题，我会给你建议 🙂";
var COMETCHAT_ASK_BOT$4 = "问";
var COMETCHAT_ASK_AI_BOT$4 = "向 AI 机器人提问";
var COMETCHAT_ASK_BOT_SUBTITLE$4 = "AI Bot";
var MENTIONS_LIMIT_WARNING_MESSAGE$4 = "您一次最多可以提及 10 次。";
var ALL$4 = "全部";
var CLICK_TO_REMOVE$4 = "点击移除";
var OTHERS$4 = "其他的";
var AND$4 = "一个";
var translationZH = {
	INFO: INFO$4,
	REACT: REACT$4,
	EDIT: EDIT$4,
	MESSAGE_PRIVATELY: MESSAGE_PRIVATELY$4,
	TRANSLATE: TRANSLATE$4,
	USERS: USERS$4,
	CHATS: CHATS$4,
	WOULD__YOU_LIKE_TO_DELETE_THIS_CONVERSATION: WOULD__YOU_LIKE_TO_DELETE_THIS_CONVERSATION$4,
	GROUPS: GROUPS$4,
	SHARED: SHARED$4,
	SOUND_MANAGER: SOUND_MANAGER$4,
	THEME: THEME$4,
	LOCALIZE: LOCALIZE$4,
	CONVERSATION_LIST_ITEM: CONVERSATION_LIST_ITEM$4,
	DATA_ITEM: DATA_ITEM$4,
	STATUS_INDICATOR: STATUS_INDICATOR$4,
	BADGE_COUNT: BADGE_COUNT$4,
	MESSAGE_RECEIPT: MESSAGE_RECEIPT$4,
	MESSAGE: MESSAGE$4,
	RECEIPT_INFORMATION: RECEIPT_INFORMATION$4,
	NO_RECIPIENT: NO_RECIPIENT$4,
	NO_RECIPIENTS: NO_RECIPIENTS$4,
	CONVERSATIONS_WITH_MESSAGES: CONVERSATIONS_WITH_MESSAGES$4,
	CONVERSATIONS: CONVERSATIONS$4,
	CONVERSATION_LIST: CONVERSATION_LIST$4,
	MESSAGES: MESSAGES$4,
	MESSAGE_HEADER: MESSAGE_HEADER$4,
	MESSAGE_LIST: MESSAGE_LIST$4,
	MESSAGE_COMPOSER: MESSAGE_COMPOSER$4,
	USERS_WITH_MESSAGES: USERS_WITH_MESSAGES$4,
	USER_LIST: USER_LIST$4,
	GROUP_LIST: GROUP_LIST$4,
	GROUPS_WITH_MESSAGES: GROUPS_WITH_MESSAGES$4,
	NEW__GROUP: NEW__GROUP$4,
	PASSWORD: PASSWORD$4,
	CONTINUE: CONTINUE$4,
	NO_CHATS_SELECTED: NO_CHATS_SELECTED$4,
	NO_USERS_SELECTED: NO_USERS_SELECTED$4,
	NO_GROUPS_SELECTED: NO_GROUPS_SELECTED$4,
	SELECT_DAY: SELECT_DAY$4,
	SELECT_TIME: SELECT_TIME$4,
	NO_CALLS_SELECTED: NO_CALLS_SELECTED$4,
	SELECT__GROUP: SELECT__GROUP$4,
	SELECT__USER: SELECT__USER$4,
	GROUP_PASSWORD_BLANK: GROUP_PASSWORD_BLANK$4,
	GROUP_NAME_BLANK: GROUP_NAME_BLANK$4,
	GROUP_TYPE_BLANK: GROUP_TYPE_BLANK$4,
	DELETE_CONVERSATION: DELETE_CONVERSATION$4,
	ADD_TO_CHAT: ADD_TO_CHAT$4,
	MORE: MORE$4,
	COPY: COPY$4,
	VOICE_RECORDING: VOICE_RECORDING$4,
	MESSAGE_IMAGE: MESSAGE_IMAGE$4,
	MESSAGE_FILE: MESSAGE_FILE$4,
	MESSAGE_VIDEO: MESSAGE_VIDEO$4,
	MESSAGE_AUDIO: MESSAGE_AUDIO$4,
	CUSTOM_MESSAGE: CUSTOM_MESSAGE$4,
	SELECT_A_DATE: SELECT_A_DATE$4,
	TIME_ZONE: TIME_ZONE$4,
	MEETING_SCHEDULED: MEETING_SCHEDULED$4,
	SOMETHING_WRONG: SOMETHING_WRONG$4,
	MEETING_SLOT_BOOK: MEETING_SLOT_BOOK$4,
	MEETING_BOOK_NEW_SLOT: MEETING_BOOK_NEW_SLOT$4,
	MEETING_NO_SLOTS_AVAILABLE: MEETING_NO_SLOTS_AVAILABLE$4,
	MEETING_TRY_DIFFERENT_DATE: MEETING_TRY_DIFFERENT_DATE$4,
	NO_TIME_SLOTS_AVAILABLE: NO_TIME_SLOTS_AVAILABLE$4,
	SCHEDULE: SCHEDULE$4,
	MORE_TIMES: MORE_TIMES$4,
	MISSED_VOICE_CALL: MISSED_VOICE_CALL$4,
	MEET_WITH: MEET_WITH$4,
	MEETING_SCHEDULER: MEETING_SCHEDULER$4,
	MISSED_VIDEO_CALL: MISSED_VIDEO_CALL$4,
	CUSTOM_MESSAGE_POLL: CUSTOM_MESSAGE_POLL$4,
	CUSTOM_MESSAGE_STICKER: CUSTOM_MESSAGE_STICKER$4,
	CUSTOM_MESSAGE_DOCUMENT: CUSTOM_MESSAGE_DOCUMENT$4,
	CUSTOM_MESSAGE_WHITEBOARD: CUSTOM_MESSAGE_WHITEBOARD$4,
	ONLINE: ONLINE$4,
	ADMINISTRATOR: ADMINISTRATOR$4,
	ADMIN: ADMIN$4,
	MODERATOR: MODERATOR$4,
	PARTICIPANT: PARTICIPANT$4,
	PUBLIC: PUBLIC$4,
	PRIVATE: PRIVATE$4,
	PASSWORD_PROTECTED: PASSWORD_PROTECTED$4,
	PRIVACY_AND_SECURITY: PRIVACY_AND_SECURITY$4,
	PREFERENCES: PREFERENCES$4,
	MEMBERS: MEMBERS$4,
	MEMBER: MEMBER$4,
	TODAY: TODAY$4,
	YESTERDAY: YESTERDAY$4,
	SUNDAY: SUNDAY$4,
	MONDAY: MONDAY$4,
	TUESDAY: TUESDAY$4,
	WEDNESDAY: WEDNESDAY$4,
	THURSDAY: THURSDAY$4,
	FRIDAY: FRIDAY$4,
	SATURDAY: SATURDAY$4,
	TYPING: TYPING$4,
	IS_TYPING: IS_TYPING$4,
	CLOSE: CLOSE$4,
	ENTER_GROUP_NAME: ENTER_GROUP_NAME$4,
	ADD_MEMBERS: ADD_MEMBERS$4,
	SEND_MESSAGE: SEND_MESSAGE$4,
	UNBLOCK_USER: UNBLOCK_USER$4,
	BLOCK_USER: BLOCK_USER$4,
	DELETE_AND_EXIT: DELETE_AND_EXIT$4,
	LEAVE_GROUP: LEAVE_GROUP$4,
	CREATE_GROUP: CREATE_GROUP$4,
	SHARED_MEDIA: SHARED_MEDIA$4,
	SHARED_FILE: SHARED_FILE$4,
	VIDEO_CALL: VIDEO_CALL$4,
	AUDIO_CALL: AUDIO_CALL$4,
	LOADING: LOADING$4,
	REPLY: REPLY$4,
	REPLIES: REPLIES$4,
	AI: AI$4,
	SMART_REPLIES: SMART_REPLIES$4,
	CONVERSATION_STARTER: CONVERSATION_STARTER$4,
	LAUNCH: LAUNCH$4,
	SHARED_COLLABORATIVE_DOCUMENT: SHARED_COLLABORATIVE_DOCUMENT$4,
	SHARED_COLLABORATIVE_WHITEBOARD: SHARED_COLLABORATIVE_WHITEBOARD$4,
	CREATED_WHITEBOARD: CREATED_WHITEBOARD$4,
	CREATED_DOCUMENT: CREATED_DOCUMENT$4,
	PHOTOS: PHOTOS$4,
	VIDEOS: VIDEOS$4,
	DOCUMENT: DOCUMENT$4,
	YOU_DELETED_THIS_MESSAGE: YOU_DELETED_THIS_MESSAGE$4,
	THIS_MESSAGE_DELETED: THIS_MESSAGE_DELETED$4,
	MESSAGE_IS_DELETED: MESSAGE_IS_DELETED$4,
	VIEW_ON_YOUTUBE: VIEW_ON_YOUTUBE$4,
	SEARCH: SEARCH$4,
	NO_USERS_FOUND: NO_USERS_FOUND$4,
	ERROR: ERROR$4,
	NO_GROUPS_FOUND: NO_GROUPS_FOUND$4,
	NO_CHATS_FOUND: NO_CHATS_FOUND$4,
	CANT__LOAD__CHATS: CANT__LOAD__CHATS$4,
	MEDIA_MESSAGE: MEDIA_MESSAGE$4,
	INCOMING_AUDIO_CALL: INCOMING_AUDIO_CALL$4,
	INCOMING_VIDEO_CALL: INCOMING_VIDEO_CALL$4,
	DECLINE: DECLINE$4,
	ACCEPT: ACCEPT$4,
	CALL_INITIATED: CALL_INITIATED$4,
	OUTGOING_AUDIO_CALL: OUTGOING_AUDIO_CALL$4,
	OUTGOING_VIDEO_CALL: OUTGOING_VIDEO_CALL$4,
	CALL_REJECTED: CALL_REJECTED$4,
	REJECTED_CALL: REJECTED_CALL$4,
	CALL_ACCEPTED: CALL_ACCEPTED$4,
	OUTGOING_CALL: OUTGOING_CALL$4,
	INCOMING_CALL: INCOMING_CALL$4,
	MISSED_CALL: MISSED_CALL$4,
	JOINED: JOINED$4,
	LEFT_THE_CALL: LEFT_THE_CALL$4,
	UNANSWERED_AUDIO_CALL: UNANSWERED_AUDIO_CALL$4,
	UNANSWERED_VIDEO_CALL: UNANSWERED_VIDEO_CALL$4,
	CALL_ENDED: CALL_ENDED$4,
	CALL_CANCELLED: CALL_CANCELLED$4,
	CALL_BUSY: CALL_BUSY$4,
	CALLING: CALLING$4,
	ADD: ADD$4,
	NO_BANNED_MEMBERS_FOUND: NO_BANNED_MEMBERS_FOUND$4,
	BANNED_MEMBERS: BANNED_MEMBERS$4,
	NAME: NAME$4,
	SCOPE: SCOPE$4,
	UNBAN: UNBAN$4,
	SELECT_GROUP_TYPE: SELECT_GROUP_TYPE$4,
	ENTER_GROUP_PASSWORD: ENTER_GROUP_PASSWORD$4,
	CREATE: CREATE$4,
	CREATE_POLL: CREATE_POLL$4,
	QUESTION: QUESTION$4,
	ENTER_YOUR_QUESTION: ENTER_YOUR_QUESTION$4,
	OPTIONS: OPTIONS$4,
	ENTER_YOUR_OPTION: ENTER_YOUR_OPTION$4,
	ADD_NEW_OPTION: ADD_NEW_OPTION$4,
	VIEW_MEMBERS: VIEW_MEMBERS$4,
	DETAILS: DETAILS$4,
	NOTIFICATIONS: NOTIFICATIONS$4,
	OTHER: OTHER$4,
	HELP: HELP$4,
	REPORT_PROBLEM: REPORT_PROBLEM$4,
	GROUP_MEMBERS: GROUP_MEMBERS$4,
	BAN: BAN$4,
	KICK: KICK$4,
	PICK_YOUR_EMOJI: PICK_YOUR_EMOJI$4,
	PRIVATE_GROUP: PRIVATE_GROUP$4,
	PROTECTED_GROUP: PROTECTED_GROUP$4,
	VISIT: VISIT$4,
	ATTACH: ATTACH$4,
	OPEN_WHITEBOARD: OPEN_WHITEBOARD$4,
	ATTACH_FILE: ATTACH_FILE$4,
	GENERATING_REPLIES: GENERATING_REPLIES$4,
	ATTACH_VIDEO: ATTACH_VIDEO$4,
	ATTACH_AUDIO: ATTACH_AUDIO$4,
	ATTACH_IMAGE: ATTACH_IMAGE$4,
	COLLABORATE_USING_DOCUMENT: COLLABORATE_USING_DOCUMENT$4,
	COLLABORATE_USING_WHITEBOARD: COLLABORATE_USING_WHITEBOARD$4,
	SUGGEST_A_REPLY: SUGGEST_A_REPLY$4,
	GENERATING_ICEBREAKERS: GENERATING_ICEBREAKERS$4,
	EMOJI: EMOJI$4,
	NO_REPLIES_FOUND: NO_REPLIES_FOUND$4,
	ENTER_YOUR_MESSAGE_HERE: ENTER_YOUR_MESSAGE_HERE$4,
	NO_MESSAGES_FOUND: NO_MESSAGES_FOUND$4,
	THREAD: THREAD$4,
	COLLABORATIVE_DOCUMENT: COLLABORATIVE_DOCUMENT$4,
	COLLABORATIVE_WHITEBOARD: COLLABORATIVE_WHITEBOARD$4,
	ADD_REACTION: ADD_REACTION$4,
	NO_STICKERS_FOUND: NO_STICKERS_FOUND$4,
	REPLY_TO_THREAD: REPLY_TO_THREAD$4,
	REPLY_IN_THREAD: REPLY_IN_THREAD$4,
	VIEW: VIEW$4,
	DELETE_MESSAGE: DELETE_MESSAGE$4,
	EDIT_MESSAGE: EDIT_MESSAGE$4,
	OWNER: OWNER$4,
	CHANGE_SCOPE: CHANGE_SCOPE$4,
	STICKER: STICKER$4,
	LAST_ACTIVE_AT: LAST_ACTIVE_AT$4,
	VOICE_CALL: VOICE_CALL$4,
	VIEW_DETAIL: VIEW_DETAIL$4,
	VOTES: VOTES$4,
	VOTE: VOTE$4,
	NO_VOTE: NO_VOTE$4,
	REACTED: REACTED$4,
	ADDED: ADDED$4,
	SHOW_UNSAFE_CONTENT: SHOW_UNSAFE_CONTENT$4,
	REACT_TO_MESSAGE: REACT_TO_MESSAGE$4,
	UNBANNED: UNBANNED$4,
	MADE: MADE$4,
	CALL_UNANSWERED: CALL_UNANSWERED$4,
	MISSED_AUDIO_CALL: MISSED_AUDIO_CALL$4,
	ENTER_YOUR_PASSWORD: ENTER_YOUR_PASSWORD$4,
	DRAW_DOCUMENT_TOGETHER: DRAW_DOCUMENT_TOGETHER$4,
	DOCS: DOCS$4,
	NO_RECORDS_FOUND: NO_RECORDS_FOUND$4,
	LIVE_REACTION: LIVE_REACTION$4,
	SMILEY_PEOPLE: SMILEY_PEOPLE$4,
	DRAW_WHITEBOARD_TOGETHER: DRAW_WHITEBOARD_TOGETHER$4,
	ANIMALES_NATURE: ANIMALES_NATURE$4,
	FOOD_DRINK: FOOD_DRINK$4,
	OPEN_DOCUMENT: OPEN_DOCUMENT$4,
	ACTIVITY: ACTIVITY$4,
	TRAVEL_PLACES: TRAVEL_PLACES$4,
	OBJECTS: OBJECTS$4,
	SYMBOLS: SYMBOLS$4,
	FLAGS: FLAGS$4,
	SENT: SENT$4,
	SEEN: SEEN$4,
	DELIVERED: DELIVERED$4,
	READ: READ$4,
	MESSAGE_INFORMATION: MESSAGE_INFORMATION$4,
	TRANSLATE_MESSAGE: TRANSLATE_MESSAGE$4,
	TRANSLATED_MESSAGE: TRANSLATED_MESSAGE$4,
	LEFT: LEFT$4,
	KICKED: KICKED$4,
	BANNED: BANNED$4,
	NEW_MESSAGES: NEW_MESSAGES$4,
	NEW_MESSAGE: NEW_MESSAGE$4,
	JUMP: JUMP$4,
	SELECT_VIDEO_SOURCE: SELECT_VIDEO_SOURCE$4,
	SELECT_INPUT_AUDIO_SOURCE: SELECT_INPUT_AUDIO_SOURCE$4,
	SELECT_OUTPUT_AUDIO_SOURCE: SELECT_OUTPUT_AUDIO_SOURCE$4,
	INITIATED_GROUP_CALL: INITIATED_GROUP_CALL$4,
	YOU_INITIATED_GROUP_CALL: YOU_INITIATED_GROUP_CALL$4,
	IGNORE: IGNORE$4,
	ON_ANOTHER_CALL: ON_ANOTHER_CALL$4,
	CREATING: CREATING$4,
	AVATAR: AVATAR$4,
	ONGOING_CALL: ONGOING_CALL$4,
	YOU_ALREADY_ONGOING_CALL: YOU_ALREADY_ONGOING_CALL$4,
	RESIZE: RESIZE$4,
	SETTINGS: SETTINGS$4,
	ACTIONS: ACTIONS$4,
	VIEW_PROFILE: VIEW_PROFILE$4,
	SEND_MESSAGE_IN_PRIVATE: SEND_MESSAGE_IN_PRIVATE$4,
	DELETE: DELETE$4,
	DELETE_CONFIRM: DELETE_CONFIRM$4,
	CANCEL: CANCEL$4,
	LEAVE_CONFIRM: LEAVE_CONFIRM$4,
	TRANSFER_CONFIRM: TRANSFER_CONFIRM$4,
	ADDING: ADDING$4,
	TRANSFER: TRANSFER$4,
	TRANSFER_OWNERSHIP: TRANSFER_OWNERSHIP$4,
	TRANSFERRING: TRANSFERRING$4,
	YES: YES$4,
	NO: NO$4,
	ANSWER: ANSWER$4,
	ADD_ANOTHER_ANSWER: ADD_ANOTHER_ANSWER$4,
	SET_THE_ANSWERS: SET_THE_ANSWERS$4,
	TRY_AGAIN: TRY_AGAIN$4,
	INVALID_GROUP_NAME: INVALID_GROUP_NAME$4,
	INVALID_PASSWORD: INVALID_PASSWORD$4,
	INVALID_GROUP_TYPE: INVALID_GROUP_TYPE$4,
	WRONG_PASSWORD: WRONG_PASSWORD$4,
	INVALID_POLL_QUESTION: INVALID_POLL_QUESTION$4,
	INVALID_POLL_OPTION: INVALID_POLL_OPTION$4,
	SAME_LANGUAGE_MESSAGE: SAME_LANGUAGE_MESSAGE$4,
	LEAVE: LEAVE$4,
	CLICK_TO_START_CONVERSATION: CLICK_TO_START_CONVERSATION$4,
	CUSTOM_MESSAGE_LOCATION: CUSTOM_MESSAGE_LOCATION$4,
	SHARED_LOCATION: SHARED_LOCATION$4,
	IN_A_THREAD: IN_A_THREAD$4,
	CALLS: CALLS$4,
	CALL_DETAILS: CALL_DETAILS$4,
	OFFLINE: OFFLINE$4,
	POLLS: POLLS$4,
	YOU: YOU$4,
	PRIVACY: PRIVACY$4,
	BLOCKED_USERS: BLOCKED_USERS$4,
	"YOU'VE_BLOCKED": "你已经封锁了",
	NO_PHOTOS: NO_PHOTOS$4,
	NO_VIDEOS: NO_VIDEOS$4,
	NO_DOCUMENTS: NO_DOCUMENTS$4,
	JOIN: JOIN$4,
	REMOVE: REMOVE$4,
	BLOCK: BLOCK$4,
	CHANGE_ROLE: CHANGE_ROLE$4,
	NEW_CHAT: NEW_CHAT$4,
	FORM_COMPLETION_MESSAGE: FORM_COMPLETION_MESSAGE$4,
	HISTORY: HISTORY$4,
	CANCELLED_AUDIO_CALL: CANCELLED_AUDIO_CALL$4,
	CANCELLED_VIDEO_CALL: CANCELLED_VIDEO_CALL$4,
	REJECTED_AUDIO_CALL: REJECTED_AUDIO_CALL$4,
	REJECTED_VIDEO_CALL: REJECTED_VIDEO_CALL$4,
	CANCELLED_CALL: CANCELLED_CALL$4,
	UNANSWERED_CALL: UNANSWERED_CALL$4,
	RECORDING: RECORDING$4,
	PARTICIPANTS: PARTICIPANTS$4,
	CALL_HISTORY: CALL_HISTORY$4,
	NO_CALLS_FOUND: NO_CALLS_FOUND$4,
	ONGOING_AUDIO_CALL: ONGOING_AUDIO_CALL$4,
	ONGOING_VIDEO_CALL: ONGOING_VIDEO_CALL$4,
	CALL_DETAIL: CALL_DETAIL$4,
	FORM: FORM$4,
	CARD: CARD$4,
	GENERATING_SUMMARY: GENERATING_SUMMARY$4,
	CONVERSATION_SUMMARY: CONVERSATION_SUMMARY$4,
	GENERATE_SUMMARY: GENERATE_SUMMARY$4,
	COMETCHAT_BOT_FIRST_MESSAGE: COMETCHAT_BOT_FIRST_MESSAGE$4,
	COMETCHAT_ASK_BOT: COMETCHAT_ASK_BOT$4,
	COMETCHAT_ASK_AI_BOT: COMETCHAT_ASK_AI_BOT$4,
	COMETCHAT_ASK_BOT_SUBTITLE: COMETCHAT_ASK_BOT_SUBTITLE$4,
	MENTIONS_LIMIT_WARNING_MESSAGE: MENTIONS_LIMIT_WARNING_MESSAGE$4,
	ALL: ALL$4,
	CLICK_TO_REMOVE: CLICK_TO_REMOVE$4,
	OTHERS: OTHERS$4,
	AND: AND$4
};

var INFO$3 = "資訊";
var REACT$3 = "反應";
var EDIT$3 = "編輯";
var MESSAGE_PRIVATELY$3 = "私下留言";
var TRANSLATE$3 = "翻譯";
var USERS$3 = "使用者";
var CHATS$3 = "聊天";
var WOULD__YOU_LIKE_TO_DELETE_THIS_CONVERSATION$3 = "您想刪除此對話嗎？此對話將從您的所有設備中刪除。";
var GROUPS$3 = "群組";
var SHARED$3 = "共用";
var SOUND_MANAGER$3 = "聲音管理員";
var THEME$3 = "主題";
var LOCALIZE$3 = "本地化";
var CONVERSATION_LIST_ITEM$3 = "對話清單項目";
var DATA_ITEM$3 = "資料項目";
var STATUS_INDICATOR$3 = "狀態指示器";
var BADGE_COUNT$3 = "徽章數";
var MESSAGE_RECEIPT$3 = "訊息收據";
var MESSAGE$3 = "留言";
var RECEIPT_INFORMATION$3 = "收據信息";
var NO_RECIPIENT$3 = "沒有收件人";
var NO_RECIPIENTS$3 = "沒有收件人";
var CONVERSATIONS_WITH_MESSAGES$3 = "使用訊息的對話";
var CONVERSATIONS$3 = "對話";
var CONVERSATION_LIST$3 = "對話清單";
var MESSAGES$3 = "訊息";
var MESSAGE_HEADER$3 = "郵件標題";
var MESSAGE_LIST$3 = "訊息清單";
var MESSAGE_COMPOSER$3 = "訊息撰寫器";
var USERS_WITH_MESSAGES$3 = "具有訊息的使用者";
var USER_LIST$3 = "使用者清單";
var GROUP_LIST$3 = "群組列表";
var GROUPS_WITH_MESSAGES$3 = "帶有訊息的群組";
var NEW__GROUP$3 = "新集團";
var PASSWORD$3 = "密碼";
var CONTINUE$3 = "繼續";
var NO_CHATS_SELECTED$3 = "未選取任何對話";
var NO_USERS_SELECTED$3 = "未選取使用者";
var NO_GROUPS_SELECTED$3 = "未選取群組";
var SELECT_DAY$3 = "選擇一天";
var SELECT_TIME$3 = "選擇時間";
var NO_CALLS_SELECTED$3 = "未選取通話";
var SELECT__GROUP$3 = "選取群組以開始傳送訊息";
var SELECT__USER$3 = "選取用戶以開始傳送訊息";
var GROUP_PASSWORD_BLANK$3 = "群組密碼不能為空白";
var GROUP_NAME_BLANK$3 = "群組名稱不能為空白";
var GROUP_TYPE_BLANK$3 = "群組類型不能為空白";
var DELETE_CONVERSATION$3 = "刪除對話？";
var ADD_TO_CHAT$3 = "加入聊天";
var MORE$3 = "更多";
var COPY$3 = "複製";
var VOICE_RECORDING$3 = "語音錄音";
var MESSAGE_IMAGE$3 = "📷 圖像";
var MESSAGE_FILE$3 = "📁 文件";
var MESSAGE_VIDEO$3 = "📹 視頻";
var MESSAGE_AUDIO$3 = "🎵 音頻";
var CUSTOM_MESSAGE$3 = "你有一條消息";
var SELECT_A_DATE$3 = "選擇日期";
var TIME_ZONE$3 = "時區";
var MEETING_SCHEDULED$3 = "您的會議已安排。";
var SOMETHING_WRONG$3 = "出了什麼問題請再試一次。";
var MEETING_SLOT_BOOK$3 = "時段不再可用。請選擇其他。";
var MEETING_BOOK_NEW_SLOT$3 = "預訂新老虎機";
var MEETING_NO_SLOTS_AVAILABLE$3 = "此日期沒有可用的時段。請嘗試另一個日期。";
var MEETING_TRY_DIFFERENT_DATE$3 = "請嘗試不同的日期。";
var NO_TIME_SLOTS_AVAILABLE$3 = "沒有可用的時間段";
var SCHEDULE$3 = "時間表";
var MORE_TIMES$3 = "更多次數";
var MISSED_VOICE_CALL$3 = "未接的語音通話";
var MEET_WITH$3 = "會面";
var MEETING_SCHEDULER$3 = "會議排程器";
var MISSED_VIDEO_CALL$3 = "未接視訊通話";
var CUSTOM_MESSAGE_POLL$3 = "📊 投票";
var CUSTOM_MESSAGE_STICKER$3 = "💟 貼紙";
var CUSTOM_MESSAGE_DOCUMENT$3 = "📃 文件";
var CUSTOM_MESSAGE_WHITEBOARD$3 = "📝 白板";
var ONLINE$3 = "在線";
var ADMINISTRATOR$3 = "管理員";
var ADMIN$3 = "管理員";
var MODERATOR$3 = "主持人";
var PARTICIPANT$3 = "參與者";
var PUBLIC$3 = "公眾";
var PRIVATE$3 = "私人";
var PASSWORD_PROTECTED$3 = "密碼保護";
var PRIVACY_AND_SECURITY$3 = "隱私與安全";
var PREFERENCES$3 = "偏好設定";
var MEMBERS$3 = "會員";
var MEMBER$3 = "會員";
var TODAY$3 = "今天";
var YESTERDAY$3 = "昨天";
var SUNDAY$3 = "星期日";
var MONDAY$3 = "星期一";
var TUESDAY$3 = "星期二";
var WEDNESDAY$3 = "星期三";
var THURSDAY$3 = "星期四";
var FRIDAY$3 = "星期五";
var SATURDAY$3 = "星期六";
var TYPING$3 = "輸入...";
var IS_TYPING$3 = "正在打字...";
var CLOSE$3 = "關閉";
var ENTER_GROUP_NAME$3 = "輸入群組名稱";
var ADD_MEMBERS$3 = "新增成員";
var SEND_MESSAGE$3 = "發送訊息";
var UNBLOCK_USER$3 = "解除封鎖使用者";
var BLOCK_USER$3 = "封鎖使用者";
var DELETE_AND_EXIT$3 = "刪除並結束";
var LEAVE_GROUP$3 = "離開組";
var CREATE_GROUP$3 = "建立群組";
var SHARED_MEDIA$3 = "共享媒體";
var SHARED_FILE$3 = "共用檔案";
var VIDEO_CALL$3 = "視訊通話";
var AUDIO_CALL$3 = "音訊通話";
var LOADING$3 = "正在載入...";
var REPLY$3 = "回复";
var REPLIES$3 = "回覆";
var AI$3 = "艾";
var SMART_REPLIES$3 = "智能回覆";
var CONVERSATION_STARTER$3 = "對話開始器";
var LAUNCH$3 = "啟動";
var SHARED_COLLABORATIVE_DOCUMENT$3 = "已共用協作文件";
var SHARED_COLLABORATIVE_WHITEBOARD$3 = "共享了一個協作白板";
var CREATED_WHITEBOARD$3 = "您已建立新的協作白板";
var CREATED_DOCUMENT$3 = "您已建立新的協作文件";
var PHOTOS$3 = "照片";
var VIDEOS$3 = "影片";
var DOCUMENT$3 = "文件";
var YOU_DELETED_THIS_MESSAGE$3 = "⚠️ 您刪除了此消息";
var THIS_MESSAGE_DELETED$3 = "⚠️ 此消息已刪除";
var MESSAGE_IS_DELETED$3 = "郵件已刪除";
var VIEW_ON_YOUTUBE$3 = "在 YouTube 上查看";
var SEARCH$3 = "搜索";
var NO_USERS_FOUND$3 = "找不到使用者";
var ERROR$3 = "錯誤";
var NO_GROUPS_FOUND$3 = "找不到群組";
var NO_CHATS_FOUND$3 = "找不到聊天";
var CANT__LOAD__CHATS$3 = "無法載入聊天";
var MEDIA_MESSAGE$3 = "媒體訊息";
var INCOMING_AUDIO_CALL$3 = "傳入音訊通話";
var INCOMING_VIDEO_CALL$3 = "傳入視訊通話";
var DECLINE$3 = "下降";
var ACCEPT$3 = "接受";
var CALL_INITIATED$3 = "通話已啟動";
var OUTGOING_AUDIO_CALL$3 = "外出音訊通話";
var OUTGOING_VIDEO_CALL$3 = "外出視訊通話";
var CALL_REJECTED$3 = "通話拒絕";
var REJECTED_CALL$3 = "拒絕的呼叫";
var CALL_ACCEPTED$3 = "接受電話";
var OUTGOING_CALL$3 = "外撥通話";
var INCOMING_CALL$3 = "來電";
var MISSED_CALL$3 = "未接來電";
var JOINED$3 = "加入";
var LEFT_THE_CALL$3 = "離開通話";
var UNANSWERED_AUDIO_CALL$3 = "未接聽的音訊通話";
var UNANSWERED_VIDEO_CALL$3 = "未接聽的視頻通話";
var CALL_ENDED$3 = "通話結束";
var CALL_CANCELLED$3 = "電話已取消";
var CALL_BUSY$3 = "打電話忙碌";
var CALLING$3 = "打電話...";
var ADD$3 = "新增";
var NO_BANNED_MEMBERS_FOUND$3 = "找不到被禁用的會員";
var BANNED_MEMBERS$3 = "被禁用的會員";
var NAME$3 = "姓名";
var SCOPE$3 = "範圍";
var UNBAN$3 = "取消禁";
var SELECT_GROUP_TYPE$3 = "選擇群組類型";
var ENTER_GROUP_PASSWORD$3 = "輸入群組密碼";
var CREATE$3 = "建立";
var CREATE_POLL$3 = "建立投票";
var QUESTION$3 = "問題";
var ENTER_YOUR_QUESTION$3 = "輸入您的問題";
var OPTIONS$3 = "選項";
var ENTER_YOUR_OPTION$3 = "輸入您的選項";
var ADD_NEW_OPTION$3 = "新增選項";
var VIEW_MEMBERS$3 = "查看成員";
var DETAILS$3 = "詳情";
var NOTIFICATIONS$3 = "通知";
var OTHER$3 = "其他";
var HELP$3 = "幫助";
var REPORT_PROBLEM$3 = "報告問題";
var GROUP_MEMBERS$3 = "群組成員";
var BAN$3 = "禁令";
var KICK$3 = "踢";
var PICK_YOUR_EMOJI$3 = "選擇您的表情符號";
var PRIVATE_GROUP$3 = "私人團體";
var PROTECTED_GROUP$3 = "受保護群組";
var VISIT$3 = "參觀";
var ATTACH$3 = "附加";
var OPEN_WHITEBOARD$3 = "打開白板";
var ATTACH_FILE$3 = "附加檔案";
var GENERATING_REPLIES$3 = "產生回覆";
var ATTACH_VIDEO$3 = "附加影片";
var ATTACH_AUDIO$3 = "附加音訊";
var ATTACH_IMAGE$3 = "附加影像";
var COLLABORATE_USING_DOCUMENT$3 = "使用文件進行協作";
var COLLABORATE_USING_WHITEBOARD$3 = "使用白板進行協作";
var SUGGEST_A_REPLY$3 = "提出回覆";
var GENERATING_ICEBREAKERS$3 = "產生破冰器";
var EMOJI$3 = "表情符號";
var NO_REPLIES_FOUND$3 = "找不到回覆";
var ENTER_YOUR_MESSAGE_HERE$3 = "在此輸入您的訊息";
var NO_MESSAGES_FOUND$3 = "找不到任何訊息";
var THREAD$3 = "線程";
var COLLABORATIVE_DOCUMENT$3 = "協作文件";
var COLLABORATIVE_WHITEBOARD$3 = "協作白板";
var ADD_REACTION$3 = "加入反應";
var NO_STICKERS_FOUND$3 = "找不到貼紙";
var REPLY_TO_THREAD$3 = "回覆主題";
var REPLY_IN_THREAD$3 = "在主題中回复";
var VIEW$3 = "查看";
var DELETE_MESSAGE$3 = "刪除訊息";
var EDIT_MESSAGE$3 = "編輯訊息";
var OWNER$3 = "業主";
var CHANGE_SCOPE$3 = "變更範圍";
var STICKER$3 = "貼紙";
var LAST_ACTIVE_AT$3 = "最後一次活動時間";
var VOICE_CALL$3 = "語音通話";
var VIEW_DETAIL$3 = "查看詳細資料";
var VOTES$3 = "票";
var VOTE$3 = "投票";
var NO_VOTE$3 = "沒有投票";
var REACTED$3 = "反應";
var ADDED$3 = "添加";
var SHOW_UNSAFE_CONTENT$3 = "您確定要查看不安全的內容嗎？";
var REACT_TO_MESSAGE$3 = "對訊息做出反應";
var UNBANNED$3 = "未禁止";
var MADE$3 = "製作";
var CALL_UNANSWERED$3 = "電話未接聽";
var MISSED_AUDIO_CALL$3 = "未接聽音訊通話";
var ENTER_YOUR_PASSWORD$3 = "輸入您的密碼";
var DRAW_DOCUMENT_TOGETHER$3 = "開啟文件以一起編輯內容";
var DOCS$3 = "文件";
var NO_RECORDS_FOUND$3 = "找不到任何記錄";
var LIVE_REACTION$3 = "實時反應";
var SMILEY_PEOPLE$3 = "笑臉和人物";
var DRAW_WHITEBOARD_TOGETHER$3 = "打開白板以一起繪製";
var ANIMALES_NATURE$3 = "動物與自然";
var FOOD_DRINK$3 = "食品和飲料";
var OPEN_DOCUMENT$3 = "開啟文件";
var ACTIVITY$3 = "活動";
var TRAVEL_PLACES$3 = "旅遊與地點";
var OBJECTS$3 = "物件";
var SYMBOLS$3 = "符號";
var FLAGS$3 = "旗幟";
var SENT$3 = "已發送";
var SEEN$3 = "已經看到";
var DELIVERED$3 = "已交付";
var READ$3 = "閱讀";
var MESSAGE_INFORMATION$3 = "訊息資訊";
var TRANSLATE_MESSAGE$3 = "翻譯訊息";
var TRANSLATED_MESSAGE$3 = "已翻譯的訊息";
var LEFT$3 = "剩下";
var KICKED$3 = "踢";
var BANNED$3 = "取締";
var NEW_MESSAGES$3 = "新消息";
var NEW_MESSAGE$3 = "新消息";
var JUMP$3 = "跳躍";
var SELECT_VIDEO_SOURCE$3 = "選擇視頻來源";
var SELECT_INPUT_AUDIO_SOURCE$3 = "選擇輸入音頻源";
var SELECT_OUTPUT_AUDIO_SOURCE$3 = "選擇輸出音頻源";
var INITIATED_GROUP_CALL$3 = "已啟動群組通話";
var YOU_INITIATED_GROUP_CALL$3 = "您已啟動群組通話";
var IGNORE$3 = "忽略";
var ON_ANOTHER_CALL$3 = "正在另一次通話";
var CREATING$3 = "建立";
var AVATAR$3 = "阿凡達";
var ONGOING_CALL$3 = "正在進行的電話";
var YOU_ALREADY_ONGOING_CALL$3 = "您已經在進行中的通話";
var RESIZE$3 = "調整大小";
var SETTINGS$3 = "設定";
var ACTIONS$3 = "行動";
var VIEW_PROFILE$3 = "查看個人資料";
var SEND_MESSAGE_IN_PRIVATE$3 = "私下傳送訊息";
var DELETE$3 = "刪除";
var DELETE_CONFIRM$3 = "您確定要刪除嗎？";
var CANCEL$3 = "取消";
var LEAVE_CONFIRM$3 = "你確定要離開團隊嗎？";
var TRANSFER_CONFIRM$3 = "您是群組擁有者，請在離開群組之前將所有權轉移給成員";
var ADDING$3 = "正在加入...";
var TRANSFER$3 = "轉移";
var TRANSFER_OWNERSHIP$3 = "轉讓所有權";
var TRANSFERRING$3 = "轉移";
var YES$3 = "是";
var NO$3 = "否";
var ANSWER$3 = "答案";
var ADD_ANOTHER_ANSWER$3 = "添加另一個答案";
var SET_THE_ANSWERS$3 = "設置答案";
var TRY_AGAIN$3 = "再試一次";
var INVALID_GROUP_NAME$3 = "請輸入群組的有效名稱，然後再試一次";
var INVALID_PASSWORD$3 = "請輸入群組的有效密碼，然後再試一次";
var INVALID_GROUP_TYPE$3 = "請輸入有效的群組類型，然後再試一次";
var WRONG_PASSWORD$3 = "請輸入正確的密碼，然後再試一次";
var INVALID_POLL_QUESTION$3 = "請在建立投票前輸入必要的問題";
var INVALID_POLL_OPTION$3 = "請在建立投票前輸入必要答案";
var SAME_LANGUAGE_MESSAGE$3 = "用於翻譯的選擇語言類似於原始消息的語言";
var LEAVE$3 = "離開";
var CLICK_TO_START_CONVERSATION$3 = "點擊開始對話";
var CUSTOM_MESSAGE_LOCATION$3 = "📍 位置";
var SHARED_LOCATION$3 = "共用位置";
var IN_A_THREAD$3 = "在一個線程中";
var CALLS$3 = "通話";
var CALL_DETAILS$3 = "通話詳情";
var OFFLINE$3 = "離線";
var POLLS$3 = "民意調查";
var YOU$3 = "你";
var PRIVACY$3 = "隱私";
var BLOCKED_USERS$3 = "封鎖的使用者";
var NO_PHOTOS$3 = "沒有照片";
var NO_VIDEOS$3 = "沒有影片";
var NO_DOCUMENTS$3 = "沒有文件";
var JOIN$3 = "加入";
var REMOVE$3 = "移除";
var BLOCK$3 = "區塊";
var CHANGE_ROLE$3 = "變更角色";
var NEW_CHAT$3 = "新聊天";
var FORM_COMPLETION_MESSAGE$3 = "感謝您填寫表格。";
var HISTORY$3 = "歷史";
var CANCELLED_AUDIO_CALL$3 = "已取消音訊通話";
var CANCELLED_VIDEO_CALL$3 = "已取消視頻通話";
var REJECTED_AUDIO_CALL$3 = "拒絕的音訊通話";
var REJECTED_VIDEO_CALL$3 = "拒絕的視訊通話";
var CANCELLED_CALL$3 = "已取消通話";
var UNANSWERED_CALL$3 = "未接聽的電話";
var RECORDING$3 = "錄音";
var PARTICIPANTS$3 = "參加者";
var CALL_HISTORY$3 = "通話記錄";
var NO_CALLS_FOUND$3 = "找不到電話";
var ONGOING_AUDIO_CALL$3 = "正在進行的音訊通話";
var ONGOING_VIDEO_CALL$3 = "正在進行的視頻通話";
var CALL_DETAIL$3 = "通話詳情";
var FORM$3 = "表格";
var CARD$3 = "卡";
var GENERATING_SUMMARY$3 = "產生摘要";
var CONVERSATION_SUMMARY$3 = "對話摘要";
var GENERATE_SUMMARY$3 = "產生摘要";
var COMETCHAT_BOT_FIRST_MESSAGE$3 = "我該如何幫助您進行這個對話？請問我一個問題，我會給你建議 🙂";
var COMETCHAT_ASK_BOT$3 = "詢問";
var COMETCHAT_ASK_AI_BOT$3 = "詢問 AI 機器人";
var COMETCHAT_ASK_BOT_SUBTITLE$3 = "人工智能機器人";
var MENTIONS_LIMIT_WARNING_MESSAGE$3 = "您一次最多可以提及 10 次。";
var ALL$3 = "全部";
var CLICK_TO_REMOVE$3 = "點擊移除";
var OTHERS$3 = "其他";
var AND$3 = "一個";
var translationZHTW = {
	INFO: INFO$3,
	REACT: REACT$3,
	EDIT: EDIT$3,
	MESSAGE_PRIVATELY: MESSAGE_PRIVATELY$3,
	TRANSLATE: TRANSLATE$3,
	USERS: USERS$3,
	CHATS: CHATS$3,
	WOULD__YOU_LIKE_TO_DELETE_THIS_CONVERSATION: WOULD__YOU_LIKE_TO_DELETE_THIS_CONVERSATION$3,
	GROUPS: GROUPS$3,
	SHARED: SHARED$3,
	SOUND_MANAGER: SOUND_MANAGER$3,
	THEME: THEME$3,
	LOCALIZE: LOCALIZE$3,
	CONVERSATION_LIST_ITEM: CONVERSATION_LIST_ITEM$3,
	DATA_ITEM: DATA_ITEM$3,
	STATUS_INDICATOR: STATUS_INDICATOR$3,
	BADGE_COUNT: BADGE_COUNT$3,
	MESSAGE_RECEIPT: MESSAGE_RECEIPT$3,
	MESSAGE: MESSAGE$3,
	RECEIPT_INFORMATION: RECEIPT_INFORMATION$3,
	NO_RECIPIENT: NO_RECIPIENT$3,
	NO_RECIPIENTS: NO_RECIPIENTS$3,
	CONVERSATIONS_WITH_MESSAGES: CONVERSATIONS_WITH_MESSAGES$3,
	CONVERSATIONS: CONVERSATIONS$3,
	CONVERSATION_LIST: CONVERSATION_LIST$3,
	MESSAGES: MESSAGES$3,
	MESSAGE_HEADER: MESSAGE_HEADER$3,
	MESSAGE_LIST: MESSAGE_LIST$3,
	MESSAGE_COMPOSER: MESSAGE_COMPOSER$3,
	USERS_WITH_MESSAGES: USERS_WITH_MESSAGES$3,
	USER_LIST: USER_LIST$3,
	GROUP_LIST: GROUP_LIST$3,
	GROUPS_WITH_MESSAGES: GROUPS_WITH_MESSAGES$3,
	NEW__GROUP: NEW__GROUP$3,
	PASSWORD: PASSWORD$3,
	CONTINUE: CONTINUE$3,
	NO_CHATS_SELECTED: NO_CHATS_SELECTED$3,
	NO_USERS_SELECTED: NO_USERS_SELECTED$3,
	NO_GROUPS_SELECTED: NO_GROUPS_SELECTED$3,
	SELECT_DAY: SELECT_DAY$3,
	SELECT_TIME: SELECT_TIME$3,
	NO_CALLS_SELECTED: NO_CALLS_SELECTED$3,
	SELECT__GROUP: SELECT__GROUP$3,
	SELECT__USER: SELECT__USER$3,
	GROUP_PASSWORD_BLANK: GROUP_PASSWORD_BLANK$3,
	GROUP_NAME_BLANK: GROUP_NAME_BLANK$3,
	GROUP_TYPE_BLANK: GROUP_TYPE_BLANK$3,
	DELETE_CONVERSATION: DELETE_CONVERSATION$3,
	ADD_TO_CHAT: ADD_TO_CHAT$3,
	MORE: MORE$3,
	COPY: COPY$3,
	VOICE_RECORDING: VOICE_RECORDING$3,
	MESSAGE_IMAGE: MESSAGE_IMAGE$3,
	MESSAGE_FILE: MESSAGE_FILE$3,
	MESSAGE_VIDEO: MESSAGE_VIDEO$3,
	MESSAGE_AUDIO: MESSAGE_AUDIO$3,
	CUSTOM_MESSAGE: CUSTOM_MESSAGE$3,
	SELECT_A_DATE: SELECT_A_DATE$3,
	TIME_ZONE: TIME_ZONE$3,
	MEETING_SCHEDULED: MEETING_SCHEDULED$3,
	SOMETHING_WRONG: SOMETHING_WRONG$3,
	MEETING_SLOT_BOOK: MEETING_SLOT_BOOK$3,
	MEETING_BOOK_NEW_SLOT: MEETING_BOOK_NEW_SLOT$3,
	MEETING_NO_SLOTS_AVAILABLE: MEETING_NO_SLOTS_AVAILABLE$3,
	MEETING_TRY_DIFFERENT_DATE: MEETING_TRY_DIFFERENT_DATE$3,
	NO_TIME_SLOTS_AVAILABLE: NO_TIME_SLOTS_AVAILABLE$3,
	SCHEDULE: SCHEDULE$3,
	MORE_TIMES: MORE_TIMES$3,
	MISSED_VOICE_CALL: MISSED_VOICE_CALL$3,
	MEET_WITH: MEET_WITH$3,
	MEETING_SCHEDULER: MEETING_SCHEDULER$3,
	MISSED_VIDEO_CALL: MISSED_VIDEO_CALL$3,
	CUSTOM_MESSAGE_POLL: CUSTOM_MESSAGE_POLL$3,
	CUSTOM_MESSAGE_STICKER: CUSTOM_MESSAGE_STICKER$3,
	CUSTOM_MESSAGE_DOCUMENT: CUSTOM_MESSAGE_DOCUMENT$3,
	CUSTOM_MESSAGE_WHITEBOARD: CUSTOM_MESSAGE_WHITEBOARD$3,
	ONLINE: ONLINE$3,
	ADMINISTRATOR: ADMINISTRATOR$3,
	ADMIN: ADMIN$3,
	MODERATOR: MODERATOR$3,
	PARTICIPANT: PARTICIPANT$3,
	PUBLIC: PUBLIC$3,
	PRIVATE: PRIVATE$3,
	PASSWORD_PROTECTED: PASSWORD_PROTECTED$3,
	PRIVACY_AND_SECURITY: PRIVACY_AND_SECURITY$3,
	PREFERENCES: PREFERENCES$3,
	MEMBERS: MEMBERS$3,
	MEMBER: MEMBER$3,
	TODAY: TODAY$3,
	YESTERDAY: YESTERDAY$3,
	SUNDAY: SUNDAY$3,
	MONDAY: MONDAY$3,
	TUESDAY: TUESDAY$3,
	WEDNESDAY: WEDNESDAY$3,
	THURSDAY: THURSDAY$3,
	FRIDAY: FRIDAY$3,
	SATURDAY: SATURDAY$3,
	TYPING: TYPING$3,
	IS_TYPING: IS_TYPING$3,
	CLOSE: CLOSE$3,
	ENTER_GROUP_NAME: ENTER_GROUP_NAME$3,
	ADD_MEMBERS: ADD_MEMBERS$3,
	SEND_MESSAGE: SEND_MESSAGE$3,
	UNBLOCK_USER: UNBLOCK_USER$3,
	BLOCK_USER: BLOCK_USER$3,
	DELETE_AND_EXIT: DELETE_AND_EXIT$3,
	LEAVE_GROUP: LEAVE_GROUP$3,
	CREATE_GROUP: CREATE_GROUP$3,
	SHARED_MEDIA: SHARED_MEDIA$3,
	SHARED_FILE: SHARED_FILE$3,
	VIDEO_CALL: VIDEO_CALL$3,
	AUDIO_CALL: AUDIO_CALL$3,
	LOADING: LOADING$3,
	REPLY: REPLY$3,
	REPLIES: REPLIES$3,
	AI: AI$3,
	SMART_REPLIES: SMART_REPLIES$3,
	CONVERSATION_STARTER: CONVERSATION_STARTER$3,
	LAUNCH: LAUNCH$3,
	SHARED_COLLABORATIVE_DOCUMENT: SHARED_COLLABORATIVE_DOCUMENT$3,
	SHARED_COLLABORATIVE_WHITEBOARD: SHARED_COLLABORATIVE_WHITEBOARD$3,
	CREATED_WHITEBOARD: CREATED_WHITEBOARD$3,
	CREATED_DOCUMENT: CREATED_DOCUMENT$3,
	PHOTOS: PHOTOS$3,
	VIDEOS: VIDEOS$3,
	DOCUMENT: DOCUMENT$3,
	YOU_DELETED_THIS_MESSAGE: YOU_DELETED_THIS_MESSAGE$3,
	THIS_MESSAGE_DELETED: THIS_MESSAGE_DELETED$3,
	MESSAGE_IS_DELETED: MESSAGE_IS_DELETED$3,
	VIEW_ON_YOUTUBE: VIEW_ON_YOUTUBE$3,
	SEARCH: SEARCH$3,
	NO_USERS_FOUND: NO_USERS_FOUND$3,
	ERROR: ERROR$3,
	NO_GROUPS_FOUND: NO_GROUPS_FOUND$3,
	NO_CHATS_FOUND: NO_CHATS_FOUND$3,
	CANT__LOAD__CHATS: CANT__LOAD__CHATS$3,
	MEDIA_MESSAGE: MEDIA_MESSAGE$3,
	INCOMING_AUDIO_CALL: INCOMING_AUDIO_CALL$3,
	INCOMING_VIDEO_CALL: INCOMING_VIDEO_CALL$3,
	DECLINE: DECLINE$3,
	ACCEPT: ACCEPT$3,
	CALL_INITIATED: CALL_INITIATED$3,
	OUTGOING_AUDIO_CALL: OUTGOING_AUDIO_CALL$3,
	OUTGOING_VIDEO_CALL: OUTGOING_VIDEO_CALL$3,
	CALL_REJECTED: CALL_REJECTED$3,
	REJECTED_CALL: REJECTED_CALL$3,
	CALL_ACCEPTED: CALL_ACCEPTED$3,
	OUTGOING_CALL: OUTGOING_CALL$3,
	INCOMING_CALL: INCOMING_CALL$3,
	MISSED_CALL: MISSED_CALL$3,
	JOINED: JOINED$3,
	LEFT_THE_CALL: LEFT_THE_CALL$3,
	UNANSWERED_AUDIO_CALL: UNANSWERED_AUDIO_CALL$3,
	UNANSWERED_VIDEO_CALL: UNANSWERED_VIDEO_CALL$3,
	CALL_ENDED: CALL_ENDED$3,
	CALL_CANCELLED: CALL_CANCELLED$3,
	CALL_BUSY: CALL_BUSY$3,
	CALLING: CALLING$3,
	ADD: ADD$3,
	NO_BANNED_MEMBERS_FOUND: NO_BANNED_MEMBERS_FOUND$3,
	BANNED_MEMBERS: BANNED_MEMBERS$3,
	NAME: NAME$3,
	SCOPE: SCOPE$3,
	UNBAN: UNBAN$3,
	SELECT_GROUP_TYPE: SELECT_GROUP_TYPE$3,
	ENTER_GROUP_PASSWORD: ENTER_GROUP_PASSWORD$3,
	CREATE: CREATE$3,
	CREATE_POLL: CREATE_POLL$3,
	QUESTION: QUESTION$3,
	ENTER_YOUR_QUESTION: ENTER_YOUR_QUESTION$3,
	OPTIONS: OPTIONS$3,
	ENTER_YOUR_OPTION: ENTER_YOUR_OPTION$3,
	ADD_NEW_OPTION: ADD_NEW_OPTION$3,
	VIEW_MEMBERS: VIEW_MEMBERS$3,
	DETAILS: DETAILS$3,
	NOTIFICATIONS: NOTIFICATIONS$3,
	OTHER: OTHER$3,
	HELP: HELP$3,
	REPORT_PROBLEM: REPORT_PROBLEM$3,
	GROUP_MEMBERS: GROUP_MEMBERS$3,
	BAN: BAN$3,
	KICK: KICK$3,
	PICK_YOUR_EMOJI: PICK_YOUR_EMOJI$3,
	PRIVATE_GROUP: PRIVATE_GROUP$3,
	PROTECTED_GROUP: PROTECTED_GROUP$3,
	VISIT: VISIT$3,
	ATTACH: ATTACH$3,
	OPEN_WHITEBOARD: OPEN_WHITEBOARD$3,
	ATTACH_FILE: ATTACH_FILE$3,
	GENERATING_REPLIES: GENERATING_REPLIES$3,
	ATTACH_VIDEO: ATTACH_VIDEO$3,
	ATTACH_AUDIO: ATTACH_AUDIO$3,
	ATTACH_IMAGE: ATTACH_IMAGE$3,
	COLLABORATE_USING_DOCUMENT: COLLABORATE_USING_DOCUMENT$3,
	COLLABORATE_USING_WHITEBOARD: COLLABORATE_USING_WHITEBOARD$3,
	SUGGEST_A_REPLY: SUGGEST_A_REPLY$3,
	GENERATING_ICEBREAKERS: GENERATING_ICEBREAKERS$3,
	EMOJI: EMOJI$3,
	NO_REPLIES_FOUND: NO_REPLIES_FOUND$3,
	ENTER_YOUR_MESSAGE_HERE: ENTER_YOUR_MESSAGE_HERE$3,
	NO_MESSAGES_FOUND: NO_MESSAGES_FOUND$3,
	THREAD: THREAD$3,
	COLLABORATIVE_DOCUMENT: COLLABORATIVE_DOCUMENT$3,
	COLLABORATIVE_WHITEBOARD: COLLABORATIVE_WHITEBOARD$3,
	ADD_REACTION: ADD_REACTION$3,
	NO_STICKERS_FOUND: NO_STICKERS_FOUND$3,
	REPLY_TO_THREAD: REPLY_TO_THREAD$3,
	REPLY_IN_THREAD: REPLY_IN_THREAD$3,
	VIEW: VIEW$3,
	DELETE_MESSAGE: DELETE_MESSAGE$3,
	EDIT_MESSAGE: EDIT_MESSAGE$3,
	OWNER: OWNER$3,
	CHANGE_SCOPE: CHANGE_SCOPE$3,
	STICKER: STICKER$3,
	LAST_ACTIVE_AT: LAST_ACTIVE_AT$3,
	VOICE_CALL: VOICE_CALL$3,
	VIEW_DETAIL: VIEW_DETAIL$3,
	VOTES: VOTES$3,
	VOTE: VOTE$3,
	NO_VOTE: NO_VOTE$3,
	REACTED: REACTED$3,
	ADDED: ADDED$3,
	SHOW_UNSAFE_CONTENT: SHOW_UNSAFE_CONTENT$3,
	REACT_TO_MESSAGE: REACT_TO_MESSAGE$3,
	UNBANNED: UNBANNED$3,
	MADE: MADE$3,
	CALL_UNANSWERED: CALL_UNANSWERED$3,
	MISSED_AUDIO_CALL: MISSED_AUDIO_CALL$3,
	ENTER_YOUR_PASSWORD: ENTER_YOUR_PASSWORD$3,
	DRAW_DOCUMENT_TOGETHER: DRAW_DOCUMENT_TOGETHER$3,
	DOCS: DOCS$3,
	NO_RECORDS_FOUND: NO_RECORDS_FOUND$3,
	LIVE_REACTION: LIVE_REACTION$3,
	SMILEY_PEOPLE: SMILEY_PEOPLE$3,
	DRAW_WHITEBOARD_TOGETHER: DRAW_WHITEBOARD_TOGETHER$3,
	ANIMALES_NATURE: ANIMALES_NATURE$3,
	FOOD_DRINK: FOOD_DRINK$3,
	OPEN_DOCUMENT: OPEN_DOCUMENT$3,
	ACTIVITY: ACTIVITY$3,
	TRAVEL_PLACES: TRAVEL_PLACES$3,
	OBJECTS: OBJECTS$3,
	SYMBOLS: SYMBOLS$3,
	FLAGS: FLAGS$3,
	SENT: SENT$3,
	SEEN: SEEN$3,
	DELIVERED: DELIVERED$3,
	READ: READ$3,
	MESSAGE_INFORMATION: MESSAGE_INFORMATION$3,
	TRANSLATE_MESSAGE: TRANSLATE_MESSAGE$3,
	TRANSLATED_MESSAGE: TRANSLATED_MESSAGE$3,
	LEFT: LEFT$3,
	KICKED: KICKED$3,
	BANNED: BANNED$3,
	NEW_MESSAGES: NEW_MESSAGES$3,
	NEW_MESSAGE: NEW_MESSAGE$3,
	JUMP: JUMP$3,
	SELECT_VIDEO_SOURCE: SELECT_VIDEO_SOURCE$3,
	SELECT_INPUT_AUDIO_SOURCE: SELECT_INPUT_AUDIO_SOURCE$3,
	SELECT_OUTPUT_AUDIO_SOURCE: SELECT_OUTPUT_AUDIO_SOURCE$3,
	INITIATED_GROUP_CALL: INITIATED_GROUP_CALL$3,
	YOU_INITIATED_GROUP_CALL: YOU_INITIATED_GROUP_CALL$3,
	IGNORE: IGNORE$3,
	ON_ANOTHER_CALL: ON_ANOTHER_CALL$3,
	CREATING: CREATING$3,
	AVATAR: AVATAR$3,
	ONGOING_CALL: ONGOING_CALL$3,
	YOU_ALREADY_ONGOING_CALL: YOU_ALREADY_ONGOING_CALL$3,
	RESIZE: RESIZE$3,
	SETTINGS: SETTINGS$3,
	ACTIONS: ACTIONS$3,
	VIEW_PROFILE: VIEW_PROFILE$3,
	SEND_MESSAGE_IN_PRIVATE: SEND_MESSAGE_IN_PRIVATE$3,
	DELETE: DELETE$3,
	DELETE_CONFIRM: DELETE_CONFIRM$3,
	CANCEL: CANCEL$3,
	LEAVE_CONFIRM: LEAVE_CONFIRM$3,
	TRANSFER_CONFIRM: TRANSFER_CONFIRM$3,
	ADDING: ADDING$3,
	TRANSFER: TRANSFER$3,
	TRANSFER_OWNERSHIP: TRANSFER_OWNERSHIP$3,
	TRANSFERRING: TRANSFERRING$3,
	YES: YES$3,
	NO: NO$3,
	ANSWER: ANSWER$3,
	ADD_ANOTHER_ANSWER: ADD_ANOTHER_ANSWER$3,
	SET_THE_ANSWERS: SET_THE_ANSWERS$3,
	TRY_AGAIN: TRY_AGAIN$3,
	INVALID_GROUP_NAME: INVALID_GROUP_NAME$3,
	INVALID_PASSWORD: INVALID_PASSWORD$3,
	INVALID_GROUP_TYPE: INVALID_GROUP_TYPE$3,
	WRONG_PASSWORD: WRONG_PASSWORD$3,
	INVALID_POLL_QUESTION: INVALID_POLL_QUESTION$3,
	INVALID_POLL_OPTION: INVALID_POLL_OPTION$3,
	SAME_LANGUAGE_MESSAGE: SAME_LANGUAGE_MESSAGE$3,
	LEAVE: LEAVE$3,
	CLICK_TO_START_CONVERSATION: CLICK_TO_START_CONVERSATION$3,
	CUSTOM_MESSAGE_LOCATION: CUSTOM_MESSAGE_LOCATION$3,
	SHARED_LOCATION: SHARED_LOCATION$3,
	IN_A_THREAD: IN_A_THREAD$3,
	CALLS: CALLS$3,
	CALL_DETAILS: CALL_DETAILS$3,
	OFFLINE: OFFLINE$3,
	POLLS: POLLS$3,
	YOU: YOU$3,
	PRIVACY: PRIVACY$3,
	BLOCKED_USERS: BLOCKED_USERS$3,
	"YOU'VE_BLOCKED": "您已封鎖",
	NO_PHOTOS: NO_PHOTOS$3,
	NO_VIDEOS: NO_VIDEOS$3,
	NO_DOCUMENTS: NO_DOCUMENTS$3,
	JOIN: JOIN$3,
	REMOVE: REMOVE$3,
	BLOCK: BLOCK$3,
	CHANGE_ROLE: CHANGE_ROLE$3,
	NEW_CHAT: NEW_CHAT$3,
	FORM_COMPLETION_MESSAGE: FORM_COMPLETION_MESSAGE$3,
	HISTORY: HISTORY$3,
	CANCELLED_AUDIO_CALL: CANCELLED_AUDIO_CALL$3,
	CANCELLED_VIDEO_CALL: CANCELLED_VIDEO_CALL$3,
	REJECTED_AUDIO_CALL: REJECTED_AUDIO_CALL$3,
	REJECTED_VIDEO_CALL: REJECTED_VIDEO_CALL$3,
	CANCELLED_CALL: CANCELLED_CALL$3,
	UNANSWERED_CALL: UNANSWERED_CALL$3,
	RECORDING: RECORDING$3,
	PARTICIPANTS: PARTICIPANTS$3,
	CALL_HISTORY: CALL_HISTORY$3,
	NO_CALLS_FOUND: NO_CALLS_FOUND$3,
	ONGOING_AUDIO_CALL: ONGOING_AUDIO_CALL$3,
	ONGOING_VIDEO_CALL: ONGOING_VIDEO_CALL$3,
	CALL_DETAIL: CALL_DETAIL$3,
	FORM: FORM$3,
	CARD: CARD$3,
	GENERATING_SUMMARY: GENERATING_SUMMARY$3,
	CONVERSATION_SUMMARY: CONVERSATION_SUMMARY$3,
	GENERATE_SUMMARY: GENERATE_SUMMARY$3,
	COMETCHAT_BOT_FIRST_MESSAGE: COMETCHAT_BOT_FIRST_MESSAGE$3,
	COMETCHAT_ASK_BOT: COMETCHAT_ASK_BOT$3,
	COMETCHAT_ASK_AI_BOT: COMETCHAT_ASK_AI_BOT$3,
	COMETCHAT_ASK_BOT_SUBTITLE: COMETCHAT_ASK_BOT_SUBTITLE$3,
	MENTIONS_LIMIT_WARNING_MESSAGE: MENTIONS_LIMIT_WARNING_MESSAGE$3,
	ALL: ALL$3,
	CLICK_TO_REMOVE: CLICK_TO_REMOVE$3,
	OTHERS: OTHERS$3,
	AND: AND$3
};

var INFO$2 = "Info";
var REACT$2 = "Reagera";
var EDIT$2 = "Redigera";
var MESSAGE_PRIVATELY$2 = "Meddelande privat";
var TRANSLATE$2 = "Översätt";
var USERS$2 = "Användare";
var CHATS$2 = "Chattar";
var WOULD__YOU_LIKE_TO_DELETE_THIS_CONVERSATION$2 = "Vill du ta bort den här konversationen? Den här konversationen kommer att raderas från alla dina enheter.";
var GROUPS$2 = "Grupper";
var SHARED$2 = "Delad";
var SOUND_MANAGER$2 = "Ljudhanterare";
var THEME$2 = "Tema";
var LOCALIZE$2 = "Lokalisera";
var CONVERSATION_LIST_ITEM$2 = "Konversationslistobjekt";
var DATA_ITEM$2 = "Dataobjekt";
var STATUS_INDICATOR$2 = "Statusindikator";
var BADGE_COUNT$2 = "Antal märken";
var MESSAGE_RECEIPT$2 = "Meddelandekvitto";
var MESSAGE$2 = "Meddelande";
var RECEIPT_INFORMATION$2 = "Kvittoinformation";
var NO_RECIPIENT$2 = "Ingen mottagare";
var NO_RECIPIENTS$2 = "Inga mottagare";
var CONVERSATIONS_WITH_MESSAGES$2 = "Konversationer med meddelanden";
var CONVERSATIONS$2 = "Konversationer";
var CONVERSATION_LIST$2 = "Konversationslista";
var MESSAGES$2 = "Meddelanden";
var MESSAGE_HEADER$2 = "Meddelandehuvud";
var MESSAGE_LIST$2 = "Meddelandelista";
var MESSAGE_COMPOSER$2 = "Meddelandekompositör";
var USERS_WITH_MESSAGES$2 = "Användare med meddelanden";
var USER_LIST$2 = "Användarlista";
var GROUP_LIST$2 = "Grupplista";
var GROUPS_WITH_MESSAGES$2 = "Grupper med meddelanden";
var NEW__GROUP$2 = "Ny grupp";
var PASSWORD$2 = "Lösenord";
var CONTINUE$2 = "Fortsätta";
var NO_CHATS_SELECTED$2 = "Inga chattar valda";
var NO_USERS_SELECTED$2 = "Inga användare valda";
var NO_GROUPS_SELECTED$2 = "Inga grupper valda";
var SELECT_DAY$2 = "Välj en dag";
var SELECT_TIME$2 = "Välj en tid";
var NO_CALLS_SELECTED$2 = "Inga samtal valda";
var SELECT__GROUP$2 = "Välj en grupp för att starta meddelanden";
var SELECT__USER$2 = "Välj en användare för att starta meddelanden";
var GROUP_PASSWORD_BLANK$2 = "Grupplösenordet kan inte vara tomt";
var GROUP_NAME_BLANK$2 = "Gruppnamnet får inte vara tomt";
var GROUP_TYPE_BLANK$2 = "Grupptyp kan inte vara tom";
var DELETE_CONVERSATION$2 = "Radera konversation?";
var ADD_TO_CHAT$2 = "Lägg till i chatten";
var MORE$2 = "Mer";
var COPY$2 = "Kopiera";
var VOICE_RECORDING$2 = "Röstinspelning";
var MESSAGE_IMAGE$2 = "📷 Bild";
var MESSAGE_FILE$2 = "📁 Fil";
var MESSAGE_VIDEO$2 = "📹 Videoklipp";
var MESSAGE_AUDIO$2 = "🎵 Ljud";
var CUSTOM_MESSAGE$2 = "Du har ett meddelande";
var SELECT_A_DATE$2 = "Välj ett datum";
var TIME_ZONE$2 = "Tidszon";
var MEETING_SCHEDULED$2 = "Ditt möte är planerat.";
var SOMETHING_WRONG$2 = "Något gick fel. Vänligen försök igen.";
var MEETING_SLOT_BOOK$2 = "Tidslucka är inte längre tillgänglig. Vänligen välj en annan.";
var MEETING_BOOK_NEW_SLOT$2 = "Boka ny spelautomat";
var MEETING_NO_SLOTS_AVAILABLE$2 = "Ingen tidslucka tillgänglig för detta datum. Försök med ett annat datum.";
var MEETING_TRY_DIFFERENT_DATE$2 = "Försök med ett annat datum.";
var NO_TIME_SLOTS_AVAILABLE$2 = "Inga tidsluckor tillgängliga";
var SCHEDULE$2 = "Schema";
var MORE_TIMES$2 = "Fler gånger";
var MISSED_VOICE_CALL$2 = "Missat röstsamtal";
var MEET_WITH$2 = "Möt med";
var MEETING_SCHEDULER$2 = "Mötesschemaläggare";
var MISSED_VIDEO_CALL$2 = "Missat videosamtal";
var CUSTOM_MESSAGE_POLL$2 = "📊 Omröstning";
var CUSTOM_MESSAGE_STICKER$2 = "💟 Klistermärke";
var CUSTOM_MESSAGE_DOCUMENT$2 = "📃 Dokument";
var CUSTOM_MESSAGE_WHITEBOARD$2 = "📝 Whiteboard";
var ONLINE$2 = "Uppkopplad";
var ADMINISTRATOR$2 = "Administratör";
var ADMIN$2 = "Administratör";
var MODERATOR$2 = "presentatör";
var PARTICIPANT$2 = "Deltagare";
var PUBLIC$2 = "Offentlig";
var PRIVATE$2 = "Privat";
var PASSWORD_PROTECTED$2 = "Lösenordsskyddad";
var PRIVACY_AND_SECURITY$2 = "Sekretess och säkerhet";
var PREFERENCES$2 = "Inställningar";
var MEMBERS$2 = "Medlemmar";
var MEMBER$2 = "Medlem";
var TODAY$2 = "I dag";
var YESTERDAY$2 = "Igår";
var SUNDAY$2 = "söndag";
var MONDAY$2 = "måndag";
var TUESDAY$2 = "tisdag";
var WEDNESDAY$2 = "onsdag";
var THURSDAY$2 = "torsdag";
var FRIDAY$2 = "fredag";
var SATURDAY$2 = "Lördag";
var TYPING$2 = "skriver...";
var IS_TYPING$2 = "skriver...";
var CLOSE$2 = "Stäng";
var ENTER_GROUP_NAME$2 = "Ange gruppnamn";
var ADD_MEMBERS$2 = "Lägg till medlemmar";
var SEND_MESSAGE$2 = "Skicka meddelande";
var UNBLOCK_USER$2 = "Avblockera användare";
var BLOCK_USER$2 = "Blockera användare";
var DELETE_AND_EXIT$2 = "Ta bort och avsluta";
var LEAVE_GROUP$2 = "Lämna gruppen";
var CREATE_GROUP$2 = "Skapa grupp";
var SHARED_MEDIA$2 = "Delade medier";
var SHARED_FILE$2 = "Delad fil";
var VIDEO_CALL$2 = "Videosamtal";
var AUDIO_CALL$2 = "Ljudsamtal";
var LOADING$2 = "Laddar...";
var REPLY$2 = "svar";
var REPLIES$2 = "svar";
var AI$2 = "AI";
var SMART_REPLIES$2 = "Smarta svar";
var CONVERSATION_STARTER$2 = "Konversationsstartare";
var LAUNCH$2 = "Lansera";
var SHARED_COLLABORATIVE_DOCUMENT$2 = "har delat ett samarbetsdokument";
var SHARED_COLLABORATIVE_WHITEBOARD$2 = "har delat en kollaborativ whiteboard";
var CREATED_WHITEBOARD$2 = "Du har skapat en ny kollaborativ whiteboard";
var CREATED_DOCUMENT$2 = "Du har skapat ett nytt samarbetsdokument";
var PHOTOS$2 = "Foton";
var VIDEOS$2 = "Videor";
var DOCUMENT$2 = "Dokument";
var YOU_DELETED_THIS_MESSAGE$2 = "⚠️ Du raderade detta meddelande";
var THIS_MESSAGE_DELETED$2 = "⚠️ Det här meddelandet raderades";
var MESSAGE_IS_DELETED$2 = "Meddelandet är borttaget";
var VIEW_ON_YOUTUBE$2 = "Visa på Youtube";
var SEARCH$2 = "Sök";
var NO_USERS_FOUND$2 = "Inga användare hittades";
var ERROR$2 = "Fel";
var NO_GROUPS_FOUND$2 = "Inga grupper hittades";
var NO_CHATS_FOUND$2 = "Inga chattar hittades";
var CANT__LOAD__CHATS$2 = "Det går inte att ladda chattar";
var MEDIA_MESSAGE$2 = "Mediemeddelande";
var INCOMING_AUDIO_CALL$2 = "Inkommande ljudsamtal";
var INCOMING_VIDEO_CALL$2 = "Inkommande videosamtal";
var DECLINE$2 = "Nedgång";
var ACCEPT$2 = "Acceptera";
var CALL_INITIATED$2 = "Samtal initierat";
var OUTGOING_AUDIO_CALL$2 = "Utgående ljudsamtal";
var OUTGOING_VIDEO_CALL$2 = "Utgående videosamtal";
var CALL_REJECTED$2 = "Samtal avvisat";
var REJECTED_CALL$2 = "avvisat samtal";
var CALL_ACCEPTED$2 = "Samtal accepterat";
var OUTGOING_CALL$2 = "Utgående samtal";
var INCOMING_CALL$2 = "Inkommande samtal";
var MISSED_CALL$2 = "Missat samtal";
var JOINED$2 = "anslöt sig";
var LEFT_THE_CALL$2 = "lämnade samtalet";
var UNANSWERED_AUDIO_CALL$2 = "Obesvarat ljudsamtal";
var UNANSWERED_VIDEO_CALL$2 = "Obesvarat videosamtal";
var CALL_ENDED$2 = "Samtalet avslutades";
var CALL_CANCELLED$2 = "Samtal avbrutits";
var CALL_BUSY$2 = "Samtal upptagen";
var CALLING$2 = "Ringer...";
var ADD$2 = "Lägg till";
var NO_BANNED_MEMBERS_FOUND$2 = "Inga förbjudna medlemmar hittades";
var BANNED_MEMBERS$2 = "Förbjudna medlemmar";
var NAME$2 = "Namn";
var SCOPE$2 = "Omfattning";
var UNBAN$2 = "Unban";
var SELECT_GROUP_TYPE$2 = "Välj grupptyp";
var ENTER_GROUP_PASSWORD$2 = "Ange grupplösenord";
var CREATE$2 = "Skapa";
var CREATE_POLL$2 = "Skapa omröstning";
var QUESTION$2 = "Fråga";
var ENTER_YOUR_QUESTION$2 = "Fyll i din fråga";
var OPTIONS$2 = "Alternativ";
var ENTER_YOUR_OPTION$2 = "Ange ditt alternativ";
var ADD_NEW_OPTION$2 = "Lägg till nytt alternativ";
var VIEW_MEMBERS$2 = "Visa medlemmar";
var DETAILS$2 = "Detaljer";
var NOTIFICATIONS$2 = "Meddelanden";
var OTHER$2 = "Övrigt";
var HELP$2 = "Hjälp";
var REPORT_PROBLEM$2 = "Rapportera ett problem";
var GROUP_MEMBERS$2 = "Gruppmedlemmar";
var BAN$2 = "Förbud";
var KICK$2 = "Sparka";
var PICK_YOUR_EMOJI$2 = "Välj din emoji";
var PRIVATE_GROUP$2 = "Privat grupp";
var PROTECTED_GROUP$2 = "Skyddad grupp";
var VISIT$2 = "Besök";
var ATTACH$2 = "Bifoga";
var OPEN_WHITEBOARD$2 = "Öppna whiteboard";
var ATTACH_FILE$2 = "Bifoga fil";
var GENERATING_REPLIES$2 = "Generera svar";
var ATTACH_VIDEO$2 = "Bifoga video";
var ATTACH_AUDIO$2 = "Bifoga ljud";
var ATTACH_IMAGE$2 = "Bifoga bild";
var COLLABORATE_USING_DOCUMENT$2 = "Samarbeta med hjälp av ett dokument";
var COLLABORATE_USING_WHITEBOARD$2 = "Samarbeta med hjälp av en whiteboard";
var SUGGEST_A_REPLY$2 = "Föreslå ett svar";
var GENERATING_ICEBREAKERS$2 = "Generera isbrytare";
var EMOJI$2 = "Emoji";
var NO_REPLIES_FOUND$2 = "Inga svar hittades";
var ENTER_YOUR_MESSAGE_HERE$2 = "Skriv ditt meddelande här";
var NO_MESSAGES_FOUND$2 = "Inga meddelanden hittades";
var THREAD$2 = "Tråd";
var COLLABORATIVE_DOCUMENT$2 = "Samarbetsdokument";
var COLLABORATIVE_WHITEBOARD$2 = "Kollaborativ whiteboard";
var ADD_REACTION$2 = "Lägg till reaktion";
var NO_STICKERS_FOUND$2 = "Inga klistermärken hittades";
var REPLY_TO_THREAD$2 = "Svara på tråden";
var REPLY_IN_THREAD$2 = "Svara i tråd";
var VIEW$2 = "Se";
var DELETE_MESSAGE$2 = "Ta bort meddelande";
var EDIT_MESSAGE$2 = "Redigera meddelande";
var OWNER$2 = "Ägare";
var CHANGE_SCOPE$2 = "Ändra omfattning";
var STICKER$2 = "Klistermärke";
var LAST_ACTIVE_AT$2 = "Senast aktiv kl";
var VOICE_CALL$2 = "Röstsamtal";
var VIEW_DETAIL$2 = "Visa detalj";
var VOTES$2 = "röster";
var VOTE$2 = "rösta";
var NO_VOTE$2 = "Ingen röst";
var REACTED$2 = "reagerade";
var ADDED$2 = "Lagt till";
var SHOW_UNSAFE_CONTENT$2 = "Är du säker på att du vill se osäkert innehåll?";
var REACT_TO_MESSAGE$2 = "Reagera på ett meddelande";
var UNBANNED$2 = "oförbjudet";
var MADE$2 = "gjord";
var CALL_UNANSWERED$2 = "Ring obesvarat";
var MISSED_AUDIO_CALL$2 = "Missat ljudsamtal";
var ENTER_YOUR_PASSWORD$2 = "Ange ditt lösenord";
var DRAW_DOCUMENT_TOGETHER$2 = "Öppna dokument för att redigera innehåll tillsammans";
var DOCS$2 = "Dokument";
var NO_RECORDS_FOUND$2 = "Inga poster hittades";
var LIVE_REACTION$2 = "Levande reaktion";
var SMILEY_PEOPLE$2 = "Smileys och människor";
var DRAW_WHITEBOARD_TOGETHER$2 = "Öppna whiteboard för att rita tillsammans";
var ANIMALES_NATURE$2 = "Djur & Natur";
var FOOD_DRINK$2 = "Mat & Dryck";
var OPEN_DOCUMENT$2 = "Öppna dokument";
var ACTIVITY$2 = "Aktivitet";
var TRAVEL_PLACES$2 = "Resor & Platser";
var OBJECTS$2 = "Objekt";
var SYMBOLS$2 = "Symboler";
var FLAGS$2 = "flaggor";
var SENT$2 = "Skickat";
var SEEN$2 = "Sett";
var DELIVERED$2 = "Levereras";
var READ$2 = "Läsa";
var MESSAGE_INFORMATION$2 = "Meddelandeinformation";
var TRANSLATE_MESSAGE$2 = "Översätt meddelande";
var TRANSLATED_MESSAGE$2 = "Översatt meddelande";
var LEFT$2 = "vänster";
var KICKED$2 = "sparkad";
var BANNED$2 = "förbjudna";
var NEW_MESSAGES$2 = "nya meddelanden";
var NEW_MESSAGE$2 = "nytt meddelande";
var JUMP$2 = "Hoppa";
var SELECT_VIDEO_SOURCE$2 = "Välj videokälla";
var SELECT_INPUT_AUDIO_SOURCE$2 = "Välj ingångsljudkälla";
var SELECT_OUTPUT_AUDIO_SOURCE$2 = "Välj ljudkälla för utgång";
var INITIATED_GROUP_CALL$2 = "har initierat ett gruppsamtal";
var YOU_INITIATED_GROUP_CALL$2 = "Du har initierat ett gruppsamtal";
var IGNORE$2 = "Ignorera";
var ON_ANOTHER_CALL$2 = "är på ett annat samtal";
var CREATING$2 = "Skapar";
var AVATAR$2 = "Avatar";
var ONGOING_CALL$2 = "Pågående utlysning";
var YOU_ALREADY_ONGOING_CALL$2 = "Du är redan i ett pågående samtal";
var RESIZE$2 = "Ändra storlek";
var SETTINGS$2 = "Inställningar";
var ACTIONS$2 = "Åtgärder";
var VIEW_PROFILE$2 = "Visa profil";
var SEND_MESSAGE_IN_PRIVATE$2 = "Skicka meddelande privat";
var DELETE$2 = "Ta bort";
var DELETE_CONFIRM$2 = "Är du säker på att du vill ta bort?";
var CANCEL$2 = "Avbryt";
var LEAVE_CONFIRM$2 = "Är du säker på att du vill lämna gruppen?";
var TRANSFER_CONFIRM$2 = "Du är gruppens ägare; överför äganderätten till en medlem innan du lämnar gruppen";
var ADDING$2 = "Lägger till...";
var TRANSFER$2 = "Överföring";
var TRANSFER_OWNERSHIP$2 = "Överför äganderätten";
var TRANSFERRING$2 = "Överföring";
var YES$2 = "Javisst";
var NO$2 = "Nej";
var ANSWER$2 = "Svara";
var ADD_ANOTHER_ANSWER$2 = "Lägg till ett annat svar";
var SET_THE_ANSWERS$2 = "STÄLL IN SVAREN";
var TRY_AGAIN$2 = "Försök igen";
var INVALID_GROUP_NAME$2 = "Ange ett giltigt namn för gruppen och försök igen";
var INVALID_PASSWORD$2 = "Ange ett giltigt lösenord för gruppen och försök igen";
var INVALID_GROUP_TYPE$2 = "Ange en giltig typ för gruppen och försök igen";
var WRONG_PASSWORD$2 = "Ange rätt lösenord och försök igen";
var INVALID_POLL_QUESTION$2 = "Ange önskad fråga innan du skapar en omröstning";
var INVALID_POLL_OPTION$2 = "Ange önskat svar innan du skapar en omröstning";
var SAME_LANGUAGE_MESSAGE$2 = "Valt språk för översättning liknar språket i originalmeddelandet";
var LEAVE$2 = "Lämna";
var CLICK_TO_START_CONVERSATION$2 = "Klicka för att starta konversation";
var CUSTOM_MESSAGE_LOCATION$2 = "📍 Plats";
var SHARED_LOCATION$2 = "Delad plats";
var IN_A_THREAD$2 = "I en tråd";
var CALLS$2 = "Samtal";
var CALL_DETAILS$2 = "Samtalsinformation";
var OFFLINE$2 = "Offline";
var POLLS$2 = "Omröstningar";
var YOU$2 = "Du";
var PRIVACY$2 = "Integritet";
var BLOCKED_USERS$2 = "Blockerade användare";
var NO_PHOTOS$2 = "Inga foton";
var NO_VIDEOS$2 = "Inga videor";
var NO_DOCUMENTS$2 = "Inga dokument";
var JOIN$2 = "Gå med";
var REMOVE$2 = "Ta bort";
var BLOCK$2 = "Blockera";
var CHANGE_ROLE$2 = "Ändra roll";
var NEW_CHAT$2 = "Ny chatt";
var FORM_COMPLETION_MESSAGE$2 = "Tack för att du fyllde i formuläret.";
var HISTORY$2 = "Historia";
var CANCELLED_AUDIO_CALL$2 = "Avbrutet ljudsamtal";
var CANCELLED_VIDEO_CALL$2 = "Avbrutet videosamtal";
var REJECTED_AUDIO_CALL$2 = "Avvisat ljudsamtal";
var REJECTED_VIDEO_CALL$2 = "Avvisat videosamtal";
var CANCELLED_CALL$2 = "Avbrutet samtal";
var UNANSWERED_CALL$2 = "Obesvarat samtal";
var RECORDING$2 = "Inspelning";
var PARTICIPANTS$2 = "Deltagare";
var CALL_HISTORY$2 = "Samtalshistorik";
var NO_CALLS_FOUND$2 = "Inga samtal hittades";
var ONGOING_AUDIO_CALL$2 = "Pågående ljudsamtal";
var ONGOING_VIDEO_CALL$2 = "Pågående videosamtal";
var CALL_DETAIL$2 = "Samtalsdetaljer";
var FORM$2 = "Formulär";
var CARD$2 = "Kort";
var GENERATING_SUMMARY$2 = "Generera sammanfattning";
var CONVERSATION_SUMMARY$2 = "Konversationssammanfattning";
var GENERATE_SUMMARY$2 = "Skapa en sammanfattning";
var COMETCHAT_BOT_FIRST_MESSAGE$2 = "Hur kan jag hjälpa dig med det här samtalet? Ställ mig en fråga så ska jag ge dig råd 🙂";
var COMETCHAT_ASK_BOT$2 = "Fråga";
var COMETCHAT_ASK_AI_BOT$2 = "Fråga AI-bots";
var COMETCHAT_ASK_BOT_SUBTITLE$2 = "AI Bot";
var MENTIONS_LIMIT_WARNING_MESSAGE$2 = "Du kan nämna upp till 10 gånger åt gången.";
var ALL$2 = "Allt";
var CLICK_TO_REMOVE$2 = "Klicka för att ta bort";
var OTHERS$2 = "andra";
var AND$2 = "ett";
var translationSV = {
	INFO: INFO$2,
	REACT: REACT$2,
	EDIT: EDIT$2,
	MESSAGE_PRIVATELY: MESSAGE_PRIVATELY$2,
	TRANSLATE: TRANSLATE$2,
	USERS: USERS$2,
	CHATS: CHATS$2,
	WOULD__YOU_LIKE_TO_DELETE_THIS_CONVERSATION: WOULD__YOU_LIKE_TO_DELETE_THIS_CONVERSATION$2,
	GROUPS: GROUPS$2,
	SHARED: SHARED$2,
	SOUND_MANAGER: SOUND_MANAGER$2,
	THEME: THEME$2,
	LOCALIZE: LOCALIZE$2,
	CONVERSATION_LIST_ITEM: CONVERSATION_LIST_ITEM$2,
	DATA_ITEM: DATA_ITEM$2,
	STATUS_INDICATOR: STATUS_INDICATOR$2,
	BADGE_COUNT: BADGE_COUNT$2,
	MESSAGE_RECEIPT: MESSAGE_RECEIPT$2,
	MESSAGE: MESSAGE$2,
	RECEIPT_INFORMATION: RECEIPT_INFORMATION$2,
	NO_RECIPIENT: NO_RECIPIENT$2,
	NO_RECIPIENTS: NO_RECIPIENTS$2,
	CONVERSATIONS_WITH_MESSAGES: CONVERSATIONS_WITH_MESSAGES$2,
	CONVERSATIONS: CONVERSATIONS$2,
	CONVERSATION_LIST: CONVERSATION_LIST$2,
	MESSAGES: MESSAGES$2,
	MESSAGE_HEADER: MESSAGE_HEADER$2,
	MESSAGE_LIST: MESSAGE_LIST$2,
	MESSAGE_COMPOSER: MESSAGE_COMPOSER$2,
	USERS_WITH_MESSAGES: USERS_WITH_MESSAGES$2,
	USER_LIST: USER_LIST$2,
	GROUP_LIST: GROUP_LIST$2,
	GROUPS_WITH_MESSAGES: GROUPS_WITH_MESSAGES$2,
	NEW__GROUP: NEW__GROUP$2,
	PASSWORD: PASSWORD$2,
	CONTINUE: CONTINUE$2,
	NO_CHATS_SELECTED: NO_CHATS_SELECTED$2,
	NO_USERS_SELECTED: NO_USERS_SELECTED$2,
	NO_GROUPS_SELECTED: NO_GROUPS_SELECTED$2,
	SELECT_DAY: SELECT_DAY$2,
	SELECT_TIME: SELECT_TIME$2,
	NO_CALLS_SELECTED: NO_CALLS_SELECTED$2,
	SELECT__GROUP: SELECT__GROUP$2,
	SELECT__USER: SELECT__USER$2,
	GROUP_PASSWORD_BLANK: GROUP_PASSWORD_BLANK$2,
	GROUP_NAME_BLANK: GROUP_NAME_BLANK$2,
	GROUP_TYPE_BLANK: GROUP_TYPE_BLANK$2,
	DELETE_CONVERSATION: DELETE_CONVERSATION$2,
	ADD_TO_CHAT: ADD_TO_CHAT$2,
	MORE: MORE$2,
	COPY: COPY$2,
	VOICE_RECORDING: VOICE_RECORDING$2,
	MESSAGE_IMAGE: MESSAGE_IMAGE$2,
	MESSAGE_FILE: MESSAGE_FILE$2,
	MESSAGE_VIDEO: MESSAGE_VIDEO$2,
	MESSAGE_AUDIO: MESSAGE_AUDIO$2,
	CUSTOM_MESSAGE: CUSTOM_MESSAGE$2,
	SELECT_A_DATE: SELECT_A_DATE$2,
	TIME_ZONE: TIME_ZONE$2,
	MEETING_SCHEDULED: MEETING_SCHEDULED$2,
	SOMETHING_WRONG: SOMETHING_WRONG$2,
	MEETING_SLOT_BOOK: MEETING_SLOT_BOOK$2,
	MEETING_BOOK_NEW_SLOT: MEETING_BOOK_NEW_SLOT$2,
	MEETING_NO_SLOTS_AVAILABLE: MEETING_NO_SLOTS_AVAILABLE$2,
	MEETING_TRY_DIFFERENT_DATE: MEETING_TRY_DIFFERENT_DATE$2,
	NO_TIME_SLOTS_AVAILABLE: NO_TIME_SLOTS_AVAILABLE$2,
	SCHEDULE: SCHEDULE$2,
	MORE_TIMES: MORE_TIMES$2,
	MISSED_VOICE_CALL: MISSED_VOICE_CALL$2,
	MEET_WITH: MEET_WITH$2,
	MEETING_SCHEDULER: MEETING_SCHEDULER$2,
	MISSED_VIDEO_CALL: MISSED_VIDEO_CALL$2,
	CUSTOM_MESSAGE_POLL: CUSTOM_MESSAGE_POLL$2,
	CUSTOM_MESSAGE_STICKER: CUSTOM_MESSAGE_STICKER$2,
	CUSTOM_MESSAGE_DOCUMENT: CUSTOM_MESSAGE_DOCUMENT$2,
	CUSTOM_MESSAGE_WHITEBOARD: CUSTOM_MESSAGE_WHITEBOARD$2,
	ONLINE: ONLINE$2,
	ADMINISTRATOR: ADMINISTRATOR$2,
	ADMIN: ADMIN$2,
	MODERATOR: MODERATOR$2,
	PARTICIPANT: PARTICIPANT$2,
	PUBLIC: PUBLIC$2,
	PRIVATE: PRIVATE$2,
	PASSWORD_PROTECTED: PASSWORD_PROTECTED$2,
	PRIVACY_AND_SECURITY: PRIVACY_AND_SECURITY$2,
	PREFERENCES: PREFERENCES$2,
	MEMBERS: MEMBERS$2,
	MEMBER: MEMBER$2,
	TODAY: TODAY$2,
	YESTERDAY: YESTERDAY$2,
	SUNDAY: SUNDAY$2,
	MONDAY: MONDAY$2,
	TUESDAY: TUESDAY$2,
	WEDNESDAY: WEDNESDAY$2,
	THURSDAY: THURSDAY$2,
	FRIDAY: FRIDAY$2,
	SATURDAY: SATURDAY$2,
	TYPING: TYPING$2,
	IS_TYPING: IS_TYPING$2,
	CLOSE: CLOSE$2,
	ENTER_GROUP_NAME: ENTER_GROUP_NAME$2,
	ADD_MEMBERS: ADD_MEMBERS$2,
	SEND_MESSAGE: SEND_MESSAGE$2,
	UNBLOCK_USER: UNBLOCK_USER$2,
	BLOCK_USER: BLOCK_USER$2,
	DELETE_AND_EXIT: DELETE_AND_EXIT$2,
	LEAVE_GROUP: LEAVE_GROUP$2,
	CREATE_GROUP: CREATE_GROUP$2,
	SHARED_MEDIA: SHARED_MEDIA$2,
	SHARED_FILE: SHARED_FILE$2,
	VIDEO_CALL: VIDEO_CALL$2,
	AUDIO_CALL: AUDIO_CALL$2,
	LOADING: LOADING$2,
	REPLY: REPLY$2,
	REPLIES: REPLIES$2,
	AI: AI$2,
	SMART_REPLIES: SMART_REPLIES$2,
	CONVERSATION_STARTER: CONVERSATION_STARTER$2,
	LAUNCH: LAUNCH$2,
	SHARED_COLLABORATIVE_DOCUMENT: SHARED_COLLABORATIVE_DOCUMENT$2,
	SHARED_COLLABORATIVE_WHITEBOARD: SHARED_COLLABORATIVE_WHITEBOARD$2,
	CREATED_WHITEBOARD: CREATED_WHITEBOARD$2,
	CREATED_DOCUMENT: CREATED_DOCUMENT$2,
	PHOTOS: PHOTOS$2,
	VIDEOS: VIDEOS$2,
	DOCUMENT: DOCUMENT$2,
	YOU_DELETED_THIS_MESSAGE: YOU_DELETED_THIS_MESSAGE$2,
	THIS_MESSAGE_DELETED: THIS_MESSAGE_DELETED$2,
	MESSAGE_IS_DELETED: MESSAGE_IS_DELETED$2,
	VIEW_ON_YOUTUBE: VIEW_ON_YOUTUBE$2,
	SEARCH: SEARCH$2,
	NO_USERS_FOUND: NO_USERS_FOUND$2,
	ERROR: ERROR$2,
	NO_GROUPS_FOUND: NO_GROUPS_FOUND$2,
	NO_CHATS_FOUND: NO_CHATS_FOUND$2,
	CANT__LOAD__CHATS: CANT__LOAD__CHATS$2,
	MEDIA_MESSAGE: MEDIA_MESSAGE$2,
	INCOMING_AUDIO_CALL: INCOMING_AUDIO_CALL$2,
	INCOMING_VIDEO_CALL: INCOMING_VIDEO_CALL$2,
	DECLINE: DECLINE$2,
	ACCEPT: ACCEPT$2,
	CALL_INITIATED: CALL_INITIATED$2,
	OUTGOING_AUDIO_CALL: OUTGOING_AUDIO_CALL$2,
	OUTGOING_VIDEO_CALL: OUTGOING_VIDEO_CALL$2,
	CALL_REJECTED: CALL_REJECTED$2,
	REJECTED_CALL: REJECTED_CALL$2,
	CALL_ACCEPTED: CALL_ACCEPTED$2,
	OUTGOING_CALL: OUTGOING_CALL$2,
	INCOMING_CALL: INCOMING_CALL$2,
	MISSED_CALL: MISSED_CALL$2,
	JOINED: JOINED$2,
	LEFT_THE_CALL: LEFT_THE_CALL$2,
	UNANSWERED_AUDIO_CALL: UNANSWERED_AUDIO_CALL$2,
	UNANSWERED_VIDEO_CALL: UNANSWERED_VIDEO_CALL$2,
	CALL_ENDED: CALL_ENDED$2,
	CALL_CANCELLED: CALL_CANCELLED$2,
	CALL_BUSY: CALL_BUSY$2,
	CALLING: CALLING$2,
	ADD: ADD$2,
	NO_BANNED_MEMBERS_FOUND: NO_BANNED_MEMBERS_FOUND$2,
	BANNED_MEMBERS: BANNED_MEMBERS$2,
	NAME: NAME$2,
	SCOPE: SCOPE$2,
	UNBAN: UNBAN$2,
	SELECT_GROUP_TYPE: SELECT_GROUP_TYPE$2,
	ENTER_GROUP_PASSWORD: ENTER_GROUP_PASSWORD$2,
	CREATE: CREATE$2,
	CREATE_POLL: CREATE_POLL$2,
	QUESTION: QUESTION$2,
	ENTER_YOUR_QUESTION: ENTER_YOUR_QUESTION$2,
	OPTIONS: OPTIONS$2,
	ENTER_YOUR_OPTION: ENTER_YOUR_OPTION$2,
	ADD_NEW_OPTION: ADD_NEW_OPTION$2,
	VIEW_MEMBERS: VIEW_MEMBERS$2,
	DETAILS: DETAILS$2,
	NOTIFICATIONS: NOTIFICATIONS$2,
	OTHER: OTHER$2,
	HELP: HELP$2,
	REPORT_PROBLEM: REPORT_PROBLEM$2,
	GROUP_MEMBERS: GROUP_MEMBERS$2,
	BAN: BAN$2,
	KICK: KICK$2,
	PICK_YOUR_EMOJI: PICK_YOUR_EMOJI$2,
	PRIVATE_GROUP: PRIVATE_GROUP$2,
	PROTECTED_GROUP: PROTECTED_GROUP$2,
	VISIT: VISIT$2,
	ATTACH: ATTACH$2,
	OPEN_WHITEBOARD: OPEN_WHITEBOARD$2,
	ATTACH_FILE: ATTACH_FILE$2,
	GENERATING_REPLIES: GENERATING_REPLIES$2,
	ATTACH_VIDEO: ATTACH_VIDEO$2,
	ATTACH_AUDIO: ATTACH_AUDIO$2,
	ATTACH_IMAGE: ATTACH_IMAGE$2,
	COLLABORATE_USING_DOCUMENT: COLLABORATE_USING_DOCUMENT$2,
	COLLABORATE_USING_WHITEBOARD: COLLABORATE_USING_WHITEBOARD$2,
	SUGGEST_A_REPLY: SUGGEST_A_REPLY$2,
	GENERATING_ICEBREAKERS: GENERATING_ICEBREAKERS$2,
	EMOJI: EMOJI$2,
	NO_REPLIES_FOUND: NO_REPLIES_FOUND$2,
	ENTER_YOUR_MESSAGE_HERE: ENTER_YOUR_MESSAGE_HERE$2,
	NO_MESSAGES_FOUND: NO_MESSAGES_FOUND$2,
	THREAD: THREAD$2,
	COLLABORATIVE_DOCUMENT: COLLABORATIVE_DOCUMENT$2,
	COLLABORATIVE_WHITEBOARD: COLLABORATIVE_WHITEBOARD$2,
	ADD_REACTION: ADD_REACTION$2,
	NO_STICKERS_FOUND: NO_STICKERS_FOUND$2,
	REPLY_TO_THREAD: REPLY_TO_THREAD$2,
	REPLY_IN_THREAD: REPLY_IN_THREAD$2,
	VIEW: VIEW$2,
	DELETE_MESSAGE: DELETE_MESSAGE$2,
	EDIT_MESSAGE: EDIT_MESSAGE$2,
	OWNER: OWNER$2,
	CHANGE_SCOPE: CHANGE_SCOPE$2,
	STICKER: STICKER$2,
	LAST_ACTIVE_AT: LAST_ACTIVE_AT$2,
	VOICE_CALL: VOICE_CALL$2,
	VIEW_DETAIL: VIEW_DETAIL$2,
	VOTES: VOTES$2,
	VOTE: VOTE$2,
	NO_VOTE: NO_VOTE$2,
	REACTED: REACTED$2,
	ADDED: ADDED$2,
	SHOW_UNSAFE_CONTENT: SHOW_UNSAFE_CONTENT$2,
	REACT_TO_MESSAGE: REACT_TO_MESSAGE$2,
	UNBANNED: UNBANNED$2,
	MADE: MADE$2,
	CALL_UNANSWERED: CALL_UNANSWERED$2,
	MISSED_AUDIO_CALL: MISSED_AUDIO_CALL$2,
	ENTER_YOUR_PASSWORD: ENTER_YOUR_PASSWORD$2,
	DRAW_DOCUMENT_TOGETHER: DRAW_DOCUMENT_TOGETHER$2,
	DOCS: DOCS$2,
	NO_RECORDS_FOUND: NO_RECORDS_FOUND$2,
	LIVE_REACTION: LIVE_REACTION$2,
	SMILEY_PEOPLE: SMILEY_PEOPLE$2,
	DRAW_WHITEBOARD_TOGETHER: DRAW_WHITEBOARD_TOGETHER$2,
	ANIMALES_NATURE: ANIMALES_NATURE$2,
	FOOD_DRINK: FOOD_DRINK$2,
	OPEN_DOCUMENT: OPEN_DOCUMENT$2,
	ACTIVITY: ACTIVITY$2,
	TRAVEL_PLACES: TRAVEL_PLACES$2,
	OBJECTS: OBJECTS$2,
	SYMBOLS: SYMBOLS$2,
	FLAGS: FLAGS$2,
	SENT: SENT$2,
	SEEN: SEEN$2,
	DELIVERED: DELIVERED$2,
	READ: READ$2,
	MESSAGE_INFORMATION: MESSAGE_INFORMATION$2,
	TRANSLATE_MESSAGE: TRANSLATE_MESSAGE$2,
	TRANSLATED_MESSAGE: TRANSLATED_MESSAGE$2,
	LEFT: LEFT$2,
	KICKED: KICKED$2,
	BANNED: BANNED$2,
	NEW_MESSAGES: NEW_MESSAGES$2,
	NEW_MESSAGE: NEW_MESSAGE$2,
	JUMP: JUMP$2,
	SELECT_VIDEO_SOURCE: SELECT_VIDEO_SOURCE$2,
	SELECT_INPUT_AUDIO_SOURCE: SELECT_INPUT_AUDIO_SOURCE$2,
	SELECT_OUTPUT_AUDIO_SOURCE: SELECT_OUTPUT_AUDIO_SOURCE$2,
	INITIATED_GROUP_CALL: INITIATED_GROUP_CALL$2,
	YOU_INITIATED_GROUP_CALL: YOU_INITIATED_GROUP_CALL$2,
	IGNORE: IGNORE$2,
	ON_ANOTHER_CALL: ON_ANOTHER_CALL$2,
	CREATING: CREATING$2,
	AVATAR: AVATAR$2,
	ONGOING_CALL: ONGOING_CALL$2,
	YOU_ALREADY_ONGOING_CALL: YOU_ALREADY_ONGOING_CALL$2,
	RESIZE: RESIZE$2,
	SETTINGS: SETTINGS$2,
	ACTIONS: ACTIONS$2,
	VIEW_PROFILE: VIEW_PROFILE$2,
	SEND_MESSAGE_IN_PRIVATE: SEND_MESSAGE_IN_PRIVATE$2,
	DELETE: DELETE$2,
	DELETE_CONFIRM: DELETE_CONFIRM$2,
	CANCEL: CANCEL$2,
	LEAVE_CONFIRM: LEAVE_CONFIRM$2,
	TRANSFER_CONFIRM: TRANSFER_CONFIRM$2,
	ADDING: ADDING$2,
	TRANSFER: TRANSFER$2,
	TRANSFER_OWNERSHIP: TRANSFER_OWNERSHIP$2,
	TRANSFERRING: TRANSFERRING$2,
	YES: YES$2,
	NO: NO$2,
	ANSWER: ANSWER$2,
	ADD_ANOTHER_ANSWER: ADD_ANOTHER_ANSWER$2,
	SET_THE_ANSWERS: SET_THE_ANSWERS$2,
	TRY_AGAIN: TRY_AGAIN$2,
	INVALID_GROUP_NAME: INVALID_GROUP_NAME$2,
	INVALID_PASSWORD: INVALID_PASSWORD$2,
	INVALID_GROUP_TYPE: INVALID_GROUP_TYPE$2,
	WRONG_PASSWORD: WRONG_PASSWORD$2,
	INVALID_POLL_QUESTION: INVALID_POLL_QUESTION$2,
	INVALID_POLL_OPTION: INVALID_POLL_OPTION$2,
	SAME_LANGUAGE_MESSAGE: SAME_LANGUAGE_MESSAGE$2,
	LEAVE: LEAVE$2,
	CLICK_TO_START_CONVERSATION: CLICK_TO_START_CONVERSATION$2,
	CUSTOM_MESSAGE_LOCATION: CUSTOM_MESSAGE_LOCATION$2,
	SHARED_LOCATION: SHARED_LOCATION$2,
	IN_A_THREAD: IN_A_THREAD$2,
	CALLS: CALLS$2,
	CALL_DETAILS: CALL_DETAILS$2,
	OFFLINE: OFFLINE$2,
	POLLS: POLLS$2,
	YOU: YOU$2,
	PRIVACY: PRIVACY$2,
	BLOCKED_USERS: BLOCKED_USERS$2,
	"YOU'VE_BLOCKED": "Du har blockerat",
	NO_PHOTOS: NO_PHOTOS$2,
	NO_VIDEOS: NO_VIDEOS$2,
	NO_DOCUMENTS: NO_DOCUMENTS$2,
	JOIN: JOIN$2,
	REMOVE: REMOVE$2,
	BLOCK: BLOCK$2,
	CHANGE_ROLE: CHANGE_ROLE$2,
	NEW_CHAT: NEW_CHAT$2,
	FORM_COMPLETION_MESSAGE: FORM_COMPLETION_MESSAGE$2,
	HISTORY: HISTORY$2,
	CANCELLED_AUDIO_CALL: CANCELLED_AUDIO_CALL$2,
	CANCELLED_VIDEO_CALL: CANCELLED_VIDEO_CALL$2,
	REJECTED_AUDIO_CALL: REJECTED_AUDIO_CALL$2,
	REJECTED_VIDEO_CALL: REJECTED_VIDEO_CALL$2,
	CANCELLED_CALL: CANCELLED_CALL$2,
	UNANSWERED_CALL: UNANSWERED_CALL$2,
	RECORDING: RECORDING$2,
	PARTICIPANTS: PARTICIPANTS$2,
	CALL_HISTORY: CALL_HISTORY$2,
	NO_CALLS_FOUND: NO_CALLS_FOUND$2,
	ONGOING_AUDIO_CALL: ONGOING_AUDIO_CALL$2,
	ONGOING_VIDEO_CALL: ONGOING_VIDEO_CALL$2,
	CALL_DETAIL: CALL_DETAIL$2,
	FORM: FORM$2,
	CARD: CARD$2,
	GENERATING_SUMMARY: GENERATING_SUMMARY$2,
	CONVERSATION_SUMMARY: CONVERSATION_SUMMARY$2,
	GENERATE_SUMMARY: GENERATE_SUMMARY$2,
	COMETCHAT_BOT_FIRST_MESSAGE: COMETCHAT_BOT_FIRST_MESSAGE$2,
	COMETCHAT_ASK_BOT: COMETCHAT_ASK_BOT$2,
	COMETCHAT_ASK_AI_BOT: COMETCHAT_ASK_AI_BOT$2,
	COMETCHAT_ASK_BOT_SUBTITLE: COMETCHAT_ASK_BOT_SUBTITLE$2,
	MENTIONS_LIMIT_WARNING_MESSAGE: MENTIONS_LIMIT_WARNING_MESSAGE$2,
	ALL: ALL$2,
	CLICK_TO_REMOVE: CLICK_TO_REMOVE$2,
	OTHERS: OTHERS$2,
	AND: AND$2
};

var INFO$1 = "Informazioni";
var REACT$1 = "Reagire";
var EDIT$1 = "Modifica";
var MESSAGE_PRIVATELY$1 = "Messaggio privato";
var TRANSLATE$1 = "Tradurre";
var USERS$1 = "Utenti";
var CHATS$1 = "Chat";
var WOULD__YOU_LIKE_TO_DELETE_THIS_CONVERSATION$1 = "Vuoi eliminare questa conversazione? Questa conversazione verrà eliminata da tutti i tuoi dispositivi.";
var GROUPS$1 = "Gruppi";
var SHARED$1 = "Condiviso";
var SOUND_MANAGER$1 = "Gestore del suono";
var THEME$1 = "Tema";
var LOCALIZE$1 = "Localizza";
var CONVERSATION_LIST_ITEM$1 = "Elemento dell'elenco delle conversazioni";
var DATA_ITEM$1 = "Elemento di dati";
var STATUS_INDICATOR$1 = "Indicatore di stato";
var BADGE_COUNT$1 = "Numero di distintivi";
var MESSAGE_RECEIPT$1 = "Ricevuta del messaggio";
var MESSAGE$1 = "Messaggio";
var RECEIPT_INFORMATION$1 = "Informazioni sulla ricevuta";
var NO_RECIPIENT$1 = "Nessun destinatario";
var NO_RECIPIENTS$1 = "Nessun destinatario";
var CONVERSATIONS_WITH_MESSAGES$1 = "Conversazioni con messaggi";
var CONVERSATIONS$1 = "Conversazioni";
var CONVERSATION_LIST$1 = "Elenco delle conversazioni";
var MESSAGES$1 = "Messaggi";
var MESSAGE_HEADER$1 = "Intestazione del messaggio";
var MESSAGE_LIST$1 = "Elenco messaggi";
var MESSAGE_COMPOSER$1 = "Compositore di messaggi";
var USERS_WITH_MESSAGES$1 = "Utenti con messaggi";
var USER_LIST$1 = "Elenco utenti";
var GROUP_LIST$1 = "Elenco dei gruppi";
var GROUPS_WITH_MESSAGES$1 = "Gruppi con messaggi";
var NEW__GROUP$1 = "Nuovo gruppo";
var PASSWORD$1 = "Password";
var CONTINUE$1 = "Continua";
var NO_CHATS_SELECTED$1 = "Nessuna chat selezionata";
var NO_USERS_SELECTED$1 = "Nessun utente selezionato";
var NO_GROUPS_SELECTED$1 = "Nessun gruppo selezionato";
var SELECT_DAY$1 = "Seleziona un giorno";
var SELECT_TIME$1 = "Seleziona un orario";
var NO_CALLS_SELECTED$1 = "Nessuna chiamata selezionata";
var SELECT__GROUP$1 = "Seleziona un gruppo per iniziare a inviare messaggi";
var SELECT__USER$1 = "Seleziona un utente per iniziare a inviare messaggi";
var GROUP_PASSWORD_BLANK$1 = "La password di gruppo non può essere vuota";
var GROUP_NAME_BLANK$1 = "Il nome del gruppo non può essere vuoto";
var GROUP_TYPE_BLANK$1 = "Il tipo di gruppo non può essere vuoto";
var DELETE_CONVERSATION$1 = "Eliminare una conversazione?";
var ADD_TO_CHAT$1 = "Aggiungi alla chat";
var MORE$1 = "Altro";
var COPY$1 = "Copia";
var VOICE_RECORDING$1 = "Registrazione vocale";
var MESSAGE_IMAGE$1 = "📷 Immagine";
var MESSAGE_FILE$1 = "📁 Fascicolo";
var MESSAGE_VIDEO$1 = "📹 Video";
var MESSAGE_AUDIO$1 = "🎵 Audio";
var CUSTOM_MESSAGE$1 = "Hai un messaggio";
var SELECT_A_DATE$1 = "Seleziona una data";
var TIME_ZONE$1 = "Fuso orario";
var MEETING_SCHEDULED$1 = "La tua riunione è stata programmata.";
var SOMETHING_WRONG$1 = "Qualcosa è andato storto. Per favore riprova.";
var MEETING_SLOT_BOOK$1 = "Fascia oraria non più disponibile. Per favore scegline un altro.";
var MEETING_BOOK_NEW_SLOT$1 = "Prenota un nuovo slot";
var MEETING_NO_SLOTS_AVAILABLE$1 = "Nessuna fascia oraria disponibile per questa data. Prova con un'altra data.";
var MEETING_TRY_DIFFERENT_DATE$1 = "Prova con una data diversa.";
var NO_TIME_SLOTS_AVAILABLE$1 = "Nessuna fascia oraria disponibile";
var SCHEDULE$1 = "Pianificazione";
var MORE_TIMES$1 = "Più volte";
var MISSED_VOICE_CALL$1 = "Chiamata vocale persa";
var MEET_WITH$1 = "Incontro con";
var MEETING_SCHEDULER$1 = "Pianificatore di riunioni";
var MISSED_VIDEO_CALL$1 = "Videochiamata persa";
var CUSTOM_MESSAGE_POLL$1 = "📊 Sondaggio";
var CUSTOM_MESSAGE_STICKER$1 = "💟 Adesivo";
var CUSTOM_MESSAGE_DOCUMENT$1 = "📃 Documento";
var CUSTOM_MESSAGE_WHITEBOARD$1 = "📝 Lavagna";
var ONLINE$1 = "Online";
var ADMINISTRATOR$1 = "Amministratore";
var ADMIN$1 = "Amministratore";
var MODERATOR$1 = "presentatrice";
var PARTICIPANT$1 = "Partecipante";
var PUBLIC$1 = "Pubblico";
var PRIVATE$1 = "Privato";
var PASSWORD_PROTECTED$1 = "Protetto con password";
var PRIVACY_AND_SECURITY$1 = "Privacy e sicurezza";
var PREFERENCES$1 = "Preferenze";
var MEMBERS$1 = "Membri";
var MEMBER$1 = "Membro";
var TODAY$1 = "Oggi";
var YESTERDAY$1 = "Ieri";
var SUNDAY$1 = "Domenica";
var MONDAY$1 = "Lunedì";
var TUESDAY$1 = "martedì";
var WEDNESDAY$1 = "Mercoledì";
var THURSDAY$1 = "Giovedì";
var FRIDAY$1 = "Venerdì";
var SATURDAY$1 = "Sabato";
var TYPING$1 = "digitando...";
var IS_TYPING$1 = "sta digitando...";
var CLOSE$1 = "Chiudi";
var ENTER_GROUP_NAME$1 = "Inserisci il nome del gruppo";
var ADD_MEMBERS$1 = "Aggiungi membri";
var SEND_MESSAGE$1 = "Invia messaggio";
var UNBLOCK_USER$1 = "Sblocca utente";
var BLOCK_USER$1 = "Blocca utente";
var DELETE_AND_EXIT$1 = "Elimina ed esci";
var LEAVE_GROUP$1 = "Lascia il gruppo";
var CREATE_GROUP$1 = "Crea gruppo";
var SHARED_MEDIA$1 = "Media condivisi";
var SHARED_FILE$1 = "File condiviso";
var VIDEO_CALL$1 = "Videochiamata";
var AUDIO_CALL$1 = "Chiamata audio";
var LOADING$1 = "Caricamento...";
var REPLY$1 = "rispondere";
var REPLIES$1 = "risposte";
var AI$1 = "AI";
var SMART_REPLIES$1 = "Risposte intelligenti";
var CONVERSATION_STARTER$1 = "Avvio della conversazione";
var LAUNCH$1 = "Lanciare";
var SHARED_COLLABORATIVE_DOCUMENT$1 = "ha condiviso un documento collaborativo";
var SHARED_COLLABORATIVE_WHITEBOARD$1 = "ha condiviso una lavagna collaborativa";
var CREATED_WHITEBOARD$1 = "Hai creato una nuova lavagna collaborativa";
var CREATED_DOCUMENT$1 = "Hai creato un nuovo documento collaborativo";
var PHOTOS$1 = "Foto";
var VIDEOS$1 = "Video";
var DOCUMENT$1 = "Documento";
var YOU_DELETED_THIS_MESSAGE$1 = "⚠️ Hai eliminato questo messaggio";
var THIS_MESSAGE_DELETED$1 = "⚠️ Questo messaggio è stato eliminato";
var MESSAGE_IS_DELETED$1 = "Il messaggio è stato eliminato";
var VIEW_ON_YOUTUBE$1 = "Visualizza su Youtube";
var SEARCH$1 = "Cerca";
var NO_USERS_FOUND$1 = "Nessun utente trovato";
var ERROR$1 = "Errore";
var NO_GROUPS_FOUND$1 = "Nessun gruppo trovato";
var NO_CHATS_FOUND$1 = "Nessuna chat trovata";
var CANT__LOAD__CHATS$1 = "Impossibile caricare le chat";
var MEDIA_MESSAGE$1 = "Messaggio multimediale";
var INCOMING_AUDIO_CALL$1 = "Chiamata audio in arrivo";
var INCOMING_VIDEO_CALL$1 = "Videochiamata in arrivo";
var DECLINE$1 = "Declino";
var ACCEPT$1 = "Accetta";
var CALL_INITIATED$1 = "Chiamata avviata";
var OUTGOING_AUDIO_CALL$1 = "Chiamata audio in uscita";
var OUTGOING_VIDEO_CALL$1 = "Videochiamata in uscita";
var CALL_REJECTED$1 = "Chiamata rifiutata";
var REJECTED_CALL$1 = "chiamata rifiutata";
var CALL_ACCEPTED$1 = "Chiamata accettata";
var OUTGOING_CALL$1 = "Chiamata in uscita";
var INCOMING_CALL$1 = "Chiamata in arrivo";
var MISSED_CALL$1 = "Chiamata persa";
var JOINED$1 = "uniti";
var LEFT_THE_CALL$1 = "ha lasciato la chiamata";
var UNANSWERED_AUDIO_CALL$1 = "Chiamata audio senza risposta";
var UNANSWERED_VIDEO_CALL$1 = "Videochiamata senza risposta";
var CALL_ENDED$1 = "Chiamata terminata";
var CALL_CANCELLED$1 = "Chiamata annullata";
var CALL_BUSY$1 = "Chiamata occupata";
var CALLING$1 = "Chiamata...";
var ADD$1 = "Inserisci";
var NO_BANNED_MEMBERS_FOUND$1 = "Nessun membro bannato trovato";
var BANNED_MEMBERS$1 = "Membri esclusi";
var NAME$1 = "Nome";
var SCOPE$1 = "Ambito";
var UNBAN$1 = "Unban";
var SELECT_GROUP_TYPE$1 = "Seleziona il tipo di gruppo";
var ENTER_GROUP_PASSWORD$1 = "Inserisci la password del gruppo";
var CREATE$1 = "Crea";
var CREATE_POLL$1 = "Crea sondaggio";
var QUESTION$1 = "Domanda";
var ENTER_YOUR_QUESTION$1 = "Inserisci la tua domanda";
var OPTIONS$1 = "Opzioni";
var ENTER_YOUR_OPTION$1 = "Inserisci la tua opzione";
var ADD_NEW_OPTION$1 = "Aggiungi nuova opzione";
var VIEW_MEMBERS$1 = "Visualizza i membri";
var DETAILS$1 = "Dettagli";
var NOTIFICATIONS$1 = "Notifiche";
var OTHER$1 = "Altro";
var HELP$1 = "Aiuto";
var REPORT_PROBLEM$1 = "Segnalare un problema";
var GROUP_MEMBERS$1 = "Membri del gruppo";
var BAN$1 = "Divieto";
var KICK$1 = "Calciare";
var PICK_YOUR_EMOJI$1 = "Scegli la tua emoji";
var PRIVATE_GROUP$1 = "Gruppo privato";
var PROTECTED_GROUP$1 = "Gruppo protetto";
var VISIT$1 = "Visita";
var ATTACH$1 = "Allega";
var OPEN_WHITEBOARD$1 = "Apri lavagna";
var ATTACH_FILE$1 = "Allega file";
var GENERATING_REPLIES$1 = "Generazione di risposte";
var ATTACH_VIDEO$1 = "Allega video";
var ATTACH_AUDIO$1 = "Allega audio";
var ATTACH_IMAGE$1 = "Allega immagine";
var COLLABORATE_USING_DOCUMENT$1 = "Collabora utilizzando un documento";
var COLLABORATE_USING_WHITEBOARD$1 = "Collabora utilizzando una lavagna";
var SUGGEST_A_REPLY$1 = "Suggerisci una risposta";
var GENERATING_ICEBREAKERS$1 = "Generazione di rompighiaccio";
var EMOJI$1 = "emoji";
var NO_REPLIES_FOUND$1 = "Nessuna risposta trovata";
var ENTER_YOUR_MESSAGE_HERE$1 = "Inserisci qui il tuo messaggio";
var NO_MESSAGES_FOUND$1 = "Nessun messaggio trovato";
var THREAD$1 = "Discussione";
var COLLABORATIVE_DOCUMENT$1 = "Documento collaborativo";
var COLLABORATIVE_WHITEBOARD$1 = "Lavagna collaborativa";
var ADD_REACTION$1 = "Aggiungi reazione";
var NO_STICKERS_FOUND$1 = "Nessun adesivo trovato";
var REPLY_TO_THREAD$1 = "Rispondi al thread";
var REPLY_IN_THREAD$1 = "Rispondi nel thread";
var VIEW$1 = "Visualizza";
var DELETE_MESSAGE$1 = "Elimina messaggio";
var EDIT_MESSAGE$1 = "Modifica messaggio";
var OWNER$1 = "Proprietario";
var CHANGE_SCOPE$1 = "Ambito di modifica";
var STICKER$1 = "Adesivo";
var LAST_ACTIVE_AT$1 = "Ultimo attivo a";
var VOICE_CALL$1 = "Chiamata vocale";
var VIEW_DETAIL$1 = "Visualizza dettagli";
var VOTES$1 = "voti";
var VOTE$1 = "voto";
var NO_VOTE$1 = "Nessun voto";
var REACTED$1 = "reagito";
var ADDED$1 = "aggiunto";
var SHOW_UNSAFE_CONTENT$1 = "Sei sicuro di voler vedere contenuti non sicuri?";
var REACT_TO_MESSAGE$1 = "Reagire a un messaggio";
var UNBANNED$1 = "sbandato";
var MADE$1 = "fatto";
var CALL_UNANSWERED$1 = "Chiamata senza risposta";
var MISSED_AUDIO_CALL$1 = "Chiamata audio persa";
var ENTER_YOUR_PASSWORD$1 = "Inserisci la tua password";
var DRAW_DOCUMENT_TOGETHER$1 = "Apri il documento per modificare i contenuti insieme";
var DOCS$1 = "Documenti";
var NO_RECORDS_FOUND$1 = "Nessun record trovato";
var LIVE_REACTION$1 = "Reazione dal vivo";
var SMILEY_PEOPLE$1 = "Smiley e persone";
var DRAW_WHITEBOARD_TOGETHER$1 = "Apri la lavagna per disegnare insieme";
var ANIMALES_NATURE$1 = "Animali e natura";
var FOOD_DRINK$1 = "Cibi e bevande";
var OPEN_DOCUMENT$1 = "Apri documento";
var ACTIVITY$1 = "Attività";
var TRAVEL_PLACES$1 = "Viaggi e luoghi";
var OBJECTS$1 = "Oggetti";
var SYMBOLS$1 = "Simboli";
var FLAGS$1 = "Bandiere";
var SENT$1 = "Inviato";
var SEEN$1 = "Visto";
var DELIVERED$1 = "Consegnato";
var READ$1 = "Leggi";
var MESSAGE_INFORMATION$1 = "Informazioni sui messaggi";
var TRANSLATE_MESSAGE$1 = "Traduci messaggio";
var TRANSLATED_MESSAGE$1 = "Messaggio tradotto";
var LEFT$1 = "sinistra";
var KICKED$1 = "calciato";
var BANNED$1 = "vietato";
var NEW_MESSAGES$1 = "nuovi messaggi";
var NEW_MESSAGE$1 = "nuovo messaggio";
var JUMP$1 = "Salta";
var SELECT_VIDEO_SOURCE$1 = "Seleziona la sorgente video";
var SELECT_INPUT_AUDIO_SOURCE$1 = "Seleziona la sorgente audio in ingresso";
var SELECT_OUTPUT_AUDIO_SOURCE$1 = "Seleziona la sorgente audio di uscita";
var INITIATED_GROUP_CALL$1 = "ha avviato una chiamata di gruppo";
var YOU_INITIATED_GROUP_CALL$1 = "Hai avviato una chiamata di gruppo";
var IGNORE$1 = "Ignora";
var ON_ANOTHER_CALL$1 = "è in un'altra chiamata";
var CREATING$1 = "Creando";
var AVATAR$1 = "Avatar";
var ONGOING_CALL$1 = "Chiamata in corso";
var YOU_ALREADY_ONGOING_CALL$1 = "È già in corso una chiamata";
var RESIZE$1 = "Ridimensiona";
var SETTINGS$1 = "Impostazioni";
var ACTIONS$1 = "Azioni";
var VIEW_PROFILE$1 = "Visualizza profilo";
var SEND_MESSAGE_IN_PRIVATE$1 = "Invia un messaggio in privato";
var DELETE$1 = "Elimina";
var DELETE_CONFIRM$1 = "Sei sicuro di volerlo eliminare?";
var CANCEL$1 = "Annulla";
var LEAVE_CONFIRM$1 = "Sei sicuro di voler lasciare il gruppo?";
var TRANSFER_CONFIRM$1 = "Sei il proprietario del gruppo; trasferisci la proprietà a un membro prima di lasciare il gruppo";
var ADDING$1 = "Aggiungendo...";
var TRANSFER$1 = "Trasferimento";
var TRANSFER_OWNERSHIP$1 = "Trasferisci la proprietà";
var TRANSFERRING$1 = "Trasferimento";
var YES$1 = "sì";
var NO$1 = "No";
var ANSWER$1 = "Risposta";
var ADD_ANOTHER_ANSWER$1 = "Aggiungi un'altra risposta";
var SET_THE_ANSWERS$1 = "IMPOSTA LE RISPOSTE";
var TRY_AGAIN$1 = "Riprova";
var INVALID_GROUP_NAME$1 = "Inserisci un nome valido per il gruppo e riprova";
var INVALID_PASSWORD$1 = "Inserisci una password valida per il gruppo e riprova";
var INVALID_GROUP_TYPE$1 = "Inserisci un tipo valido per il gruppo e riprova";
var WRONG_PASSWORD$1 = "Inserisci la password corretta e riprova";
var INVALID_POLL_QUESTION$1 = "Inserisci la domanda richiesta prima di creare un sondaggio";
var INVALID_POLL_OPTION$1 = "Inserisci la risposta richiesta prima di creare un sondaggio";
var SAME_LANGUAGE_MESSAGE$1 = "La lingua selezionata per la traduzione è simile alla lingua del messaggio originale";
var LEAVE$1 = "Lasciare";
var CLICK_TO_START_CONVERSATION$1 = "Fai clic per iniziare la conversazione";
var CUSTOM_MESSAGE_LOCATION$1 = "📍 Posizione";
var SHARED_LOCATION$1 = "Posizione condivisa";
var IN_A_THREAD$1 = "In un thread";
var CALLS$1 = "Chiamate";
var CALL_DETAILS$1 = "Dettagli della chiamata";
var OFFLINE$1 = "Offline";
var POLLS$1 = "Sondaggi";
var YOU$1 = "Tu";
var PRIVACY$1 = "Privacy";
var BLOCKED_USERS$1 = "Utenti bloccati";
var NO_PHOTOS$1 = "Nessuna foto";
var NO_VIDEOS$1 = "Nessun video";
var NO_DOCUMENTS$1 = "Nessun documento";
var JOIN$1 = "Unisciti";
var REMOVE$1 = "Rimuovi";
var BLOCK$1 = "Blocca";
var CHANGE_ROLE$1 = "Cambia ruolo";
var NEW_CHAT$1 = "Nuova chat";
var FORM_COMPLETION_MESSAGE$1 = "Grazie per aver compilato il modulo.";
var HISTORY$1 = "Storia";
var CANCELLED_AUDIO_CALL$1 = "Chiamata audio annullata";
var CANCELLED_VIDEO_CALL$1 = "Videochiamata annullata";
var REJECTED_AUDIO_CALL$1 = "Chiamata audio rifiutata";
var REJECTED_VIDEO_CALL$1 = "Videochiamata rifiutata";
var CANCELLED_CALL$1 = "Chiamata annullata";
var UNANSWERED_CALL$1 = "Chiamata senza risposta";
var RECORDING$1 = "Registrazione";
var PARTICIPANTS$1 = "Partecipanti";
var CALL_HISTORY$1 = "Cronologia chiamate";
var NO_CALLS_FOUND$1 = "Nessuna chiamata trovata";
var ONGOING_AUDIO_CALL$1 = "Chiamata audio in corso";
var ONGOING_VIDEO_CALL$1 = "Videochiamata in corso";
var CALL_DETAIL$1 = "Dettagli della chiamata";
var FORM$1 = "Modulo";
var CARD$1 = "Carta";
var GENERATING_SUMMARY$1 = "Generazione del riassunto";
var CONVERSATION_SUMMARY$1 = "Riepilogo della conversazione";
var GENERATE_SUMMARY$1 = "Genera un riepilogo";
var COMETCHAT_BOT_FIRST_MESSAGE$1 = "Come posso aiutarti in questa conversazione? Per favore, fammi una domanda e ti consiglierò 🙂";
var COMETCHAT_ASK_BOT$1 = "Chiedere";
var COMETCHAT_ASK_AI_BOT$1 = "Chiedi ai bot AI";
var COMETCHAT_ASK_BOT_SUBTITLE$1 = "Bot AI";
var MENTIONS_LIMIT_WARNING_MESSAGE$1 = "Puoi menzionare fino a 10 volte alla volta.";
var ALL$1 = "Tutti";
var CLICK_TO_REMOVE$1 = "Fai clic per rimuovere";
var OTHERS$1 = "altri";
var AND$1 = "un";
var translationLT = {
	INFO: INFO$1,
	REACT: REACT$1,
	EDIT: EDIT$1,
	MESSAGE_PRIVATELY: MESSAGE_PRIVATELY$1,
	TRANSLATE: TRANSLATE$1,
	USERS: USERS$1,
	CHATS: CHATS$1,
	WOULD__YOU_LIKE_TO_DELETE_THIS_CONVERSATION: WOULD__YOU_LIKE_TO_DELETE_THIS_CONVERSATION$1,
	GROUPS: GROUPS$1,
	SHARED: SHARED$1,
	SOUND_MANAGER: SOUND_MANAGER$1,
	THEME: THEME$1,
	LOCALIZE: LOCALIZE$1,
	CONVERSATION_LIST_ITEM: CONVERSATION_LIST_ITEM$1,
	DATA_ITEM: DATA_ITEM$1,
	STATUS_INDICATOR: STATUS_INDICATOR$1,
	BADGE_COUNT: BADGE_COUNT$1,
	MESSAGE_RECEIPT: MESSAGE_RECEIPT$1,
	MESSAGE: MESSAGE$1,
	RECEIPT_INFORMATION: RECEIPT_INFORMATION$1,
	NO_RECIPIENT: NO_RECIPIENT$1,
	NO_RECIPIENTS: NO_RECIPIENTS$1,
	CONVERSATIONS_WITH_MESSAGES: CONVERSATIONS_WITH_MESSAGES$1,
	CONVERSATIONS: CONVERSATIONS$1,
	CONVERSATION_LIST: CONVERSATION_LIST$1,
	MESSAGES: MESSAGES$1,
	MESSAGE_HEADER: MESSAGE_HEADER$1,
	MESSAGE_LIST: MESSAGE_LIST$1,
	MESSAGE_COMPOSER: MESSAGE_COMPOSER$1,
	USERS_WITH_MESSAGES: USERS_WITH_MESSAGES$1,
	USER_LIST: USER_LIST$1,
	GROUP_LIST: GROUP_LIST$1,
	GROUPS_WITH_MESSAGES: GROUPS_WITH_MESSAGES$1,
	NEW__GROUP: NEW__GROUP$1,
	PASSWORD: PASSWORD$1,
	CONTINUE: CONTINUE$1,
	NO_CHATS_SELECTED: NO_CHATS_SELECTED$1,
	NO_USERS_SELECTED: NO_USERS_SELECTED$1,
	NO_GROUPS_SELECTED: NO_GROUPS_SELECTED$1,
	SELECT_DAY: SELECT_DAY$1,
	SELECT_TIME: SELECT_TIME$1,
	NO_CALLS_SELECTED: NO_CALLS_SELECTED$1,
	SELECT__GROUP: SELECT__GROUP$1,
	SELECT__USER: SELECT__USER$1,
	GROUP_PASSWORD_BLANK: GROUP_PASSWORD_BLANK$1,
	GROUP_NAME_BLANK: GROUP_NAME_BLANK$1,
	GROUP_TYPE_BLANK: GROUP_TYPE_BLANK$1,
	DELETE_CONVERSATION: DELETE_CONVERSATION$1,
	ADD_TO_CHAT: ADD_TO_CHAT$1,
	MORE: MORE$1,
	COPY: COPY$1,
	VOICE_RECORDING: VOICE_RECORDING$1,
	MESSAGE_IMAGE: MESSAGE_IMAGE$1,
	MESSAGE_FILE: MESSAGE_FILE$1,
	MESSAGE_VIDEO: MESSAGE_VIDEO$1,
	MESSAGE_AUDIO: MESSAGE_AUDIO$1,
	CUSTOM_MESSAGE: CUSTOM_MESSAGE$1,
	SELECT_A_DATE: SELECT_A_DATE$1,
	TIME_ZONE: TIME_ZONE$1,
	MEETING_SCHEDULED: MEETING_SCHEDULED$1,
	SOMETHING_WRONG: SOMETHING_WRONG$1,
	MEETING_SLOT_BOOK: MEETING_SLOT_BOOK$1,
	MEETING_BOOK_NEW_SLOT: MEETING_BOOK_NEW_SLOT$1,
	MEETING_NO_SLOTS_AVAILABLE: MEETING_NO_SLOTS_AVAILABLE$1,
	MEETING_TRY_DIFFERENT_DATE: MEETING_TRY_DIFFERENT_DATE$1,
	NO_TIME_SLOTS_AVAILABLE: NO_TIME_SLOTS_AVAILABLE$1,
	SCHEDULE: SCHEDULE$1,
	MORE_TIMES: MORE_TIMES$1,
	MISSED_VOICE_CALL: MISSED_VOICE_CALL$1,
	MEET_WITH: MEET_WITH$1,
	MEETING_SCHEDULER: MEETING_SCHEDULER$1,
	MISSED_VIDEO_CALL: MISSED_VIDEO_CALL$1,
	CUSTOM_MESSAGE_POLL: CUSTOM_MESSAGE_POLL$1,
	CUSTOM_MESSAGE_STICKER: CUSTOM_MESSAGE_STICKER$1,
	CUSTOM_MESSAGE_DOCUMENT: CUSTOM_MESSAGE_DOCUMENT$1,
	CUSTOM_MESSAGE_WHITEBOARD: CUSTOM_MESSAGE_WHITEBOARD$1,
	ONLINE: ONLINE$1,
	ADMINISTRATOR: ADMINISTRATOR$1,
	ADMIN: ADMIN$1,
	MODERATOR: MODERATOR$1,
	PARTICIPANT: PARTICIPANT$1,
	PUBLIC: PUBLIC$1,
	PRIVATE: PRIVATE$1,
	PASSWORD_PROTECTED: PASSWORD_PROTECTED$1,
	PRIVACY_AND_SECURITY: PRIVACY_AND_SECURITY$1,
	PREFERENCES: PREFERENCES$1,
	MEMBERS: MEMBERS$1,
	MEMBER: MEMBER$1,
	TODAY: TODAY$1,
	YESTERDAY: YESTERDAY$1,
	SUNDAY: SUNDAY$1,
	MONDAY: MONDAY$1,
	TUESDAY: TUESDAY$1,
	WEDNESDAY: WEDNESDAY$1,
	THURSDAY: THURSDAY$1,
	FRIDAY: FRIDAY$1,
	SATURDAY: SATURDAY$1,
	TYPING: TYPING$1,
	IS_TYPING: IS_TYPING$1,
	CLOSE: CLOSE$1,
	ENTER_GROUP_NAME: ENTER_GROUP_NAME$1,
	ADD_MEMBERS: ADD_MEMBERS$1,
	SEND_MESSAGE: SEND_MESSAGE$1,
	UNBLOCK_USER: UNBLOCK_USER$1,
	BLOCK_USER: BLOCK_USER$1,
	DELETE_AND_EXIT: DELETE_AND_EXIT$1,
	LEAVE_GROUP: LEAVE_GROUP$1,
	CREATE_GROUP: CREATE_GROUP$1,
	SHARED_MEDIA: SHARED_MEDIA$1,
	SHARED_FILE: SHARED_FILE$1,
	VIDEO_CALL: VIDEO_CALL$1,
	AUDIO_CALL: AUDIO_CALL$1,
	LOADING: LOADING$1,
	REPLY: REPLY$1,
	REPLIES: REPLIES$1,
	AI: AI$1,
	SMART_REPLIES: SMART_REPLIES$1,
	CONVERSATION_STARTER: CONVERSATION_STARTER$1,
	LAUNCH: LAUNCH$1,
	SHARED_COLLABORATIVE_DOCUMENT: SHARED_COLLABORATIVE_DOCUMENT$1,
	SHARED_COLLABORATIVE_WHITEBOARD: SHARED_COLLABORATIVE_WHITEBOARD$1,
	CREATED_WHITEBOARD: CREATED_WHITEBOARD$1,
	CREATED_DOCUMENT: CREATED_DOCUMENT$1,
	PHOTOS: PHOTOS$1,
	VIDEOS: VIDEOS$1,
	DOCUMENT: DOCUMENT$1,
	YOU_DELETED_THIS_MESSAGE: YOU_DELETED_THIS_MESSAGE$1,
	THIS_MESSAGE_DELETED: THIS_MESSAGE_DELETED$1,
	MESSAGE_IS_DELETED: MESSAGE_IS_DELETED$1,
	VIEW_ON_YOUTUBE: VIEW_ON_YOUTUBE$1,
	SEARCH: SEARCH$1,
	NO_USERS_FOUND: NO_USERS_FOUND$1,
	ERROR: ERROR$1,
	NO_GROUPS_FOUND: NO_GROUPS_FOUND$1,
	NO_CHATS_FOUND: NO_CHATS_FOUND$1,
	CANT__LOAD__CHATS: CANT__LOAD__CHATS$1,
	MEDIA_MESSAGE: MEDIA_MESSAGE$1,
	INCOMING_AUDIO_CALL: INCOMING_AUDIO_CALL$1,
	INCOMING_VIDEO_CALL: INCOMING_VIDEO_CALL$1,
	DECLINE: DECLINE$1,
	ACCEPT: ACCEPT$1,
	CALL_INITIATED: CALL_INITIATED$1,
	OUTGOING_AUDIO_CALL: OUTGOING_AUDIO_CALL$1,
	OUTGOING_VIDEO_CALL: OUTGOING_VIDEO_CALL$1,
	CALL_REJECTED: CALL_REJECTED$1,
	REJECTED_CALL: REJECTED_CALL$1,
	CALL_ACCEPTED: CALL_ACCEPTED$1,
	OUTGOING_CALL: OUTGOING_CALL$1,
	INCOMING_CALL: INCOMING_CALL$1,
	MISSED_CALL: MISSED_CALL$1,
	JOINED: JOINED$1,
	LEFT_THE_CALL: LEFT_THE_CALL$1,
	UNANSWERED_AUDIO_CALL: UNANSWERED_AUDIO_CALL$1,
	UNANSWERED_VIDEO_CALL: UNANSWERED_VIDEO_CALL$1,
	CALL_ENDED: CALL_ENDED$1,
	CALL_CANCELLED: CALL_CANCELLED$1,
	CALL_BUSY: CALL_BUSY$1,
	CALLING: CALLING$1,
	ADD: ADD$1,
	NO_BANNED_MEMBERS_FOUND: NO_BANNED_MEMBERS_FOUND$1,
	BANNED_MEMBERS: BANNED_MEMBERS$1,
	NAME: NAME$1,
	SCOPE: SCOPE$1,
	UNBAN: UNBAN$1,
	SELECT_GROUP_TYPE: SELECT_GROUP_TYPE$1,
	ENTER_GROUP_PASSWORD: ENTER_GROUP_PASSWORD$1,
	CREATE: CREATE$1,
	CREATE_POLL: CREATE_POLL$1,
	QUESTION: QUESTION$1,
	ENTER_YOUR_QUESTION: ENTER_YOUR_QUESTION$1,
	OPTIONS: OPTIONS$1,
	ENTER_YOUR_OPTION: ENTER_YOUR_OPTION$1,
	ADD_NEW_OPTION: ADD_NEW_OPTION$1,
	VIEW_MEMBERS: VIEW_MEMBERS$1,
	DETAILS: DETAILS$1,
	NOTIFICATIONS: NOTIFICATIONS$1,
	OTHER: OTHER$1,
	HELP: HELP$1,
	REPORT_PROBLEM: REPORT_PROBLEM$1,
	GROUP_MEMBERS: GROUP_MEMBERS$1,
	BAN: BAN$1,
	KICK: KICK$1,
	PICK_YOUR_EMOJI: PICK_YOUR_EMOJI$1,
	PRIVATE_GROUP: PRIVATE_GROUP$1,
	PROTECTED_GROUP: PROTECTED_GROUP$1,
	VISIT: VISIT$1,
	ATTACH: ATTACH$1,
	OPEN_WHITEBOARD: OPEN_WHITEBOARD$1,
	ATTACH_FILE: ATTACH_FILE$1,
	GENERATING_REPLIES: GENERATING_REPLIES$1,
	ATTACH_VIDEO: ATTACH_VIDEO$1,
	ATTACH_AUDIO: ATTACH_AUDIO$1,
	ATTACH_IMAGE: ATTACH_IMAGE$1,
	COLLABORATE_USING_DOCUMENT: COLLABORATE_USING_DOCUMENT$1,
	COLLABORATE_USING_WHITEBOARD: COLLABORATE_USING_WHITEBOARD$1,
	SUGGEST_A_REPLY: SUGGEST_A_REPLY$1,
	GENERATING_ICEBREAKERS: GENERATING_ICEBREAKERS$1,
	EMOJI: EMOJI$1,
	NO_REPLIES_FOUND: NO_REPLIES_FOUND$1,
	ENTER_YOUR_MESSAGE_HERE: ENTER_YOUR_MESSAGE_HERE$1,
	NO_MESSAGES_FOUND: NO_MESSAGES_FOUND$1,
	THREAD: THREAD$1,
	COLLABORATIVE_DOCUMENT: COLLABORATIVE_DOCUMENT$1,
	COLLABORATIVE_WHITEBOARD: COLLABORATIVE_WHITEBOARD$1,
	ADD_REACTION: ADD_REACTION$1,
	NO_STICKERS_FOUND: NO_STICKERS_FOUND$1,
	REPLY_TO_THREAD: REPLY_TO_THREAD$1,
	REPLY_IN_THREAD: REPLY_IN_THREAD$1,
	VIEW: VIEW$1,
	DELETE_MESSAGE: DELETE_MESSAGE$1,
	EDIT_MESSAGE: EDIT_MESSAGE$1,
	OWNER: OWNER$1,
	CHANGE_SCOPE: CHANGE_SCOPE$1,
	STICKER: STICKER$1,
	LAST_ACTIVE_AT: LAST_ACTIVE_AT$1,
	VOICE_CALL: VOICE_CALL$1,
	VIEW_DETAIL: VIEW_DETAIL$1,
	VOTES: VOTES$1,
	VOTE: VOTE$1,
	NO_VOTE: NO_VOTE$1,
	REACTED: REACTED$1,
	ADDED: ADDED$1,
	SHOW_UNSAFE_CONTENT: SHOW_UNSAFE_CONTENT$1,
	REACT_TO_MESSAGE: REACT_TO_MESSAGE$1,
	UNBANNED: UNBANNED$1,
	MADE: MADE$1,
	CALL_UNANSWERED: CALL_UNANSWERED$1,
	MISSED_AUDIO_CALL: MISSED_AUDIO_CALL$1,
	ENTER_YOUR_PASSWORD: ENTER_YOUR_PASSWORD$1,
	DRAW_DOCUMENT_TOGETHER: DRAW_DOCUMENT_TOGETHER$1,
	DOCS: DOCS$1,
	NO_RECORDS_FOUND: NO_RECORDS_FOUND$1,
	LIVE_REACTION: LIVE_REACTION$1,
	SMILEY_PEOPLE: SMILEY_PEOPLE$1,
	DRAW_WHITEBOARD_TOGETHER: DRAW_WHITEBOARD_TOGETHER$1,
	ANIMALES_NATURE: ANIMALES_NATURE$1,
	FOOD_DRINK: FOOD_DRINK$1,
	OPEN_DOCUMENT: OPEN_DOCUMENT$1,
	ACTIVITY: ACTIVITY$1,
	TRAVEL_PLACES: TRAVEL_PLACES$1,
	OBJECTS: OBJECTS$1,
	SYMBOLS: SYMBOLS$1,
	FLAGS: FLAGS$1,
	SENT: SENT$1,
	SEEN: SEEN$1,
	DELIVERED: DELIVERED$1,
	READ: READ$1,
	MESSAGE_INFORMATION: MESSAGE_INFORMATION$1,
	TRANSLATE_MESSAGE: TRANSLATE_MESSAGE$1,
	TRANSLATED_MESSAGE: TRANSLATED_MESSAGE$1,
	LEFT: LEFT$1,
	KICKED: KICKED$1,
	BANNED: BANNED$1,
	NEW_MESSAGES: NEW_MESSAGES$1,
	NEW_MESSAGE: NEW_MESSAGE$1,
	JUMP: JUMP$1,
	SELECT_VIDEO_SOURCE: SELECT_VIDEO_SOURCE$1,
	SELECT_INPUT_AUDIO_SOURCE: SELECT_INPUT_AUDIO_SOURCE$1,
	SELECT_OUTPUT_AUDIO_SOURCE: SELECT_OUTPUT_AUDIO_SOURCE$1,
	INITIATED_GROUP_CALL: INITIATED_GROUP_CALL$1,
	YOU_INITIATED_GROUP_CALL: YOU_INITIATED_GROUP_CALL$1,
	IGNORE: IGNORE$1,
	ON_ANOTHER_CALL: ON_ANOTHER_CALL$1,
	CREATING: CREATING$1,
	AVATAR: AVATAR$1,
	ONGOING_CALL: ONGOING_CALL$1,
	YOU_ALREADY_ONGOING_CALL: YOU_ALREADY_ONGOING_CALL$1,
	RESIZE: RESIZE$1,
	SETTINGS: SETTINGS$1,
	ACTIONS: ACTIONS$1,
	VIEW_PROFILE: VIEW_PROFILE$1,
	SEND_MESSAGE_IN_PRIVATE: SEND_MESSAGE_IN_PRIVATE$1,
	DELETE: DELETE$1,
	DELETE_CONFIRM: DELETE_CONFIRM$1,
	CANCEL: CANCEL$1,
	LEAVE_CONFIRM: LEAVE_CONFIRM$1,
	TRANSFER_CONFIRM: TRANSFER_CONFIRM$1,
	ADDING: ADDING$1,
	TRANSFER: TRANSFER$1,
	TRANSFER_OWNERSHIP: TRANSFER_OWNERSHIP$1,
	TRANSFERRING: TRANSFERRING$1,
	YES: YES$1,
	NO: NO$1,
	ANSWER: ANSWER$1,
	ADD_ANOTHER_ANSWER: ADD_ANOTHER_ANSWER$1,
	SET_THE_ANSWERS: SET_THE_ANSWERS$1,
	TRY_AGAIN: TRY_AGAIN$1,
	INVALID_GROUP_NAME: INVALID_GROUP_NAME$1,
	INVALID_PASSWORD: INVALID_PASSWORD$1,
	INVALID_GROUP_TYPE: INVALID_GROUP_TYPE$1,
	WRONG_PASSWORD: WRONG_PASSWORD$1,
	INVALID_POLL_QUESTION: INVALID_POLL_QUESTION$1,
	INVALID_POLL_OPTION: INVALID_POLL_OPTION$1,
	SAME_LANGUAGE_MESSAGE: SAME_LANGUAGE_MESSAGE$1,
	LEAVE: LEAVE$1,
	CLICK_TO_START_CONVERSATION: CLICK_TO_START_CONVERSATION$1,
	CUSTOM_MESSAGE_LOCATION: CUSTOM_MESSAGE_LOCATION$1,
	SHARED_LOCATION: SHARED_LOCATION$1,
	IN_A_THREAD: IN_A_THREAD$1,
	CALLS: CALLS$1,
	CALL_DETAILS: CALL_DETAILS$1,
	OFFLINE: OFFLINE$1,
	POLLS: POLLS$1,
	YOU: YOU$1,
	PRIVACY: PRIVACY$1,
	BLOCKED_USERS: BLOCKED_USERS$1,
	"YOU'VE_BLOCKED": "Hai bloccato",
	NO_PHOTOS: NO_PHOTOS$1,
	NO_VIDEOS: NO_VIDEOS$1,
	NO_DOCUMENTS: NO_DOCUMENTS$1,
	JOIN: JOIN$1,
	REMOVE: REMOVE$1,
	BLOCK: BLOCK$1,
	CHANGE_ROLE: CHANGE_ROLE$1,
	NEW_CHAT: NEW_CHAT$1,
	FORM_COMPLETION_MESSAGE: FORM_COMPLETION_MESSAGE$1,
	HISTORY: HISTORY$1,
	CANCELLED_AUDIO_CALL: CANCELLED_AUDIO_CALL$1,
	CANCELLED_VIDEO_CALL: CANCELLED_VIDEO_CALL$1,
	REJECTED_AUDIO_CALL: REJECTED_AUDIO_CALL$1,
	REJECTED_VIDEO_CALL: REJECTED_VIDEO_CALL$1,
	CANCELLED_CALL: CANCELLED_CALL$1,
	UNANSWERED_CALL: UNANSWERED_CALL$1,
	RECORDING: RECORDING$1,
	PARTICIPANTS: PARTICIPANTS$1,
	CALL_HISTORY: CALL_HISTORY$1,
	NO_CALLS_FOUND: NO_CALLS_FOUND$1,
	ONGOING_AUDIO_CALL: ONGOING_AUDIO_CALL$1,
	ONGOING_VIDEO_CALL: ONGOING_VIDEO_CALL$1,
	CALL_DETAIL: CALL_DETAIL$1,
	FORM: FORM$1,
	CARD: CARD$1,
	GENERATING_SUMMARY: GENERATING_SUMMARY$1,
	CONVERSATION_SUMMARY: CONVERSATION_SUMMARY$1,
	GENERATE_SUMMARY: GENERATE_SUMMARY$1,
	COMETCHAT_BOT_FIRST_MESSAGE: COMETCHAT_BOT_FIRST_MESSAGE$1,
	COMETCHAT_ASK_BOT: COMETCHAT_ASK_BOT$1,
	COMETCHAT_ASK_AI_BOT: COMETCHAT_ASK_AI_BOT$1,
	COMETCHAT_ASK_BOT_SUBTITLE: COMETCHAT_ASK_BOT_SUBTITLE$1,
	MENTIONS_LIMIT_WARNING_MESSAGE: MENTIONS_LIMIT_WARNING_MESSAGE$1,
	ALL: ALL$1,
	CLICK_TO_REMOVE: CLICK_TO_REMOVE$1,
	OTHERS: OTHERS$1,
	AND: AND$1
};

var INFO = "Információ";
var REACT = "Reagáljon";
var EDIT = "Szerkesztés";
var MESSAGE_PRIVATELY = "Privát üzenet";
var TRANSLATE = "Fordítás";
var USERS = "Felhasználók";
var CHATS = "Beszélgetések";
var WOULD__YOU_LIKE_TO_DELETE_THIS_CONVERSATION = "Szeretné törölni ezt a beszélgetést? Ez a beszélgetés törlődik az összes eszközéről.";
var GROUPS = "Csoportok";
var SHARED = "Megosztott";
var SOUND_MANAGER = "Hangkezelő";
var THEME = "Téma";
var LOCALIZE = "Lokalizálás";
var CONVERSATION_LIST_ITEM = "Beszélgetési lista elem";
var DATA_ITEM = "Adatelem";
var STATUS_INDICATOR = "Állapotjelző";
var BADGE_COUNT = "Jelvény száma";
var MESSAGE_RECEIPT = "Üzenet átvétele";
var MESSAGE = "Üzenet";
var RECEIPT_INFORMATION = "Átvételi információk";
var NO_RECIPIENT = "Nincs címzett";
var NO_RECIPIENTS = "Nincsenek címzettek";
var CONVERSATIONS_WITH_MESSAGES = "Beszélgetések üzenetekkel";
var CONVERSATIONS = "Beszélgetések";
var CONVERSATION_LIST = "Beszélgetési lista";
var MESSAGES = "Üzenetek";
var MESSAGE_HEADER = "Üzenet fejléc";
var MESSAGE_LIST = "Üzenetek listája";
var MESSAGE_COMPOSER = "Üzenet zeneszerző";
var USERS_WITH_MESSAGES = "Üzenetekkel rendelkező felhasználók";
var USER_LIST = "Felhasználói lista";
var GROUP_LIST = "Csoportlista";
var GROUPS_WITH_MESSAGES = "Csoportok üzenetekkel";
var NEW__GROUP = "Új csoport";
var PASSWORD = "Jelszó";
var CONTINUE = "Folytatás";
var NO_CHATS_SELECTED = "Nincs kiválasztott csevegés";
var NO_USERS_SELECTED = "Nincs kiválasztott felhasználó";
var NO_GROUPS_SELECTED = "Nincs kiválasztott csoport";
var SELECT_DAY = "Válasszon egy napot";
var SELECT_TIME = "Válasszon egy időt";
var NO_CALLS_SELECTED = "Nincs kiválasztott hívás";
var SELECT__GROUP = "Válasszon ki egy csoportot az üzenetküldés elindításához";
var SELECT__USER = "Válasszon ki egy felhasználót az üzenetküldés elindításához";
var GROUP_PASSWORD_BLANK = "A csoport jelszava nem lehet üres";
var GROUP_NAME_BLANK = "A csoport neve nem lehet üres";
var GROUP_TYPE_BLANK = "A csoport típusa nem lehet üres";
var DELETE_CONVERSATION = "Beszélgetés törlése?";
var ADD_TO_CHAT = "Hozzáadás a csevegéshez";
var MORE = "Több";
var COPY = "Másolás";
var VOICE_RECORDING = "Hangfelvétel";
var MESSAGE_IMAGE = "📷 Kép";
var MESSAGE_FILE = "📁 Fájl";
var MESSAGE_VIDEO = "📹 Videó";
var MESSAGE_AUDIO = "🎵 Hang";
var CUSTOM_MESSAGE = "Van egy üzeneted";
var SELECT_A_DATE = "Válasszon egy dátumot";
var TIME_ZONE = "Időzóna";
var MEETING_SCHEDULED = "A találkozót már ütemeztük.";
var SOMETHING_WRONG = "Valami rosszul ment. Kérjük, próbálkozzon újra.";
var MEETING_SLOT_BOOK = "Az időhely már nem érhető el. Kérjük, válasszon másikat.";
var MEETING_BOOK_NEW_SLOT = "Foglaljon új nyerőgépet";
var MEETING_NO_SLOTS_AVAILABLE = "Erre a dátumra nincs időszint. Kérjük, próbálkozzon egy másik dátumot.";
var MEETING_TRY_DIFFERENT_DATE = "Próbáljon meg egy másik dátumot.";
var NO_TIME_SLOTS_AVAILABLE = "Nincsenek rendelkezésre álló időpontok";
var SCHEDULE = "Menetrend";
var MORE_TIMES = "Több alkalommal";
var MISSED_VOICE_CALL = "Hiányzott hanghívás";
var MEET_WITH = "Találkozz";
var MEETING_SCHEDULER = "Találkozó ütemező";
var MISSED_VIDEO_CALL = "Elmulasztott videohívás";
var CUSTOM_MESSAGE_POLL = "📊 Szavazás";
var CUSTOM_MESSAGE_STICKER = "💟 Matrica";
var CUSTOM_MESSAGE_DOCUMENT = "📃 Dokumentum";
var CUSTOM_MESSAGE_WHITEBOARD = "📝 Tábla";
var ONLINE = "Online";
var ADMINISTRATOR = "Rendszergazda";
var ADMIN = "Rendszergazda";
var MODERATOR = "Előadó";
var PARTICIPANT = "Résztvevő";
var PUBLIC = "Nyilvános";
var PRIVATE = "Privát";
var PASSWORD_PROTECTED = "Jelszóval védett";
var PRIVACY_AND_SECURITY = "Adatvédelem és biztonság";
var PREFERENCES = "Beállítások";
var MEMBERS = "Tagok";
var MEMBER = "Tagja";
var TODAY = "Ma";
var YESTERDAY = "Tegnap";
var SUNDAY = "Vasárnap";
var MONDAY = "Hétfő";
var TUESDAY = "Kedd";
var WEDNESDAY = "Szerda";
var THURSDAY = "csütörtök";
var FRIDAY = "péntek";
var SATURDAY = "Szombat";
var TYPING = "gépelés...";
var IS_TYPING = "gépelne...";
var CLOSE = "Bezárás";
var ENTER_GROUP_NAME = "Adja meg a csoport nevét";
var ADD_MEMBERS = "Tagok hozzáadása";
var SEND_MESSAGE = "Üzenet küldése";
var UNBLOCK_USER = "Felhasználó letiltása";
var BLOCK_USER = "Felhasználó blokkolása";
var DELETE_AND_EXIT = "Törlés és kilépés";
var LEAVE_GROUP = "Elhagyja a csoportot";
var CREATE_GROUP = "Csoport létrehozása";
var SHARED_MEDIA = "Megosztott média";
var SHARED_FILE = "Megosztott fájl";
var VIDEO_CALL = "Videohívás";
var AUDIO_CALL = "Hanghívás";
var LOADING = "Betöltés...";
var REPLY = "Válasz";
var REPLIES = "Válaszok";
var AI = "Ó,";
var SMART_REPLIES = "Intelligens válaszok";
var CONVERSATION_STARTER = "Beszélgetés indítója";
var LAUNCH = "Indítás";
var SHARED_COLLABORATIVE_DOCUMENT = "megosztott egy együttműködési dokumentumot";
var SHARED_COLLABORATIVE_WHITEBOARD = "megosztott egy együttműködési táblát";
var CREATED_WHITEBOARD = "Új együttműködési táblát hoztál létre";
var CREATED_DOCUMENT = "Új együttműködési dokumentumot hoztál létre";
var PHOTOS = "Képek";
var VIDEOS = "Videók";
var DOCUMENT = "Dokumentum";
var YOU_DELETED_THIS_MESSAGE = "⚠️ Törölted ezt az üzenetet";
var THIS_MESSAGE_DELETED = "⚠️ Ezt az üzenetet törölték";
var MESSAGE_IS_DELETED = "Az üzenet törlődött";
var VIEW_ON_YOUTUBE = "Megtekintés a Youtube-on";
var SEARCH = "Keresés";
var NO_USERS_FOUND = "Nem találtak felhasználót";
var ERROR = "Hiba";
var NO_GROUPS_FOUND = "Nem találtak csoportokat";
var NO_CHATS_FOUND = "Nem találtak csevegést";
var CANT__LOAD__CHATS = "Nem lehet betölteni a csevegéseket";
var MEDIA_MESSAGE = "Médiaüzenet";
var INCOMING_AUDIO_CALL = "Bejövő hanghívás";
var INCOMING_VIDEO_CALL = "Bejövő videohívás";
var DECLINE = "Visszaesés";
var ACCEPT = "Elfogadom";
var CALL_INITIATED = "Hívás kezdeményezett";
var OUTGOING_AUDIO_CALL = "Kimenő hanghívás";
var OUTGOING_VIDEO_CALL = "Kimenő videohívás";
var CALL_REJECTED = "A hívás elutasítva";
var REJECTED_CALL = "elutasított hívás";
var CALL_ACCEPTED = "Hívás elfogadva";
var OUTGOING_CALL = "Kimenő hívás";
var INCOMING_CALL = "Bejövő hívás";
var MISSED_CALL = "Elmulasztott hívás";
var JOINED = "csatlakozott";
var LEFT_THE_CALL = "elhagyta a hívást";
var UNANSWERED_AUDIO_CALL = "Megválaszolatlan hanghívás";
var UNANSWERED_VIDEO_CALL = "Megválaszolatlan videohívás";
var CALL_ENDED = "A hívás véget ért";
var CALL_CANCELLED = "Hívás törölve";
var CALL_BUSY = "Hívás elfoglalt";
var CALLING = "Hívom...";
var ADD = "Hozzáadás";
var NO_BANNED_MEMBERS_FOUND = "Nem találtak tiltott tagokat";
var BANNED_MEMBERS = "Tiltott tagok";
var NAME = "Név";
var SCOPE = "Hatály";
var UNBAN = "Unban";
var SELECT_GROUP_TYPE = "Válassza ki a csoporttípust";
var ENTER_GROUP_PASSWORD = "Adja meg a csoport jelszavát";
var CREATE = "Létrehozni";
var CREATE_POLL = "Szavazás létrehozása";
var QUESTION = "Kérdés";
var ENTER_YOUR_QUESTION = "Írja be a kérdését";
var OPTIONS = "Opciók";
var ENTER_YOUR_OPTION = "Adja meg az opciót";
var ADD_NEW_OPTION = "Új opció hozzáadása";
var VIEW_MEMBERS = "Tagok megtekintése";
var DETAILS = "Részletek";
var NOTIFICATIONS = "Értesítések";
var OTHER = "Egyéb";
var HELP = "Segítség";
var REPORT_PROBLEM = "Hiba jelentése";
var GROUP_MEMBERS = "Csoporttagok";
var BAN = "Tiltás";
var KICK = "Rúgás";
var PICK_YOUR_EMOJI = "Válassza ki a hangulatjeleket";
var PRIVATE_GROUP = "Magáncsoport";
var PROTECTED_GROUP = "Védett csoport";
var VISIT = "Látogatás";
var ATTACH = "Csatlakoztassa";
var OPEN_WHITEBOARD = "Nyissa meg a táblát";
var ATTACH_FILE = "Fájl csatolása";
var GENERATING_REPLIES = "Válaszok generálása";
var ATTACH_VIDEO = "Videó csatolása";
var ATTACH_AUDIO = "Hang csatolása";
var ATTACH_IMAGE = "Kép csatolása";
var COLLABORATE_USING_DOCUMENT = "Együttműködés dokumentum használatával";
var COLLABORATE_USING_WHITEBOARD = "Együttműködés tábla segítségével";
var SUGGEST_A_REPLY = "Javasolj egy választ";
var GENERATING_ICEBREAKERS = "Jégtörők generálása";
var EMOJI = "Emoji";
var NO_REPLIES_FOUND = "Nem található válasz";
var ENTER_YOUR_MESSAGE_HERE = "Írja be ide az üzenetét";
var NO_MESSAGES_FOUND = "Nem található üzenet";
var THREAD = "Szál";
var COLLABORATIVE_DOCUMENT = "Együttműködési dokumentum";
var COLLABORATIVE_WHITEBOARD = "Együttműködési tábla";
var ADD_REACTION = "Adjon hozzá reakciót";
var NO_STICKERS_FOUND = "Nem találtak matricát";
var REPLY_TO_THREAD = "Válasz a szálra";
var REPLY_IN_THREAD = "Válasz szálban";
var VIEW = "Nézet";
var DELETE_MESSAGE = "Üzenet törlése";
var EDIT_MESSAGE = "Üzenet szerkesztése";
var OWNER = "Tulajdonos";
var CHANGE_SCOPE = "Hatókör módosítása";
var STICKER = "Matrica";
var LAST_ACTIVE_AT = "Utoljára aktív itt:";
var VOICE_CALL = "Hanghívás";
var VIEW_DETAIL = "Részletek megtekintése";
var VOTES = "szavazatok";
var VOTE = "szavazás";
var NO_VOTE = "Nincs szavazás";
var REACTED = "reagált";
var ADDED = "Hozzátette";
var SHOW_UNSAFE_CONTENT = "Biztosan nem biztonságos tartalmat szeretne látni?";
var REACT_TO_MESSAGE = "Reagáljon egy üzenetre";
var UNBANNED = "nem tiltott";
var MADE = "készített";
var CALL_UNANSWERED = "Hívás megválaszolatlan";
var MISSED_AUDIO_CALL = "Hiányzott hanghívás";
var ENTER_YOUR_PASSWORD = "Adja meg a jelszavát";
var DRAW_DOCUMENT_TOGETHER = "Nyissa meg a dokumentumot a tartalom közös szerkesztéséhez";
var DOCS = "Dokumentumok";
var NO_RECORDS_FOUND = "Nem találtak nyilvántartást";
var LIVE_REACTION = "Élő reakció";
var SMILEY_PEOPLE = "Mosolyok és emberek";
var DRAW_WHITEBOARD_TOGETHER = "Nyissa meg a táblát a rajzoláshoz";
var ANIMALES_NATURE = "Állatok és természet";
var FOOD_DRINK = "Étel és ital";
var OPEN_DOCUMENT = "Nyissa meg a dokumentumot";
var ACTIVITY = "Tevékenység";
var TRAVEL_PLACES = "Utazás és helyek";
var OBJECTS = "Tárgyak";
var SYMBOLS = "Szimbólumok";
var FLAGS = "Zászlók";
var SENT = "Elküldött";
var SEEN = "Látott";
var DELIVERED = "Szállított";
var READ = "Olvassa el";
var MESSAGE_INFORMATION = "Üzeneti információk";
var TRANSLATE_MESSAGE = "Üzenet fordítása";
var TRANSLATED_MESSAGE = "Fordított üzenet";
var LEFT = "balra";
var KICKED = "rúgott";
var BANNED = "betiltott";
var NEW_MESSAGES = "új üzenetek";
var NEW_MESSAGE = "új üzenet";
var JUMP = "Ugrás";
var SELECT_VIDEO_SOURCE = "Válassza ki a videó forrását";
var SELECT_INPUT_AUDIO_SOURCE = "Válassza ki a bemeneti hangforrást";
var SELECT_OUTPUT_AUDIO_SOURCE = "Válassza ki a kimeneti hangforrást";
var INITIATED_GROUP_CALL = "Csoportos felhívást kezdeményezett";
var YOU_INITIATED_GROUP_CALL = "Csoportos hívást kezdeményeztél";
var IGNORE = "Figyelmen kívül";
var ON_ANOTHER_CALL = "Újabb hívásban van";
var CREATING = "Létrehozás";
var AVATAR = "Avatár";
var ONGOING_CALL = "Folyamatos hívás";
var YOU_ALREADY_ONGOING_CALL = "Már folyamatos hívásban van";
var RESIZE = "Átméretezés";
var SETTINGS = "Beállítások";
var ACTIONS = "Tevékenységek";
var VIEW_PROFILE = "Profil megtekintése";
var SEND_MESSAGE_IN_PRIVATE = "Üzenet küldése privát módon";
var DELETE = "Törlés";
var DELETE_CONFIRM = "Biztos vagy benne, hogy törölni akarod?";
var CANCEL = "Törölje";
var LEAVE_CONFIRM = "Biztos vagy benne, hogy el akarod hagyni a csoportot?";
var TRANSFER_CONFIRM = "Ön a csoport tulajdonosa, kérjük, adja át a tulajdonjogot egy tagra, mielőtt elhagyja a csoportot";
var ADDING = "Hozzáadva...";
var TRANSFER = "Átutalás";
var TRANSFER_OWNERSHIP = "Tulajdonjog átruházása";
var TRANSFERRING = "Átvitel";
var YES = "Igen";
var NO = "Nem";
var ANSWER = "Válasz";
var ADD_ANOTHER_ANSWER = "Adjon hozzá egy másik választ";
var SET_THE_ANSWERS = "ÁLLÍTSA BE A VÁLASZOKAT";
var TRY_AGAIN = "Próbáld újra";
var INVALID_GROUP_NAME = "Kérjük, adja meg a csoport érvényes nevét, és próbálkozzon újra";
var INVALID_PASSWORD = "Kérjük, írjon be egy érvényes jelszót a csoport számára, és próbálkozzon újra";
var INVALID_GROUP_TYPE = "Adjon meg egy érvényes típust a csoporthoz, és próbálkozzon újra";
var WRONG_PASSWORD = "Kérjük, adja meg a helyes jelszót, és próbálja újra";
var INVALID_POLL_QUESTION = "Kérjük, írja be a szükséges kérdést a szavazás létrehozása előtt";
var INVALID_POLL_OPTION = "Kérjük, a szavazás létrehozása előtt adja meg a szükséges választ";
var SAME_LANGUAGE_MESSAGE = "A fordításhoz kiválasztott nyelv hasonló az eredeti üzenet nyelvéhez";
var LEAVE = "Menj el";
var CLICK_TO_START_CONVERSATION = "Kattintson a beszélgetés megkezdéséhez";
var CUSTOM_MESSAGE_LOCATION = "📍 Elhelyezkedés";
var SHARED_LOCATION = "Megosztott hely";
var IN_A_THREAD = "Egy szálban";
var CALLS = "Hívások";
var CALL_DETAILS = "Hívás részletei";
var OFFLINE = "Offline";
var POLLS = "Közvélemény-kutatások";
var YOU = "Te";
var PRIVACY = "Adatvédelem";
var BLOCKED_USERS = "Blokkolt felhasználók";
var NO_PHOTOS = "Nincsenek fotók";
var NO_VIDEOS = "Nincsenek videók";
var NO_DOCUMENTS = "Nincsenek dokumentumok";
var JOIN = "Csatlakozz";
var REMOVE = "Távolítsa el";
var BLOCK = "Blokkolás";
var CHANGE_ROLE = "Szerepváltás";
var NEW_CHAT = "Új csevegés";
var FORM_COMPLETION_MESSAGE = "Köszönjük, hogy kitöltötte az űrlapot.";
var HISTORY = "Történelem";
var CANCELLED_AUDIO_CALL = "Hanghívás törlése";
var CANCELLED_VIDEO_CALL = "Törölték a videohívást";
var REJECTED_AUDIO_CALL = "Elutasított hanghívás";
var REJECTED_VIDEO_CALL = "Elutasított videohívás";
var CANCELLED_CALL = "Törölött hívás";
var UNANSWERED_CALL = "Megválaszolatlan hívás";
var RECORDING = "Felvétel";
var PARTICIPANTS = "Résztvevők";
var CALL_HISTORY = "Hívási előzmények";
var NO_CALLS_FOUND = "Nem találtak hívásokat";
var ONGOING_AUDIO_CALL = "Folyamatos hanghívás";
var ONGOING_VIDEO_CALL = "Folyamatos videohívás";
var CALL_DETAIL = "Hívás részletei";
var FORM = "Űrlap";
var CARD = "Kártya";
var GENERATING_SUMMARY = "Összefoglaló generálása";
var CONVERSATION_SUMMARY = "A beszélgetés összefoglalása";
var GENERATE_SUMMARY = "Összefoglaló létrehozása";
var COMETCHAT_BOT_FIRST_MESSAGE = "Hogyan segíthetek ebben a beszélgetésben? Kérlek, tegyen fel egy kérdést, és tanácsot adok neked 🙂";
var COMETCHAT_ASK_BOT = "Kérdezd";
var COMETCHAT_ASK_AI_BOT = "Kérdezze meg AI botokat";
var COMETCHAT_ASK_BOT_SUBTITLE = "AI Bot";
var MENTIONS_LIMIT_WARNING_MESSAGE = "Egyszerre akár tízszer is megemlíthetjük.";
var ALL = "Minden";
var CLICK_TO_REMOVE = "Kattintson az eltávolításhoz";
var OTHERS = "mások";
var AND = "egy";
var translationHU = {
	INFO: INFO,
	REACT: REACT,
	EDIT: EDIT,
	MESSAGE_PRIVATELY: MESSAGE_PRIVATELY,
	TRANSLATE: TRANSLATE,
	USERS: USERS,
	CHATS: CHATS,
	WOULD__YOU_LIKE_TO_DELETE_THIS_CONVERSATION: WOULD__YOU_LIKE_TO_DELETE_THIS_CONVERSATION,
	GROUPS: GROUPS,
	SHARED: SHARED,
	SOUND_MANAGER: SOUND_MANAGER,
	THEME: THEME,
	LOCALIZE: LOCALIZE,
	CONVERSATION_LIST_ITEM: CONVERSATION_LIST_ITEM,
	DATA_ITEM: DATA_ITEM,
	STATUS_INDICATOR: STATUS_INDICATOR,
	BADGE_COUNT: BADGE_COUNT,
	MESSAGE_RECEIPT: MESSAGE_RECEIPT,
	MESSAGE: MESSAGE,
	RECEIPT_INFORMATION: RECEIPT_INFORMATION,
	NO_RECIPIENT: NO_RECIPIENT,
	NO_RECIPIENTS: NO_RECIPIENTS,
	CONVERSATIONS_WITH_MESSAGES: CONVERSATIONS_WITH_MESSAGES,
	CONVERSATIONS: CONVERSATIONS,
	CONVERSATION_LIST: CONVERSATION_LIST,
	MESSAGES: MESSAGES,
	MESSAGE_HEADER: MESSAGE_HEADER,
	MESSAGE_LIST: MESSAGE_LIST,
	MESSAGE_COMPOSER: MESSAGE_COMPOSER,
	USERS_WITH_MESSAGES: USERS_WITH_MESSAGES,
	USER_LIST: USER_LIST,
	GROUP_LIST: GROUP_LIST,
	GROUPS_WITH_MESSAGES: GROUPS_WITH_MESSAGES,
	NEW__GROUP: NEW__GROUP,
	PASSWORD: PASSWORD,
	CONTINUE: CONTINUE,
	NO_CHATS_SELECTED: NO_CHATS_SELECTED,
	NO_USERS_SELECTED: NO_USERS_SELECTED,
	NO_GROUPS_SELECTED: NO_GROUPS_SELECTED,
	SELECT_DAY: SELECT_DAY,
	SELECT_TIME: SELECT_TIME,
	NO_CALLS_SELECTED: NO_CALLS_SELECTED,
	SELECT__GROUP: SELECT__GROUP,
	SELECT__USER: SELECT__USER,
	GROUP_PASSWORD_BLANK: GROUP_PASSWORD_BLANK,
	GROUP_NAME_BLANK: GROUP_NAME_BLANK,
	GROUP_TYPE_BLANK: GROUP_TYPE_BLANK,
	DELETE_CONVERSATION: DELETE_CONVERSATION,
	ADD_TO_CHAT: ADD_TO_CHAT,
	MORE: MORE,
	COPY: COPY,
	VOICE_RECORDING: VOICE_RECORDING,
	MESSAGE_IMAGE: MESSAGE_IMAGE,
	MESSAGE_FILE: MESSAGE_FILE,
	MESSAGE_VIDEO: MESSAGE_VIDEO,
	MESSAGE_AUDIO: MESSAGE_AUDIO,
	CUSTOM_MESSAGE: CUSTOM_MESSAGE,
	SELECT_A_DATE: SELECT_A_DATE,
	TIME_ZONE: TIME_ZONE,
	MEETING_SCHEDULED: MEETING_SCHEDULED,
	SOMETHING_WRONG: SOMETHING_WRONG,
	MEETING_SLOT_BOOK: MEETING_SLOT_BOOK,
	MEETING_BOOK_NEW_SLOT: MEETING_BOOK_NEW_SLOT,
	MEETING_NO_SLOTS_AVAILABLE: MEETING_NO_SLOTS_AVAILABLE,
	MEETING_TRY_DIFFERENT_DATE: MEETING_TRY_DIFFERENT_DATE,
	NO_TIME_SLOTS_AVAILABLE: NO_TIME_SLOTS_AVAILABLE,
	SCHEDULE: SCHEDULE,
	MORE_TIMES: MORE_TIMES,
	MISSED_VOICE_CALL: MISSED_VOICE_CALL,
	MEET_WITH: MEET_WITH,
	MEETING_SCHEDULER: MEETING_SCHEDULER,
	MISSED_VIDEO_CALL: MISSED_VIDEO_CALL,
	CUSTOM_MESSAGE_POLL: CUSTOM_MESSAGE_POLL,
	CUSTOM_MESSAGE_STICKER: CUSTOM_MESSAGE_STICKER,
	CUSTOM_MESSAGE_DOCUMENT: CUSTOM_MESSAGE_DOCUMENT,
	CUSTOM_MESSAGE_WHITEBOARD: CUSTOM_MESSAGE_WHITEBOARD,
	ONLINE: ONLINE,
	ADMINISTRATOR: ADMINISTRATOR,
	ADMIN: ADMIN,
	MODERATOR: MODERATOR,
	PARTICIPANT: PARTICIPANT,
	PUBLIC: PUBLIC,
	PRIVATE: PRIVATE,
	PASSWORD_PROTECTED: PASSWORD_PROTECTED,
	PRIVACY_AND_SECURITY: PRIVACY_AND_SECURITY,
	PREFERENCES: PREFERENCES,
	MEMBERS: MEMBERS,
	MEMBER: MEMBER,
	TODAY: TODAY,
	YESTERDAY: YESTERDAY,
	SUNDAY: SUNDAY,
	MONDAY: MONDAY,
	TUESDAY: TUESDAY,
	WEDNESDAY: WEDNESDAY,
	THURSDAY: THURSDAY,
	FRIDAY: FRIDAY,
	SATURDAY: SATURDAY,
	TYPING: TYPING,
	IS_TYPING: IS_TYPING,
	CLOSE: CLOSE,
	ENTER_GROUP_NAME: ENTER_GROUP_NAME,
	ADD_MEMBERS: ADD_MEMBERS,
	SEND_MESSAGE: SEND_MESSAGE,
	UNBLOCK_USER: UNBLOCK_USER,
	BLOCK_USER: BLOCK_USER,
	DELETE_AND_EXIT: DELETE_AND_EXIT,
	LEAVE_GROUP: LEAVE_GROUP,
	CREATE_GROUP: CREATE_GROUP,
	SHARED_MEDIA: SHARED_MEDIA,
	SHARED_FILE: SHARED_FILE,
	VIDEO_CALL: VIDEO_CALL,
	AUDIO_CALL: AUDIO_CALL,
	LOADING: LOADING,
	REPLY: REPLY,
	REPLIES: REPLIES,
	AI: AI,
	SMART_REPLIES: SMART_REPLIES,
	CONVERSATION_STARTER: CONVERSATION_STARTER,
	LAUNCH: LAUNCH,
	SHARED_COLLABORATIVE_DOCUMENT: SHARED_COLLABORATIVE_DOCUMENT,
	SHARED_COLLABORATIVE_WHITEBOARD: SHARED_COLLABORATIVE_WHITEBOARD,
	CREATED_WHITEBOARD: CREATED_WHITEBOARD,
	CREATED_DOCUMENT: CREATED_DOCUMENT,
	PHOTOS: PHOTOS,
	VIDEOS: VIDEOS,
	DOCUMENT: DOCUMENT,
	YOU_DELETED_THIS_MESSAGE: YOU_DELETED_THIS_MESSAGE,
	THIS_MESSAGE_DELETED: THIS_MESSAGE_DELETED,
	MESSAGE_IS_DELETED: MESSAGE_IS_DELETED,
	VIEW_ON_YOUTUBE: VIEW_ON_YOUTUBE,
	SEARCH: SEARCH,
	NO_USERS_FOUND: NO_USERS_FOUND,
	ERROR: ERROR,
	NO_GROUPS_FOUND: NO_GROUPS_FOUND,
	NO_CHATS_FOUND: NO_CHATS_FOUND,
	CANT__LOAD__CHATS: CANT__LOAD__CHATS,
	MEDIA_MESSAGE: MEDIA_MESSAGE,
	INCOMING_AUDIO_CALL: INCOMING_AUDIO_CALL,
	INCOMING_VIDEO_CALL: INCOMING_VIDEO_CALL,
	DECLINE: DECLINE,
	ACCEPT: ACCEPT,
	CALL_INITIATED: CALL_INITIATED,
	OUTGOING_AUDIO_CALL: OUTGOING_AUDIO_CALL,
	OUTGOING_VIDEO_CALL: OUTGOING_VIDEO_CALL,
	CALL_REJECTED: CALL_REJECTED,
	REJECTED_CALL: REJECTED_CALL,
	CALL_ACCEPTED: CALL_ACCEPTED,
	OUTGOING_CALL: OUTGOING_CALL,
	INCOMING_CALL: INCOMING_CALL,
	MISSED_CALL: MISSED_CALL,
	JOINED: JOINED,
	LEFT_THE_CALL: LEFT_THE_CALL,
	UNANSWERED_AUDIO_CALL: UNANSWERED_AUDIO_CALL,
	UNANSWERED_VIDEO_CALL: UNANSWERED_VIDEO_CALL,
	CALL_ENDED: CALL_ENDED,
	CALL_CANCELLED: CALL_CANCELLED,
	CALL_BUSY: CALL_BUSY,
	CALLING: CALLING,
	ADD: ADD,
	NO_BANNED_MEMBERS_FOUND: NO_BANNED_MEMBERS_FOUND,
	BANNED_MEMBERS: BANNED_MEMBERS,
	NAME: NAME,
	SCOPE: SCOPE,
	UNBAN: UNBAN,
	SELECT_GROUP_TYPE: SELECT_GROUP_TYPE,
	ENTER_GROUP_PASSWORD: ENTER_GROUP_PASSWORD,
	CREATE: CREATE,
	CREATE_POLL: CREATE_POLL,
	QUESTION: QUESTION,
	ENTER_YOUR_QUESTION: ENTER_YOUR_QUESTION,
	OPTIONS: OPTIONS,
	ENTER_YOUR_OPTION: ENTER_YOUR_OPTION,
	ADD_NEW_OPTION: ADD_NEW_OPTION,
	VIEW_MEMBERS: VIEW_MEMBERS,
	DETAILS: DETAILS,
	NOTIFICATIONS: NOTIFICATIONS,
	OTHER: OTHER,
	HELP: HELP,
	REPORT_PROBLEM: REPORT_PROBLEM,
	GROUP_MEMBERS: GROUP_MEMBERS,
	BAN: BAN,
	KICK: KICK,
	PICK_YOUR_EMOJI: PICK_YOUR_EMOJI,
	PRIVATE_GROUP: PRIVATE_GROUP,
	PROTECTED_GROUP: PROTECTED_GROUP,
	VISIT: VISIT,
	ATTACH: ATTACH,
	OPEN_WHITEBOARD: OPEN_WHITEBOARD,
	ATTACH_FILE: ATTACH_FILE,
	GENERATING_REPLIES: GENERATING_REPLIES,
	ATTACH_VIDEO: ATTACH_VIDEO,
	ATTACH_AUDIO: ATTACH_AUDIO,
	ATTACH_IMAGE: ATTACH_IMAGE,
	COLLABORATE_USING_DOCUMENT: COLLABORATE_USING_DOCUMENT,
	COLLABORATE_USING_WHITEBOARD: COLLABORATE_USING_WHITEBOARD,
	SUGGEST_A_REPLY: SUGGEST_A_REPLY,
	GENERATING_ICEBREAKERS: GENERATING_ICEBREAKERS,
	EMOJI: EMOJI,
	NO_REPLIES_FOUND: NO_REPLIES_FOUND,
	ENTER_YOUR_MESSAGE_HERE: ENTER_YOUR_MESSAGE_HERE,
	NO_MESSAGES_FOUND: NO_MESSAGES_FOUND,
	THREAD: THREAD,
	COLLABORATIVE_DOCUMENT: COLLABORATIVE_DOCUMENT,
	COLLABORATIVE_WHITEBOARD: COLLABORATIVE_WHITEBOARD,
	ADD_REACTION: ADD_REACTION,
	NO_STICKERS_FOUND: NO_STICKERS_FOUND,
	REPLY_TO_THREAD: REPLY_TO_THREAD,
	REPLY_IN_THREAD: REPLY_IN_THREAD,
	VIEW: VIEW,
	DELETE_MESSAGE: DELETE_MESSAGE,
	EDIT_MESSAGE: EDIT_MESSAGE,
	OWNER: OWNER,
	CHANGE_SCOPE: CHANGE_SCOPE,
	STICKER: STICKER,
	LAST_ACTIVE_AT: LAST_ACTIVE_AT,
	VOICE_CALL: VOICE_CALL,
	VIEW_DETAIL: VIEW_DETAIL,
	VOTES: VOTES,
	VOTE: VOTE,
	NO_VOTE: NO_VOTE,
	REACTED: REACTED,
	ADDED: ADDED,
	SHOW_UNSAFE_CONTENT: SHOW_UNSAFE_CONTENT,
	REACT_TO_MESSAGE: REACT_TO_MESSAGE,
	UNBANNED: UNBANNED,
	MADE: MADE,
	CALL_UNANSWERED: CALL_UNANSWERED,
	MISSED_AUDIO_CALL: MISSED_AUDIO_CALL,
	ENTER_YOUR_PASSWORD: ENTER_YOUR_PASSWORD,
	DRAW_DOCUMENT_TOGETHER: DRAW_DOCUMENT_TOGETHER,
	DOCS: DOCS,
	NO_RECORDS_FOUND: NO_RECORDS_FOUND,
	LIVE_REACTION: LIVE_REACTION,
	SMILEY_PEOPLE: SMILEY_PEOPLE,
	DRAW_WHITEBOARD_TOGETHER: DRAW_WHITEBOARD_TOGETHER,
	ANIMALES_NATURE: ANIMALES_NATURE,
	FOOD_DRINK: FOOD_DRINK,
	OPEN_DOCUMENT: OPEN_DOCUMENT,
	ACTIVITY: ACTIVITY,
	TRAVEL_PLACES: TRAVEL_PLACES,
	OBJECTS: OBJECTS,
	SYMBOLS: SYMBOLS,
	FLAGS: FLAGS,
	SENT: SENT,
	SEEN: SEEN,
	DELIVERED: DELIVERED,
	READ: READ,
	MESSAGE_INFORMATION: MESSAGE_INFORMATION,
	TRANSLATE_MESSAGE: TRANSLATE_MESSAGE,
	TRANSLATED_MESSAGE: TRANSLATED_MESSAGE,
	LEFT: LEFT,
	KICKED: KICKED,
	BANNED: BANNED,
	NEW_MESSAGES: NEW_MESSAGES,
	NEW_MESSAGE: NEW_MESSAGE,
	JUMP: JUMP,
	SELECT_VIDEO_SOURCE: SELECT_VIDEO_SOURCE,
	SELECT_INPUT_AUDIO_SOURCE: SELECT_INPUT_AUDIO_SOURCE,
	SELECT_OUTPUT_AUDIO_SOURCE: SELECT_OUTPUT_AUDIO_SOURCE,
	INITIATED_GROUP_CALL: INITIATED_GROUP_CALL,
	YOU_INITIATED_GROUP_CALL: YOU_INITIATED_GROUP_CALL,
	IGNORE: IGNORE,
	ON_ANOTHER_CALL: ON_ANOTHER_CALL,
	CREATING: CREATING,
	AVATAR: AVATAR,
	ONGOING_CALL: ONGOING_CALL,
	YOU_ALREADY_ONGOING_CALL: YOU_ALREADY_ONGOING_CALL,
	RESIZE: RESIZE,
	SETTINGS: SETTINGS,
	ACTIONS: ACTIONS,
	VIEW_PROFILE: VIEW_PROFILE,
	SEND_MESSAGE_IN_PRIVATE: SEND_MESSAGE_IN_PRIVATE,
	DELETE: DELETE,
	DELETE_CONFIRM: DELETE_CONFIRM,
	CANCEL: CANCEL,
	LEAVE_CONFIRM: LEAVE_CONFIRM,
	TRANSFER_CONFIRM: TRANSFER_CONFIRM,
	ADDING: ADDING,
	TRANSFER: TRANSFER,
	TRANSFER_OWNERSHIP: TRANSFER_OWNERSHIP,
	TRANSFERRING: TRANSFERRING,
	YES: YES,
	NO: NO,
	ANSWER: ANSWER,
	ADD_ANOTHER_ANSWER: ADD_ANOTHER_ANSWER,
	SET_THE_ANSWERS: SET_THE_ANSWERS,
	TRY_AGAIN: TRY_AGAIN,
	INVALID_GROUP_NAME: INVALID_GROUP_NAME,
	INVALID_PASSWORD: INVALID_PASSWORD,
	INVALID_GROUP_TYPE: INVALID_GROUP_TYPE,
	WRONG_PASSWORD: WRONG_PASSWORD,
	INVALID_POLL_QUESTION: INVALID_POLL_QUESTION,
	INVALID_POLL_OPTION: INVALID_POLL_OPTION,
	SAME_LANGUAGE_MESSAGE: SAME_LANGUAGE_MESSAGE,
	LEAVE: LEAVE,
	CLICK_TO_START_CONVERSATION: CLICK_TO_START_CONVERSATION,
	CUSTOM_MESSAGE_LOCATION: CUSTOM_MESSAGE_LOCATION,
	SHARED_LOCATION: SHARED_LOCATION,
	IN_A_THREAD: IN_A_THREAD,
	CALLS: CALLS,
	CALL_DETAILS: CALL_DETAILS,
	OFFLINE: OFFLINE,
	POLLS: POLLS,
	YOU: YOU,
	PRIVACY: PRIVACY,
	BLOCKED_USERS: BLOCKED_USERS,
	"YOU'VE_BLOCKED": "Letiltottad",
	NO_PHOTOS: NO_PHOTOS,
	NO_VIDEOS: NO_VIDEOS,
	NO_DOCUMENTS: NO_DOCUMENTS,
	JOIN: JOIN,
	REMOVE: REMOVE,
	BLOCK: BLOCK,
	CHANGE_ROLE: CHANGE_ROLE,
	NEW_CHAT: NEW_CHAT,
	FORM_COMPLETION_MESSAGE: FORM_COMPLETION_MESSAGE,
	HISTORY: HISTORY,
	CANCELLED_AUDIO_CALL: CANCELLED_AUDIO_CALL,
	CANCELLED_VIDEO_CALL: CANCELLED_VIDEO_CALL,
	REJECTED_AUDIO_CALL: REJECTED_AUDIO_CALL,
	REJECTED_VIDEO_CALL: REJECTED_VIDEO_CALL,
	CANCELLED_CALL: CANCELLED_CALL,
	UNANSWERED_CALL: UNANSWERED_CALL,
	RECORDING: RECORDING,
	PARTICIPANTS: PARTICIPANTS,
	CALL_HISTORY: CALL_HISTORY,
	NO_CALLS_FOUND: NO_CALLS_FOUND,
	ONGOING_AUDIO_CALL: ONGOING_AUDIO_CALL,
	ONGOING_VIDEO_CALL: ONGOING_VIDEO_CALL,
	CALL_DETAIL: CALL_DETAIL,
	FORM: FORM,
	CARD: CARD,
	GENERATING_SUMMARY: GENERATING_SUMMARY,
	CONVERSATION_SUMMARY: CONVERSATION_SUMMARY,
	GENERATE_SUMMARY: GENERATE_SUMMARY,
	COMETCHAT_BOT_FIRST_MESSAGE: COMETCHAT_BOT_FIRST_MESSAGE,
	COMETCHAT_ASK_BOT: COMETCHAT_ASK_BOT,
	COMETCHAT_ASK_AI_BOT: COMETCHAT_ASK_AI_BOT,
	COMETCHAT_ASK_BOT_SUBTITLE: COMETCHAT_ASK_BOT_SUBTITLE,
	MENTIONS_LIMIT_WARNING_MESSAGE: MENTIONS_LIMIT_WARNING_MESSAGE,
	ALL: ALL,
	CLICK_TO_REMOVE: CLICK_TO_REMOVE,
	OTHERS: OTHERS,
	AND: AND
};

class CometChatLocalize {
    /**
     * Accepts the string to localize and return the localized string
     * @param {String} str
     * @returns {String} localized str
     */
    static localize(str) {
        let language = CometChatLocalize.getLocale();
        return CometChatLocalize.translations[language][str];
    }
}
/**Properties and constants */
CometChatLocalize.fallbackLanguage = "en";
CometChatLocalize.rtlLanguages = ["ar"];
CometChatLocalize.direction = Object.freeze({
    ltr: "ltr",
    rtl: "rtl",
});
CometChatLocalize.translations = {
    ar: translationAR,
    de: translationDE,
    en: translationEN,
    es: translationES,
    fr: translationFR,
    hi: translationHI,
    ms: translationMS,
    pt: translationPT,
    ru: translationRU,
    zh: translationZH,
    "zh-tw": translationZHTW,
    sv: translationSV,
    lt: translationLT,
    hu: translationHU
};
/**
 * Needs to be called at the start of the application in order to set the language
 * @param {Object} - language & resources
 */
/**
 * @param  {string=""} language
 * @param  {object={}} resources
 */
CometChatLocalize.init = (language = "", resources = {}) => {
    if (language) {
        CometChatLocalize.locale = language;
    }
    else {
        CometChatLocalize.setDefaultLanguage();
    }
    /**Override resources */
    if (resources) {
        for (const resource in resources) {
            /**Add to the original array of translations if language code is not found */
            if (!CometChatLocalize.translations[resource]) {
                CometChatLocalize.translations[resource] = resources[resource];
            }
            else {
                for (const key in (resources[resource])) {
                    CometChatLocalize.translations[resource][key] = resources[resource][key];
                }
            }
        }
    }
};
/**
 * Returns the browser language
 * @returns {String} browser langauge i.e. en-US
 */
CometChatLocalize.getBrowserLanguage = () => {
    return (navigator.languages && navigator.languages[0]) || navigator.language;
};
/**
 * Returns the language code
 * @returns {String} language code i.e. en
 */
CometChatLocalize.getLanguageCode = () => {
    const languageCode = CometChatLocalize.getBrowserLanguage().toLowerCase();
    // check if the language set in the browser has hyphen(-), if yes split and take the first element of the array
    if (languageCode.indexOf("-") !== -1 && languageCode !== "zh-tw") {
        return languageCode.split("-")[0];
    }
    return languageCode;
};
/**
 * Returns the active language. Return fallback language if translation is not available for the active language
 * @returns {String} active language
 */
CometChatLocalize.getLocale = () => {
    let language = CometChatLocalize.locale;
    if (!CometChatLocalize.translations.hasOwnProperty(language)) {
        language = CometChatLocalize.fallbackLanguage;
    }
    return language;
};
/**
 * Set the active language
 * @param {String} language
 */
CometChatLocalize.setLocale = (language) => {
    CometChatLocalize.locale = language;
};
/**
 * Sets the default lannguage if no language is passed in init method
 */
CometChatLocalize.setDefaultLanguage = () => {
    // get the active language
    const activeLanguage = CometChatLocalize.getLocale();
    // get the browser language code
    let browserLanguageCode = CometChatLocalize.getLanguageCode();
    // if there is no active language or active language is different from browser language, update active language with browser language
    if (!activeLanguage || activeLanguage !== browserLanguageCode) {
        CometChatLocalize.setLocale(browserLanguageCode);
    }
};
/**
 * Returns true if the active language is rtl otherwise return false
 * @returns {Boolean} whether the language is rtl or not
 */
CometChatLocalize.isRTL = () => {
    if (CometChatLocalize.rtlLanguages.includes(CometChatLocalize.getLocale())) {
        return true;
    }
    return false;
};
/**
 * Returns rtl or ltr based on the active language
 * @returns {String} the direction of the active langauge
 */
CometChatLocalize.getDir = () => {
    if (CometChatLocalize.rtlLanguages.includes(CometChatLocalize.getLocale())) {
        return CometChatLocalize.direction.rtl;
    }
    return CometChatLocalize.direction.ltr;
};
const localize = (str) => CometChatLocalize.localize(str);

/**
 * @class PaletteItem
 * @param {String} light
 * @param {String} dark
 */
class PaletteItem {
    constructor({ light = "", dark = "" }) {
        this.light = "";
        this.dark = "";
        this.light = light;
        this.dark = dark;
    }
}
const modes = {
    light: "light",
    dark: "dark",
};
const opacity = {
    accent50: {
        [modes.light]: "0.04",
        [modes.dark]: "0.04",
    },
    accent100: {
        [modes.light]: "0.08",
        [modes.dark]: "0.08",
    },
    accent200: {
        [modes.light]: "0.15",
        [modes.dark]: "0.14",
    },
    accent300: {
        [modes.light]: "0.24",
        [modes.dark]: "0.23",
    },
    accent400: {
        [modes.light]: "0.33",
        [modes.dark]: "0.34",
    },
    accent500: {
        [modes.light]: "0.46",
        [modes.dark]: "0.46",
    },
    accent600: {
        [modes.light]: "0.58",
        [modes.dark]: "0.58",
    },
    accent700: {
        [modes.light]: "0.69",
        [modes.dark]: "0.71",
    },
    accent800: {
        [modes.light]: "0.82",
        [modes.dark]: "0.84",
    },
};
const getAccentOpacity = (colorCode, opacity) => {
    if (colorCode.startsWith("#")) {
        return hexToRGBA(colorCode, opacity);
    }
    return RGBToRGBA(colorCode, opacity);
};
const hexToRGBA = (hex, opacity) => {
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    return "rgba(" + +r + "," + +g + "," + +b + "," + opacity + ")";
};
const RGBToRGBA = (rgb, opacity) => {
    // Choose correct separator
    let sep = rgb.indexOf(",") > -1 ? "," : " ";
    // Turn "rgb(r,g,b)" into [r,g,b]
    rgb = rgb.substr(4).split(")")[0].split(sep);
    let r = (+rgb[0]).toString(16), g = (+rgb[1]).toString(16), b = (+rgb[2]).toString(16);
    return "rgba(" + r + "," + g + "," + b + "," + opacity + ")";
};
class CometChatPalette {
    constructor({ mode = modes.light, background = new PaletteItem({
        [modes.light]: "rgba(255,255,255)",
        [modes.dark]: "rgba(0,0,0)",
    }), primary = new PaletteItem({
        [modes.light]: "rgba(51, 153, 255)",
        [modes.dark]: "rgba(51, 153, 255)",
    }), primary150 = new PaletteItem({
        [modes.light]: "rgba(51, 153, 255, .15)",
        [modes.dark]: "rgba(51, 153, 255, .15)",
    }), primary500 = new PaletteItem({
        [modes.light]: "rgba(51, 153, 255, .5)",
        [modes.dark]: "rgba(51, 153, 255, .5)",
    }), error = new PaletteItem({
        [modes.light]: "rgba(255, 59, 48)",
        [modes.dark]: "rgba(255, 59, 48)",
    }), accent = new PaletteItem({
        [modes.light]: "rgba(20, 20, 20)",
        [modes.dark]: "rgba(255, 255, 255)",
    }), accent50 = new PaletteItem({
        [modes.light]: "rgba(20, 20, 20, 0.04)",
        [modes.dark]: "rgba(255, 255, 255, 0.4)",
    }), accent100 = new PaletteItem({
        [modes.light]: "rgba(20, 20, 20, 0.08)",
        [modes.dark]: "rgba(255, 255, 255, 0.08)",
    }), accent200 = new PaletteItem({
        [modes.light]: "rgba(20, 20, 20, 0.15)",
        [modes.dark]: "rgba(255, 255, 255, 0.14)",
    }), accent300 = new PaletteItem({
        [modes.light]: "rgba(20, 20, 20, 0.24)",
        [modes.dark]: "rgba(255, 255, 255, 0.23)",
    }), accent400 = new PaletteItem({
        [modes.light]: "rgba(20, 20, 20, 0.33)",
        [modes.dark]: "rgba(255, 255, 255, 0.34)",
    }), accent500 = new PaletteItem({
        [modes.light]: "rgba(20, 20, 20, 0.46)",
        [modes.dark]: "rgba(255, 255, 255, 0.46)",
    }), accent600 = new PaletteItem({
        [modes.light]: "rgba(20, 20, 20, 0.58)",
        [modes.dark]: "rgba(255, 255, 255, 0.58)",
    }), accent700 = new PaletteItem({
        [modes.light]: "rgba(20, 20, 20, 0.69)",
        [modes.dark]: "rgba(255, 255, 255, 0.71)",
    }), accent800 = new PaletteItem({
        [modes.light]: "rgba(20, 20, 20, 0.82)",
        [modes.dark]: "rgba(255, 255, 255, 0.84)",
    }), accent900 = new PaletteItem({
        [modes.light]: "rgba(255, 255, 255)",
        [modes.dark]: "rgb(20, 20, 20)",
    }), success = new PaletteItem({
        [modes.light]: "rgb(0, 200, 111)",
        [modes.dark]: "rgb(0, 200, 111)",
    }), secondary = new PaletteItem({
        [modes.light]: "rgba(248, 248, 248, 0.92)",
        [modes.dark]: "rgb(51, 51, 51)",
    }), tertiary = new PaletteItem({
        [modes.light]: "rgb(255, 245, 0)",
        [modes.dark]: "rgb(255, 245, 0)",
    }), }) {
        this.mode = modes.light;
        this.background = new PaletteItem({
            [modes.light]: "rgba(255,255,255)",
            [modes.dark]: "rgba(0,0,0)",
        });
        this.primary = new PaletteItem({
            [modes.light]: "rgba(51, 153, 255)",
            [modes.dark]: "rgba(51, 153, 255)",
        });
        this.primary150 = new PaletteItem({
            [modes.light]: "rgba(51, 153, 255, .15)",
            [modes.dark]: "rgba(51, 153, 255, .15)",
        });
        this.primary500 = new PaletteItem({
            [modes.light]: "rgba(51, 153, 255, .5)",
            [modes.dark]: "rgba(51, 153, 255, .5)",
        });
        this.error = new PaletteItem({
            [modes.light]: "rgba(255, 59, 48)",
            [modes.dark]: "rgba(255, 59, 48)",
        });
        this.accent = new PaletteItem({
            [modes.light]: "rgba(20, 20, 20)",
            [modes.dark]: "rgba(255, 255, 255)",
        });
        this.accent50 = new PaletteItem({
            [modes.light]: "rgba(20, 20, 20, 0.04)",
            [modes.dark]: "rgba(255, 255, 255, 0.4)",
        });
        this.accent100 = new PaletteItem({
            [modes.light]: "rgba(20, 20, 20, 0.08)",
            [modes.dark]: "rgba(255, 255, 255, 0.08)",
        });
        this.accent200 = new PaletteItem({
            [modes.light]: "rgba(20, 20, 20, 0.15)",
            [modes.dark]: "rgba(255, 255, 255, 0.14)",
        });
        this.accent300 = new PaletteItem({
            [modes.light]: "rgba(20, 20, 20, 0.24)",
            [modes.dark]: "rgba(255, 255, 255, 0.23)",
        });
        this.accent400 = new PaletteItem({
            [modes.light]: "rgba(20, 20, 20, 0.33)",
            [modes.dark]: "rgba(255, 255, 255, 0.34)",
        });
        this.accent500 = new PaletteItem({
            [modes.light]: "rgba(20, 20, 20, 0.46)",
            [modes.dark]: "rgba(255, 255, 255, 0.46)",
        });
        this.accent600 = new PaletteItem({
            [modes.light]: "rgba(20, 20, 20, 0.58)",
            [modes.dark]: "rgba(255, 255, 255, 0.58)",
        });
        this.accent700 = new PaletteItem({
            [modes.light]: "rgba(20, 20, 20, 0.69)",
            [modes.dark]: "rgba(255, 255, 255, 0.71)",
        });
        this.accent800 = new PaletteItem({
            [modes.light]: "rgba(20, 20, 20, 0.82)",
            [modes.dark]: "rgba(255, 255, 255, 0.84)",
        });
        this.accent900 = new PaletteItem({
            [modes.light]: "rgba(255, 255, 255)",
            [modes.dark]: "rgb(20, 20, 20)",
        });
        this.success = new PaletteItem({
            [modes.light]: "rgb(0, 200, 111)",
            [modes.dark]: "rgb(0, 200, 111)",
        });
        this.secondary = new PaletteItem({
            [modes.light]: "rgba(248, 248, 248, 0.92)",
            [modes.dark]: "rgb(51, 51, 51)",
        });
        this.tertiary = new PaletteItem({
            [modes.light]: "rgb(255, 245, 0)",
            [modes.dark]: "rgb(255, 245, 0)",
        });
        this.getAccent = (mode = this.mode) => {
            return this.accent[mode];
        };
        this.getAccent50 = (mode = this.mode) => {
            return this.accent50[mode];
        };
        this.getAccent100 = (mode = this.mode) => {
            return this.accent100[mode];
        };
        this.getAccent200 = (mode = this.mode) => {
            return this.accent200[mode];
        };
        this.getAccent300 = (mode = this.mode) => {
            return this.accent300[mode];
        };
        this.getAccent400 = (mode = this.mode) => {
            return this.accent400[mode];
        };
        this.getAccent500 = (mode = this.mode) => {
            return this.accent500[mode];
        };
        this.getAccent600 = (mode = this.mode) => {
            return this.accent600[mode];
        };
        this.getAccent700 = (mode = this.mode) => {
            return this.accent700[mode];
        };
        this.getAccent800 = (mode = this.mode) => {
            return this.accent800[mode];
        };
        this.getAccent900 = (mode = this.mode) => {
            return this.accent900[mode];
        };
        this.getSuccess = (mode = this.mode) => {
            return this.success[mode];
        };
        this.getError = (mode = this.mode) => {
            return this.error[mode];
        };
        this.getPrimary = (mode = this.mode) => {
            return this.primary[mode];
        };
        this.getPrimary150 = (mode = this.mode) => {
            return this.primary150[mode];
        };
        this.getPrimary500 = (mode = this.mode) => {
            return this.primary500[mode];
        };
        this.getSecondary = (mode = this.mode) => {
            return this.secondary[mode];
        };
        this.getBackground = (mode = this.mode) => {
            return this.background[mode];
        };
        this.getTertiary = (mode = this.mode) => {
            return this.tertiary[mode];
        };
        this.mode = mode;
        this.background = background;
        this.primary = primary;
        this.primary150 = primary150;
        this.primary500 = primary500;
        this.secondary = secondary;
        this.error = error;
        this.success = success;
        this.accent = accent;
        this.accent50 = accent50;
        this.accent100 = accent100;
        this.accent200 = accent200;
        this.accent300 = accent300;
        this.accent400 = accent400;
        this.accent500 = accent500;
        this.accent600 = accent600;
        this.accent700 = accent700;
        this.accent800 = accent800;
        this.accent900 = accent900;
        this.tertiary = tertiary;
    }
    /**
     * @param  {string} mode
     */
    setMode(mode) {
        this.mode = mode;
    }
    /**
     * @param  {PaletteItem} colorset
     */
    setBackground(colorset) {
        if (colorset &&
            colorset[modes.light] &&
            colorset[modes.dark]) {
            this.background = colorset;
        }
    }
    /**
     * @param  {PaletteItem} colorset
     */
    setPrimary(colorset) {
        if (colorset &&
            colorset[modes.light] &&
            colorset[modes.dark]) {
            this.primary = colorset;
        }
    }
    /**
     * @param  {PaletteItem} colorset
     */
    setPrimary150(colorset) {
        if (colorset &&
            colorset[modes.light] &&
            colorset[modes.dark]) {
            this.primary150 = colorset;
        }
    }
    /**
     * @param  {PaletteItem} colorset
     */
    setPrimary500(colorset) {
        if (colorset &&
            colorset[modes.light] &&
            colorset[modes.dark]) {
            this.primary500 = colorset;
        }
    }
    /**
     * @param  {PaletteItem} colorset
     */
    setSecondary(colorset) {
        if (colorset &&
            colorset[modes.light] &&
            colorset[modes.dark]) {
            this.secondary = colorset;
        }
    }
    /**
     * @param  {PaletteItem} colorset
     */
    setError(colorset) {
        if (colorset &&
            colorset[modes.light] &&
            colorset[modes.dark]) {
            this.error = colorset;
        }
    }
    /**
     * @param  {PaletteItem} colorset
     */
    setAccent(colorset) {
        if (colorset &&
            colorset[modes.light] &&
            colorset[modes.dark]) {
            this.accent = {
                [modes.light]: colorset[modes.light],
                [modes.dark]: colorset[modes.dark],
            };
            this.setAccent50({
                [modes.light]: getAccentOpacity(colorset.light, opacity.accent50[modes.light]),
                [modes.dark]: getAccentOpacity(colorset.dark, opacity.accent50[modes.dark]),
            });
            this.setAccent100({
                [modes.light]: getAccentOpacity(colorset.light, opacity.accent100[modes.light]),
                [modes.dark]: getAccentOpacity(colorset.dark, opacity.accent100[modes.dark]),
            });
            this.setAccent200({
                [modes.light]: getAccentOpacity(colorset.light, opacity.accent200[modes.light]),
                [modes.dark]: getAccentOpacity(colorset.dark, opacity.accent200[modes.dark]),
            });
            this.setAccent300({
                [modes.light]: getAccentOpacity(colorset.light, opacity.accent300[modes.light]),
                [modes.dark]: getAccentOpacity(colorset.dark, opacity.accent300[modes.dark]),
            });
            this.setAccent400({
                [modes.light]: getAccentOpacity(colorset.light, opacity.accent400[modes.light]),
                [modes.dark]: getAccentOpacity(colorset.dark, opacity.accent400[modes.dark]),
            });
            this.setAccent500({
                [modes.light]: getAccentOpacity(colorset.light, opacity.accent500[modes.light]),
                [modes.dark]: getAccentOpacity(colorset.dark, opacity.accent500[modes.dark]),
            });
            this.setAccent600({
                [modes.light]: getAccentOpacity(colorset.light, opacity.accent600[modes.light]),
                [modes.dark]: getAccentOpacity(colorset.dark, opacity.accent600[modes.dark]),
            });
            this.setAccent700({
                [modes.light]: getAccentOpacity(colorset.light, opacity.accent700[modes.light]),
                [modes.dark]: getAccentOpacity(colorset.dark, opacity.accent700[modes.dark]),
            });
            this.setAccent800({
                [modes.light]: getAccentOpacity(colorset.light, opacity.accent800[modes.light]),
                [modes.dark]: getAccentOpacity(colorset.dark, opacity.accent800[modes.dark]),
            });
        }
    }
    /**
     * @param  {PaletteItem} colorset
     */
    setAccent50(colorset = new PaletteItem({})) {
        if (colorset &&
            colorset[modes.light] &&
            colorset[modes.dark]) {
            this.accent50 = {
                [modes.light]: colorset[modes.light],
                [modes.dark]: colorset[modes.dark],
            };
        }
    }
    setAccent100(colorset) {
        if (colorset &&
            colorset[modes.light] &&
            colorset[modes.dark]) {
            this.accent100 = {
                [modes.light]: colorset[modes.light],
                [modes.dark]: colorset[modes.dark],
            };
        }
    }
    /**
     * @param  {PaletteItem} colorset
     */
    setAccent200(colorset) {
        if (colorset &&
            colorset[modes.light] &&
            colorset[modes.dark]) {
            this.accent200 = {
                [modes.light]: colorset[modes.light],
                [modes.dark]: colorset[modes.dark],
            };
        }
    }
    /**
     * @param  {PaletteItem} colorset
     */
    setAccent300(colorset) {
        if (colorset &&
            colorset[modes.light] &&
            colorset[modes.dark]) {
            this.accent300 = {
                [modes.light]: colorset[modes.light],
                [modes.dark]: colorset[modes.dark],
            };
        }
    }
    /**
     * @param  {PaletteItem} colorset
     */
    setAccent400(colorset) {
        if (colorset &&
            colorset[modes.light] &&
            colorset[modes.dark]) {
            this.accent400 = {
                [modes.light]: colorset[modes.light],
                [modes.dark]: colorset[modes.dark],
            };
        }
    }
    /**
     * @param  {PaletteItem} colorset
     */
    setAccent500(colorset) {
        if (colorset &&
            colorset[modes.light] &&
            colorset[modes.dark]) {
            this.accent500 = {
                [modes.light]: colorset[modes.light],
                [modes.dark]: colorset[modes.dark],
            };
        }
    }
    /**
     * @param  {PaletteItem} colorset
     */
    setAccent600(colorset) {
        if (colorset &&
            colorset[modes.light] &&
            colorset[modes.dark]) {
            this.accent600 = {
                [modes.light]: colorset[modes.light],
                [modes.dark]: colorset[modes.dark],
            };
        }
    }
    /**
     * @param  {PaletteItem} colorset
     */
    setAccent700(colorset) {
        if (colorset &&
            colorset[modes.light] &&
            colorset[modes.dark]) {
            this.accent700 = {
                [modes.light]: colorset[modes.light],
                [modes.dark]: colorset[modes.dark],
            };
        }
    }
    /**
     * @param  {PaletteItem} colorset
     */
    setAccent800(colorset) {
        if (colorset &&
            colorset[modes.light] &&
            colorset[modes.dark]) {
            this.accent800 = {
                [modes.light]: colorset[modes.light],
                [modes.dark]: colorset[modes.dark],
            };
        }
    }
    /**
     * @param  {PaletteItem} colorset
     */
    setAccent900(colorset) {
        if (colorset &&
            colorset[modes.light] &&
            colorset[modes.dark]) {
            this.accent900 = {
                [modes.light]: colorset[modes.light],
                [modes.dark]: colorset[modes.dark],
            };
        }
    }
    /**
     * @param  {PaletteItem} colorset
     */
    setTertiary(colorset) {
        if (colorset &&
            colorset[modes.light] &&
            colorset[modes.dark]) {
            this.tertiary = colorset;
        }
    }
}
new CometChatPalette({});

/**
 * @class CometChatFont
 * @param {String} fontFamily
 * @param {String} fontWeight
 * @param {String} fontSize
 */
class CometChatFont {
    constructor({ fontFamily = "", fontWeight = "", fontSize = "" }) {
        this.fontWeight = "";
        this.fontSize = "";
        this.fontFamily = fontFamily;
        this.fontWeight = fontWeight;
        this.fontSize = fontSize;
    }
}
/**
 * @class Typography
 * @param {String} fontFamily
 * @param {String} fontWeightRegular
 * @param {String} fontWeightMedium
 * @param {String} fontWeightSemibold
 * @param {String} fontWeightBold
 * @param {Object} heading
 * @param {Object} name
 * @param {Object} title1
 * @param {Object} title2
 * @param {Object} subtitle1
 * @param {Object} subtitle2
 * @param {Object} text1
 * @param {Object} text2
 * @param {Object} caption1
 * @param {Object} caption2
 */
class CometChatTypography {
    constructor({ fontFamily = "sans-serif,Inter", fontWeightRegular = "400", fontWeightMedium = "500", fontWeightSemibold = "600", fontWeightBold = "700", heading = new CometChatFont({
        fontFamily: "sans-serif,Inter",
        fontWeight: "700",
        fontSize: "22px",
    }), name = new CometChatFont({
        fontFamily: "sans-serif,Inter",
        fontWeight: "500",
        fontSize: "16px",
    }), title1 = new CometChatFont({
        fontFamily: "sans-serif,Inter",
        fontWeight: "600",
        fontSize: "22px",
    }), title2 = new CometChatFont({
        fontFamily: "sans-serif,Inter",
        fontWeight: "600",
        fontSize: "15px",
    }), subtitle1 = new CometChatFont({
        fontFamily: "sans-serif,Inter",
        fontWeight: "400",
        fontSize: "15px",
    }), subtitle2 = new CometChatFont({
        fontFamily: "sans-serif,Inter",
        fontWeight: "400",
        fontSize: "13px",
    }), text1 = new CometChatFont({
        fontFamily: "sans-serif,Inter",
        fontWeight: "400",
        fontSize: "17px",
    }), text2 = new CometChatFont({
        fontFamily: "sans-serif,Inter",
        fontWeight: "500",
        fontSize: "15px",
    }), text3 = new CometChatFont({
        fontFamily: "sans-serif,Inter",
        fontWeight: "500",
        fontSize: "13px",
    }), caption1 = new CometChatFont({
        fontFamily: "sans-serif,Inter",
        fontWeight: "500",
        fontSize: "12px",
    }), caption2 = new CometChatFont({
        fontFamily: "sans-serif,Inter",
        fontWeight: "500",
        fontSize: "11px",
    }), caption3 = new CometChatFont({
        fontFamily: "sans-serif,Inter",
        fontWeight: "400",
        fontSize: "8px",
    }) }) {
        this.fontFamily = "sans-serif,Inter";
        this.fontWeightRegular = "400";
        this.fontWeightMedium = "500";
        this.fontWeightSemibold = "600";
        this.fontWeightBold = "700";
        this.heading = new CometChatFont({});
        this.name = new CometChatFont({});
        this.title1 = new CometChatFont({});
        this.title2 = new CometChatFont({});
        this.subtitle1 = new CometChatFont({});
        this.subtitle2 = new CometChatFont({});
        this.text1 = new CometChatFont({});
        this.text2 = new CometChatFont({});
        this.text3 = new CometChatFont({});
        this.caption1 = new CometChatFont({});
        this.caption2 = new CometChatFont({});
        this.caption3 = new CometChatFont({});
        this.fontFamily = fontFamily;
        this.fontWeightRegular = fontWeightRegular;
        this.fontWeightMedium = fontWeightMedium;
        this.fontWeightSemibold = fontWeightSemibold;
        this.fontWeightBold = fontWeightBold;
        this.heading = heading;
        this.name = name;
        this.title1 = title1;
        this.title2 = title2;
        this.subtitle1 = subtitle1;
        this.subtitle2 = subtitle2;
        this.text1 = text1;
        this.text2 = text2;
        this.text3 = text3;
        this.caption1 = caption1;
        this.caption2 = caption2;
        this.caption3 = caption3;
    }
    setFontFamily(fontFamily) {
        this.fontFamily = fontFamily;
        this.heading.fontFamily = fontFamily;
        this.name.fontFamily = fontFamily;
        this.title1.fontFamily = fontFamily;
        this.title2.fontFamily = fontFamily;
        this.subtitle1.fontFamily = fontFamily;
        this.subtitle2.fontFamily = fontFamily;
        this.text1.fontFamily = fontFamily;
        this.text2.fontFamily = fontFamily;
        this.text3.fontFamily = fontFamily;
        this.caption1.fontFamily = fontFamily;
        this.caption2.fontFamily = fontFamily;
        this.caption3.fontFamily = fontFamily;
    }
    setFontWeightRegular(fontWeightRegular) {
        this.fontWeightRegular = fontWeightRegular;
    }
    setFontWeightMedium(fontWeightMedium) {
        this.fontWeightMedium = fontWeightMedium;
    }
    setFontWeightSemibold(fontWeightSemibold) {
        this.fontWeightSemibold = fontWeightSemibold;
    }
    setFontWeightBold(fontWeightBold) {
        this.fontWeightBold = fontWeightBold;
    }
    setHeading(headingFont) {
        if (headingFont && headingFont.fontSize) {
            this.heading.fontSize = headingFont.fontSize;
        }
        if (headingFont && headingFont.fontWeight) {
            this.heading.fontWeight = headingFont.fontWeight;
        }
    }
    setName(nameFont) {
        if (nameFont && nameFont.fontSize) {
            this.name.fontSize = nameFont.fontSize;
        }
        if (nameFont && nameFont.fontWeight) {
            this.name.fontWeight = nameFont.fontWeight;
        }
    }
    setTitle1(titleFont) {
        if (titleFont && titleFont.fontSize) {
            this.title1.fontSize = titleFont.fontSize;
        }
        if (titleFont && titleFont.fontWeight) {
            this.title1.fontWeight = titleFont.fontWeight;
        }
    }
    setTitle2(titleFont) {
        if (titleFont && titleFont.fontSize) {
            this.title2.fontSize = titleFont.fontSize;
        }
        if (titleFont && titleFont.fontWeight) {
            this.title2.fontWeight = titleFont.fontWeight;
        }
    }
    setSubtitle1(subtitleFont) {
        if (subtitleFont && subtitleFont.fontSize) {
            this.subtitle1.fontSize = subtitleFont.fontSize;
        }
        if (subtitleFont && subtitleFont.fontWeight) {
            this.subtitle1.fontWeight = subtitleFont.fontWeight;
        }
    }
    setSubtitle2(subtitleFont) {
        if (subtitleFont && subtitleFont.fontSize) {
            this.subtitle2.fontSize = subtitleFont.fontSize;
        }
        if (subtitleFont && subtitleFont.fontWeight) {
            this.subtitle2.fontWeight = subtitleFont.fontWeight;
        }
    }
    setText1(textFont) {
        if (textFont && textFont.fontSize) {
            this.text1.fontSize = textFont.fontSize;
        }
        if (textFont && textFont.fontWeight) {
            this.text1.fontWeight = textFont.fontWeight;
        }
    }
    setText2(textFont) {
        if (textFont && textFont.fontSize) {
            this.text2.fontSize = textFont.fontSize;
        }
        if (textFont && textFont.fontWeight) {
            this.text2.fontWeight = textFont.fontWeight;
        }
    }
    setText3(textFont) {
        if (textFont && textFont.fontSize) {
            this.text3.fontSize = textFont.fontSize;
        }
        if (textFont && textFont.fontWeight) {
            this.text3.fontWeight = textFont.fontWeight;
        }
    }
    setCaption1(captionFont) {
        if (captionFont && captionFont.fontSize) {
            this.caption1.fontSize = captionFont.fontSize;
        }
        if (captionFont && captionFont.fontWeight) {
            this.caption1.fontWeight = captionFont.fontWeight;
        }
    }
    setCaption2(captionFont) {
        if (captionFont && captionFont.fontSize) {
            this.caption2.fontSize = captionFont.fontSize;
        }
        if (captionFont && captionFont.fontWeight) {
            this.caption2.fontWeight = captionFont.fontWeight;
        }
    }
    setCaption3(captionFont) {
        if (captionFont && captionFont.fontSize) {
            this.caption3.fontSize = captionFont.fontSize;
        }
        if (captionFont && captionFont.fontWeight) {
            this.caption3.fontWeight = captionFont.fontWeight;
        }
    }
}
const fontHelper = (obj) => {
    return `${obj.fontWeight} ${obj.fontSize} ${obj.fontFamily}`;
};
new CometChatTypography({});

class CometChatTheme {
    constructor({ palette = new CometChatPalette({}), typography = new CometChatTypography({}), }) {
        this.palette = new CometChatPalette({});
        this.typography = new CometChatTypography({});
        this.palette = palette;
        this.typography = typography;
    }
}

class CometChatMessageComposerAction {
    constructor(props) {
        this.id = "";
        this.iconURL = "";
        this.iconTint = "";
        this.onClick = null;
        this.title = "";
        this.titleFont = "";
        this.titleColor = "";
        this.background = "";
        this.borderRadius = ""; //create actionItem datamodel in web component
        Object.assign(this, props);
    }
}

class CometChatOption {
    constructor(props) {
        this.id = "";
        this.title = "";
        this.iconURL = "";
        this.titleFont = "";
        this.titleColor = "";
        this.backgroundColor = "";
        this.iconTint = "";
        this.onClick = null;
        Object.assign(this, props);
    }
}

/**
 * @class CometChatMessageOption
 * @description CometChatMessageOption class is used for defining the message options.
 *  * @param {string} id
 * @param {string} title
 * @param {string} iconURL
 * @param {any} onClick
 * @param {string} titleFont
 *  @param {string} titleColor
 *  @param {string} backgroundColor
 *   @param {string} iconTint
 */
class CometChatMessageOption extends CometChatOption {
    constructor({ id = "", title = "", iconURL = "", onClick = null, titleFont = "", titleColor = "", backgroundColor = "", iconTint = "" }) {
        super({ id, onClick, iconURL, title, titleFont, titleColor, backgroundColor, iconTint });
    }
    ;
}

// template
/**
 * @class CometChatMessageTemplate
 * @description CometChatMessageTemplate class is used for defining the message templates.
 *
 * @param {String} type
 *  @param {String} category
 * @param {any} contentView
 * @param {any} bubbleView
 * @param {any} headerView
 * @param {any} footerView
 * @param {any} bottomView
 * @param {any} statusInfoView
 * @param {typeof getMessageOptions} options
 */
class CometChatMessageTemplate {
    constructor(props) {
        this.contentView = null;
        this.category = "";
        Object.assign(this, props);
    }
}

class CometChatTabItem {
    constructor(props) {
        this.id = "";
        this.title = "";
        this.iconURL = "";
        this.style = {};
        this.childView = null;
        this.isActive = false;
        Object.assign(this, props);
    }
}

class CometChatDetailsOption {
    constructor(props) {
        this.id = "";
        this.title = "";
        this.iconURL = "";
        this.titleFont = "";
        this.titleColor = "";
        this.backgroundColor = "";
        this.iconTint = "";
        this.onClick = null;
        Object.assign(this, props);
    }
}

class CometChatDetailsTemplate {
    constructor(props) {
        this.id = "";
        this.title = "";
        this.titleFont = "";
        this.titleColor = "";
        this.sectionSeparatorColor = "";
        this.itemSeparatorColor = "";
        this.hideSectionSeparator = true;
        this.hideItemSeparator = true;
        Object.assign(this, props);
    }
}

class CometChatCallDetailsOption {
    constructor(props) {
        this.id = "";
        this.title = "";
        this.iconURL = "";
        this.titleFont = "";
        this.titleColor = "";
        this.backgroundColor = "";
        this.iconTint = "";
        this.onClick = null;
        Object.assign(this, props);
    }
}

class CometChatCallDetailsTemplate {
    constructor(props) {
        this.id = "";
        this.title = "";
        this.titleFont = "";
        this.titleColor = "";
        this.sectionSeparatorColor = "";
        this.itemSeparatorColor = "";
        this.hideSectionSeparator = true;
        this.hideItemSeparator = true;
        Object.assign(this, props);
    }
}

class CometChatActions {
    constructor(options) {
        this.id = options.id;
        this.title = options.title;
        this.iconURL = options.iconURL;
        this.titleFont = options.titleFont;
        this.iconTint = options.iconTint || "rgba(20, 20, 20, 0.58)";
        this.titleColor = options.titleColor;
        this.backgroundColor = options.backgroundColor;
    }
}

class CometChatActionsIcon extends CometChatActions {
    constructor(options) {
        super(options);
        this.onClick = options.onClick;
    }
}

class CometChatActionsView extends CometChatActions {
    constructor(options) {
        super(options);
        this.customView = options.customView;
    }
}

exports.DatePatterns = void 0;
(function (DatePatterns) {
    DatePatterns[DatePatterns["time"] = 0] = "time";
    DatePatterns[DatePatterns["DayDate"] = 1] = "DayDate";
    DatePatterns[DatePatterns["DayDateTime"] = 2] = "DayDateTime";
    DatePatterns[DatePatterns["DateTime"] = 3] = "DateTime";
})(exports.DatePatterns || (exports.DatePatterns = {}));
exports.AuxiliaryButtonAlignment = void 0;
(function (AuxiliaryButtonAlignment) {
    AuxiliaryButtonAlignment[AuxiliaryButtonAlignment["left"] = 0] = "left";
    AuxiliaryButtonAlignment[AuxiliaryButtonAlignment["right"] = 1] = "right";
})(exports.AuxiliaryButtonAlignment || (exports.AuxiliaryButtonAlignment = {}));
exports.Placement = void 0;
(function (Placement) {
    Placement["top"] = "top";
    Placement["right"] = "right";
    Placement["bottom"] = "bottom";
    Placement["left"] = "left";
})(exports.Placement || (exports.Placement = {}));
exports.MessageListAlignment = void 0;
(function (MessageListAlignment) {
    MessageListAlignment[MessageListAlignment["left"] = 0] = "left";
    MessageListAlignment[MessageListAlignment["standard"] = 1] = "standard";
})(exports.MessageListAlignment || (exports.MessageListAlignment = {}));
exports.MessageBubbleAlignment = void 0;
(function (MessageBubbleAlignment) {
    MessageBubbleAlignment[MessageBubbleAlignment["left"] = 0] = "left";
    MessageBubbleAlignment[MessageBubbleAlignment["right"] = 1] = "right";
    MessageBubbleAlignment[MessageBubbleAlignment["center"] = 2] = "center";
})(exports.MessageBubbleAlignment || (exports.MessageBubbleAlignment = {}));
exports.DocumentIconAlignment = void 0;
(function (DocumentIconAlignment) {
    DocumentIconAlignment[DocumentIconAlignment["left"] = 0] = "left";
    DocumentIconAlignment[DocumentIconAlignment["right"] = 1] = "right";
})(exports.DocumentIconAlignment || (exports.DocumentIconAlignment = {}));
exports.TabAlignment = void 0;
(function (TabAlignment) {
    TabAlignment[TabAlignment["top"] = 0] = "top";
    TabAlignment[TabAlignment["bottom"] = 1] = "bottom";
    TabAlignment[TabAlignment["left"] = 2] = "left";
    TabAlignment[TabAlignment["right"] = 3] = "right";
})(exports.TabAlignment || (exports.TabAlignment = {}));
exports.MessageStatus = void 0;
(function (MessageStatus) {
    MessageStatus[MessageStatus["inprogress"] = 0] = "inprogress";
    MessageStatus[MessageStatus["success"] = 1] = "success";
    MessageStatus[MessageStatus["error"] = 2] = "error";
})(exports.MessageStatus || (exports.MessageStatus = {}));
exports.Receipts = void 0;
(function (Receipts) {
    Receipts[Receipts["wait"] = 0] = "wait";
    Receipts[Receipts["sent"] = 1] = "sent";
    Receipts[Receipts["delivered"] = 2] = "delivered";
    Receipts[Receipts["read"] = 3] = "read";
    Receipts[Receipts["error"] = 4] = "error";
})(exports.Receipts || (exports.Receipts = {}));
exports.TitleAlignment = void 0;
(function (TitleAlignment) {
    TitleAlignment[TitleAlignment["left"] = 0] = "left";
    TitleAlignment[TitleAlignment["center"] = 1] = "center";
})(exports.TitleAlignment || (exports.TitleAlignment = {}));
exports.SelectionMode = void 0;
(function (SelectionMode) {
    SelectionMode[SelectionMode["single"] = 0] = "single";
    SelectionMode[SelectionMode["multiple"] = 1] = "multiple";
    SelectionMode[SelectionMode["none"] = 2] = "none";
})(exports.SelectionMode || (exports.SelectionMode = {}));
exports.States = void 0;
(function (States) {
    States[States["loading"] = 0] = "loading";
    States[States["empty"] = 1] = "empty";
    States[States["error"] = 2] = "error";
    States[States["loaded"] = 3] = "loaded";
})(exports.States || (exports.States = {}));
exports.TimestampAlignment = void 0;
(function (TimestampAlignment) {
    TimestampAlignment[TimestampAlignment["top"] = 0] = "top";
    TimestampAlignment[TimestampAlignment["bottom"] = 1] = "bottom";
})(exports.TimestampAlignment || (exports.TimestampAlignment = {}));
exports.IconButtonAlignment = void 0;
(function (IconButtonAlignment) {
    IconButtonAlignment["top"] = "column";
    IconButtonAlignment["bottom"] = "column-reverse";
    IconButtonAlignment["left"] = "row";
    IconButtonAlignment["right"] = "row-reverse";
})(exports.IconButtonAlignment || (exports.IconButtonAlignment = {}));
exports.RecordingType = void 0;
(function (RecordingType) {
    RecordingType[RecordingType["audio"] = 0] = "audio";
    RecordingType[RecordingType["video"] = 1] = "video";
})(exports.RecordingType || (exports.RecordingType = {}));
exports.TabsVisibility = void 0;
(function (TabsVisibility) {
    TabsVisibility[TabsVisibility["usersAndGroups"] = 0] = "usersAndGroups";
    TabsVisibility[TabsVisibility["users"] = 1] = "users";
    TabsVisibility[TabsVisibility["groups"] = 2] = "groups";
})(exports.TabsVisibility || (exports.TabsVisibility = {}));
exports.CallWorkflow = void 0;
(function (CallWorkflow) {
    CallWorkflow[CallWorkflow["defaultCalling"] = 0] = "defaultCalling";
    CallWorkflow[CallWorkflow["directCalling"] = 1] = "directCalling";
})(exports.CallWorkflow || (exports.CallWorkflow = {}));
exports.PanelAlignment = void 0;
(function (PanelAlignment) {
    PanelAlignment[PanelAlignment["composerHeader"] = 0] = "composerHeader";
    PanelAlignment[PanelAlignment["messageListHeader"] = 1] = "messageListHeader";
    PanelAlignment[PanelAlignment["messageListFooter"] = 2] = "messageListFooter";
    PanelAlignment[PanelAlignment["messages"] = 3] = "messages";
})(exports.PanelAlignment || (exports.PanelAlignment = {}));
exports.LabelAlignment = void 0;
(function (LabelAlignment) {
    LabelAlignment["top"] = "column";
    LabelAlignment["bottom"] = "column-reverse";
    LabelAlignment["left"] = "row";
    LabelAlignment["right"] = "row-reverse";
})(exports.LabelAlignment || (exports.LabelAlignment = {}));
exports.ElementType = void 0;
(function (ElementType) {
    ElementType["label"] = "label";
    ElementType["text"] = "textInput";
    ElementType["dropdown"] = "dropdown";
    ElementType["checkbox"] = "checkbox";
    ElementType["radio"] = "radio";
    ElementType["button"] = "button";
    ElementType["singleSelect"] = "singleSelect";
    ElementType["dateTime"] = "dateTime";
})(exports.ElementType || (exports.ElementType = {}));
exports.ButtonAction = void 0;
(function (ButtonAction) {
    ButtonAction["apiAction"] = "apiAction";
    ButtonAction["urlNavigation"] = "urlNavigation";
    ButtonAction["custom"] = "custom";
})(exports.ButtonAction || (exports.ButtonAction = {}));
exports.HTTPSRequestMethods = void 0;
(function (HTTPSRequestMethods) {
    HTTPSRequestMethods["POST"] = "POST";
    HTTPSRequestMethods["PUT"] = "PUT";
    HTTPSRequestMethods["PATCH"] = "PATCH";
    HTTPSRequestMethods["DELETE"] = "DELETE";
})(exports.HTTPSRequestMethods || (exports.HTTPSRequestMethods = {}));
exports.DateTimePickerMode = void 0;
(function (DateTimePickerMode) {
    DateTimePickerMode["date"] = "date";
    DateTimePickerMode["dateTime"] = "dateTime";
    DateTimePickerMode["time"] = "time";
})(exports.DateTimePickerMode || (exports.DateTimePickerMode = {}));
exports.UserMemberListType = void 0;
(function (UserMemberListType) {
    UserMemberListType[UserMemberListType["users"] = 0] = "users";
    UserMemberListType[UserMemberListType["groupmembers"] = 1] = "groupmembers";
})(exports.UserMemberListType || (exports.UserMemberListType = {}));
exports.MouseEventSource = void 0;
(function (MouseEventSource) {
    MouseEventSource[MouseEventSource["mentions"] = 0] = "mentions";
})(exports.MouseEventSource || (exports.MouseEventSource = {}));
/**
 * to adjust the position of user presence icon in list item
 */
exports.UserPresencePlacement = void 0;
(function (UserPresencePlacement) {
    UserPresencePlacement[UserPresencePlacement["bottom"] = 0] = "bottom";
    UserPresencePlacement[UserPresencePlacement["right"] = 1] = "right";
})(exports.UserPresencePlacement || (exports.UserPresencePlacement = {}));
/**
 * to adjust the position of user presence icon in list item
 */
exports.MentionsTargetElement = void 0;
(function (MentionsTargetElement) {
    MentionsTargetElement[MentionsTargetElement["textinput"] = 0] = "textinput";
    MentionsTargetElement[MentionsTargetElement["textbubble"] = 1] = "textbubble";
    MentionsTargetElement[MentionsTargetElement["conversation"] = 2] = "conversation";
})(exports.MentionsTargetElement || (exports.MentionsTargetElement = {}));

/**
 * Represents an action that can be performed on a UI element, such as a button.
 */
class ActionEntity {
    /**
     * Creates an instance of the ActionEntity class.
     * @param {ButtonAction} actionType - The type of action that the button performs.
     */
    constructor(actionType) {
        this.actionType = actionType;
    }
    /**
     * Returns the type of action to perform when the UI element is interacted with.
     * @returns {ButtonAction} The type of action to perform when the UI element is interacted with.
     */
    getActionType() {
        return this.actionType;
    }
    static fromJSON(json) {
        switch (json.actionType) {
            case exports.ButtonAction.apiAction:
                return APIAction.fromJSON(json);
            case exports.ButtonAction.urlNavigation:
                return URLNavigationAction.fromJSON(json);
            default:
                return CustomAction.fromJSON();
        }
    }
}

/**
 * Represents an API action that can be performed on a dynamic form.
 */
class APIAction extends ActionEntity {
    /**
     * Creates a new instance of the APIAction class.
     * @param {string} url - The URL to which the API action should be performed.
     * @param {string} method - The HTTP method to be used for the API action.
     */
    constructor(url, method) {
        super(exports.ButtonAction.apiAction);
        this.url = url || "https://example.com";
        this.method = method || exports.HTTPSRequestMethods.POST;
    }
    /**
     * Returns the URL to which the API action should be performed.
     * @returns {string} The URL to which the API action should be performed.
     */
    getURL() {
        return this.url;
    }
    /**
     * Returns the HTTP method to be used for the API action.
     * @returns {string} The HTTP method to be used for the API action.
     */
    getMethod() {
        return this.method;
    }
    /**
     * Returns the payload to be sent with the API action.
     * @returns {Object} The payload to be sent with the API action.
     */
    getPayload() {
        return this.payload;
    }
    /**
     * Sets the payload to be sent with the API action.
     * @param {Object} payload - The payload to be sent with the API action.
     */
    setPayload(payload) {
        this.payload = payload;
    }
    /**
     * Returns the headers to be sent with the API action.
     * @returns {Object} The headers to be sent with the API action.
     */
    getHeaders() {
        return this.headers;
    }
    /**
     * Sets the headers to be sent with the API action.
     * @param {Object} headers - The headers to be sent with the API action.
     */
    setHeaders(headers) {
        this.headers = headers;
    }
    static fromJSON(json) {
        const apiAction = new APIAction(json.url, json.method);
        if (json.payload)
            apiAction.setPayload(json.payload);
        if (json.headers)
            apiAction.setHeaders(json.headers);
        return apiAction;
    }
}

/**
 * Represents a URL navigation action that can be performed on a dynamic form.
 */
class URLNavigationAction extends ActionEntity {
    /**
     * Creates a new instance of the URLNavigationAction class.
     * @param {string} url - The URL to navigate to.
     */
    constructor(url) {
        super(exports.ButtonAction.urlNavigation);
        this.url = url || "https://example.com";
    }
    /**
     * Returns the URL to navigate to.
     * @returns {string} The URL to navigate to.
     */
    getURL() {
        return this.url;
    }
    static fromJSON(json) {
        return new URLNavigationAction(json.url);
    }
}

/**
 * Represents a custom action entity.
 */
class CustomAction extends ActionEntity {
    constructor() {
        super(exports.ButtonAction.custom);
    }
    /**
     * Creates a new CustomAction object from a JSON object.
     * @returns A new CustomAction object created from the JSON object.
     */
    static fromJSON() {
        return new CustomAction();
    }
}

/**
 * Represents the base input for a dynamic form element.
 */
class ElementEntity {
    constructor(elementId, elementType) {
        this.elementId = elementId || "";
        this.elementType = elementType || "";
    }
    /**
     * Returns the type of the form element.
     * @returns {string} The type of the form element.
     */
    getElementType() {
        return this.elementType;
    }
    /**
     * Returns the unique identifier of the form element.
     * @returns {string} The unique identifier of the form element.
     */
    getElementId() {
        return this.elementId;
    }
    static fromJSON(json) {
        switch (json.elementType) {
            case exports.ElementType.text:
                return BaseInputElement.fromJSON(json);
            case exports.ElementType.checkbox:
                return BaseInputElement.fromJSON(json);
            case exports.ElementType.dropdown:
                return BaseInputElement.fromJSON(json);
            case exports.ElementType.radio:
                return BaseInputElement.fromJSON(json);
            case exports.ElementType.singleSelect:
                return BaseInputElement.fromJSON(json);
            case exports.ElementType.button:
                return BaseInteractiveElement.fromJSON(json);
            case exports.ElementType.label:
                return LabelElement.fromJSON(json);
            case exports.ElementType.dateTime:
                return DateTimePickerElement.fromJSON(json);
            default:
                return LabelElement.fromJSON({
                    elementId: "1",
                    elementType: exports.ElementType.label,
                    text: "unknown element type",
                });
        }
    }
}

/**
 * Represents the base input for a dynamic form element.
 */
class BaseInputElement extends ElementEntity {
    /**
     * Creates a new instance of the BaseInputElement class.
     * @param {string} elementId - The unique identifier of the form element.
     * @param {string} elementType - The type of the form element.
     */
    constructor(elementId, elementType) {
        super(elementId, elementType);
        /**
         * Whether the input element is optional or required.
         * */
        this.optional = true;
    }
    /**
     * Sets the response of an input.
     */
    setResponse(response) {
        this.response = response;
    }
    /**
     * Returns the response of an input.
     * @returns {T} The response of an input.
     */
    getResponse() {
        return this.response;
    }
    /**
 * Returns whether the element is optional or required.
 * @returns {boolean} Whether the element is optional or required.
 */
    getOptional() {
        return this.optional;
    }
    /**
     * Sets whether the element is optional or required.
     * @param {boolean} optional - Whether the element is optional or required.
     */
    setOptional(optional) {
        let optionalValue;
        if (typeof optional === "boolean" || typeof optional === "string") {
            optionalValue = optional === "true" ? true : optional === "false" ? false : optional;
        }
        else {
            optionalValue = true;
        }
        this.optional = optionalValue;
    }
    static fromJSON(json) {
        switch (json.elementType) {
            case exports.ElementType.text:
                const element = TextInputElement.fromJSON(json);
                element.setOptional(json.optional);
                return element;
            case exports.ElementType.checkbox:
                const checkboxElement = CheckboxElement.fromJSON(json);
                checkboxElement.setOptional(json.optional);
                return checkboxElement;
            case exports.ElementType.dropdown:
                const dropdownElement = DropdownElement.fromJSON(json);
                dropdownElement.setOptional(json.optional);
                return dropdownElement;
            case exports.ElementType.radio:
                const radioButtonElement = RadioButtonElement.fromJSON(json);
                radioButtonElement.setOptional(json.optional);
                return radioButtonElement;
            case exports.ElementType.singleSelect:
                const singleSelectElement = SingleSelectElement.fromJSON(json);
                singleSelectElement.setOptional(json.optional);
                return singleSelectElement;
            default:
                return TextInputElement.fromJSON({
                    elementId: "1",
                    elementType: exports.ElementType.text,
                    label: "Label",
                });
        }
    }
}

/**
 * Represents a base interactive element in a interactive message.
 */
class BaseInteractiveElement extends ElementEntity {
    constructor(elementId, elementType, action) {
        super(elementId, elementType);
        if (action instanceof APIAction || action instanceof URLNavigationAction || action instanceof CustomAction) {
            this.action = action;
        }
        else {
            this.action = ActionEntity.fromJSON(action);
        }
    }
    /**
     * Returns the action associated with the bubble.
     * @returns {APIAction | URLNavigationAction | CustomAction} The action associated with the bubble.
     */
    getAction() {
        return this.action;
    }
    static fromJSON(json) {
        switch (json.elementType) {
            case exports.ElementType.button:
                return ButtonElement.fromJSON(json);
            default:
                return ButtonElement.fromJSON({
                    elementId: "1",
                    elementType: exports.ElementType.button,
                    buttonText: "Button",
                    action: new CustomAction()
                });
        }
    }
}

/**
 * Represents a button element that can be added to a interactive bubble.
 */
class ButtonElement extends BaseInteractiveElement {
    /**
     * Creates an instance of ButtonInput.
     * @param elementId - The unique identifier for the button element.
     * @param action - The action to be performed when the button is clicked.
     * @param buttonText - The text to display on the button.
     */
    constructor(elementId, action, buttonText) {
        super(elementId, exports.ElementType.button, action);
        /**
         * Whether the button should be disabled after it is interacted with.
         * */
        this.disableAfterInteracted = true;
        this.buttonText = buttonText || "";
    }
    /**
     * Gets the text to display on the button.
     * @returns The text to display on the button.
     */
    getButtonText() {
        return this.buttonText;
    }
    /**
     * Gets whether the button should be disabled after it is interacted with.
     * @returns Whether the button should be disabled after it is interacted with.
     */
    getDisableAfterInteracted() {
        return this.disableAfterInteracted;
    }
    /**
     * Sets whether the button should be disabled after it is interacted with.
     * @param disableAfterInteracted - Whether the button should be disabled after it is interacted with.
     */
    setDisableAfterInteracted(disableAfterInteracted) {
        this.disableAfterInteracted = disableAfterInteracted;
    }
    static fromJSON(json) {
        const action = ActionEntity.fromJSON(json.action);
        const buttonElement = new ButtonElement(json.elementId, action, json.buttonText);
        if (json.disableAfterInteracted)
            buttonElement.setDisableAfterInteracted(json.disableAfterInteracted);
        return buttonElement;
    }
}

/**
 * Represents a checkbox input element.
 */
class CheckboxElement extends BaseInputElement {
    /**
     * Creates a new instance of the CheckboxInput class.
     * @param elementId The ID of the input element.
     * @param label The label of the input element.
     * @param options The options available for the checkbox input element.
     */
    constructor(elementId, label, options = []) {
        super(elementId, exports.ElementType.checkbox);
        this.label = label || "";
        this.options = options.map((option) => {
            if (option instanceof OptionElement) {
                return option;
            }
            else {
                return OptionElement.fromJSON(option);
            }
        });
    }
    /**
     * Gets the label of the input element.
     * @returns The label of the input element.
     */
    getLabel() {
        return this.label;
    }
    /**
     * Sets the default values to be selected in the checkbox.
     * @param defaultValue The default values to be selected in the checkbox.
     */
    setDefaultValue(defaultValue) {
        this.defaultValue = defaultValue;
    }
    /**
     * Gets the default values to be selected in the checkbox.
     * @returns The default values to be selected in the checkbox.
     * */
    getDefaultValue() {
        return this.defaultValue;
    }
    /**
     * Gets the options available for the checkbox input element.
     * @returns The options available for the checkbox input element.
     */
    getOptions() {
        return this.options;
    }
    static fromJSON(json) {
        const options = ((json === null || json === void 0 ? void 0 : json.options) || []).map((option) => {
            return OptionElement.fromJSON(option);
        });
        const checkboxElement = new CheckboxElement(json.elementId, json.label, options);
        if (json.defaultValue)
            checkboxElement.setDefaultValue(json.defaultValue);
        return checkboxElement;
    }
}

/**
 * Represents a dropdown input element.
 */
class DropdownElement extends BaseInputElement {
    /**
     * Creates a new instance of DropdownInput.
     * @param elementId - The ID of the input element.
     * @param label - The label of the input element.
     * @param options - The options available for the dropdown input element.
     */
    constructor(elementId, label, options = []) {
        super(elementId, exports.ElementType.dropdown);
        this.label = label || "";
        this.options = options.map((option) => {
            if (option instanceof OptionElement) {
                return option;
            }
            else {
                return OptionElement.fromJSON(option);
            }
        });
    }
    /**
     * Gets the label of the input element.
     * @returns The label of the input element.
     */
    getLabel() {
        return this.label;
    }
    /**
     * Gets the default value to be selected in the dropdown.
     * @returns The default value to be selected in the dropdown.
     */
    getDefaultValue() {
        return this.defaultValue;
    }
    /**
     * Sets the default value to be selected in the dropdown.
     * @param defaultValue - The default value to be selected in the dropdown.
     */
    setDefaultValue(defaultValue) {
        this.defaultValue = defaultValue;
    }
    /**
     * Gets the options available for the dropdown input element.
     * @returns The options available for the dropdown input element.
     */
    getOptions() {
        return this.options;
    }
    static fromJSON(json) {
        const options = ((json === null || json === void 0 ? void 0 : json.options) || []).map((option) => {
            return OptionElement.fromJSON(option);
        });
        const dropdownElement = new DropdownElement(json.elementId, json.label, options);
        if (json.defaultValue)
            dropdownElement.setDefaultValue(json.defaultValue);
        return dropdownElement;
    }
}

/**
 * Represents a label element.
 */
class LabelElement extends ElementEntity {
    /**
     * Creates a new instance of the LabelElement class.
     * @param {string} elementId - The unique identifier of the form element.
     * @param {string} text - The text to display in the label.
     */
    constructor(elementId, text) {
        super(elementId, exports.ElementType.label);
        this.text = text || "";
    }
    /**
     * Returns the text to display in the label.
     * @returns {string} The text to display in the label.
     */
    getText() {
        return this.text;
    }
    static fromJSON(json) {
        return new LabelElement(json.elementId, json.text);
    }
}

/**
 * Represents a option.
 */
class OptionElement {
    /**
     * Creates a new instance of the OptionElement class.
     * @param {string} label - The unique identifier for the option.
     * @param {string} value - The display value for the option.
     */
    constructor(label, value) {
        this.label = label || "";
        this.value = value || "";
    }
    /**
     * Returns the unique identifier for the option.
     * @returns {string} The unique identifier for the option.
     */
    getLabel() {
        return this.label;
    }
    /**
     * Returns the display value for the option.
     * @returns {string} The display value for the option.
     */
    getValue() {
        return this.value;
    }
    static fromJSON(json) {
        return new OptionElement(json.label, json.value);
    }
}

/**
 * Represents a radio button input element.
 */
class RadioButtonElement extends BaseInputElement {
    /**
     * Creates a new instance of the RadioButtonElement class.
     * @param elementId The ID of the radio button element.
     * @param label The label of the radio button element.
     * @param options The options available for the radio button element.
     */
    constructor(elementId, label, options = []) {
        super(elementId, exports.ElementType.radio);
        this.label = label || "";
        this.options = options.map((option) => {
            if (option instanceof OptionElement) {
                return option;
            }
            else {
                return OptionElement.fromJSON(option);
            }
        });
    }
    /**
     * Gets the label of the input element.
     * @returns The label of the input element.
     */
    getLabel() {
        return this.label;
    }
    /**
     * Gets the default value of the input element.
     * @returns The default value of the input element.
     */
    getDefaultValue() {
        return this.defaultValue;
    }
    /**
     * Sets the default value of the input element.
     * @param defaultValue The default value of the input element.
     */
    setDefaultValue(defaultValue) {
        this.defaultValue = defaultValue;
    }
    /**
     * Gets the options available for the radio input element.
     * @returns The options available for the radio input element.
     */
    getOptions() {
        return this.options;
    }
    static fromJSON(json) {
        const options = ((json === null || json === void 0 ? void 0 : json.options) || []).map((option) => {
            return OptionElement.fromJSON(option);
        });
        const radioButtonElement = new RadioButtonElement(json.elementId, json.label, options);
        if (json.defaultValue)
            radioButtonElement.setDefaultValue(json.defaultValue);
        return radioButtonElement;
    }
}

/**
 * Represents a singleSelect button input element.
 */
class SingleSelectElement extends BaseInputElement {
    /**
     * Creates a new instance of the SingleSelectElement class.
     * @param elementId The ID of the singleSelect button element.
     * @param label The label of the singleSelect button element.
     * @param options The options available for the singleSelect button element.
     */
    constructor(elementId, label, options = []) {
        super(elementId, exports.ElementType.singleSelect);
        this.label = label || "";
        this.options = options.map((option) => {
            if (option instanceof OptionElement) {
                return option;
            }
            else {
                return OptionElement.fromJSON(option);
            }
        });
    }
    /**
     * Gets the label of the input element.
     * @returns The label of the input element.
     */
    getLabel() {
        return this.label;
    }
    /**
     * Gets the default value of the input element.
     * @returns The default value of the input element.
     */
    getDefaultValue() {
        return this.defaultValue;
    }
    /**
     * Sets the default value of the input element.
     * @param defaultValue The default value of the input element.
     */
    setDefaultValue(defaultValue) {
        this.defaultValue = defaultValue;
    }
    /**
     * Gets the options available for the singleSelect input element.
     * @returns The options available for the singleSelect input element.
     */
    getOptions() {
        return this.options;
    }
    static fromJSON(json) {
        const options = ((json === null || json === void 0 ? void 0 : json.options) || []).map((option) => {
            return OptionElement.fromJSON(option);
        });
        const singleSelectElement = new SingleSelectElement(json.elementId, json.label, options);
        if (json.defaultValue)
            singleSelectElement.setDefaultValue(json.defaultValue);
        return singleSelectElement;
    }
}

/**
 * Represents a text input element.
 */
class TextInputElement extends BaseInputElement {
    /**
     * Creates a new instance of the TextInputElement class.
     * @param {string} elementId - The unique identifier of the form element.
     * @param {string} label - The label of the input element.
     */
    constructor(elementId, label) {
        super(elementId, exports.ElementType.text);
        /** The maximum number of lines for a multi-line text input element. */
        this.maxLines = 1;
        /** The placeholder text to display in the input element. */
        this.placeholder = {
            text: "Enter text here..."
        };
        this.label = label || "";
    }
    /**
     * Returns the label of the input element.
     * @returns {string} The label of the input element.
     */
    getLabel() {
        return this.label;
    }
    /**
     * Returns the maximum number of lines for a multi-line text input element.
     * @returns {number} The maximum number of lines for a multi-line text input element.
     */
    getMaxLines() {
        return this.maxLines;
    }
    /**
     * Sets the maximum number of lines for a multi-line text input element.
     * @param {number} maxLines - The maximum number of lines for a multi-line text input element.
     */
    setMaxLines(maxLines) {
        this.maxLines = maxLines;
    }
    /**
     * Returns the placeholder text to display in the input element.
     * @returns {string} The placeholder text to display in the input element.
     */
    getPlaceholder() {
        var _a;
        return (_a = this === null || this === void 0 ? void 0 : this.placeholder) === null || _a === void 0 ? void 0 : _a.text;
    }
    /**
     * Sets the placeholder text to display in the input element.
     * @param {string} placeholder - The placeholder text to display in the input element.
     */
    setPlaceholder(placeholder) {
        this.placeholder = {
            text: placeholder
        };
    }
    /**
     * Returns the default value in text input.
     * @returns {string} The default value in text input.
     */
    getDefaultValue() {
        return this.defaultValue;
    }
    /**
     * Sets the default value in text input.
     * @param {string} defaultValue - The default value in text input.
     * @returns {string} The default value in text input.
     */
    setDefaultValue(defaultValue) {
        this.defaultValue = defaultValue;
    }
    static fromJSON(json) {
        var _a;
        const textInput = new TextInputElement(json.elementId, json.label);
        if (json.maxLines)
            textInput.setMaxLines(json.maxLines);
        if (json.placeholder && json.placeholder.text)
            textInput.setPlaceholder((_a = json.placeholder) === null || _a === void 0 ? void 0 : _a.text);
        if (json.defaultValue)
            textInput.setDefaultValue(json.defaultValue);
        return textInput;
    }
}

class DateTimePickerElement extends BaseInputElement {
    constructor(elementId, label, mode, timezoneCode, optional = true) {
        super(elementId, exports.ElementType.dateTime);
        this.label = label || "";
        this.mode = mode;
        this.timezoneCode = timezoneCode;
        this.setOptional(optional);
    }
    getLabel() {
        return this.label;
    }
    getDefaultValue() {
        return this.defaultValue;
    }
    setDefaultValue(defaultValue) {
        this.defaultValue = defaultValue;
    }
    getMode() {
        return this.mode;
    }
    getFrom() {
        return this.from;
    }
    setFrom(fromDateTime) {
        this.from = fromDateTime;
    }
    getTo() {
        return this.to;
    }
    setTo(toDateTime) {
        this.to = toDateTime;
    }
    getDateTimeFormat() {
        return this.dateTimeFormat;
    }
    setDateTimeFormat(dateTimeFormat) {
        this.dateTimeFormat = dateTimeFormat;
    }
    formatDateTime(dateTime) {
        if (this.dateTimeFormat && dateTime) {
            try {
                return new Intl.DateTimeFormat('en-US', {
                    dateStyle: 'full',
                    timeStyle: 'long',
                }).format(dateTime);
            }
            catch (error) {
                console.error("Error formatting date:", error);
                return undefined;
            }
        }
        return undefined;
    }
    setTimezoneCode(timezoneCode) {
        this.timezoneCode = timezoneCode;
    }
    getTimezoneCode() {
        return this.timezoneCode;
    }
    static fromJSON(json) {
        const { elementId, label, mode = exports.DateTimePickerMode.date, optional = true, defaultValue, from, to, dateTimeFormat, timezoneCode = "UTC", } = json;
        const dateTimePickerElement = new DateTimePickerElement(elementId, label, mode, timezoneCode, optional);
        if (defaultValue) {
            dateTimePickerElement.setDefaultValue(defaultValue);
        }
        if (from) {
            dateTimePickerElement.setFrom(from);
        }
        if (to) {
            dateTimePickerElement.setTo(to);
        }
        if (dateTimeFormat) {
            dateTimePickerElement.setDateTimeFormat(dateTimeFormat);
        }
        return dateTimePickerElement;
    }
}

/**
 * Represents a form message that extends CometChat's InteractiveMessage class.
 * @extends CometChat.InteractiveMessage
 */
class FormMessage extends chatSdkJavascript.CometChat.InteractiveMessage {
    /**
     * Represents a form message that can be sent via CometChat.
     */
    constructor(receiverId, receiverType, title, formFields, submitElement) {
        super(receiverId, receiverType, CometChatUIKitConstants.MessageTypes.form, {});
        this.title = title || "";
        this.formFields = formFields || [];
        this.submitElement = submitElement;
        this.setInteractiveData({ title, formFields, submitElement });
    }
    /**
     * Sets the interactive form data for the message.
     * @param {InteractiveFormData} interactiveFormData - The interactive form data to be set.
     */
    setInteractiveData(formData) {
        const title = formData.title || this.title;
        const formFields = formData.formFields || this.formFields;
        const submitElement = formData.submitElement || this.submitElement;
        const goalCompletionText = formData.goalCompletionText || this.goalCompletionText;
        const data = {
            title: title,
            formFields: formFields,
            submitElement: submitElement,
        };
        if (goalCompletionText) {
            data.goalCompletionText = goalCompletionText;
        }
        super.setInteractiveData(data);
        if (title)
            this.title = title;
        if (formFields)
            this.formFields = formFields;
        if (submitElement)
            this.submitElement = submitElement;
        if (goalCompletionText)
            this.goalCompletionText = goalCompletionText;
    }
    getInteractiveData() {
        const data = {
            title: this.title,
            formFields: this.formFields,
            submitElement: this.submitElement,
        };
        if (this.goalCompletionText) {
            data["goalCompletionText"] = this.goalCompletionText;
        }
        return data;
    }
    /**
     * Returns the form fields of the form.
     * @returns An array of form fields.
     */
    getFormFields() {
        return this.formFields;
    }
    /**
     * Returns the title of the form.
     * @returns The title of the form.
     */
    getTitle() {
        return this.title;
    }
    /**
     * Returns the submit button of the form.
     * @returns The submit button of the form.
     */
    getSubmitElement() {
        return this.submitElement;
    }
    /**
     * Returns the goal completion text of the form.
     * @returns The goal completion text of the form.
     */
    getGoalCompletionText() {
        return this.goalCompletionText;
    }
    /**
     * Sets the goal completion text of the form.
     * @param goalCompletionText - The goal completion text of the form.
     */
    setGoalCompletionText(goalCompletionText) {
        this.goalCompletionText = goalCompletionText;
        this.setInteractiveData({ goalCompletionText });
    }
    static fromJSON(json) {
        var _a;
        const data = (_a = json === null || json === void 0 ? void 0 : json.data) === null || _a === void 0 ? void 0 : _a.interactiveData;
        const formFields = ((data === null || data === void 0 ? void 0 : data.formFields) || []).map((field) => {
            return ElementEntity.fromJSON(field);
        });
        const submitElement = ButtonElement.fromJSON(data.submitElement);
        const goalCompletionText = data === null || data === void 0 ? void 0 : data.goalCompletionText;
        const formMessage = new FormMessage(json.receiver, json.receiverType, data === null || data === void 0 ? void 0 : data.title, formFields, submitElement);
        if (goalCompletionText) {
            formMessage.setGoalCompletionText(goalCompletionText);
        }
        Object.assign(formMessage, json);
        return formMessage;
    }
}

/**
 * Represents a card message for CometChat.
 * @extends CometChat.InteractiveMessage
 */
class CardMessage extends chatSdkJavascript.CometChat.InteractiveMessage {
    /**
     * Creates a new instance of CardMessage.
     * @param receiverId - The ID of the receiver.
     * @param receiverType - The type of the receiver.
     * @param text - The text to display on the card.
     * @param cardActions - The actions to perform when the card is interacted with.
     */
    constructor(receiverId, receiverType, text, cardActions) {
        super(receiverId, receiverType, CometChatUIKitConstants.MessageTypes.card, {});
        this.text = text;
        this.cardActions = cardActions;
        this.setInteractiveData({ text, cardActions });
    }
    /**
     * Gets the URL of the image for the card.
     * @returns The URL of the image.
     */
    getImageUrl() {
        return this.imageUrl;
    }
    /**
     * Sets the image URL for the interactive card data.
     * @param imageUrl - The URL of the image to be set.
     */
    setImageUrl(imageUrl) {
        this.imageUrl = imageUrl;
        this.setInteractiveData({ imageUrl });
    }
    /**
     * Gets the text to display on the card.
     * @returns The text to display.
     */
    getText() {
        return this.text;
    }
    /**
     * Gets the actions to perform when the card is interacted with.
     * @returns The actions to perform.
     */
    getCardActions() {
        return this.cardActions;
    }
    /**
     * Sets the interactive data for the card message.
     * @param json - The partial data to set.
     */
    setInteractiveData(json) {
        const text = json.text || this.text;
        const cardActions = json.cardActions || this.cardActions;
        const imageUrl = json.imageUrl || this.imageUrl;
        const data = {
            text: text,
            cardActions: cardActions,
        };
        if (imageUrl) {
            data.imageUrl = imageUrl;
        }
        super.setInteractiveData(data);
        if (text)
            this.text = text;
        if (cardActions)
            this.cardActions = cardActions;
        if (imageUrl)
            this.imageUrl = imageUrl;
    }
    /**
     * Gets the interactive data for the card message.
     * @returns The interactive data.
     */
    getInteractiveData() {
        const data = {
            text: this.text,
            cardActions: this.cardActions,
        };
        if (this.imageUrl) {
            data.imageUrl = this.imageUrl;
        }
        return data;
    }
    /**
     * Creates a new instance of CardMessage from the provided JSON.
     * @param json - The JSON to create the instance from.
     * @returns The new instance of CardMessage.
     */
    static fromJSON(json) {
        var _a;
        const data = (_a = json === null || json === void 0 ? void 0 : json.data) === null || _a === void 0 ? void 0 : _a.interactiveData;
        const cardActions = ((data === null || data === void 0 ? void 0 : data.cardActions) || []).map((action) => {
            return ButtonElement.fromJSON(action);
        });
        const imageUrl = data === null || data === void 0 ? void 0 : data.imageUrl;
        const cardMessage = new CardMessage(json.receiverId, json.receiverType, data === null || data === void 0 ? void 0 : data.text, cardActions);
        if (imageUrl)
            cardMessage.setImageUrl(imageUrl);
        Object.assign(cardMessage, json);
        return cardMessage;
    }
}

/**
 * Represents a custom interactive message that extends CometChat's InteractiveMessage class.
 * @extends CometChat.InteractiveMessage
 */
class CustomInteractiveMessage extends chatSdkJavascript.CometChat.InteractiveMessage {
    /**
     * Creates a new instance of CustomInteractiveMessage.
     * @param receiverId - The ID of the receiver of the message.
     * @param receiverType - The type of the receiver of the message.
     * @param json - The JSON object to create the CustomInteractiveMessage object from.
     */
    constructor(receiverId, receiverType, json) {
        super(receiverId, receiverType, CometChatUIKitConstants.MessageTypes.customInteractive, json);
    }
    /**
     * Static method to create a CustomInteractiveMessage object from a JSON object.
     * @param json - JSON object to create the CustomInteractiveMessage object from.
     * @returns CustomInteractiveMessage object.
     */
    static fromJSON(json) {
        var _a;
        const data = (_a = json === null || json === void 0 ? void 0 : json.data) === null || _a === void 0 ? void 0 : _a.interactiveData;
        const customInteractiveMessage = new CustomInteractiveMessage(json.receiverId, json.receiverType, data);
        Object.assign(customInteractiveMessage, json);
        return customInteractiveMessage;
    }
}

class SchedulerMessage extends chatSdkJavascript.CometChat.InteractiveMessage {
    constructor(receiverId, receiverType, interactiveData) {
        super(receiverId, receiverType, CometChatUIKitConstants.MessageTypes.scheduler, interactiveData);
        // this.interactiveData = interactiveData;
        Object.assign(this, interactiveData);
    }
    // Setters
    setInteractiveData(interactiveData) {
        super.setInteractiveData(interactiveData);
    }
    setTitle(title) {
        this.title = title;
    }
    setAvatarUrl(avatarUrl) {
        this.avatarUrl = avatarUrl;
    }
    setGoalCompletionText(goalCompletionText) {
        this.goalCompletionText = goalCompletionText;
    }
    setTimezoneCode(timezoneCode) {
        this.timezoneCode = timezoneCode;
    }
    setDuration(duration) {
        this.duration = duration;
    }
    setBufferTime(bufferTime) {
        this.bufferTime = bufferTime;
    }
    setAvailability(availability) {
        this.availability = availability;
    }
    setDateRangeStart(dateRangeStart) {
        this.dateRangeStart = dateRangeStart;
    }
    setDateRangeEnd(dateRangeEnd) {
        this.dateRangeEnd = dateRangeEnd;
    }
    setIcsFileUrl(icsFileUrl) {
        this.icsFileUrl = icsFileUrl;
    }
    setScheduleElement(scheduleElement) {
        this.scheduleElement = scheduleElement;
    }
    // ... more setters as needed
    // Getters
    getInteractiveData() {
        return super.getInteractiveData();
    }
    getTitle() {
        return this.title;
    }
    getAvatarUrl() {
        return this.avatarUrl;
    }
    getGoalCompletionText() {
        return this.goalCompletionText;
    }
    getTimezoneCode() {
        return this.timezoneCode;
    }
    getDuration() {
        return this.duration;
    }
    getBufferTime() {
        return this.bufferTime;
    }
    getAvailability() {
        return this.availability;
    }
    getDateRangeStart() {
        return this.dateRangeStart;
    }
    getDateRangeEnd() {
        return this.dateRangeEnd;
    }
    getIcsFileUrl() {
        return this.icsFileUrl;
    }
    getScheduleElement() {
        return this.scheduleElement;
    }
    // ... more getters as needed
    // Method to refresh the data in the parent class
    static fromJSON(json) {
        var _a;
        let interactiveData = (_a = json === null || json === void 0 ? void 0 : json.data) === null || _a === void 0 ? void 0 : _a.interactiveData;
        const schedulerMessage = new SchedulerMessage(json === null || json === void 0 ? void 0 : json.receiverId, json === null || json === void 0 ? void 0 : json.receiverType, interactiveData);
        Object.assign(schedulerMessage, json);
        return schedulerMessage;
    }
}

class CometChatUIEvents {
}
CometChatUIEvents.ccHidePanel = new rxjs.Subject();
CometChatUIEvents.ccShowPanel = new rxjs.Subject();
CometChatUIEvents.ccShowModal = new rxjs.Subject();
CometChatUIEvents.ccHideModal = new rxjs.Subject();
CometChatUIEvents.ccShowDialog = new rxjs.Subject();
CometChatUIEvents.ccHideDialog = new rxjs.Subject();
CometChatUIEvents.ccActiveChatChanged = new rxjs.Subject();
CometChatUIEvents.ccShowOngoingCall = new rxjs.Subject();
CometChatUIEvents.ccOpenChat = new rxjs.Subject();
CometChatUIEvents.ccComposeMessage = new rxjs.Subject();
CometChatUIEvents.ccMouseEvent = new rxjs.Subject();
CometChatUIEvents.ccShowMentionsCountWarning = new rxjs.Subject();

class CometChatCallEvents {
}
CometChatCallEvents.ccOutgoingCall = new rxjs.Subject();
CometChatCallEvents.ccCallAccepted = new rxjs.Subject();
CometChatCallEvents.ccCallRejected = new rxjs.Subject();
CometChatCallEvents.ccCallEnded = new rxjs.Subject();

class CometChatConversationEvents {
    /**
     * @param  {any} event
     * @param  {any} item
     */
    static publishEvent(event, conversation) {
        event.next(conversation);
    }
}
CometChatConversationEvents.ccConversationDeleted = new rxjs.Subject();

class CometChatGroupEvents {
    /**
     * @param  {any} event
     * @param  {any} item
     */
    static publishEvent(event, group) {
        event.next(group);
    }
}
CometChatGroupEvents.ccGroupCreated = new rxjs.Subject();
CometChatGroupEvents.ccGroupDeleted = new rxjs.Subject();
CometChatGroupEvents.ccGroupMemberJoined = new rxjs.Subject();
CometChatGroupEvents.ccGroupLeft = new rxjs.Subject();
CometChatGroupEvents.ccGroupMemberAdded = new rxjs.Subject();
CometChatGroupEvents.ccGroupMemberScopeChanged = new rxjs.Subject();
CometChatGroupEvents.ccGroupMemberKicked = new rxjs.Subject();
CometChatGroupEvents.ccGroupMemberBanned = new rxjs.Subject();
CometChatGroupEvents.ccGroupMemberUnbanned = new rxjs.Subject();
CometChatGroupEvents.ccOwnershipChanged = new rxjs.Subject();

class CometChatMessageEvents {
    /**
     * name of the event to publish
     * @param  {any} event
     * item to pass in that event
     * @param  {any} item
     */
    static publishEvent(event, item = null) {
        event.next(item);
    }
}
CometChatMessageEvents.ccMessageSent = new rxjs.Subject();
CometChatMessageEvents.ccMessageEdited = new rxjs.Subject();
CometChatMessageEvents.ccMessageTranslated = new rxjs.Subject();
CometChatMessageEvents.ccLiveReaction = new rxjs.Subject();
CometChatMessageEvents.ccMessageRead = new rxjs.Subject();
CometChatMessageEvents.ccMessageDeleted = new rxjs.Subject();
CometChatMessageEvents.onTextMessageReceived = new rxjs.Subject();
CometChatMessageEvents.onMediaMessageReceived = new rxjs.Subject();
CometChatMessageEvents.onCustomMessageReceived = new rxjs.Subject();
CometChatMessageEvents.onTypingStarted = new rxjs.Subject();
CometChatMessageEvents.onTypingEnded = new rxjs.Subject();
CometChatMessageEvents.onMessagesDelivered = new rxjs.Subject();
CometChatMessageEvents.onMessagesRead = new rxjs.Subject();
CometChatMessageEvents.onMessageEdited = new rxjs.Subject();
CometChatMessageEvents.onMessageDeleted = new rxjs.Subject();
CometChatMessageEvents.onTransientMessageReceived = new rxjs.Subject();
CometChatMessageEvents.onCustomInteractiveMessageReceived = new rxjs.Subject();
CometChatMessageEvents.onFormMessageReceived = new rxjs.Subject();
CometChatMessageEvents.onCardMessageReceived = new rxjs.Subject();
CometChatMessageEvents.onInteractionGoalCompleted = new rxjs.Subject();
CometChatMessageEvents.onSchedulerMessageReceived = new rxjs.Subject();
CometChatMessageEvents.onMessageReactionAdded = new rxjs.Subject();
CometChatMessageEvents.onMessageReactionRemoved = new rxjs.Subject();

class CometChatUserEvents {
    /**
     * @param  {Subject<CometChat.User>} event
     * @param  {any} item
     */
    static publishEvent(event, item) {
        event.next(item);
    }
}
CometChatUserEvents.ccUserBlocked = new rxjs.Subject();
CometChatUserEvents.ccUserUnblocked = new rxjs.Subject();

class ChatSdkEventInitializer {
    static attachListeners() {
        chatSdkJavascript.CometChat.addMessageListener(this.messageListenerId, this.getMessageListenerObject());
    }
    static detachListeners() {
        chatSdkJavascript.CometChat.removeMessageListener(this.messageListenerId);
    }
    static getMessageListenerObject() {
        return new chatSdkJavascript.CometChat.MessageListener({
            onTextMessageReceived: (textMessage) => {
                CometChatMessageEvents.onTextMessageReceived.next(textMessage);
            },
            onMediaMessageReceived: (mediaMessage) => {
                CometChatMessageEvents.onMediaMessageReceived.next(mediaMessage);
            },
            onCustomMessageReceived: (customMessage) => {
                CometChatMessageEvents.onCustomMessageReceived.next(customMessage);
            },
            onSchedulerMessageReceived: (message) => {
                CometChatMessageEvents.onSchedulerMessageReceived.next(message);
            },
            onTypingStarted: (typingIndicator) => {
                CometChatMessageEvents.onTypingStarted.next(typingIndicator);
            },
            onTypingEnded: (typingIndicator) => {
                CometChatMessageEvents.onTypingEnded.next(typingIndicator);
            },
            onMessagesDelivered: (messageReceipt) => {
                CometChatMessageEvents.onMessagesDelivered.next(messageReceipt);
            },
            onMessagesRead: (messageReceipt) => {
                CometChatMessageEvents.onMessagesRead.next(messageReceipt);
            },
            onMessageEdited: (message) => {
                message = classRectifier(message);
                CometChatMessageEvents.onMessageEdited.next(message);
            },
            onMessageDeleted: (message) => {
                message = classRectifier(message);
                CometChatMessageEvents.onMessageDeleted.next(message);
            },
            onTransientMessageReceived: (message) => {
                CometChatMessageEvents.onTransientMessageReceived.next(message);
            },
            onInteractionGoalCompleted: (receipt) => {
                CometChatMessageEvents.onInteractionGoalCompleted.next(receipt);
            },
            onInteractiveMessageReceived: (message) => {
                switch (message.getType()) {
                    case CometChatUIKitConstants.MessageTypes.form:
                        const formMessage = FormMessage.fromJSON(message);
                        CometChatMessageEvents.onFormMessageReceived.next(formMessage);
                        break;
                    case CometChatUIKitConstants.MessageTypes.card:
                        const cardMessage = CardMessage.fromJSON(message);
                        CometChatMessageEvents.onCardMessageReceived.next(cardMessage);
                        break;
                    default:
                        const customInteractiveMessage = CustomInteractiveMessage.fromJSON(message);
                        CometChatMessageEvents.onCustomInteractiveMessageReceived.next(customInteractiveMessage);
                        break;
                }
            },
            onMessageReactionAdded: (reaction) => {
                CometChatMessageEvents.onMessageReactionAdded.next(reaction);
            },
            onMessageReactionRemoved: (reaction) => {
                CometChatMessageEvents.onMessageReactionRemoved.next(reaction);
            }
        });
    }
}
ChatSdkEventInitializer.messageListenerId = `message_listener_${new Date().getTime()}`;
function classRectifier(message) {
    if (message.getCategory() === CometChatUIKitConstants.MessageCategory.interactive) {
        switch (message.getType()) {
            case CometChatUIKitConstants.MessageTypes.form:
                return FormMessage.fromJSON(message);
            case CometChatUIKitConstants.MessageTypes.card:
                return CardMessage.fromJSON(message);
            case CometChatUIKitConstants.MessageTypes.scheduler:
                return SchedulerMessage.fromJSON(message);
            default:
                return CustomInteractiveMessage.fromJSON(message);
        }
    }
    else {
        return message;
    }
}

exports.APIAction = APIAction;
exports.ActionEntity = ActionEntity;
exports.BaseInputElement = BaseInputElement;
exports.BaseInteractiveElement = BaseInteractiveElement;
exports.ButtonElement = ButtonElement;
exports.CardMessage = CardMessage;
exports.ChatSdkEventInitializer = ChatSdkEventInitializer;
exports.CheckboxElement = CheckboxElement;
exports.CometChatActions = CometChatActions;
exports.CometChatActionsIcon = CometChatActionsIcon;
exports.CometChatActionsView = CometChatActionsView;
exports.CometChatCallDetailsOption = CometChatCallDetailsOption;
exports.CometChatCallDetailsTemplate = CometChatCallDetailsTemplate;
exports.CometChatCallEvents = CometChatCallEvents;
exports.CometChatConversationEvents = CometChatConversationEvents;
exports.CometChatDetailsOption = CometChatDetailsOption;
exports.CometChatDetailsTemplate = CometChatDetailsTemplate;
exports.CometChatFont = CometChatFont;
exports.CometChatGroupEvents = CometChatGroupEvents;
exports.CometChatLocalize = CometChatLocalize;
exports.CometChatMessageComposerAction = CometChatMessageComposerAction;
exports.CometChatMessageEvents = CometChatMessageEvents;
exports.CometChatMessageOption = CometChatMessageOption;
exports.CometChatMessageTemplate = CometChatMessageTemplate;
exports.CometChatOption = CometChatOption;
exports.CometChatPalette = CometChatPalette;
exports.CometChatTabItem = CometChatTabItem;
exports.CometChatTheme = CometChatTheme;
exports.CometChatTypography = CometChatTypography;
exports.CometChatUIEvents = CometChatUIEvents;
exports.CometChatUIKitConstants = CometChatUIKitConstants;
exports.CometChatUserEvents = CometChatUserEvents;
exports.CometChatUtilityConstants = CometChatUtilityConstants;
exports.CustomAction = CustomAction;
exports.CustomInteractiveMessage = CustomInteractiveMessage;
exports.DateTimePickerElement = DateTimePickerElement;
exports.DropdownElement = DropdownElement;
exports.ElementEntity = ElementEntity;
exports.FormMessage = FormMessage;
exports.LabelElement = LabelElement;
exports.OptionElement = OptionElement;
exports.PaletteItem = PaletteItem;
exports.RadioButtonElement = RadioButtonElement;
exports.SchedulerMessage = SchedulerMessage;
exports.SingleSelectElement = SingleSelectElement;
exports.TextInputElement = TextInputElement;
exports.URLNavigationAction = URLNavigationAction;
exports.fontHelper = fontHelper;
exports.localize = localize;
